/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const listAccountMasterv2 = /* GraphQL */ `query ListAccountMasterv2 {
  listAccountMasterv2 {
    accountsid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    accountname
    accounttypecd
    accountgroupid
    hsnsaccode
    displayordernumber
    statuscode
    statusmessage
    restrictedflag
    is_active
    accountgroupenteredtimestamp
    accountgroupexpiredtimestamp
    accountgrouptypecd
    accountgroupname
    accountparentgroupid
    accountgroupdisplayordernumber
    accountgrouprestrictedflag
    accountgroupis_active
    accountgstenteredtimestamp
    accountgstexpiredtimestamp
    accountgsteffectivedate
    accountgstexpireddate
    hsnid
    gstcompensationtype
    gstrate
    cessamount
    accounttypeflag
    partyid
    tdspercentage
    tdssection
    path
    tax_type
    balancesign
    accountcreationdate
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAccountMasterv2QueryVariables,
  APITypes.ListAccountMasterv2Query
>;
export const getCognitoUserSessions = /* GraphQL */ `query GetCognitoUserSessions {
  getCognitoUserSessions {
    sessionid
    cognitousername
    logintimestamp
    logouttimestamp
    linkedsessionid
    deviceinfo
    ipaddress
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCognitoUserSessionsQueryVariables,
  APITypes.GetCognitoUserSessionsQuery
>;
export const getOTPDetails = /* GraphQL */ `query GetOTPDetails {
  getOTPDetails {
    id
    purpose
    otpcode
    enteredtimestamp
    active
    userid
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOTPDetailsQueryVariables,
  APITypes.GetOTPDetailsQuery
>;
export const listPhoneContacts = /* GraphQL */ `query ListPhoneContacts {
  listPhoneContacts {
    id
    objecttype
    objectid
    enteredtimestamp
    expiredtimestamp
    countrycode
    phonenumber
    verifieddatetime
    promotionssignup
    smsallowed
    callallowed
    whatsappallowed
    lastupdatedby
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPhoneContactsQueryVariables,
  APITypes.ListPhoneContactsQuery
>;
export const listPOSParties = /* GraphQL */ `query ListPOSParties {
  listPOSParties {
    pospartyid
    companyid
    partyname
    partycontactnumberid
    lastupdatedby
    enteredtimestamp
    expiredtimestamp
    relatedphonecontacts {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      countrycode
      phonenumber
      verifieddatetime
      promotionssignup
      smsallowed
      callallowed
      whatsappallowed
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPOSPartiesQueryVariables,
  APITypes.ListPOSPartiesQuery
>;
export const searchHSN = /* GraphQL */ `query SearchHSN(
  $rowfrom: Int!
  $limitno: Int!
  $codetype: String!
  $word: String!
) {
  searchHSN(
    rowfrom: $rowfrom
    limitno: $limitno
    codetype: $codetype
    word: $word
  ) {
    hsnsacid
    codetype
    hsnsaccode
    description
    enteredtimestamp
    expiredtimestamp
    lastupdatedby
    statuscode
    statusmessage
    companyid
    __typename
  }
}
` as GeneratedQuery<APITypes.SearchHSNQueryVariables, APITypes.SearchHSNQuery>;
export const getAccountGSTDetails = /* GraphQL */ `query GetAccountGSTDetails($accountid: Int!) {
  getAccountGSTDetails(accountid: $accountid) {
    accountid
    companyid
    enteredtimestamp
    expiredtimestamp
    effectivedate
    expireddate
    hsnid
    gstcompensationtype
    gstrate
    cessamount
    lastupdatedby
    statuscode
    statusmessage
    hsnsaccode
    codetype
    description
    taxability
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAccountGSTDetailsQueryVariables,
  APITypes.GetAccountGSTDetailsQuery
>;
export const getBankDetails = /* GraphQL */ `query GetBankDetails($objectid: String!, $objecttype: String!) {
  getBankDetails(objectid: $objectid, objecttype: $objecttype) {
    bankdetailsid
    companyid
    companybranchid
    objecttype
    enteredtimestamp
    expiredtimestamp
    objectid
    userid
    bankname
    bankaccountnumber
    ifsccode
    branch
    notes
    ledgeraccount
    bankaccounttype
    cash
    swiftcode
    statuscode
    statusmessage
    relatedaccountdetails {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    upi
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBankDetailsQueryVariables,
  APITypes.GetBankDetailsQuery
>;
export const getBankDetailsByAccountName = /* GraphQL */ `query GetBankDetailsByAccountName($accountname: String!) {
  getBankDetailsByAccountName(accountname: $accountname) {
    bankdetailsid
    companyid
    companybranchid
    objecttype
    enteredtimestamp
    expiredtimestamp
    objectid
    userid
    bankname
    bankaccountnumber
    ifsccode
    branch
    notes
    ledgeraccount
    bankaccounttype
    cash
    swiftcode
    statuscode
    statusmessage
    relatedaccountdetails {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    upi
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBankDetailsByAccountNameQueryVariables,
  APITypes.GetBankDetailsByAccountNameQuery
>;
export const getCodeTranslation = /* GraphQL */ `query GetCodeTranslation($codetype: String!) {
  getCodeTranslation(codetype: $codetype) {
    id
    companyid
    codetype
    codevalue
    language
    enteredtimestamp
    expiredtimestamp
    codetext
    statecode
    codeorder
    statuscode
    statusmessage
    lastupdatedby
    uqc
    is_active
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCodeTranslationQueryVariables,
  APITypes.GetCodeTranslationQuery
>;
export const listVoucherSerialNumbers = /* GraphQL */ `query ListVoucherSerialNumbers($entrytypecd: String!) {
  listVoucherSerialNumbers(entrytypecd: $entrytypecd) {
    id
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    financialyearid
    entrytypecd
    serialnumber
    serialisactive
    serialisused
    nextinvoicenumber
    prefix
    suffix
    lastupdatedby
    statuscode
    statusmessage
    serialflag
    startinvoicenumber
    taxability
    lastused
    secondlastused
    restrictedflag
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListVoucherSerialNumbersQueryVariables,
  APITypes.ListVoucherSerialNumbersQuery
>;
export const listUserPreference = /* GraphQL */ `query ListUserPreference {
  listUserPreference {
    userid
    attributetypecd
    enteredtimestamp
    expiredtimestamp
    attributevalue
    additionalvalue
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserPreferenceQueryVariables,
  APITypes.ListUserPreferenceQuery
>;
export const listCompanyPreference = /* GraphQL */ `query ListCompanyPreference {
  listCompanyPreference {
    companyid
    attributetypecd
    enteredtimestamp
    expiredtimestamp
    attributevalue
    additionalvalue
    lastupdatedby
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCompanyPreferenceQueryVariables,
  APITypes.ListCompanyPreferenceQuery
>;
export const listUserCompanies = /* GraphQL */ `query ListUserCompanies {
  listUserCompanies {
    companyid
    enteredtimestamp
    expiredtimestamp
    websiteurl
    currencycd
    accountinventoryflag
    pannumber
    tdstcsnumber
    cinregistrationnumber
    registrationtype
    comppercentage
    gstrperiod
    lut
    lutbondvalidfrom
    ewaybillflag
    gstapplicablefrom
    thresholdlimitcd
    thresholdlimitamount
    companylegalname
    companyshort
    lutbondtodate
    invoicedetailapplicablefromdate
    tdsapplicable
    gstcategory
    financialyearstartandendmonth
    companylogourl
    msmetype
    udhyamregno
    udhyamdocs
    ewaybillstartdate
    minamountewayinter
    minamountewayintra
    einvoiceflag
    einvoicestartingdate
    gstcompensationcessflag
    tradelicensenumber
    tradelicensestartdate
    tradelicenseenddate
    lastupdatedby
    cinregistrationdate
    einvoiceconnect
    statuscode
    statusmessage
    activeflag
    relatedfinancialyeardata {
      financialyearid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      startdate
      enddate
      startyear
      endyear
      comments
      userid
      aliasname
      statuscode
      statusmessage
      freezestatus
      transferdate
      freezedate
      stepscompleted
      __typename
    }
    financialyearid
    lastupdatedtimestamp
    companydeletiontime
    ewaybillconnect
    stepscompleted
    disablegstcompensation
    businesstypeid
    industrytypeid
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserCompaniesQueryVariables,
  APITypes.ListUserCompaniesQuery
>;
export const listPriceType = /* GraphQL */ `query ListPriceType {
  listPriceType {
    id
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    pricetype
    userid
    is_default
    is_active
    statuscode
    statusmessage
    tabletype
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPriceTypeQueryVariables,
  APITypes.ListPriceTypeQuery
>;
export const getInvoiceMaster = /* GraphQL */ `query GetInvoiceMaster($invoiceid: Int!) {
  getInvoiceMaster(invoiceid: $invoiceid) {
    invoiceid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    invoicetypecd
    partyid
    paymentaccountid
    invoicedate
    invoicenumber
    customerordernumber
    customerorderdate
    invoiceamount
    paymenttype
    creditduration
    invoicebillingaddressid
    invoicedeliveryaddressid
    invoicetaxabletypecd
    receipturl
    invoicelinetypecd
    invoicecurrencycd
    exchangerate
    comments
    receivedamount
    adjustmentamount
    placeofsupply
    balancedueamount
    reversechargeflag
    tcsapplicableflag
    relatedinvoicetcsdetails {
      invoiceid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tcsapplicablecd
      totaltaxableamount
      ineligibletcflag
      reversechargeflag
      gstcesstotal
      tcsamount
      adjustmentamount
      tcssection
      lastupdatedby
      statuscode
      statusmessage
      tcspercentage
      tcsmanual
      __typename
    }
    relatedinvoicelineitems {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      lineitemnumber
      invoicelineitemtype
      itemid
      quantity
      unittypecd
      itemrate
      itemamount
      itemdiscount
      taxableamount
      discounttype
      discountrate
      netamount
      hsnsaccode
      taxability
      lastupdatedby
      statuscode
      statusmessage
      pricetype
      lotid
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      gstrate
      gsttypecd
      gstamount
      cessamount
      unit
      uqc
      salesaccountname
      salesaccountid
      itemname
      itemcode
      itemtype
      manualdiscount
      manualcess
      itemmaster_timestamp
      description
      relatedinvoicelinegst {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        gsttypecd
        gstamount
        cessamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relateditemmaster {
        itemid
        itemcode
        companyid
        enteredtimestamp
        expiredtimestamp
        itemname
        salesinvoiceflag
        purchaseinvoiceflag
        itemcategorycd
        measurementcd
        currencycd
        salesaccountid
        purchaseaccountid
        taxabilitycd
        reversechargeflag
        itemtype
        hsnid
        is_active
        statuscode
        statusmessage
        relateditemamountdetails {
          id
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          amount
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstcompensationvalue
          gstrate
          statuscode
          statusmessage
          lastupdatedby
          discounttype
          discountvalue
          invoicetype
          pricetype
          isactive
          isdefault
          pricetypeid
          tabletype
          __typename
        }
        relateditemgstdetails {
          itemid
          companyid
          enteredtimestamp
          expiredtimestamp
          hsnid
          gstcesstype
          gstcompensationvalue
          effectivedate
          expireddate
          gstcessvalue
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemimages {
          attachmentid
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          imagename
          imageurl
          documentname
          type
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        serialnumber
        financialyearid
        description
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        cessexist
        barcode
        __typename
      }
      pricetypeid
      manualgst
      cessrate
      cesstype
      type
      __typename
    }
    relatedinvoicelinenonitems {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoicelineitemtype
      incomeaccountid
      hsnsaccode
      taxability
      itemdescription
      taxableamount
      rate
      discount
      netamount
      relatedaccounts {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accountname
        accounttypecd
        accountgroupid
        hsnsaccode
        displayordernumber
        statuscode
        statusmessage
        restrictedflag
        is_active
        accounttypeflag
        relatedaccountgstdetails {
          accountid
          companyid
          enteredtimestamp
          expiredtimestamp
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstrate
          cessamount
          lastupdatedby
          statuscode
          statusmessage
          hsnsaccode
          codetype
          description
          taxability
          __typename
        }
        relatedaccountopeningbalance {
          accountsid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          financialyearid
          startdate
          creditamount
          debitamount
          statuscode
          statusmessage
          __typename
        }
        relatedaccountgroupmaster {
          accountgroupid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          accounttypecd
          accountgroupname
          accountparentgroupid
          displayordernumber
          statuscode
          statusmessage
          is_active
          restrictedflag
          path
          __typename
        }
        relatedaccountbalance {
          accountid
          accountbalance
          actualbalance
          __typename
        }
        path
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      gstrate
      gsttypecd
      gstamount
      cessamount
      incomeaccountname
      manualgst
      manualcess
      cessrate
      cesstype
      type
      __typename
    }
    relatedinvoiceattachment {
      invoiceid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      lastupdatedby
      statuscode
      statusmessage
      documentname
      type
      __typename
    }
    relatedinvoicedispatch {
      invoiceid
      dispatchid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transportationcd
      vehiclenumber
      dispatchdate
      ewaybillnumber
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedinvoiceposdetails {
      posid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      partyposid
      lastupdatedby
      relatedposparty {
        pospartyid
        companyid
        partyname
        partycontactnumberid
        lastupdatedby
        enteredtimestamp
        expiredtimestamp
        relatedphonecontacts {
          id
          objecttype
          objectid
          enteredtimestamp
          expiredtimestamp
          countrycode
          phonenumber
          verifieddatetime
          promotionssignup
          smsallowed
          callallowed
          whatsappallowed
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        __typename
      }
      statuscode
      statusmessage
      __typename
    }
    relatedinvoicelinegst {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      gsttypecd
      gstamount
      cessamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedinvoicelinenongst {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      gsttypecd
      gstamount
      cessamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedinvoicenumbertracker {
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      nextinvoicenumber
      lastupdatedby
      __typename
    }
    relatedinvoicetransactiondetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      vouchernumber
      entrydate
      bankreferencenumber
      comments
      relatedtransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        accountid
        creditamount
        debitamount
        comments
        entryordernumber
        transactionbalance
        openingbalance
        lastupdatedby
        statuscode
        statusmessage
        financialyearid
        __typename
      }
      relatedtransactionattachment {
        transactionid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        documentname
        statuscode
        statusmessage
        type
        __typename
      }
      relatedtransactiontdsdetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tdsapplicablecd
        tdsamount
        tdsmanual
        lastupdatedby
        statuscode
        statusmessage
        tdspercentage
        __typename
      }
      relatedpurchasemaster {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        purchasegsttypecd
        supplierid
        entrydate
        vouchernumber
        supplierinvoicedate
        supplierinvoicenumber
        supplieraddressid
        paymenttypecd
        paidamount
        creditduration
        paymentaccountid
        comments
        tdsapplicableflag
        granttotalamount
        balancedueamount
        paymentclearedflag
        placeofsupply
        companystate
        relatedpurchasetdsdetails {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          totaltaxableamount
          ineligibletcflag
          reversechargeflag
          gstcesstotal
          tdsamount
          adjustmentamount
          tdssection
          tdspercentage
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaselineitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          itemnumber
          itemid
          purchaseaccountid
          hsncode
          itemquantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          taxableamount
          description
          discounttype
          discountrate
          netamount
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          pricetype
          lotid
          hsnid
          hsncodetype
          hsndescription
          gstrate
          gstamount
          cessamount
          unit
          uqc
          purchaseaccountname
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          pricetypeid
          manualgst
          cessrate
          cesstype
          type
          __typename
        }
        relatedpurchaselinenonitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchaselineitemtype
          purchaseaccountid
          hsnsaccode
          itemdescription
          taxableamount
          rate
          discount
          netamount
          relatedpurchaselinenongst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gstamount
          cessamount
          purchaseaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          type
          __typename
        }
        relatedpurchaselinegst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaseattachment {
          purchaseid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedpurchasetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              description
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              description
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        relatedpurchasetransactionrelation {
          transactionid
          transactiontypecd
          objecttype
          objectid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          linkedamount
          objectattribute
          isdirect
          lastupdatedby
          accountid
          paymentvouchernumber
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        cancelflag
        roundoffamount
        discounttype
        discountvalue
        adjustmentamount
        serialnumber
        currencycode
        currencyrate
        reversechargeflag
        paymentstatus
        partyregistrationtype
        partygstcategory
        itcflag
        __typename
      }
      relatedinvoicemaster {
        invoiceid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        invoicetypecd
        partyid
        paymentaccountid
        invoicedate
        invoicenumber
        customerordernumber
        customerorderdate
        invoiceamount
        paymenttype
        creditduration
        invoicebillingaddressid
        invoicedeliveryaddressid
        invoicetaxabletypecd
        receipturl
        invoicelinetypecd
        invoicecurrencycd
        exchangerate
        comments
        receivedamount
        adjustmentamount
        placeofsupply
        balancedueamount
        reversechargeflag
        tcsapplicableflag
        relatedinvoicelineitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          lineitemnumber
          invoicelineitemtype
          itemid
          quantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          taxableamount
          discounttype
          discountrate
          netamount
          hsnsaccode
          taxability
          lastupdatedby
          statuscode
          statusmessage
          pricetype
          lotid
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          unit
          uqc
          salesaccountname
          salesaccountid
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          itemmaster_timestamp
          description
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          pricetypeid
          manualgst
          cessrate
          cesstype
          type
          __typename
        }
        relatedinvoicelinenonitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicelineitemtype
          incomeaccountid
          hsnsaccode
          taxability
          itemdescription
          taxableamount
          rate
          discount
          netamount
          relatedaccounts {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accountname
            accounttypecd
            accountgroupid
            hsnsaccode
            displayordernumber
            statuscode
            statusmessage
            restrictedflag
            is_active
            accounttypeflag
            relatedaccountgstdetails {
              accountid
              companyid
              enteredtimestamp
              expiredtimestamp
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstrate
              cessamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsaccode
              codetype
              description
              taxability
              __typename
            }
            relatedaccountopeningbalance {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              financialyearid
              startdate
              creditamount
              debitamount
              statuscode
              statusmessage
              __typename
            }
            relatedaccountgroupmaster {
              accountgroupid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accounttypecd
              accountgroupname
              accountparentgroupid
              displayordernumber
              statuscode
              statusmessage
              is_active
              restrictedflag
              path
              __typename
            }
            relatedaccountbalance {
              accountid
              accountbalance
              actualbalance
              __typename
            }
            path
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          incomeaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          type
          __typename
        }
        relatedinvoiceattachment {
          invoiceid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedinvoicedispatch {
          invoiceid
          dispatchid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transportationcd
          vehiclenumber
          dispatchdate
          ewaybillnumber
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoiceposdetails {
          posid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          partyposid
          lastupdatedby
          relatedposparty {
            pospartyid
            companyid
            partyname
            partycontactnumberid
            lastupdatedby
            enteredtimestamp
            expiredtimestamp
            relatedphonecontacts {
              id
              objecttype
              objectid
              enteredtimestamp
              expiredtimestamp
              countrycode
              phonenumber
              verifieddatetime
              promotionssignup
              smsallowed
              callallowed
              whatsappallowed
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            __typename
          }
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicelinegst {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          gsttypecd
          gstamount
          cessamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicenumbertracker {
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          nextinvoicenumber
          lastupdatedby
          __typename
        }
        relatedinvoicetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              description
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              description
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        lastupdatedby
        cancelflag
        statuscode
        statusmessage
        consigneename
        consigneegstin
        companystate
        cancelremark
        deleteremark
        roundoffamount
        discounttype
        discountvalue
        serialnumber
        currencycode
        currencyrate
        paymentstatus
        ackno
        ackdt
        irn
        signedqrcode
        itcflag
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      cancelflag
      cancelremark
      serialnumber
      pdflink
      towards
      isvouchereditable
      __typename
    }
    relatedpartymaster {
      partyid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      partytypecd
      partydisplayname
      partylegalname
      groupaccountid
      gstcategory
      placeofsupply
      entity
      email
      contactnumber
      whatsappnumber
      accountsid
      is_active
      msmetype
      deliveryconsigneename
      deliveryconsigneegstin
      statuscode
      statusmessage
      relatedpartygstdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        pannumber
        gstin
        partyaddressid
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycreditdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        creditperiodduration
        billingcurrency
        creditlimitcd
        creditlimitamount
        billwiseflag
        notes
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycontact {
        partyid
        enteredtimestamp
        expiredtimestamp
        contacttypename
        contactdesignationname
        contactorder
        email
        phonenumber
        whatsappnumber
        lastupdatedby
        statuscode
        statusmessage
        contactcountry
        whatsappcountry
        __typename
      }
      relatedpartyimages {
        attachmentid
        partyid
        companyid
        enteredtimestamp
        expiredtimestamp
        type
        documentname
        imagename
        imageurl
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      tdspercentage
      udhyamregno
      sameaddressflag
      comments
      tdssection
      accountname
      deliverystatecode
      deliverystatename
      contactcountry
      whatsappcountry
      entityname
      __typename
    }
    relatedpaymentaccountdetails {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    relatedinvoiceaddressdetails {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      line1
      line2
      line3
      city
      statecode
      statename
      statuscode
      statusmessage
      pincode
      countrycode
      codevalue
      district
      lastupdatedby
      godownname
      gstin
      phone
      email
      personincharge
      consigneename
      consigneegstin
      foreignstate
      foreigndistrict
      defaultflag
      addresstitle
      addressindex
      __typename
    }
    lastupdatedby
    statuscode
    statusmessage
    cancelflag
    consigneename
    consigneegstin
    companystate
    cancelremark
    deleteremark
    roundoffamount
    discounttype
    discountvalue
    serialnumber
    serialflag
    currencycode
    currencyrate
    partydisplayname
    partylegalname
    partyaccountid
    paymentstatus
    ackno
    ackdt
    irn
    signedqrcode
    partyemail
    invoicepdf
    partygstin
    partytypecd
    partygstcategory
    is_cancelled
    cancel_reason
    cancel_remarks
    phonenumber
    bankaccountid
    bankamount
    ewaybillno
    validupto
    ewaybill_validupto
    ewaybill_is_cancelled
    ewaybill_cancel_remarks
    ewaybill_cancel_rsn_code
    cancel_rsn_code
    einvoiceenteredtimestamp
    ewaybillenteredtimestamp
    ewaybillid
    ewaybillpdf
    ewaybillstatus
    invoicetype
    accountname
    partyisactive
    goods_exist
    overduedays
    duedatetimestamp
    isvouchereditable
    itcflag
    taxability
    linkedamount
    cessexist
    partyamount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInvoiceMasterQueryVariables,
  APITypes.GetInvoiceMasterQuery
>;
export const getlatestvoucherdate = /* GraphQL */ `query Getlatestvoucherdate {
  getlatestvoucherdate {
    companyid
    financialyearid
    latestenteredtimestamp
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetlatestvoucherdateQueryVariables,
  APITypes.GetlatestvoucherdateQuery
>;
export const getPartyInvoices = /* GraphQL */ `query GetPartyInvoices($partyid: Int!, $partytypecd: String!) {
  getPartyInvoices(partyid: $partyid, partytypecd: $partytypecd) {
    invoiceid
    purchaseid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    invoicetypecd
    purchasegsttypecd
    partyid
    supplierid
    paymentaccountid
    invoicedate
    entrydate
    invoicenumber
    vouchernumber
    customerordernumber
    supplierinvoicenumber
    customerorderdate
    invoiceamount
    granttotalamount
    paymenttype
    creditduration
    invoicebillingaddressid
    supplieraddressid
    invoicedeliveryaddressid
    invoicetaxabletypecd
    receipturl
    invoicelinetypecd
    invoicecurrencycd
    paymenttypecd
    exchangerate
    currencyrate
    comments
    receivedamount
    adjustmentamount
    placeofsupply
    statename
    balancedueamount
    reversechargeflag
    lastupdatedby
    cancelflag
    consigneename
    consigneegstin
    tcsapplicableflag
    tdsapplicableflag
    companystate
    cancelremark
    deleteremark
    financialyearid
    roundoffamount
    discounttype
    discountvalue
    serialnumber
    paymentclearedflag
    paymentstatus
    partyregistrationtype
    currencycode
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPartyInvoicesQueryVariables,
  APITypes.GetPartyInvoicesQuery
>;
export const getFinancialYear = /* GraphQL */ `query GetFinancialYear($financialyearid: Int!) {
  getFinancialYear(financialyearid: $financialyearid) {
    financialyearid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    startdate
    enddate
    startyear
    endyear
    comments
    userid
    aliasname
    statuscode
    statusmessage
    freezestatus
    transferdate
    freezedate
    stepscompleted
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFinancialYearQueryVariables,
  APITypes.GetFinancialYearQuery
>;
export const getEmailTemplateMaster = /* GraphQL */ `query GetEmailTemplateMaster {
  getEmailTemplateMaster {
    templateid
    templatename
    valueid
    fieldname
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEmailTemplateMasterQueryVariables,
  APITypes.GetEmailTemplateMasterQuery
>;
export const getEmailSettings = /* GraphQL */ `query GetEmailSettings {
  getEmailSettings {
    email
    templateid
    emailbody
    smtp_port
    smtp_hostname
    username
    password
    companyid
    enteredtimestamp
    expiredtimestamp
    lastupdatedby
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEmailSettingsQueryVariables,
  APITypes.GetEmailSettingsQuery
>;
export const geteInvoiceMaster = /* GraphQL */ `query GeteInvoiceMaster($invoiceid: Int!) {
  geteInvoiceMaster(invoiceid: $invoiceid) {
    id
    invoiceid
    invoicetype
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    ackno
    ackdt
    irn
    signedqrcode
    lastupdatedby
    is_cancelled
    cancel_reason
    cancel_remarks
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GeteInvoiceMasterQueryVariables,
  APITypes.GeteInvoiceMasterQuery
>;
export const listUsedVoucherSerialNumbers = /* GraphQL */ `query ListUsedVoucherSerialNumbers($entryTypecd: String!) {
  listUsedVoucherSerialNumbers(entryTypecd: $entryTypecd) {
    id
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    financialyearid
    entrytypecd
    serialnumber
    serialisactive
    serialisused
    nextinvoicenumber
    prefix
    suffix
    lastupdatedby
    statuscode
    statusmessage
    serialflag
    startinvoicenumber
    taxability
    lastused
    secondlastused
    restrictedflag
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUsedVoucherSerialNumbersQueryVariables,
  APITypes.ListUsedVoucherSerialNumbersQuery
>;
export const listTransactionMasterv2 = /* GraphQL */ `query ListTransactionMasterv2(
  $transactiontypecd: String
  $rowfrom: Int!
  $limitno: Int!
  $columnname: String
  $ordertype: String
  $searchmode: Int
  $searcharray: AWSJSON
) {
  listTransactionMasterv2(
    transactiontypecd: $transactiontypecd
    rowfrom: $rowfrom
    limitno: $limitno
    columnname: $columnname
    ordertype: $ordertype
    searchmode: $searchmode
    searcharray: $searcharray
  ) {
    transactionid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    transactiontypecd
    vouchernumber
    entrydate
    bankreferencenumber
    comments
    lastupdatedby
    statuscode
    statusmessage
    cancelflag
    cancelremark
    serialnumber
    paidfrom
    paidto
    paidfromamount
    paidtoamount
    paidfromaccountid
    paidtoaccountid
    paidfromemail
    paidtoemail
    paidfrompartyid
    paidtopartyid
    paidfrompartytypecd
    paidtopartytypecd
    paidfromcomments
    paidtocomments
    pdflink
    tds_payable_amount
    tds_receivable_amount
    tcs_payable_amount
    tcs_receivable_amount
    receiptamount
    paymentamount
    totalamount
    lastpaidtoaccountid
    lastpaidfromaccountid
    towards
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTransactionMasterv2QueryVariables,
  APITypes.ListTransactionMasterv2Query
>;
export const listTransactionMaster = /* GraphQL */ `query ListTransactionMaster {
  listTransactionMaster {
    transactionid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    transactiontypecd
    vouchernumber
    entrydate
    bankreferencenumber
    comments
    relatedtransactiondetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      accountid
      creditamount
      debitamount
      comments
      entryordernumber
      transactionbalance
      openingbalance
      lastupdatedby
      statuscode
      statusmessage
      financialyearid
      __typename
    }
    relatedtransactionattachment {
      transactionid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      lastupdatedby
      documentname
      statuscode
      statusmessage
      type
      __typename
    }
    relatedtransactiontdsdetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tdsapplicablecd
      tdsamount
      tdsmanual
      lastupdatedby
      statuscode
      statusmessage
      tdspercentage
      __typename
    }
    relatedpurchasemaster {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      purchasegsttypecd
      supplierid
      entrydate
      vouchernumber
      supplierinvoicedate
      supplierinvoicenumber
      supplieraddressid
      paymenttypecd
      paidamount
      creditduration
      paymentaccountid
      comments
      tdsapplicableflag
      granttotalamount
      balancedueamount
      paymentclearedflag
      placeofsupply
      companystate
      relatedpurchasetdsdetails {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tdsapplicablecd
        totaltaxableamount
        ineligibletcflag
        reversechargeflag
        gstcesstotal
        tdsamount
        adjustmentamount
        tdssection
        tdspercentage
        tdsmanual
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpurchaselineitems {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        itemnumber
        itemid
        purchaseaccountid
        hsncode
        itemquantity
        unittypecd
        itemrate
        itemamount
        itemdiscount
        taxableamount
        description
        discounttype
        discountrate
        netamount
        relatedpurchaselinegst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemmaster {
          itemid
          itemcode
          companyid
          enteredtimestamp
          expiredtimestamp
          itemname
          salesinvoiceflag
          purchaseinvoiceflag
          itemcategorycd
          measurementcd
          currencycd
          salesaccountid
          purchaseaccountid
          taxabilitycd
          reversechargeflag
          itemtype
          hsnid
          is_active
          statuscode
          statusmessage
          relateditemamountdetails {
            id
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            amount
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstcompensationvalue
            gstrate
            statuscode
            statusmessage
            lastupdatedby
            discounttype
            discountvalue
            invoicetype
            pricetype
            isactive
            isdefault
            pricetypeid
            tabletype
            __typename
          }
          relateditemgstdetails {
            itemid
            companyid
            enteredtimestamp
            expiredtimestamp
            hsnid
            gstcesstype
            gstcompensationvalue
            effectivedate
            expireddate
            gstcessvalue
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemimages {
            attachmentid
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            imagename
            imageurl
            documentname
            type
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          serialnumber
          financialyearid
          description
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          cessexist
          barcode
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        taxability
        pricetype
        lotid
        hsnid
        hsncodetype
        hsndescription
        gstrate
        gstamount
        cessamount
        unit
        uqc
        purchaseaccountname
        itemname
        itemcode
        itemtype
        manualdiscount
        manualcess
        pricetypeid
        manualgst
        cessrate
        cesstype
        type
        __typename
      }
      relatedpurchaselinenonitems {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        purchaselineitemtype
        purchaseaccountid
        hsnsaccode
        itemdescription
        taxableamount
        rate
        discount
        netamount
        relatedpurchaselinenongst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        taxability
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gstamount
        cessamount
        purchaseaccountname
        manualgst
        manualcess
        cessrate
        cesstype
        type
        __typename
      }
      relatedpurchaselinegst {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        cessamount
        gstamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpurchaseattachment {
        purchaseid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        statuscode
        statusmessage
        documentname
        type
        __typename
      }
      relatedpurchasetransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        vouchernumber
        entrydate
        bankreferencenumber
        comments
        relatedtransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          accountid
          creditamount
          debitamount
          comments
          entryordernumber
          transactionbalance
          openingbalance
          lastupdatedby
          statuscode
          statusmessage
          financialyearid
          __typename
        }
        relatedtransactionattachment {
          transactionid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          documentname
          statuscode
          statusmessage
          type
          __typename
        }
        relatedtransactiontdsdetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          tdsamount
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          tdspercentage
          __typename
        }
        relatedpurchasemaster {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchasegsttypecd
          supplierid
          entrydate
          vouchernumber
          supplierinvoicedate
          supplierinvoicenumber
          supplieraddressid
          paymenttypecd
          paidamount
          creditduration
          paymentaccountid
          comments
          tdsapplicableflag
          granttotalamount
          balancedueamount
          paymentclearedflag
          placeofsupply
          companystate
          relatedpurchasetdsdetails {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            totaltaxableamount
            ineligibletcflag
            reversechargeflag
            gstcesstotal
            tdsamount
            adjustmentamount
            tdssection
            tdspercentage
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaselineitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            itemnumber
            itemid
            purchaseaccountid
            hsncode
            itemquantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            description
            discounttype
            discountrate
            netamount
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            pricetype
            lotid
            hsnid
            hsncodetype
            hsndescription
            gstrate
            gstamount
            cessamount
            unit
            uqc
            purchaseaccountname
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinenonitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchaselineitemtype
            purchaseaccountid
            hsnsaccode
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedpurchaselinenongst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gstamount
            cessamount
            purchaseaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaseattachment {
            purchaseid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedpurchasetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          relatedpurchasetransactionrelation {
            transactionid
            transactiontypecd
            objecttype
            objectid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            linkedamount
            objectattribute
            isdirect
            lastupdatedby
            accountid
            paymentvouchernumber
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          cancelflag
          roundoffamount
          discounttype
          discountvalue
          adjustmentamount
          serialnumber
          currencycode
          currencyrate
          reversechargeflag
          paymentstatus
          partyregistrationtype
          partygstcategory
          itcflag
          __typename
        }
        relatedinvoicemaster {
          invoiceid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicetypecd
          partyid
          paymentaccountid
          invoicedate
          invoicenumber
          customerordernumber
          customerorderdate
          invoiceamount
          paymenttype
          creditduration
          invoicebillingaddressid
          invoicedeliveryaddressid
          invoicetaxabletypecd
          receipturl
          invoicelinetypecd
          invoicecurrencycd
          exchangerate
          comments
          receivedamount
          adjustmentamount
          placeofsupply
          balancedueamount
          reversechargeflag
          tcsapplicableflag
          relatedinvoicelineitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            lineitemnumber
            invoicelineitemtype
            itemid
            quantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            discounttype
            discountrate
            netamount
            hsnsaccode
            taxability
            lastupdatedby
            statuscode
            statusmessage
            pricetype
            lotid
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            unit
            uqc
            salesaccountname
            salesaccountid
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            itemmaster_timestamp
            description
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoicelinenonitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicelineitemtype
            incomeaccountid
            hsnsaccode
            taxability
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedaccounts {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accountname
              accounttypecd
              accountgroupid
              hsnsaccode
              displayordernumber
              statuscode
              statusmessage
              restrictedflag
              is_active
              accounttypeflag
              path
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            incomeaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoiceattachment {
            invoiceid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedinvoicedispatch {
            invoiceid
            dispatchid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transportationcd
            vehiclenumber
            dispatchdate
            ewaybillnumber
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoiceposdetails {
            posid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            partyposid
            lastupdatedby
            relatedposparty {
              pospartyid
              companyid
              partyname
              partycontactnumberid
              lastupdatedby
              enteredtimestamp
              expiredtimestamp
              __typename
            }
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicenumbertracker {
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            nextinvoicenumber
            lastupdatedby
            __typename
          }
          relatedinvoicetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          lastupdatedby
          cancelflag
          statuscode
          statusmessage
          consigneename
          consigneegstin
          companystate
          cancelremark
          deleteremark
          roundoffamount
          discounttype
          discountvalue
          serialnumber
          currencycode
          currencyrate
          paymentstatus
          ackno
          ackdt
          irn
          signedqrcode
          itcflag
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        cancelflag
        cancelremark
        serialnumber
        pdflink
        towards
        isvouchereditable
        __typename
      }
      relatedpurchasetransactionrelation {
        transactionid
        transactiontypecd
        objecttype
        objectid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        linkedamount
        objectattribute
        isdirect
        lastupdatedby
        accountid
        paymentvouchernumber
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      cancelflag
      roundoffamount
      discounttype
      discountvalue
      adjustmentamount
      serialnumber
      currencycode
      currencyrate
      reversechargeflag
      paymentstatus
      partyregistrationtype
      partygstcategory
      itcflag
      __typename
    }
    relatedinvoicemaster {
      invoiceid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoicetypecd
      partyid
      paymentaccountid
      invoicedate
      invoicenumber
      customerordernumber
      customerorderdate
      invoiceamount
      paymenttype
      creditduration
      invoicebillingaddressid
      invoicedeliveryaddressid
      invoicetaxabletypecd
      receipturl
      invoicelinetypecd
      invoicecurrencycd
      exchangerate
      comments
      receivedamount
      adjustmentamount
      placeofsupply
      balancedueamount
      reversechargeflag
      tcsapplicableflag
      relatedinvoicelineitems {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        lineitemnumber
        invoicelineitemtype
        itemid
        quantity
        unittypecd
        itemrate
        itemamount
        itemdiscount
        taxableamount
        discounttype
        discountrate
        netamount
        hsnsaccode
        taxability
        lastupdatedby
        statuscode
        statusmessage
        pricetype
        lotid
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gsttypecd
        gstamount
        cessamount
        unit
        uqc
        salesaccountname
        salesaccountid
        itemname
        itemcode
        itemtype
        manualdiscount
        manualcess
        itemmaster_timestamp
        description
        relatedinvoicelinegst {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          gsttypecd
          gstamount
          cessamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemmaster {
          itemid
          itemcode
          companyid
          enteredtimestamp
          expiredtimestamp
          itemname
          salesinvoiceflag
          purchaseinvoiceflag
          itemcategorycd
          measurementcd
          currencycd
          salesaccountid
          purchaseaccountid
          taxabilitycd
          reversechargeflag
          itemtype
          hsnid
          is_active
          statuscode
          statusmessage
          relateditemamountdetails {
            id
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            amount
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstcompensationvalue
            gstrate
            statuscode
            statusmessage
            lastupdatedby
            discounttype
            discountvalue
            invoicetype
            pricetype
            isactive
            isdefault
            pricetypeid
            tabletype
            __typename
          }
          relateditemgstdetails {
            itemid
            companyid
            enteredtimestamp
            expiredtimestamp
            hsnid
            gstcesstype
            gstcompensationvalue
            effectivedate
            expireddate
            gstcessvalue
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemimages {
            attachmentid
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            imagename
            imageurl
            documentname
            type
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          serialnumber
          financialyearid
          description
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          cessexist
          barcode
          __typename
        }
        pricetypeid
        manualgst
        cessrate
        cesstype
        type
        __typename
      }
      relatedinvoicelinenonitems {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        invoicelineitemtype
        incomeaccountid
        hsnsaccode
        taxability
        itemdescription
        taxableamount
        rate
        discount
        netamount
        relatedaccounts {
          accountsid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          accountname
          accounttypecd
          accountgroupid
          hsnsaccode
          displayordernumber
          statuscode
          statusmessage
          restrictedflag
          is_active
          accounttypeflag
          relatedaccountgstdetails {
            accountid
            companyid
            enteredtimestamp
            expiredtimestamp
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstrate
            cessamount
            lastupdatedby
            statuscode
            statusmessage
            hsnsaccode
            codetype
            description
            taxability
            __typename
          }
          relatedaccountopeningbalance {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            financialyearid
            startdate
            creditamount
            debitamount
            statuscode
            statusmessage
            __typename
          }
          relatedaccountgroupmaster {
            accountgroupid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accounttypecd
            accountgroupname
            accountparentgroupid
            displayordernumber
            statuscode
            statusmessage
            is_active
            restrictedflag
            path
            __typename
          }
          relatedaccountbalance {
            accountid
            accountbalance
            actualbalance
            __typename
          }
          path
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gsttypecd
        gstamount
        cessamount
        incomeaccountname
        manualgst
        manualcess
        cessrate
        cesstype
        type
        __typename
      }
      relatedinvoiceattachment {
        invoiceid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        statuscode
        statusmessage
        documentname
        type
        __typename
      }
      relatedinvoicedispatch {
        invoiceid
        dispatchid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transportationcd
        vehiclenumber
        dispatchdate
        ewaybillnumber
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedinvoiceposdetails {
        posid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        partyposid
        lastupdatedby
        relatedposparty {
          pospartyid
          companyid
          partyname
          partycontactnumberid
          lastupdatedby
          enteredtimestamp
          expiredtimestamp
          relatedphonecontacts {
            id
            objecttype
            objectid
            enteredtimestamp
            expiredtimestamp
            countrycode
            phonenumber
            verifieddatetime
            promotionssignup
            smsallowed
            callallowed
            whatsappallowed
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          __typename
        }
        statuscode
        statusmessage
        __typename
      }
      relatedinvoicelinegst {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        gsttypecd
        gstamount
        cessamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedinvoicenumbertracker {
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        nextinvoicenumber
        lastupdatedby
        __typename
      }
      relatedinvoicetransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        vouchernumber
        entrydate
        bankreferencenumber
        comments
        relatedtransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          accountid
          creditamount
          debitamount
          comments
          entryordernumber
          transactionbalance
          openingbalance
          lastupdatedby
          statuscode
          statusmessage
          financialyearid
          __typename
        }
        relatedtransactionattachment {
          transactionid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          documentname
          statuscode
          statusmessage
          type
          __typename
        }
        relatedtransactiontdsdetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          tdsamount
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          tdspercentage
          __typename
        }
        relatedpurchasemaster {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchasegsttypecd
          supplierid
          entrydate
          vouchernumber
          supplierinvoicedate
          supplierinvoicenumber
          supplieraddressid
          paymenttypecd
          paidamount
          creditduration
          paymentaccountid
          comments
          tdsapplicableflag
          granttotalamount
          balancedueamount
          paymentclearedflag
          placeofsupply
          companystate
          relatedpurchasetdsdetails {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            totaltaxableamount
            ineligibletcflag
            reversechargeflag
            gstcesstotal
            tdsamount
            adjustmentamount
            tdssection
            tdspercentage
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaselineitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            itemnumber
            itemid
            purchaseaccountid
            hsncode
            itemquantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            description
            discounttype
            discountrate
            netamount
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            pricetype
            lotid
            hsnid
            hsncodetype
            hsndescription
            gstrate
            gstamount
            cessamount
            unit
            uqc
            purchaseaccountname
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinenonitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchaselineitemtype
            purchaseaccountid
            hsnsaccode
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedpurchaselinenongst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gstamount
            cessamount
            purchaseaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaseattachment {
            purchaseid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedpurchasetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          relatedpurchasetransactionrelation {
            transactionid
            transactiontypecd
            objecttype
            objectid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            linkedamount
            objectattribute
            isdirect
            lastupdatedby
            accountid
            paymentvouchernumber
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          cancelflag
          roundoffamount
          discounttype
          discountvalue
          adjustmentamount
          serialnumber
          currencycode
          currencyrate
          reversechargeflag
          paymentstatus
          partyregistrationtype
          partygstcategory
          itcflag
          __typename
        }
        relatedinvoicemaster {
          invoiceid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicetypecd
          partyid
          paymentaccountid
          invoicedate
          invoicenumber
          customerordernumber
          customerorderdate
          invoiceamount
          paymenttype
          creditduration
          invoicebillingaddressid
          invoicedeliveryaddressid
          invoicetaxabletypecd
          receipturl
          invoicelinetypecd
          invoicecurrencycd
          exchangerate
          comments
          receivedamount
          adjustmentamount
          placeofsupply
          balancedueamount
          reversechargeflag
          tcsapplicableflag
          relatedinvoicelineitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            lineitemnumber
            invoicelineitemtype
            itemid
            quantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            discounttype
            discountrate
            netamount
            hsnsaccode
            taxability
            lastupdatedby
            statuscode
            statusmessage
            pricetype
            lotid
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            unit
            uqc
            salesaccountname
            salesaccountid
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            itemmaster_timestamp
            description
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoicelinenonitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicelineitemtype
            incomeaccountid
            hsnsaccode
            taxability
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedaccounts {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accountname
              accounttypecd
              accountgroupid
              hsnsaccode
              displayordernumber
              statuscode
              statusmessage
              restrictedflag
              is_active
              accounttypeflag
              path
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            incomeaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoiceattachment {
            invoiceid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedinvoicedispatch {
            invoiceid
            dispatchid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transportationcd
            vehiclenumber
            dispatchdate
            ewaybillnumber
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoiceposdetails {
            posid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            partyposid
            lastupdatedby
            relatedposparty {
              pospartyid
              companyid
              partyname
              partycontactnumberid
              lastupdatedby
              enteredtimestamp
              expiredtimestamp
              __typename
            }
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicenumbertracker {
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            nextinvoicenumber
            lastupdatedby
            __typename
          }
          relatedinvoicetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          lastupdatedby
          cancelflag
          statuscode
          statusmessage
          consigneename
          consigneegstin
          companystate
          cancelremark
          deleteremark
          roundoffamount
          discounttype
          discountvalue
          serialnumber
          currencycode
          currencyrate
          paymentstatus
          ackno
          ackdt
          irn
          signedqrcode
          itcflag
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        cancelflag
        cancelremark
        serialnumber
        pdflink
        towards
        isvouchereditable
        __typename
      }
      lastupdatedby
      cancelflag
      statuscode
      statusmessage
      consigneename
      consigneegstin
      companystate
      cancelremark
      deleteremark
      roundoffamount
      discounttype
      discountvalue
      serialnumber
      currencycode
      currencyrate
      paymentstatus
      ackno
      ackdt
      irn
      signedqrcode
      itcflag
      __typename
    }
    lastupdatedby
    statuscode
    statusmessage
    cancelflag
    cancelremark
    serialnumber
    pdflink
    towards
    isvouchereditable
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTransactionMasterQueryVariables,
  APITypes.ListTransactionMasterQuery
>;
export const listTransactionManualJournal = /* GraphQL */ `query ListTransactionManualJournal {
  listTransactionManualJournal {
    transactionid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    transactiontypecd
    vouchernumber
    entrydate
    bankreferencenumber
    comments
    relatedtransactiondetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      accountid
      creditamount
      debitamount
      comments
      entryordernumber
      transactionbalance
      openingbalance
      lastupdatedby
      statuscode
      statusmessage
      financialyearid
      __typename
    }
    relatedtransactionattachment {
      transactionid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      lastupdatedby
      documentname
      statuscode
      statusmessage
      type
      __typename
    }
    relatedtransactiontdsdetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tdsapplicablecd
      tdsamount
      tdsmanual
      lastupdatedby
      statuscode
      statusmessage
      tdspercentage
      __typename
    }
    relatedpurchasemaster {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      purchasegsttypecd
      supplierid
      entrydate
      vouchernumber
      supplierinvoicedate
      supplierinvoicenumber
      supplieraddressid
      paymenttypecd
      paidamount
      creditduration
      paymentaccountid
      comments
      tdsapplicableflag
      granttotalamount
      balancedueamount
      paymentclearedflag
      placeofsupply
      companystate
      relatedpurchasetdsdetails {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tdsapplicablecd
        totaltaxableamount
        ineligibletcflag
        reversechargeflag
        gstcesstotal
        tdsamount
        adjustmentamount
        tdssection
        tdspercentage
        tdsmanual
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpurchaselineitems {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        itemnumber
        itemid
        purchaseaccountid
        hsncode
        itemquantity
        unittypecd
        itemrate
        itemamount
        itemdiscount
        taxableamount
        description
        discounttype
        discountrate
        netamount
        relatedpurchaselinegst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemmaster {
          itemid
          itemcode
          companyid
          enteredtimestamp
          expiredtimestamp
          itemname
          salesinvoiceflag
          purchaseinvoiceflag
          itemcategorycd
          measurementcd
          currencycd
          salesaccountid
          purchaseaccountid
          taxabilitycd
          reversechargeflag
          itemtype
          hsnid
          is_active
          statuscode
          statusmessage
          relateditemamountdetails {
            id
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            amount
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstcompensationvalue
            gstrate
            statuscode
            statusmessage
            lastupdatedby
            discounttype
            discountvalue
            invoicetype
            pricetype
            isactive
            isdefault
            pricetypeid
            tabletype
            __typename
          }
          relateditemgstdetails {
            itemid
            companyid
            enteredtimestamp
            expiredtimestamp
            hsnid
            gstcesstype
            gstcompensationvalue
            effectivedate
            expireddate
            gstcessvalue
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemimages {
            attachmentid
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            imagename
            imageurl
            documentname
            type
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          serialnumber
          financialyearid
          description
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          cessexist
          barcode
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        taxability
        pricetype
        lotid
        hsnid
        hsncodetype
        hsndescription
        gstrate
        gstamount
        cessamount
        unit
        uqc
        purchaseaccountname
        itemname
        itemcode
        itemtype
        manualdiscount
        manualcess
        pricetypeid
        manualgst
        cessrate
        cesstype
        type
        __typename
      }
      relatedpurchaselinenonitems {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        purchaselineitemtype
        purchaseaccountid
        hsnsaccode
        itemdescription
        taxableamount
        rate
        discount
        netamount
        relatedpurchaselinenongst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        taxability
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gstamount
        cessamount
        purchaseaccountname
        manualgst
        manualcess
        cessrate
        cesstype
        type
        __typename
      }
      relatedpurchaselinegst {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        cessamount
        gstamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpurchaseattachment {
        purchaseid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        statuscode
        statusmessage
        documentname
        type
        __typename
      }
      relatedpurchasetransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        vouchernumber
        entrydate
        bankreferencenumber
        comments
        relatedtransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          accountid
          creditamount
          debitamount
          comments
          entryordernumber
          transactionbalance
          openingbalance
          lastupdatedby
          statuscode
          statusmessage
          financialyearid
          __typename
        }
        relatedtransactionattachment {
          transactionid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          documentname
          statuscode
          statusmessage
          type
          __typename
        }
        relatedtransactiontdsdetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          tdsamount
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          tdspercentage
          __typename
        }
        relatedpurchasemaster {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchasegsttypecd
          supplierid
          entrydate
          vouchernumber
          supplierinvoicedate
          supplierinvoicenumber
          supplieraddressid
          paymenttypecd
          paidamount
          creditduration
          paymentaccountid
          comments
          tdsapplicableflag
          granttotalamount
          balancedueamount
          paymentclearedflag
          placeofsupply
          companystate
          relatedpurchasetdsdetails {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            totaltaxableamount
            ineligibletcflag
            reversechargeflag
            gstcesstotal
            tdsamount
            adjustmentamount
            tdssection
            tdspercentage
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaselineitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            itemnumber
            itemid
            purchaseaccountid
            hsncode
            itemquantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            description
            discounttype
            discountrate
            netamount
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            pricetype
            lotid
            hsnid
            hsncodetype
            hsndescription
            gstrate
            gstamount
            cessamount
            unit
            uqc
            purchaseaccountname
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinenonitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchaselineitemtype
            purchaseaccountid
            hsnsaccode
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedpurchaselinenongst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gstamount
            cessamount
            purchaseaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaseattachment {
            purchaseid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedpurchasetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          relatedpurchasetransactionrelation {
            transactionid
            transactiontypecd
            objecttype
            objectid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            linkedamount
            objectattribute
            isdirect
            lastupdatedby
            accountid
            paymentvouchernumber
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          cancelflag
          roundoffamount
          discounttype
          discountvalue
          adjustmentamount
          serialnumber
          currencycode
          currencyrate
          reversechargeflag
          paymentstatus
          partyregistrationtype
          partygstcategory
          itcflag
          __typename
        }
        relatedinvoicemaster {
          invoiceid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicetypecd
          partyid
          paymentaccountid
          invoicedate
          invoicenumber
          customerordernumber
          customerorderdate
          invoiceamount
          paymenttype
          creditduration
          invoicebillingaddressid
          invoicedeliveryaddressid
          invoicetaxabletypecd
          receipturl
          invoicelinetypecd
          invoicecurrencycd
          exchangerate
          comments
          receivedamount
          adjustmentamount
          placeofsupply
          balancedueamount
          reversechargeflag
          tcsapplicableflag
          relatedinvoicelineitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            lineitemnumber
            invoicelineitemtype
            itemid
            quantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            discounttype
            discountrate
            netamount
            hsnsaccode
            taxability
            lastupdatedby
            statuscode
            statusmessage
            pricetype
            lotid
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            unit
            uqc
            salesaccountname
            salesaccountid
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            itemmaster_timestamp
            description
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoicelinenonitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicelineitemtype
            incomeaccountid
            hsnsaccode
            taxability
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedaccounts {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accountname
              accounttypecd
              accountgroupid
              hsnsaccode
              displayordernumber
              statuscode
              statusmessage
              restrictedflag
              is_active
              accounttypeflag
              path
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            incomeaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoiceattachment {
            invoiceid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedinvoicedispatch {
            invoiceid
            dispatchid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transportationcd
            vehiclenumber
            dispatchdate
            ewaybillnumber
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoiceposdetails {
            posid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            partyposid
            lastupdatedby
            relatedposparty {
              pospartyid
              companyid
              partyname
              partycontactnumberid
              lastupdatedby
              enteredtimestamp
              expiredtimestamp
              __typename
            }
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicenumbertracker {
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            nextinvoicenumber
            lastupdatedby
            __typename
          }
          relatedinvoicetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          lastupdatedby
          cancelflag
          statuscode
          statusmessage
          consigneename
          consigneegstin
          companystate
          cancelremark
          deleteremark
          roundoffamount
          discounttype
          discountvalue
          serialnumber
          currencycode
          currencyrate
          paymentstatus
          ackno
          ackdt
          irn
          signedqrcode
          itcflag
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        cancelflag
        cancelremark
        serialnumber
        pdflink
        towards
        isvouchereditable
        __typename
      }
      relatedpurchasetransactionrelation {
        transactionid
        transactiontypecd
        objecttype
        objectid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        linkedamount
        objectattribute
        isdirect
        lastupdatedby
        accountid
        paymentvouchernumber
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      cancelflag
      roundoffamount
      discounttype
      discountvalue
      adjustmentamount
      serialnumber
      currencycode
      currencyrate
      reversechargeflag
      paymentstatus
      partyregistrationtype
      partygstcategory
      itcflag
      __typename
    }
    relatedinvoicemaster {
      invoiceid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoicetypecd
      partyid
      paymentaccountid
      invoicedate
      invoicenumber
      customerordernumber
      customerorderdate
      invoiceamount
      paymenttype
      creditduration
      invoicebillingaddressid
      invoicedeliveryaddressid
      invoicetaxabletypecd
      receipturl
      invoicelinetypecd
      invoicecurrencycd
      exchangerate
      comments
      receivedamount
      adjustmentamount
      placeofsupply
      balancedueamount
      reversechargeflag
      tcsapplicableflag
      relatedinvoicelineitems {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        lineitemnumber
        invoicelineitemtype
        itemid
        quantity
        unittypecd
        itemrate
        itemamount
        itemdiscount
        taxableamount
        discounttype
        discountrate
        netamount
        hsnsaccode
        taxability
        lastupdatedby
        statuscode
        statusmessage
        pricetype
        lotid
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gsttypecd
        gstamount
        cessamount
        unit
        uqc
        salesaccountname
        salesaccountid
        itemname
        itemcode
        itemtype
        manualdiscount
        manualcess
        itemmaster_timestamp
        description
        relatedinvoicelinegst {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          gsttypecd
          gstamount
          cessamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemmaster {
          itemid
          itemcode
          companyid
          enteredtimestamp
          expiredtimestamp
          itemname
          salesinvoiceflag
          purchaseinvoiceflag
          itemcategorycd
          measurementcd
          currencycd
          salesaccountid
          purchaseaccountid
          taxabilitycd
          reversechargeflag
          itemtype
          hsnid
          is_active
          statuscode
          statusmessage
          relateditemamountdetails {
            id
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            amount
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstcompensationvalue
            gstrate
            statuscode
            statusmessage
            lastupdatedby
            discounttype
            discountvalue
            invoicetype
            pricetype
            isactive
            isdefault
            pricetypeid
            tabletype
            __typename
          }
          relateditemgstdetails {
            itemid
            companyid
            enteredtimestamp
            expiredtimestamp
            hsnid
            gstcesstype
            gstcompensationvalue
            effectivedate
            expireddate
            gstcessvalue
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemimages {
            attachmentid
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            imagename
            imageurl
            documentname
            type
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          serialnumber
          financialyearid
          description
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          cessexist
          barcode
          __typename
        }
        pricetypeid
        manualgst
        cessrate
        cesstype
        type
        __typename
      }
      relatedinvoicelinenonitems {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        invoicelineitemtype
        incomeaccountid
        hsnsaccode
        taxability
        itemdescription
        taxableamount
        rate
        discount
        netamount
        relatedaccounts {
          accountsid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          accountname
          accounttypecd
          accountgroupid
          hsnsaccode
          displayordernumber
          statuscode
          statusmessage
          restrictedflag
          is_active
          accounttypeflag
          relatedaccountgstdetails {
            accountid
            companyid
            enteredtimestamp
            expiredtimestamp
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstrate
            cessamount
            lastupdatedby
            statuscode
            statusmessage
            hsnsaccode
            codetype
            description
            taxability
            __typename
          }
          relatedaccountopeningbalance {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            financialyearid
            startdate
            creditamount
            debitamount
            statuscode
            statusmessage
            __typename
          }
          relatedaccountgroupmaster {
            accountgroupid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accounttypecd
            accountgroupname
            accountparentgroupid
            displayordernumber
            statuscode
            statusmessage
            is_active
            restrictedflag
            path
            __typename
          }
          relatedaccountbalance {
            accountid
            accountbalance
            actualbalance
            __typename
          }
          path
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gsttypecd
        gstamount
        cessamount
        incomeaccountname
        manualgst
        manualcess
        cessrate
        cesstype
        type
        __typename
      }
      relatedinvoiceattachment {
        invoiceid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        statuscode
        statusmessage
        documentname
        type
        __typename
      }
      relatedinvoicedispatch {
        invoiceid
        dispatchid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transportationcd
        vehiclenumber
        dispatchdate
        ewaybillnumber
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedinvoiceposdetails {
        posid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        partyposid
        lastupdatedby
        relatedposparty {
          pospartyid
          companyid
          partyname
          partycontactnumberid
          lastupdatedby
          enteredtimestamp
          expiredtimestamp
          relatedphonecontacts {
            id
            objecttype
            objectid
            enteredtimestamp
            expiredtimestamp
            countrycode
            phonenumber
            verifieddatetime
            promotionssignup
            smsallowed
            callallowed
            whatsappallowed
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          __typename
        }
        statuscode
        statusmessage
        __typename
      }
      relatedinvoicelinegst {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        gsttypecd
        gstamount
        cessamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedinvoicenumbertracker {
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        nextinvoicenumber
        lastupdatedby
        __typename
      }
      relatedinvoicetransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        vouchernumber
        entrydate
        bankreferencenumber
        comments
        relatedtransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          accountid
          creditamount
          debitamount
          comments
          entryordernumber
          transactionbalance
          openingbalance
          lastupdatedby
          statuscode
          statusmessage
          financialyearid
          __typename
        }
        relatedtransactionattachment {
          transactionid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          documentname
          statuscode
          statusmessage
          type
          __typename
        }
        relatedtransactiontdsdetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          tdsamount
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          tdspercentage
          __typename
        }
        relatedpurchasemaster {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchasegsttypecd
          supplierid
          entrydate
          vouchernumber
          supplierinvoicedate
          supplierinvoicenumber
          supplieraddressid
          paymenttypecd
          paidamount
          creditduration
          paymentaccountid
          comments
          tdsapplicableflag
          granttotalamount
          balancedueamount
          paymentclearedflag
          placeofsupply
          companystate
          relatedpurchasetdsdetails {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            totaltaxableamount
            ineligibletcflag
            reversechargeflag
            gstcesstotal
            tdsamount
            adjustmentamount
            tdssection
            tdspercentage
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaselineitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            itemnumber
            itemid
            purchaseaccountid
            hsncode
            itemquantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            description
            discounttype
            discountrate
            netamount
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            pricetype
            lotid
            hsnid
            hsncodetype
            hsndescription
            gstrate
            gstamount
            cessamount
            unit
            uqc
            purchaseaccountname
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinenonitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchaselineitemtype
            purchaseaccountid
            hsnsaccode
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedpurchaselinenongst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gstamount
            cessamount
            purchaseaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaseattachment {
            purchaseid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedpurchasetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          relatedpurchasetransactionrelation {
            transactionid
            transactiontypecd
            objecttype
            objectid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            linkedamount
            objectattribute
            isdirect
            lastupdatedby
            accountid
            paymentvouchernumber
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          cancelflag
          roundoffamount
          discounttype
          discountvalue
          adjustmentamount
          serialnumber
          currencycode
          currencyrate
          reversechargeflag
          paymentstatus
          partyregistrationtype
          partygstcategory
          itcflag
          __typename
        }
        relatedinvoicemaster {
          invoiceid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicetypecd
          partyid
          paymentaccountid
          invoicedate
          invoicenumber
          customerordernumber
          customerorderdate
          invoiceamount
          paymenttype
          creditduration
          invoicebillingaddressid
          invoicedeliveryaddressid
          invoicetaxabletypecd
          receipturl
          invoicelinetypecd
          invoicecurrencycd
          exchangerate
          comments
          receivedamount
          adjustmentamount
          placeofsupply
          balancedueamount
          reversechargeflag
          tcsapplicableflag
          relatedinvoicelineitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            lineitemnumber
            invoicelineitemtype
            itemid
            quantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            discounttype
            discountrate
            netamount
            hsnsaccode
            taxability
            lastupdatedby
            statuscode
            statusmessage
            pricetype
            lotid
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            unit
            uqc
            salesaccountname
            salesaccountid
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            itemmaster_timestamp
            description
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoicelinenonitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicelineitemtype
            incomeaccountid
            hsnsaccode
            taxability
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedaccounts {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accountname
              accounttypecd
              accountgroupid
              hsnsaccode
              displayordernumber
              statuscode
              statusmessage
              restrictedflag
              is_active
              accounttypeflag
              path
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            incomeaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoiceattachment {
            invoiceid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedinvoicedispatch {
            invoiceid
            dispatchid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transportationcd
            vehiclenumber
            dispatchdate
            ewaybillnumber
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoiceposdetails {
            posid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            partyposid
            lastupdatedby
            relatedposparty {
              pospartyid
              companyid
              partyname
              partycontactnumberid
              lastupdatedby
              enteredtimestamp
              expiredtimestamp
              __typename
            }
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicenumbertracker {
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            nextinvoicenumber
            lastupdatedby
            __typename
          }
          relatedinvoicetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          lastupdatedby
          cancelflag
          statuscode
          statusmessage
          consigneename
          consigneegstin
          companystate
          cancelremark
          deleteremark
          roundoffamount
          discounttype
          discountvalue
          serialnumber
          currencycode
          currencyrate
          paymentstatus
          ackno
          ackdt
          irn
          signedqrcode
          itcflag
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        cancelflag
        cancelremark
        serialnumber
        pdflink
        towards
        isvouchereditable
        __typename
      }
      lastupdatedby
      cancelflag
      statuscode
      statusmessage
      consigneename
      consigneegstin
      companystate
      cancelremark
      deleteremark
      roundoffamount
      discounttype
      discountvalue
      serialnumber
      currencycode
      currencyrate
      paymentstatus
      ackno
      ackdt
      irn
      signedqrcode
      itcflag
      __typename
    }
    lastupdatedby
    statuscode
    statusmessage
    cancelflag
    cancelremark
    serialnumber
    pdflink
    towards
    isvouchereditable
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTransactionManualJournalQueryVariables,
  APITypes.ListTransactionManualJournalQuery
>;
export const getItemImages = /* GraphQL */ `query GetItemImages($itemid: Int!) {
  getItemImages(itemid: $itemid) {
    attachmentid
    itemid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    imagename
    imageurl
    documentname
    type
    lastupdatedby
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetItemImagesQueryVariables,
  APITypes.GetItemImagesQuery
>;
export const getItemmaster = /* GraphQL */ `query GetItemmaster($itemid: Int!) {
  getItemmaster(itemid: $itemid) {
    itemid
    itemcode
    companyid
    enteredtimestamp
    expiredtimestamp
    itemname
    salesinvoiceflag
    purchaseinvoiceflag
    itemcategorycd
    measurementcd
    currencycd
    salesaccountid
    purchaseaccountid
    taxabilitycd
    reversechargeflag
    itemtype
    hsnid
    is_active
    statuscode
    statusmessage
    relateditemamountdetails {
      id
      itemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      amount
      effectivedate
      expireddate
      hsnid
      gstcompensationtype
      gstcompensationvalue
      gstrate
      statuscode
      statusmessage
      lastupdatedby
      discounttype
      discountvalue
      invoicetype
      pricetype
      isactive
      isdefault
      pricetypeid
      tabletype
      __typename
    }
    relateditemgstdetails {
      itemid
      companyid
      enteredtimestamp
      expiredtimestamp
      hsnid
      gstcesstype
      gstcompensationvalue
      effectivedate
      expireddate
      gstcessvalue
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relateditemimages {
      attachmentid
      itemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      imagename
      imageurl
      documentname
      type
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    lastupdatedby
    serialnumber
    financialyearid
    description
    hsnsacid
    hsncodetype
    hsncodevalue
    hsndescription
    cessexist
    barcode
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetItemmasterQueryVariables,
  APITypes.GetItemmasterQuery
>;
export const getbarcodeitemdata = /* GraphQL */ `query Getbarcodeitemdata($barcode: String!, $itemin: String) {
  getbarcodeitemdata(barcode: $barcode, itemin: $itemin) {
    itemid
    itemcode
    companyid
    enteredtimestamp
    expiredtimestamp
    itemname
    salesinvoiceflag
    purchaseinvoiceflag
    itemcategorycd
    measurementcd
    currencycd
    salesaccountid
    purchaseaccountid
    taxabilitycd
    reversechargeflag
    itemtype
    hsnid
    is_active
    statuscode
    statusmessage
    relateditemamountdetails {
      id
      itemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      amount
      effectivedate
      expireddate
      hsnid
      gstcompensationtype
      gstcompensationvalue
      gstrate
      statuscode
      statusmessage
      lastupdatedby
      discounttype
      discountvalue
      invoicetype
      pricetype
      isactive
      isdefault
      pricetypeid
      tabletype
      __typename
    }
    relateditemgstdetails {
      itemid
      companyid
      enteredtimestamp
      expiredtimestamp
      hsnid
      gstcesstype
      gstcompensationvalue
      effectivedate
      expireddate
      gstcessvalue
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relateditemimages {
      attachmentid
      itemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      imagename
      imageurl
      documentname
      type
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    lastupdatedby
    serialnumber
    financialyearid
    description
    hsnsacid
    hsncodetype
    hsncodevalue
    hsndescription
    cessexist
    barcode
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetbarcodeitemdataQueryVariables,
  APITypes.GetbarcodeitemdataQuery
>;
export const getLinkedReceipts = /* GraphQL */ `query GetLinkedReceipts($vouchernumber: String!, $accountid: Int) {
  getLinkedReceipts(vouchernumber: $vouchernumber, accountid: $accountid) {
    transactionid
    transactiontypecd
    objecttype
    objectid
    companyid
    companybranchid
    enteredtimestamp
    linkedamount
    invoicenumber
    invoicedate
    receiptvouchernumber
    grandtotalamount
    balancedueamount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLinkedReceiptsQueryVariables,
  APITypes.GetLinkedReceiptsQuery
>;
export const getLocation = /* GraphQL */ `query GetLocation($pincode: String!) {
  getLocation(pincode: $pincode) {
    pincode
    state
    district
    city
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLocationQueryVariables,
  APITypes.GetLocationQuery
>;
export const getPartyAddressEntity = /* GraphQL */ `query GetPartyAddressEntity($objecttype: String!, $objectid: String!) {
  getPartyAddressEntity(objecttype: $objecttype, objectid: $objectid) {
    id
    objecttype
    objectid
    enteredtimestamp
    expiredtimestamp
    line1
    line2
    line3
    city
    statecode
    statename
    statuscode
    statusmessage
    pincode
    countrycode
    codevalue
    district
    lastupdatedby
    godownname
    gstin
    phone
    email
    personincharge
    consigneename
    consigneegstin
    foreignstate
    foreigndistrict
    defaultflag
    addresstitle
    addressindex
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPartyAddressEntityQueryVariables,
  APITypes.GetPartyAddressEntityQuery
>;
export const getPartyMaster = /* GraphQL */ `query GetPartyMaster($partyid: Int!) {
  getPartyMaster(partyid: $partyid) {
    partyid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    partytypecd
    partydisplayname
    partylegalname
    groupaccountid
    gstcategory
    placeofsupply
    entity
    email
    contactnumber
    whatsappnumber
    accountsid
    is_active
    msmetype
    deliveryconsigneename
    deliveryconsigneegstin
    statuscode
    statusmessage
    relatedpartygstdetails {
      partyid
      enteredtimestamp
      expiredtimestamp
      pannumber
      gstin
      partyaddressid
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpartycreditdetails {
      partyid
      enteredtimestamp
      expiredtimestamp
      creditperiodduration
      billingcurrency
      creditlimitcd
      creditlimitamount
      billwiseflag
      notes
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpartycontact {
      partyid
      enteredtimestamp
      expiredtimestamp
      contacttypename
      contactdesignationname
      contactorder
      email
      phonenumber
      whatsappnumber
      lastupdatedby
      statuscode
      statusmessage
      contactcountry
      whatsappcountry
      __typename
    }
    relatedpartyimages {
      attachmentid
      partyid
      companyid
      enteredtimestamp
      expiredtimestamp
      type
      documentname
      imagename
      imageurl
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    lastupdatedby
    tdspercentage
    udhyamregno
    sameaddressflag
    comments
    tdssection
    accountname
    deliverystatecode
    deliverystatename
    contactcountry
    whatsappcountry
    entityname
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPartyMasterQueryVariables,
  APITypes.GetPartyMasterQuery
>;
export const getPartyMasterAccountWise = /* GraphQL */ `query GetPartyMasterAccountWise($accountsid: Int!) {
  getPartyMasterAccountWise(accountsid: $accountsid) {
    partyid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    partytypecd
    partydisplayname
    partylegalname
    groupaccountid
    gstcategory
    placeofsupply
    entity
    email
    contactnumber
    whatsappnumber
    accountsid
    is_active
    msmetype
    deliveryconsigneename
    deliveryconsigneegstin
    statuscode
    statusmessage
    relatedpartygstdetails {
      partyid
      enteredtimestamp
      expiredtimestamp
      pannumber
      gstin
      partyaddressid
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpartycreditdetails {
      partyid
      enteredtimestamp
      expiredtimestamp
      creditperiodduration
      billingcurrency
      creditlimitcd
      creditlimitamount
      billwiseflag
      notes
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpartycontact {
      partyid
      enteredtimestamp
      expiredtimestamp
      contacttypename
      contactdesignationname
      contactorder
      email
      phonenumber
      whatsappnumber
      lastupdatedby
      statuscode
      statusmessage
      contactcountry
      whatsappcountry
      __typename
    }
    relatedpartyimages {
      attachmentid
      partyid
      companyid
      enteredtimestamp
      expiredtimestamp
      type
      documentname
      imagename
      imageurl
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    lastupdatedby
    tdspercentage
    udhyamregno
    sameaddressflag
    comments
    tdssection
    accountname
    deliverystatecode
    deliverystatename
    contactcountry
    whatsappcountry
    entityname
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPartyMasterAccountWiseQueryVariables,
  APITypes.GetPartyMasterAccountWiseQuery
>;
export const getPaymentSettings = /* GraphQL */ `query GetPaymentSettings {
  getPaymentSettings {
    enable_itemwiseentry
    enable_creditperiod
    enable_creditlimit
    enable_autopayreminder
    enable_autoreminderdays
    companyid
    enteredtimestamp
    expiredtimestamp
    lastupdatedby
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPaymentSettingsQueryVariables,
  APITypes.GetPaymentSettingsQuery
>;
export const getPhoneContacts = /* GraphQL */ `query GetPhoneContacts($id: Int!) {
  getPhoneContacts(id: $id) {
    id
    objecttype
    objectid
    enteredtimestamp
    expiredtimestamp
    countrycode
    phonenumber
    verifieddatetime
    promotionssignup
    smsallowed
    callallowed
    whatsappallowed
    lastupdatedby
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPhoneContactsQueryVariables,
  APITypes.GetPhoneContactsQuery
>;
export const getPurchaseMaster = /* GraphQL */ `query GetPurchaseMaster($purchaseid: Int!) {
  getPurchaseMaster(purchaseid: $purchaseid) {
    purchaseid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    purchasegsttypecd
    supplierid
    entrydate
    vouchernumber
    supplierinvoicedate
    supplierinvoicenumber
    supplieraddressid
    paymenttypecd
    paidamount
    creditduration
    paymentaccountid
    comments
    tdsapplicableflag
    granttotalamount
    balancedueamount
    paymentclearedflag
    placeofsupply
    companystate
    relatedpurchasetdsdetails {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tdsapplicablecd
      totaltaxableamount
      ineligibletcflag
      reversechargeflag
      gstcesstotal
      tdsamount
      adjustmentamount
      tdssection
      tdspercentage
      tdsmanual
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpurchasetcsdetails {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tcsapplicablecd
      totaltaxableamount
      ineligibletcflag
      reversechargeflag
      gstcesstotal
      tcsamount
      adjustmentamount
      tcssection
      lastupdatedby
      statuscode
      statusmessage
      tcspercentage
      tcsmanual
      __typename
    }
    relatedpurchaselineitems {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      itemnumber
      itemid
      purchaseaccountid
      hsncode
      itemquantity
      unittypecd
      itemrate
      itemamount
      itemdiscount
      taxableamount
      description
      discounttype
      discountrate
      netamount
      relatedpurchaselinegst {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        cessamount
        gstamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relateditemmaster {
        itemid
        itemcode
        companyid
        enteredtimestamp
        expiredtimestamp
        itemname
        salesinvoiceflag
        purchaseinvoiceflag
        itemcategorycd
        measurementcd
        currencycd
        salesaccountid
        purchaseaccountid
        taxabilitycd
        reversechargeflag
        itemtype
        hsnid
        is_active
        statuscode
        statusmessage
        relateditemamountdetails {
          id
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          amount
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstcompensationvalue
          gstrate
          statuscode
          statusmessage
          lastupdatedby
          discounttype
          discountvalue
          invoicetype
          pricetype
          isactive
          isdefault
          pricetypeid
          tabletype
          __typename
        }
        relateditemgstdetails {
          itemid
          companyid
          enteredtimestamp
          expiredtimestamp
          hsnid
          gstcesstype
          gstcompensationvalue
          effectivedate
          expireddate
          gstcessvalue
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemimages {
          attachmentid
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          imagename
          imageurl
          documentname
          type
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        serialnumber
        financialyearid
        description
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        cessexist
        barcode
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      taxability
      pricetype
      lotid
      hsnid
      hsncodetype
      hsndescription
      gstrate
      gstamount
      cessamount
      unit
      uqc
      purchaseaccountname
      itemname
      itemcode
      itemtype
      manualdiscount
      manualcess
      pricetypeid
      manualgst
      cessrate
      cesstype
      type
      __typename
    }
    relatedpurchaselinenonitems {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      purchaselineitemtype
      purchaseaccountid
      hsnsaccode
      itemdescription
      taxableamount
      rate
      discount
      netamount
      relatedpurchaselinenongst {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        cessamount
        gstamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      taxability
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      gstrate
      gstamount
      cessamount
      purchaseaccountname
      manualgst
      manualcess
      cessrate
      cesstype
      type
      __typename
    }
    relatedpurchaselinegst {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      cessamount
      gstamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpurchaselinenongst {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      cessamount
      gstamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpurchaseattachment {
      purchaseid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      lastupdatedby
      statuscode
      statusmessage
      documentname
      type
      __typename
    }
    relatedpurchasetransactiondetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      vouchernumber
      entrydate
      bankreferencenumber
      comments
      relatedtransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        accountid
        creditamount
        debitamount
        comments
        entryordernumber
        transactionbalance
        openingbalance
        lastupdatedby
        statuscode
        statusmessage
        financialyearid
        __typename
      }
      relatedtransactionattachment {
        transactionid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        documentname
        statuscode
        statusmessage
        type
        __typename
      }
      relatedtransactiontdsdetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tdsapplicablecd
        tdsamount
        tdsmanual
        lastupdatedby
        statuscode
        statusmessage
        tdspercentage
        __typename
      }
      relatedpurchasemaster {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        purchasegsttypecd
        supplierid
        entrydate
        vouchernumber
        supplierinvoicedate
        supplierinvoicenumber
        supplieraddressid
        paymenttypecd
        paidamount
        creditduration
        paymentaccountid
        comments
        tdsapplicableflag
        granttotalamount
        balancedueamount
        paymentclearedflag
        placeofsupply
        companystate
        relatedpurchasetdsdetails {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          totaltaxableamount
          ineligibletcflag
          reversechargeflag
          gstcesstotal
          tdsamount
          adjustmentamount
          tdssection
          tdspercentage
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaselineitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          itemnumber
          itemid
          purchaseaccountid
          hsncode
          itemquantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          taxableamount
          description
          discounttype
          discountrate
          netamount
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          pricetype
          lotid
          hsnid
          hsncodetype
          hsndescription
          gstrate
          gstamount
          cessamount
          unit
          uqc
          purchaseaccountname
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          pricetypeid
          manualgst
          cessrate
          cesstype
          type
          __typename
        }
        relatedpurchaselinenonitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchaselineitemtype
          purchaseaccountid
          hsnsaccode
          itemdescription
          taxableamount
          rate
          discount
          netamount
          relatedpurchaselinenongst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gstamount
          cessamount
          purchaseaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          type
          __typename
        }
        relatedpurchaselinegst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaseattachment {
          purchaseid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedpurchasetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              description
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              description
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        relatedpurchasetransactionrelation {
          transactionid
          transactiontypecd
          objecttype
          objectid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          linkedamount
          objectattribute
          isdirect
          lastupdatedby
          accountid
          paymentvouchernumber
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        cancelflag
        roundoffamount
        discounttype
        discountvalue
        adjustmentamount
        serialnumber
        currencycode
        currencyrate
        reversechargeflag
        paymentstatus
        partyregistrationtype
        partygstcategory
        itcflag
        __typename
      }
      relatedinvoicemaster {
        invoiceid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        invoicetypecd
        partyid
        paymentaccountid
        invoicedate
        invoicenumber
        customerordernumber
        customerorderdate
        invoiceamount
        paymenttype
        creditduration
        invoicebillingaddressid
        invoicedeliveryaddressid
        invoicetaxabletypecd
        receipturl
        invoicelinetypecd
        invoicecurrencycd
        exchangerate
        comments
        receivedamount
        adjustmentamount
        placeofsupply
        balancedueamount
        reversechargeflag
        tcsapplicableflag
        relatedinvoicelineitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          lineitemnumber
          invoicelineitemtype
          itemid
          quantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          taxableamount
          discounttype
          discountrate
          netamount
          hsnsaccode
          taxability
          lastupdatedby
          statuscode
          statusmessage
          pricetype
          lotid
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          unit
          uqc
          salesaccountname
          salesaccountid
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          itemmaster_timestamp
          description
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          pricetypeid
          manualgst
          cessrate
          cesstype
          type
          __typename
        }
        relatedinvoicelinenonitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicelineitemtype
          incomeaccountid
          hsnsaccode
          taxability
          itemdescription
          taxableamount
          rate
          discount
          netamount
          relatedaccounts {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accountname
            accounttypecd
            accountgroupid
            hsnsaccode
            displayordernumber
            statuscode
            statusmessage
            restrictedflag
            is_active
            accounttypeflag
            relatedaccountgstdetails {
              accountid
              companyid
              enteredtimestamp
              expiredtimestamp
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstrate
              cessamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsaccode
              codetype
              description
              taxability
              __typename
            }
            relatedaccountopeningbalance {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              financialyearid
              startdate
              creditamount
              debitamount
              statuscode
              statusmessage
              __typename
            }
            relatedaccountgroupmaster {
              accountgroupid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accounttypecd
              accountgroupname
              accountparentgroupid
              displayordernumber
              statuscode
              statusmessage
              is_active
              restrictedflag
              path
              __typename
            }
            relatedaccountbalance {
              accountid
              accountbalance
              actualbalance
              __typename
            }
            path
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          incomeaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          type
          __typename
        }
        relatedinvoiceattachment {
          invoiceid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedinvoicedispatch {
          invoiceid
          dispatchid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transportationcd
          vehiclenumber
          dispatchdate
          ewaybillnumber
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoiceposdetails {
          posid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          partyposid
          lastupdatedby
          relatedposparty {
            pospartyid
            companyid
            partyname
            partycontactnumberid
            lastupdatedby
            enteredtimestamp
            expiredtimestamp
            relatedphonecontacts {
              id
              objecttype
              objectid
              enteredtimestamp
              expiredtimestamp
              countrycode
              phonenumber
              verifieddatetime
              promotionssignup
              smsallowed
              callallowed
              whatsappallowed
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            __typename
          }
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicelinegst {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          gsttypecd
          gstamount
          cessamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicenumbertracker {
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          nextinvoicenumber
          lastupdatedby
          __typename
        }
        relatedinvoicetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              description
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              description
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        lastupdatedby
        cancelflag
        statuscode
        statusmessage
        consigneename
        consigneegstin
        companystate
        cancelremark
        deleteremark
        roundoffamount
        discounttype
        discountvalue
        serialnumber
        currencycode
        currencyrate
        paymentstatus
        ackno
        ackdt
        irn
        signedqrcode
        itcflag
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      cancelflag
      cancelremark
      serialnumber
      pdflink
      towards
      isvouchereditable
      __typename
    }
    relatedpartymaster {
      partyid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      partytypecd
      partydisplayname
      partylegalname
      groupaccountid
      gstcategory
      placeofsupply
      entity
      email
      contactnumber
      whatsappnumber
      accountsid
      is_active
      msmetype
      deliveryconsigneename
      deliveryconsigneegstin
      statuscode
      statusmessage
      relatedpartygstdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        pannumber
        gstin
        partyaddressid
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycreditdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        creditperiodduration
        billingcurrency
        creditlimitcd
        creditlimitamount
        billwiseflag
        notes
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycontact {
        partyid
        enteredtimestamp
        expiredtimestamp
        contacttypename
        contactdesignationname
        contactorder
        email
        phonenumber
        whatsappnumber
        lastupdatedby
        statuscode
        statusmessage
        contactcountry
        whatsappcountry
        __typename
      }
      relatedpartyimages {
        attachmentid
        partyid
        companyid
        enteredtimestamp
        expiredtimestamp
        type
        documentname
        imagename
        imageurl
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      tdspercentage
      udhyamregno
      sameaddressflag
      comments
      tdssection
      accountname
      deliverystatecode
      deliverystatename
      contactcountry
      whatsappcountry
      entityname
      __typename
    }
    relatedpartyaddressdetails {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      line1
      line2
      line3
      city
      statecode
      statename
      statuscode
      statusmessage
      pincode
      countrycode
      codevalue
      district
      lastupdatedby
      godownname
      gstin
      phone
      email
      personincharge
      consigneename
      consigneegstin
      foreignstate
      foreigndistrict
      defaultflag
      addresstitle
      addressindex
      __typename
    }
    relatedpaymentaccountdetails {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    relatedpurchaseaddressdetails {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      line1
      line2
      line3
      city
      statecode
      statename
      statuscode
      statusmessage
      pincode
      countrycode
      codevalue
      district
      lastupdatedby
      godownname
      gstin
      phone
      email
      personincharge
      consigneename
      consigneegstin
      foreignstate
      foreigndistrict
      defaultflag
      addresstitle
      addressindex
      __typename
    }
    lastupdatedby
    cancelflag
    roundoffamount
    discounttype
    discountvalue
    adjustmentamount
    statuscode
    statusmessage
    serialnumber
    currencycode
    currencyrate
    partydisplayname
    partylegalname
    partyaccountid
    reversechargeflag
    overduedays
    paymentstatus
    partyregistrationtype
    purchaseinvoicepdf
    partygstcategory
    partyemail
    partygstin
    partytypecd
    ewaybillno
    validupto
    ewaybill_is_cancelled
    ewaybill_cancel_remarks
    cancel_rsn_code
    einvoiceenteredtimestamp
    ewaybillenteredtimestamp
    ewaybillid
    accountname
    duedatetimestamp
    partyisactive
    consigneename
    consigneegstin
    ewaybillpdf
    ewaybillstatus
    isvouchereditable
    goods_exist
    itcflag
    linkedamount
    cessexist
    partyamount
    totalgstamount
    tdsamount
    tcsamount
    taxableamount
    igstamount
    cgstamount
    sgstamount
    cessamount
    sourceofsupply
    taxabilitylabel
    additionaldiscount
    netinvoiceamount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPurchaseMasterQueryVariables,
  APITypes.GetPurchaseMasterQuery
>;
export const getReceiptDetails = /* GraphQL */ `query GetReceiptDetails($transactionid: Int, $financialyearid: Int) {
  getReceiptDetails(
    transactionid: $transactionid
    financialyearid: $financialyearid
  ) {
    id
    transactionid
    companyid
    financialyearid
    lastupdatedby
    enteredtimestamp
    expiredtimestamp
    tan
    partyname
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetReceiptDetailsQueryVariables,
  APITypes.GetReceiptDetailsQuery
>;
export const listTransactionDetails = /* GraphQL */ `query ListTransactionDetails {
  listTransactionDetails {
    transactionid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    transactiontypecd
    accountid
    creditamount
    debitamount
    comments
    entryordernumber
    transactionbalance
    openingbalance
    lastupdatedby
    statuscode
    statusmessage
    financialyearid
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTransactionDetailsQueryVariables,
  APITypes.ListTransactionDetailsQuery
>;
export const listTransactionAttachment = /* GraphQL */ `query ListTransactionAttachment {
  listTransactionAttachment {
    transactionid
    attachmentid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    attachmentname
    attachmenturl
    lastupdatedby
    documentname
    statuscode
    statusmessage
    type
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTransactionAttachmentQueryVariables,
  APITypes.ListTransactionAttachmentQuery
>;
export const listThemeColors = /* GraphQL */ `query ListThemeColors {
  listThemeColors {
    themecolorid
    color
    enteredtimestamp
    expiredtimestamp
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListThemeColorsQueryVariables,
  APITypes.ListThemeColorsQuery
>;
export const listspecificaccountbalance = /* GraphQL */ `query Listspecificaccountbalance($accountid: String!) {
  listspecificaccountbalance(accountid: $accountid) {
    accountid
    accountbalance
    actualbalance
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListspecificaccountbalanceQueryVariables,
  APITypes.ListspecificaccountbalanceQuery
>;
export const listPurchaseMasterTest = /* GraphQL */ `query ListPurchaseMasterTest(
  $rowfrom: Int!
  $limitno: Int!
  $columnname: String
  $ordertype: String
  $searchmode: Int
  $searcharray: AWSJSON
) {
  listPurchaseMasterTest(
    rowfrom: $rowfrom
    limitno: $limitno
    columnname: $columnname
    ordertype: $ordertype
    searchmode: $searchmode
    searcharray: $searcharray
  ) {
    purchaseid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    purchasegsttypecd
    supplierid
    entrydate
    vouchernumber
    supplierinvoicedate
    supplierinvoicenumber
    supplieraddressid
    paymenttypecd
    paidamount
    creditduration
    paymentaccountid
    comments
    tdsapplicableflag
    granttotalamount
    balancedueamount
    paymentclearedflag
    placeofsupply
    companystate
    relatedpurchasetdsdetails {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tdsapplicablecd
      totaltaxableamount
      ineligibletcflag
      reversechargeflag
      gstcesstotal
      tdsamount
      adjustmentamount
      tdssection
      tdspercentage
      tdsmanual
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpurchasetcsdetails {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tcsapplicablecd
      totaltaxableamount
      ineligibletcflag
      reversechargeflag
      gstcesstotal
      tcsamount
      adjustmentamount
      tcssection
      lastupdatedby
      statuscode
      statusmessage
      tcspercentage
      tcsmanual
      __typename
    }
    relatedpurchaselineitems {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      itemnumber
      itemid
      purchaseaccountid
      hsncode
      itemquantity
      unittypecd
      itemrate
      itemamount
      itemdiscount
      taxableamount
      description
      discounttype
      discountrate
      netamount
      relatedpurchaselinegst {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        cessamount
        gstamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relateditemmaster {
        itemid
        itemcode
        companyid
        enteredtimestamp
        expiredtimestamp
        itemname
        salesinvoiceflag
        purchaseinvoiceflag
        itemcategorycd
        measurementcd
        currencycd
        salesaccountid
        purchaseaccountid
        taxabilitycd
        reversechargeflag
        itemtype
        hsnid
        is_active
        statuscode
        statusmessage
        relateditemamountdetails {
          id
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          amount
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstcompensationvalue
          gstrate
          statuscode
          statusmessage
          lastupdatedby
          discounttype
          discountvalue
          invoicetype
          pricetype
          isactive
          isdefault
          pricetypeid
          tabletype
          __typename
        }
        relateditemgstdetails {
          itemid
          companyid
          enteredtimestamp
          expiredtimestamp
          hsnid
          gstcesstype
          gstcompensationvalue
          effectivedate
          expireddate
          gstcessvalue
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemimages {
          attachmentid
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          imagename
          imageurl
          documentname
          type
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        serialnumber
        financialyearid
        description
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        cessexist
        barcode
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      taxability
      pricetype
      lotid
      hsnid
      hsncodetype
      hsndescription
      gstrate
      gstamount
      cessamount
      unit
      uqc
      purchaseaccountname
      itemname
      itemcode
      itemtype
      manualdiscount
      manualcess
      pricetypeid
      manualgst
      cessrate
      cesstype
      type
      __typename
    }
    relatedpurchaselinenonitems {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      purchaselineitemtype
      purchaseaccountid
      hsnsaccode
      itemdescription
      taxableamount
      rate
      discount
      netamount
      relatedpurchaselinenongst {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        cessamount
        gstamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      taxability
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      gstrate
      gstamount
      cessamount
      purchaseaccountname
      manualgst
      manualcess
      cessrate
      cesstype
      type
      __typename
    }
    relatedpurchaselinegst {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      cessamount
      gstamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpurchaselinenongst {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      cessamount
      gstamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpurchaseattachment {
      purchaseid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      lastupdatedby
      statuscode
      statusmessage
      documentname
      type
      __typename
    }
    relatedpurchasetransactiondetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      vouchernumber
      entrydate
      bankreferencenumber
      comments
      relatedtransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        accountid
        creditamount
        debitamount
        comments
        entryordernumber
        transactionbalance
        openingbalance
        lastupdatedby
        statuscode
        statusmessage
        financialyearid
        __typename
      }
      relatedtransactionattachment {
        transactionid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        documentname
        statuscode
        statusmessage
        type
        __typename
      }
      relatedtransactiontdsdetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tdsapplicablecd
        tdsamount
        tdsmanual
        lastupdatedby
        statuscode
        statusmessage
        tdspercentage
        __typename
      }
      relatedpurchasemaster {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        purchasegsttypecd
        supplierid
        entrydate
        vouchernumber
        supplierinvoicedate
        supplierinvoicenumber
        supplieraddressid
        paymenttypecd
        paidamount
        creditduration
        paymentaccountid
        comments
        tdsapplicableflag
        granttotalamount
        balancedueamount
        paymentclearedflag
        placeofsupply
        companystate
        relatedpurchasetdsdetails {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          totaltaxableamount
          ineligibletcflag
          reversechargeflag
          gstcesstotal
          tdsamount
          adjustmentamount
          tdssection
          tdspercentage
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaselineitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          itemnumber
          itemid
          purchaseaccountid
          hsncode
          itemquantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          taxableamount
          description
          discounttype
          discountrate
          netamount
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          pricetype
          lotid
          hsnid
          hsncodetype
          hsndescription
          gstrate
          gstamount
          cessamount
          unit
          uqc
          purchaseaccountname
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          pricetypeid
          manualgst
          cessrate
          cesstype
          type
          __typename
        }
        relatedpurchaselinenonitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchaselineitemtype
          purchaseaccountid
          hsnsaccode
          itemdescription
          taxableamount
          rate
          discount
          netamount
          relatedpurchaselinenongst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gstamount
          cessamount
          purchaseaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          type
          __typename
        }
        relatedpurchaselinegst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaseattachment {
          purchaseid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedpurchasetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              description
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              description
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        relatedpurchasetransactionrelation {
          transactionid
          transactiontypecd
          objecttype
          objectid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          linkedamount
          objectattribute
          isdirect
          lastupdatedby
          accountid
          paymentvouchernumber
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        cancelflag
        roundoffamount
        discounttype
        discountvalue
        adjustmentamount
        serialnumber
        currencycode
        currencyrate
        reversechargeflag
        paymentstatus
        partyregistrationtype
        partygstcategory
        itcflag
        __typename
      }
      relatedinvoicemaster {
        invoiceid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        invoicetypecd
        partyid
        paymentaccountid
        invoicedate
        invoicenumber
        customerordernumber
        customerorderdate
        invoiceamount
        paymenttype
        creditduration
        invoicebillingaddressid
        invoicedeliveryaddressid
        invoicetaxabletypecd
        receipturl
        invoicelinetypecd
        invoicecurrencycd
        exchangerate
        comments
        receivedamount
        adjustmentamount
        placeofsupply
        balancedueamount
        reversechargeflag
        tcsapplicableflag
        relatedinvoicelineitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          lineitemnumber
          invoicelineitemtype
          itemid
          quantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          taxableamount
          discounttype
          discountrate
          netamount
          hsnsaccode
          taxability
          lastupdatedby
          statuscode
          statusmessage
          pricetype
          lotid
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          unit
          uqc
          salesaccountname
          salesaccountid
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          itemmaster_timestamp
          description
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          pricetypeid
          manualgst
          cessrate
          cesstype
          type
          __typename
        }
        relatedinvoicelinenonitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicelineitemtype
          incomeaccountid
          hsnsaccode
          taxability
          itemdescription
          taxableamount
          rate
          discount
          netamount
          relatedaccounts {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accountname
            accounttypecd
            accountgroupid
            hsnsaccode
            displayordernumber
            statuscode
            statusmessage
            restrictedflag
            is_active
            accounttypeflag
            relatedaccountgstdetails {
              accountid
              companyid
              enteredtimestamp
              expiredtimestamp
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstrate
              cessamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsaccode
              codetype
              description
              taxability
              __typename
            }
            relatedaccountopeningbalance {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              financialyearid
              startdate
              creditamount
              debitamount
              statuscode
              statusmessage
              __typename
            }
            relatedaccountgroupmaster {
              accountgroupid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accounttypecd
              accountgroupname
              accountparentgroupid
              displayordernumber
              statuscode
              statusmessage
              is_active
              restrictedflag
              path
              __typename
            }
            relatedaccountbalance {
              accountid
              accountbalance
              actualbalance
              __typename
            }
            path
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          incomeaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          type
          __typename
        }
        relatedinvoiceattachment {
          invoiceid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedinvoicedispatch {
          invoiceid
          dispatchid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transportationcd
          vehiclenumber
          dispatchdate
          ewaybillnumber
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoiceposdetails {
          posid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          partyposid
          lastupdatedby
          relatedposparty {
            pospartyid
            companyid
            partyname
            partycontactnumberid
            lastupdatedby
            enteredtimestamp
            expiredtimestamp
            relatedphonecontacts {
              id
              objecttype
              objectid
              enteredtimestamp
              expiredtimestamp
              countrycode
              phonenumber
              verifieddatetime
              promotionssignup
              smsallowed
              callallowed
              whatsappallowed
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            __typename
          }
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicelinegst {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          gsttypecd
          gstamount
          cessamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicenumbertracker {
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          nextinvoicenumber
          lastupdatedby
          __typename
        }
        relatedinvoicetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              description
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              description
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        lastupdatedby
        cancelflag
        statuscode
        statusmessage
        consigneename
        consigneegstin
        companystate
        cancelremark
        deleteremark
        roundoffamount
        discounttype
        discountvalue
        serialnumber
        currencycode
        currencyrate
        paymentstatus
        ackno
        ackdt
        irn
        signedqrcode
        itcflag
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      cancelflag
      cancelremark
      serialnumber
      pdflink
      towards
      isvouchereditable
      __typename
    }
    relatedpartymaster {
      partyid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      partytypecd
      partydisplayname
      partylegalname
      groupaccountid
      gstcategory
      placeofsupply
      entity
      email
      contactnumber
      whatsappnumber
      accountsid
      is_active
      msmetype
      deliveryconsigneename
      deliveryconsigneegstin
      statuscode
      statusmessage
      relatedpartygstdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        pannumber
        gstin
        partyaddressid
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycreditdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        creditperiodduration
        billingcurrency
        creditlimitcd
        creditlimitamount
        billwiseflag
        notes
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycontact {
        partyid
        enteredtimestamp
        expiredtimestamp
        contacttypename
        contactdesignationname
        contactorder
        email
        phonenumber
        whatsappnumber
        lastupdatedby
        statuscode
        statusmessage
        contactcountry
        whatsappcountry
        __typename
      }
      relatedpartyimages {
        attachmentid
        partyid
        companyid
        enteredtimestamp
        expiredtimestamp
        type
        documentname
        imagename
        imageurl
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      tdspercentage
      udhyamregno
      sameaddressflag
      comments
      tdssection
      accountname
      deliverystatecode
      deliverystatename
      contactcountry
      whatsappcountry
      entityname
      __typename
    }
    relatedpartyaddressdetails {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      line1
      line2
      line3
      city
      statecode
      statename
      statuscode
      statusmessage
      pincode
      countrycode
      codevalue
      district
      lastupdatedby
      godownname
      gstin
      phone
      email
      personincharge
      consigneename
      consigneegstin
      foreignstate
      foreigndistrict
      defaultflag
      addresstitle
      addressindex
      __typename
    }
    relatedpaymentaccountdetails {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    relatedpurchaseaddressdetails {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      line1
      line2
      line3
      city
      statecode
      statename
      statuscode
      statusmessage
      pincode
      countrycode
      codevalue
      district
      lastupdatedby
      godownname
      gstin
      phone
      email
      personincharge
      consigneename
      consigneegstin
      foreignstate
      foreigndistrict
      defaultflag
      addresstitle
      addressindex
      __typename
    }
    lastupdatedby
    cancelflag
    roundoffamount
    discounttype
    discountvalue
    adjustmentamount
    statuscode
    statusmessage
    serialnumber
    currencycode
    currencyrate
    partydisplayname
    partylegalname
    partyaccountid
    reversechargeflag
    overduedays
    paymentstatus
    partyregistrationtype
    purchaseinvoicepdf
    partygstcategory
    partyemail
    partygstin
    partytypecd
    ewaybillno
    validupto
    ewaybill_is_cancelled
    ewaybill_cancel_remarks
    cancel_rsn_code
    einvoiceenteredtimestamp
    ewaybillenteredtimestamp
    ewaybillid
    accountname
    duedatetimestamp
    partyisactive
    consigneename
    consigneegstin
    ewaybillpdf
    ewaybillstatus
    isvouchereditable
    goods_exist
    itcflag
    linkedamount
    cessexist
    partyamount
    totalgstamount
    tdsamount
    tcsamount
    taxableamount
    igstamount
    cgstamount
    sgstamount
    cessamount
    sourceofsupply
    taxabilitylabel
    additionaldiscount
    netinvoiceamount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPurchaseMasterTestQueryVariables,
  APITypes.ListPurchaseMasterTestQuery
>;
export const getSideBarUserPreference = /* GraphQL */ `query GetSideBarUserPreference($financialyearid: Int!) {
  getSideBarUserPreference(financialyearid: $financialyearid) {
    userid
    attributetypecd
    enteredtimestamp
    expiredtimestamp
    attributevalue
    additionalvalue
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSideBarUserPreferenceQueryVariables,
  APITypes.GetSideBarUserPreferenceQuery
>;
export const getTransactionDetails = /* GraphQL */ `query GetTransactionDetails($transactionid: Int!) {
  getTransactionDetails(transactionid: $transactionid) {
    transactionid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    transactiontypecd
    accountid
    creditamount
    debitamount
    comments
    entryordernumber
    transactionbalance
    openingbalance
    lastupdatedby
    statuscode
    statusmessage
    financialyearid
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTransactionDetailsQueryVariables,
  APITypes.GetTransactionDetailsQuery
>;
export const getTransactionMaster = /* GraphQL */ `query GetTransactionMaster($transactionid: Int!) {
  getTransactionMaster(transactionid: $transactionid) {
    transactionid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    transactiontypecd
    vouchernumber
    entrydate
    bankreferencenumber
    comments
    relatedtransactiondetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      accountid
      creditamount
      debitamount
      comments
      entryordernumber
      transactionbalance
      openingbalance
      lastupdatedby
      statuscode
      statusmessage
      financialyearid
      __typename
    }
    relatedtransactionattachment {
      transactionid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      lastupdatedby
      documentname
      statuscode
      statusmessage
      type
      __typename
    }
    relatedtransactiontdsdetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tdsapplicablecd
      tdsamount
      tdsmanual
      lastupdatedby
      statuscode
      statusmessage
      tdspercentage
      __typename
    }
    relatedpurchasemaster {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      purchasegsttypecd
      supplierid
      entrydate
      vouchernumber
      supplierinvoicedate
      supplierinvoicenumber
      supplieraddressid
      paymenttypecd
      paidamount
      creditduration
      paymentaccountid
      comments
      tdsapplicableflag
      granttotalamount
      balancedueamount
      paymentclearedflag
      placeofsupply
      companystate
      relatedpurchasetdsdetails {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tdsapplicablecd
        totaltaxableamount
        ineligibletcflag
        reversechargeflag
        gstcesstotal
        tdsamount
        adjustmentamount
        tdssection
        tdspercentage
        tdsmanual
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpurchaselineitems {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        itemnumber
        itemid
        purchaseaccountid
        hsncode
        itemquantity
        unittypecd
        itemrate
        itemamount
        itemdiscount
        taxableamount
        description
        discounttype
        discountrate
        netamount
        relatedpurchaselinegst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemmaster {
          itemid
          itemcode
          companyid
          enteredtimestamp
          expiredtimestamp
          itemname
          salesinvoiceflag
          purchaseinvoiceflag
          itemcategorycd
          measurementcd
          currencycd
          salesaccountid
          purchaseaccountid
          taxabilitycd
          reversechargeflag
          itemtype
          hsnid
          is_active
          statuscode
          statusmessage
          relateditemamountdetails {
            id
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            amount
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstcompensationvalue
            gstrate
            statuscode
            statusmessage
            lastupdatedby
            discounttype
            discountvalue
            invoicetype
            pricetype
            isactive
            isdefault
            pricetypeid
            tabletype
            __typename
          }
          relateditemgstdetails {
            itemid
            companyid
            enteredtimestamp
            expiredtimestamp
            hsnid
            gstcesstype
            gstcompensationvalue
            effectivedate
            expireddate
            gstcessvalue
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemimages {
            attachmentid
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            imagename
            imageurl
            documentname
            type
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          serialnumber
          financialyearid
          description
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          cessexist
          barcode
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        taxability
        pricetype
        lotid
        hsnid
        hsncodetype
        hsndescription
        gstrate
        gstamount
        cessamount
        unit
        uqc
        purchaseaccountname
        itemname
        itemcode
        itemtype
        manualdiscount
        manualcess
        pricetypeid
        manualgst
        cessrate
        cesstype
        type
        __typename
      }
      relatedpurchaselinenonitems {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        purchaselineitemtype
        purchaseaccountid
        hsnsaccode
        itemdescription
        taxableamount
        rate
        discount
        netamount
        relatedpurchaselinenongst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        taxability
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gstamount
        cessamount
        purchaseaccountname
        manualgst
        manualcess
        cessrate
        cesstype
        type
        __typename
      }
      relatedpurchaselinegst {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        cessamount
        gstamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpurchaseattachment {
        purchaseid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        statuscode
        statusmessage
        documentname
        type
        __typename
      }
      relatedpurchasetransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        vouchernumber
        entrydate
        bankreferencenumber
        comments
        relatedtransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          accountid
          creditamount
          debitamount
          comments
          entryordernumber
          transactionbalance
          openingbalance
          lastupdatedby
          statuscode
          statusmessage
          financialyearid
          __typename
        }
        relatedtransactionattachment {
          transactionid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          documentname
          statuscode
          statusmessage
          type
          __typename
        }
        relatedtransactiontdsdetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          tdsamount
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          tdspercentage
          __typename
        }
        relatedpurchasemaster {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchasegsttypecd
          supplierid
          entrydate
          vouchernumber
          supplierinvoicedate
          supplierinvoicenumber
          supplieraddressid
          paymenttypecd
          paidamount
          creditduration
          paymentaccountid
          comments
          tdsapplicableflag
          granttotalamount
          balancedueamount
          paymentclearedflag
          placeofsupply
          companystate
          relatedpurchasetdsdetails {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            totaltaxableamount
            ineligibletcflag
            reversechargeflag
            gstcesstotal
            tdsamount
            adjustmentamount
            tdssection
            tdspercentage
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaselineitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            itemnumber
            itemid
            purchaseaccountid
            hsncode
            itemquantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            description
            discounttype
            discountrate
            netamount
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            pricetype
            lotid
            hsnid
            hsncodetype
            hsndescription
            gstrate
            gstamount
            cessamount
            unit
            uqc
            purchaseaccountname
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinenonitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchaselineitemtype
            purchaseaccountid
            hsnsaccode
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedpurchaselinenongst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gstamount
            cessamount
            purchaseaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaseattachment {
            purchaseid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedpurchasetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          relatedpurchasetransactionrelation {
            transactionid
            transactiontypecd
            objecttype
            objectid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            linkedamount
            objectattribute
            isdirect
            lastupdatedby
            accountid
            paymentvouchernumber
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          cancelflag
          roundoffamount
          discounttype
          discountvalue
          adjustmentamount
          serialnumber
          currencycode
          currencyrate
          reversechargeflag
          paymentstatus
          partyregistrationtype
          partygstcategory
          itcflag
          __typename
        }
        relatedinvoicemaster {
          invoiceid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicetypecd
          partyid
          paymentaccountid
          invoicedate
          invoicenumber
          customerordernumber
          customerorderdate
          invoiceamount
          paymenttype
          creditduration
          invoicebillingaddressid
          invoicedeliveryaddressid
          invoicetaxabletypecd
          receipturl
          invoicelinetypecd
          invoicecurrencycd
          exchangerate
          comments
          receivedamount
          adjustmentamount
          placeofsupply
          balancedueamount
          reversechargeflag
          tcsapplicableflag
          relatedinvoicelineitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            lineitemnumber
            invoicelineitemtype
            itemid
            quantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            discounttype
            discountrate
            netamount
            hsnsaccode
            taxability
            lastupdatedby
            statuscode
            statusmessage
            pricetype
            lotid
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            unit
            uqc
            salesaccountname
            salesaccountid
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            itemmaster_timestamp
            description
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoicelinenonitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicelineitemtype
            incomeaccountid
            hsnsaccode
            taxability
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedaccounts {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accountname
              accounttypecd
              accountgroupid
              hsnsaccode
              displayordernumber
              statuscode
              statusmessage
              restrictedflag
              is_active
              accounttypeflag
              path
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            incomeaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoiceattachment {
            invoiceid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedinvoicedispatch {
            invoiceid
            dispatchid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transportationcd
            vehiclenumber
            dispatchdate
            ewaybillnumber
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoiceposdetails {
            posid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            partyposid
            lastupdatedby
            relatedposparty {
              pospartyid
              companyid
              partyname
              partycontactnumberid
              lastupdatedby
              enteredtimestamp
              expiredtimestamp
              __typename
            }
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicenumbertracker {
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            nextinvoicenumber
            lastupdatedby
            __typename
          }
          relatedinvoicetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          lastupdatedby
          cancelflag
          statuscode
          statusmessage
          consigneename
          consigneegstin
          companystate
          cancelremark
          deleteremark
          roundoffamount
          discounttype
          discountvalue
          serialnumber
          currencycode
          currencyrate
          paymentstatus
          ackno
          ackdt
          irn
          signedqrcode
          itcflag
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        cancelflag
        cancelremark
        serialnumber
        pdflink
        towards
        isvouchereditable
        __typename
      }
      relatedpurchasetransactionrelation {
        transactionid
        transactiontypecd
        objecttype
        objectid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        linkedamount
        objectattribute
        isdirect
        lastupdatedby
        accountid
        paymentvouchernumber
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      cancelflag
      roundoffamount
      discounttype
      discountvalue
      adjustmentamount
      serialnumber
      currencycode
      currencyrate
      reversechargeflag
      paymentstatus
      partyregistrationtype
      partygstcategory
      itcflag
      __typename
    }
    relatedinvoicemaster {
      invoiceid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoicetypecd
      partyid
      paymentaccountid
      invoicedate
      invoicenumber
      customerordernumber
      customerorderdate
      invoiceamount
      paymenttype
      creditduration
      invoicebillingaddressid
      invoicedeliveryaddressid
      invoicetaxabletypecd
      receipturl
      invoicelinetypecd
      invoicecurrencycd
      exchangerate
      comments
      receivedamount
      adjustmentamount
      placeofsupply
      balancedueamount
      reversechargeflag
      tcsapplicableflag
      relatedinvoicelineitems {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        lineitemnumber
        invoicelineitemtype
        itemid
        quantity
        unittypecd
        itemrate
        itemamount
        itemdiscount
        taxableamount
        discounttype
        discountrate
        netamount
        hsnsaccode
        taxability
        lastupdatedby
        statuscode
        statusmessage
        pricetype
        lotid
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gsttypecd
        gstamount
        cessamount
        unit
        uqc
        salesaccountname
        salesaccountid
        itemname
        itemcode
        itemtype
        manualdiscount
        manualcess
        itemmaster_timestamp
        description
        relatedinvoicelinegst {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          gsttypecd
          gstamount
          cessamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemmaster {
          itemid
          itemcode
          companyid
          enteredtimestamp
          expiredtimestamp
          itemname
          salesinvoiceflag
          purchaseinvoiceflag
          itemcategorycd
          measurementcd
          currencycd
          salesaccountid
          purchaseaccountid
          taxabilitycd
          reversechargeflag
          itemtype
          hsnid
          is_active
          statuscode
          statusmessage
          relateditemamountdetails {
            id
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            amount
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstcompensationvalue
            gstrate
            statuscode
            statusmessage
            lastupdatedby
            discounttype
            discountvalue
            invoicetype
            pricetype
            isactive
            isdefault
            pricetypeid
            tabletype
            __typename
          }
          relateditemgstdetails {
            itemid
            companyid
            enteredtimestamp
            expiredtimestamp
            hsnid
            gstcesstype
            gstcompensationvalue
            effectivedate
            expireddate
            gstcessvalue
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemimages {
            attachmentid
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            imagename
            imageurl
            documentname
            type
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          serialnumber
          financialyearid
          description
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          cessexist
          barcode
          __typename
        }
        pricetypeid
        manualgst
        cessrate
        cesstype
        type
        __typename
      }
      relatedinvoicelinenonitems {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        invoicelineitemtype
        incomeaccountid
        hsnsaccode
        taxability
        itemdescription
        taxableamount
        rate
        discount
        netamount
        relatedaccounts {
          accountsid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          accountname
          accounttypecd
          accountgroupid
          hsnsaccode
          displayordernumber
          statuscode
          statusmessage
          restrictedflag
          is_active
          accounttypeflag
          relatedaccountgstdetails {
            accountid
            companyid
            enteredtimestamp
            expiredtimestamp
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstrate
            cessamount
            lastupdatedby
            statuscode
            statusmessage
            hsnsaccode
            codetype
            description
            taxability
            __typename
          }
          relatedaccountopeningbalance {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            financialyearid
            startdate
            creditamount
            debitamount
            statuscode
            statusmessage
            __typename
          }
          relatedaccountgroupmaster {
            accountgroupid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accounttypecd
            accountgroupname
            accountparentgroupid
            displayordernumber
            statuscode
            statusmessage
            is_active
            restrictedflag
            path
            __typename
          }
          relatedaccountbalance {
            accountid
            accountbalance
            actualbalance
            __typename
          }
          path
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gsttypecd
        gstamount
        cessamount
        incomeaccountname
        manualgst
        manualcess
        cessrate
        cesstype
        type
        __typename
      }
      relatedinvoiceattachment {
        invoiceid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        statuscode
        statusmessage
        documentname
        type
        __typename
      }
      relatedinvoicedispatch {
        invoiceid
        dispatchid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transportationcd
        vehiclenumber
        dispatchdate
        ewaybillnumber
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedinvoiceposdetails {
        posid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        partyposid
        lastupdatedby
        relatedposparty {
          pospartyid
          companyid
          partyname
          partycontactnumberid
          lastupdatedby
          enteredtimestamp
          expiredtimestamp
          relatedphonecontacts {
            id
            objecttype
            objectid
            enteredtimestamp
            expiredtimestamp
            countrycode
            phonenumber
            verifieddatetime
            promotionssignup
            smsallowed
            callallowed
            whatsappallowed
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          __typename
        }
        statuscode
        statusmessage
        __typename
      }
      relatedinvoicelinegst {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        gsttypecd
        gstamount
        cessamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedinvoicenumbertracker {
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        nextinvoicenumber
        lastupdatedby
        __typename
      }
      relatedinvoicetransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        vouchernumber
        entrydate
        bankreferencenumber
        comments
        relatedtransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          accountid
          creditamount
          debitamount
          comments
          entryordernumber
          transactionbalance
          openingbalance
          lastupdatedby
          statuscode
          statusmessage
          financialyearid
          __typename
        }
        relatedtransactionattachment {
          transactionid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          documentname
          statuscode
          statusmessage
          type
          __typename
        }
        relatedtransactiontdsdetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          tdsamount
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          tdspercentage
          __typename
        }
        relatedpurchasemaster {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchasegsttypecd
          supplierid
          entrydate
          vouchernumber
          supplierinvoicedate
          supplierinvoicenumber
          supplieraddressid
          paymenttypecd
          paidamount
          creditduration
          paymentaccountid
          comments
          tdsapplicableflag
          granttotalamount
          balancedueamount
          paymentclearedflag
          placeofsupply
          companystate
          relatedpurchasetdsdetails {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            totaltaxableamount
            ineligibletcflag
            reversechargeflag
            gstcesstotal
            tdsamount
            adjustmentamount
            tdssection
            tdspercentage
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaselineitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            itemnumber
            itemid
            purchaseaccountid
            hsncode
            itemquantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            description
            discounttype
            discountrate
            netamount
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            pricetype
            lotid
            hsnid
            hsncodetype
            hsndescription
            gstrate
            gstamount
            cessamount
            unit
            uqc
            purchaseaccountname
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinenonitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchaselineitemtype
            purchaseaccountid
            hsnsaccode
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedpurchaselinenongst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gstamount
            cessamount
            purchaseaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaseattachment {
            purchaseid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedpurchasetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          relatedpurchasetransactionrelation {
            transactionid
            transactiontypecd
            objecttype
            objectid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            linkedamount
            objectattribute
            isdirect
            lastupdatedby
            accountid
            paymentvouchernumber
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          cancelflag
          roundoffamount
          discounttype
          discountvalue
          adjustmentamount
          serialnumber
          currencycode
          currencyrate
          reversechargeflag
          paymentstatus
          partyregistrationtype
          partygstcategory
          itcflag
          __typename
        }
        relatedinvoicemaster {
          invoiceid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicetypecd
          partyid
          paymentaccountid
          invoicedate
          invoicenumber
          customerordernumber
          customerorderdate
          invoiceamount
          paymenttype
          creditduration
          invoicebillingaddressid
          invoicedeliveryaddressid
          invoicetaxabletypecd
          receipturl
          invoicelinetypecd
          invoicecurrencycd
          exchangerate
          comments
          receivedamount
          adjustmentamount
          placeofsupply
          balancedueamount
          reversechargeflag
          tcsapplicableflag
          relatedinvoicelineitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            lineitemnumber
            invoicelineitemtype
            itemid
            quantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            discounttype
            discountrate
            netamount
            hsnsaccode
            taxability
            lastupdatedby
            statuscode
            statusmessage
            pricetype
            lotid
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            unit
            uqc
            salesaccountname
            salesaccountid
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            itemmaster_timestamp
            description
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoicelinenonitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicelineitemtype
            incomeaccountid
            hsnsaccode
            taxability
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedaccounts {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accountname
              accounttypecd
              accountgroupid
              hsnsaccode
              displayordernumber
              statuscode
              statusmessage
              restrictedflag
              is_active
              accounttypeflag
              path
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            incomeaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoiceattachment {
            invoiceid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedinvoicedispatch {
            invoiceid
            dispatchid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transportationcd
            vehiclenumber
            dispatchdate
            ewaybillnumber
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoiceposdetails {
            posid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            partyposid
            lastupdatedby
            relatedposparty {
              pospartyid
              companyid
              partyname
              partycontactnumberid
              lastupdatedby
              enteredtimestamp
              expiredtimestamp
              __typename
            }
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicenumbertracker {
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            nextinvoicenumber
            lastupdatedby
            __typename
          }
          relatedinvoicetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          lastupdatedby
          cancelflag
          statuscode
          statusmessage
          consigneename
          consigneegstin
          companystate
          cancelremark
          deleteremark
          roundoffamount
          discounttype
          discountvalue
          serialnumber
          currencycode
          currencyrate
          paymentstatus
          ackno
          ackdt
          irn
          signedqrcode
          itcflag
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        cancelflag
        cancelremark
        serialnumber
        pdflink
        towards
        isvouchereditable
        __typename
      }
      lastupdatedby
      cancelflag
      statuscode
      statusmessage
      consigneename
      consigneegstin
      companystate
      cancelremark
      deleteremark
      roundoffamount
      discounttype
      discountvalue
      serialnumber
      currencycode
      currencyrate
      paymentstatus
      ackno
      ackdt
      irn
      signedqrcode
      itcflag
      __typename
    }
    lastupdatedby
    statuscode
    statusmessage
    cancelflag
    cancelremark
    serialnumber
    pdflink
    towards
    isvouchereditable
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTransactionMasterQueryVariables,
  APITypes.GetTransactionMasterQuery
>;
export const getSetOffDetails = /* GraphQL */ `query GetSetOffDetails(
  $invoiceid: Int!
  $transactiontype: String!
  $accountid: Int
) {
  getSetOffDetails(
    invoiceid: $invoiceid
    transactiontype: $transactiontype
    accountid: $accountid
  ) {
    invoiceid
    invoicenumber
    invoicedate
    invoiceamount_converted
    partyid
    companyid
    transactiontype
    transactiontypedesc
    net_adjustments
    payments_receipts
    setoff_balance
    setoff_status
    available_amount
    linked_to_target
    can_setoff
    setoff_priority
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSetOffDetailsQueryVariables,
  APITypes.GetSetOffDetailsQuery
>;
export const getTransactionRelation = /* GraphQL */ `query GetTransactionRelation($objectid: Int!) {
  getTransactionRelation(objectid: $objectid) {
    transactionid
    transactiontypecd
    objecttype
    objectid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    linkedamount
    objectattribute
    isdirect
    lastupdatedby
    accountid
    paymentvouchernumber
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTransactionRelationQueryVariables,
  APITypes.GetTransactionRelationQuery
>;
export const getTransactionRelationWithAccountID = /* GraphQL */ `query GetTransactionRelationWithAccountID($accountid: Int!) {
  getTransactionRelationWithAccountID(accountid: $accountid) {
    transactionid
    transactiontypecd
    objecttype
    objectid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    linkedamount
    objectattribute
    isdirect
    lastupdatedby
    accountid
    paymentvouchernumber
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTransactionRelationWithAccountIDQueryVariables,
  APITypes.GetTransactionRelationWithAccountIDQuery
>;
export const getTransactionTDSDetails = /* GraphQL */ `query GetTransactionTDSDetails($transactionid: Int!) {
  getTransactionTDSDetails(transactionid: $transactionid) {
    transactionid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    tdsapplicablecd
    tdsamount
    tdsmanual
    lastupdatedby
    statuscode
    statusmessage
    tdspercentage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTransactionTDSDetailsQueryVariables,
  APITypes.GetTransactionTDSDetailsQuery
>;
export const getUserPreference = /* GraphQL */ `query GetUserPreference($financialyearid: Int!) {
  getUserPreference(financialyearid: $financialyearid) {
    userid
    attributetypecd
    enteredtimestamp
    expiredtimestamp
    attributevalue
    additionalvalue
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserPreferenceQueryVariables,
  APITypes.GetUserPreferenceQuery
>;
export const getUserThemePreference = /* GraphQL */ `query GetUserThemePreference {
  getUserThemePreference {
    userid
    attributetypecd
    enteredtimestamp
    expiredtimestamp
    attributevalue
    additionalvalue
    relatedthemecolor {
      themecolorid
      color
      enteredtimestamp
      expiredtimestamp
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserThemePreferenceQueryVariables,
  APITypes.GetUserThemePreferenceQuery
>;
export const listaccountbalances = /* GraphQL */ `query Listaccountbalances {
  listaccountbalances {
    accountid
    accountbalance
    actualbalance
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListaccountbalancesQueryVariables,
  APITypes.ListaccountbalancesQuery
>;
export const listAccountGroupMaster = /* GraphQL */ `query ListAccountGroupMaster {
  listAccountGroupMaster {
    accountgroupid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    accounttypecd
    accountgroupname
    accountparentgroupid
    displayordernumber
    statuscode
    statusmessage
    restrictedflag
    is_active
    relatedaccounts {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    path
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAccountGroupMasterQueryVariables,
  APITypes.ListAccountGroupMasterQuery
>;
export const listAccountGroupMasterv2 = /* GraphQL */ `query ListAccountGroupMasterv2 {
  listAccountGroupMasterv2 {
    accountgroupid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    accounttypecd
    accountgroupname
    accountparentgroupid
    displayordernumber
    statuscode
    statusmessage
    restrictedflag
    is_active
    path
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAccountGroupMasterv2QueryVariables,
  APITypes.ListAccountGroupMasterv2Query
>;
export const listAccountGroupsDropdown = /* GraphQL */ `query ListAccountGroupsDropdown(
  $rowfrom: Int!
  $limitno: Int!
  $word: String!
) {
  listAccountGroupsDropdown(rowfrom: $rowfrom, limitno: $limitno, word: $word) {
    accountgroupid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    accounttypecd
    accountgroupname
    accountparentgroupid
    displayordernumber
    statuscode
    statusmessage
    restrictedflag
    is_active
    relatedaccounts {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    path
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAccountGroupsDropdownQueryVariables,
  APITypes.ListAccountGroupsDropdownQuery
>;
export const listaccountgroups = /* GraphQL */ `query Listaccountgroups(
  $type: String
  $rowfrom: Int!
  $limitno: Int!
  $columnname: String
  $ordertype: String
  $searchmode: Int
  $searcharray: AWSJSON
) {
  listaccountgroups(
    type: $type
    rowfrom: $rowfrom
    limitno: $limitno
    columnname: $columnname
    ordertype: $ordertype
    searchmode: $searchmode
    searcharray: $searcharray
  ) {
    id
    name
    parent_name
    account_type
    actual_numeric_balance
    account_balance
    created_date
    numeric_created_date
    is_active
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    accounttypecd
    accountgroupname
    accountparentgroupid
    displayordernumber
    restrictedflag
    accountgroupid
    balancesign
    financialyearid
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListaccountgroupsQueryVariables,
  APITypes.ListaccountgroupsQuery
>;
export const listAccountMaster = /* GraphQL */ `query ListAccountMaster {
  listAccountMaster {
    accountsid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    accountname
    accounttypecd
    accountgroupid
    hsnsaccode
    displayordernumber
    statuscode
    statusmessage
    restrictedflag
    is_active
    accounttypeflag
    relatedaccountgstdetails {
      accountid
      companyid
      enteredtimestamp
      expiredtimestamp
      effectivedate
      expireddate
      hsnid
      gstcompensationtype
      gstrate
      cessamount
      lastupdatedby
      statuscode
      statusmessage
      hsnsaccode
      codetype
      description
      taxability
      __typename
    }
    relatedaccountopeningbalance {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      financialyearid
      startdate
      creditamount
      debitamount
      statuscode
      statusmessage
      __typename
    }
    relatedaccountgroupmaster {
      accountgroupid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accounttypecd
      accountgroupname
      accountparentgroupid
      displayordernumber
      statuscode
      statusmessage
      is_active
      restrictedflag
      path
      __typename
    }
    relatedaccountbalance {
      accountid
      accountbalance
      actualbalance
      __typename
    }
    path
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAccountMasterQueryVariables,
  APITypes.ListAccountMasterQuery
>;
export const listAccountMasterSearch = /* GraphQL */ `query ListAccountMasterSearch($word: String!) {
  listAccountMasterSearch(word: $word) {
    accountsid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    accountname
    accounttypecd
    accountgroupid
    hsnsaccode
    displayordernumber
    statuscode
    statusmessage
    restrictedflag
    is_active
    accountgroupenteredtimestamp
    accountgroupexpiredtimestamp
    accountgrouptypecd
    accountgroupname
    accountparentgroupid
    accountgroupdisplayordernumber
    accountgrouprestrictedflag
    accountgroupis_active
    accountgstenteredtimestamp
    accountgstexpiredtimestamp
    accountgsteffectivedate
    accountgstexpireddate
    hsnid
    gstcompensationtype
    gstrate
    cessamount
    accounttypeflag
    partyid
    tdspercentage
    tdssection
    path
    tax_type
    balancesign
    accountcreationdate
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAccountMasterSearchQueryVariables,
  APITypes.ListAccountMasterSearchQuery
>;
export const listPartymasters = /* GraphQL */ `query ListPartymasters {
  listPartymasters {
    partyid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    partytypecd
    partydisplayname
    partylegalname
    groupaccountid
    gstcategory
    placeofsupply
    entity
    email
    contactnumber
    whatsappnumber
    accountsid
    is_active
    msmetype
    deliveryconsigneename
    deliveryconsigneegstin
    statuscode
    statusmessage
    relatedpartygstdetails {
      partyid
      enteredtimestamp
      expiredtimestamp
      pannumber
      gstin
      partyaddressid
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpartycreditdetails {
      partyid
      enteredtimestamp
      expiredtimestamp
      creditperiodduration
      billingcurrency
      creditlimitcd
      creditlimitamount
      billwiseflag
      notes
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpartycontact {
      partyid
      enteredtimestamp
      expiredtimestamp
      contacttypename
      contactdesignationname
      contactorder
      email
      phonenumber
      whatsappnumber
      lastupdatedby
      statuscode
      statusmessage
      contactcountry
      whatsappcountry
      __typename
    }
    relatedpartyimages {
      attachmentid
      partyid
      companyid
      enteredtimestamp
      expiredtimestamp
      type
      documentname
      imagename
      imageurl
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    lastupdatedby
    tdspercentage
    udhyamregno
    sameaddressflag
    comments
    tdssection
    accountname
    deliverystatecode
    deliverystatename
    contactcountry
    whatsappcountry
    entityname
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPartymastersQueryVariables,
  APITypes.ListPartymastersQuery
>;
export const listPartymastersv2 = /* GraphQL */ `query ListPartymastersv2(
  $rowfrom: Int!
  $limitno: Int!
  $columnname: String
  $ordertype: String
  $searchmode: Int
  $searcharray: AWSJSON
) {
  listPartymastersv2(
    rowfrom: $rowfrom
    limitno: $limitno
    columnname: $columnname
    ordertype: $ordertype
    searchmode: $searchmode
    searcharray: $searcharray
  ) {
    partyid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    partytypecd
    partydisplayname
    partylegalname
    groupaccountid
    gstcategory
    placeofsupply
    placeofsupplytext
    entity
    email
    contactnumber
    whatsappnumber
    accountsid
    is_active
    msmetype
    deliveryconsigneename
    deliveryconsigneegstin
    statuscode
    statusmessage
    lastupdatedby
    tdspercentage
    udhyamregno
    partygstenteredtimestamp
    partygstexpiredtimestamp
    pannumber
    gstin
    partyaddressid
    contacttypename
    contactdesignationname
    contactorder
    partycontactemail
    phonenumber
    partycontactwhatsappnumber
    creditperiodduration
    billingcurrency
    creditlimitcd
    creditlimitamount
    billwiseflag
    notes
    sameaddressflag
    comments
    accountbalance
    tdssection
    accounttypeflag
    accountgroup
    contactcountry
    whatsappcountry
    partybillingaddress
    partydeliveryaddress
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPartymastersv2QueryVariables,
  APITypes.ListPartymastersv2Query
>;
export const listPartymastersv2Count = /* GraphQL */ `query ListPartymastersv2Count(
  $columnname: String
  $ordertype: String
  $searchmode: Int
  $searcharray: AWSJSON
) {
  listPartymastersv2Count(
    columnname: $columnname
    ordertype: $ordertype
    searchmode: $searchmode
    searcharray: $searcharray
  ) {
    partycount
    total_accountbalance
    total_accountbalance_side
    total_creditlimitamount
    minbalancedue
    maxbalancedue
    totalpartybalance
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPartymastersv2CountQueryVariables,
  APITypes.ListPartymastersv2CountQuery
>;
export const listPartyDropdown = /* GraphQL */ `query ListPartyDropdown($rowfrom: Int!, $limitno: Int!, $word: String!) {
  listPartyDropdown(rowfrom: $rowfrom, limitno: $limitno, word: $word) {
    partyid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    partytypecd
    partydisplayname
    partylegalname
    groupaccountid
    gstcategory
    placeofsupply
    entity
    email
    contactnumber
    whatsappnumber
    accountsid
    is_active
    msmetype
    deliveryconsigneename
    deliveryconsigneegstin
    statuscode
    statusmessage
    relatedpartygstdetails {
      partyid
      enteredtimestamp
      expiredtimestamp
      pannumber
      gstin
      partyaddressid
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpartycreditdetails {
      partyid
      enteredtimestamp
      expiredtimestamp
      creditperiodduration
      billingcurrency
      creditlimitcd
      creditlimitamount
      billwiseflag
      notes
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpartycontact {
      partyid
      enteredtimestamp
      expiredtimestamp
      contacttypename
      contactdesignationname
      contactorder
      email
      phonenumber
      whatsappnumber
      lastupdatedby
      statuscode
      statusmessage
      contactcountry
      whatsappcountry
      __typename
    }
    relatedpartyimages {
      attachmentid
      partyid
      companyid
      enteredtimestamp
      expiredtimestamp
      type
      documentname
      imagename
      imageurl
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    lastupdatedby
    tdspercentage
    udhyamregno
    sameaddressflag
    comments
    tdssection
    accountname
    deliverystatecode
    deliverystatename
    contactcountry
    whatsappcountry
    entityname
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPartyDropdownQueryVariables,
  APITypes.ListPartyDropdownQuery
>;
export const listPartyInvoices = /* GraphQL */ `query ListPartyInvoices($partyid: Int!) {
  listPartyInvoices(partyid: $partyid) {
    invoiceid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    invoicetypecd
    partyid
    paymentaccountid
    invoicedate
    invoicenumber
    customerordernumber
    customerorderdate
    invoiceamount
    paymenttype
    creditduration
    invoicebillingaddressid
    invoicedeliveryaddressid
    invoicetaxabletypecd
    receipturl
    invoicelinetypecd
    invoicecurrencycd
    exchangerate
    comments
    receivedamount
    adjustmentamount
    placeofsupply
    balancedueamount
    reversechargeflag
    tcsapplicableflag
    relatedinvoicetcsdetails {
      invoiceid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tcsapplicablecd
      totaltaxableamount
      ineligibletcflag
      reversechargeflag
      gstcesstotal
      tcsamount
      adjustmentamount
      tcssection
      lastupdatedby
      statuscode
      statusmessage
      tcspercentage
      tcsmanual
      __typename
    }
    relatedinvoicelineitems {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      lineitemnumber
      invoicelineitemtype
      itemid
      quantity
      unittypecd
      itemrate
      itemamount
      itemdiscount
      taxableamount
      discounttype
      discountrate
      netamount
      hsnsaccode
      taxability
      lastupdatedby
      statuscode
      statusmessage
      pricetype
      lotid
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      gstrate
      gsttypecd
      gstamount
      cessamount
      unit
      uqc
      salesaccountname
      salesaccountid
      itemname
      itemcode
      itemtype
      manualdiscount
      manualcess
      itemmaster_timestamp
      description
      relatedinvoicelinegst {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        gsttypecd
        gstamount
        cessamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relateditemmaster {
        itemid
        itemcode
        companyid
        enteredtimestamp
        expiredtimestamp
        itemname
        salesinvoiceflag
        purchaseinvoiceflag
        itemcategorycd
        measurementcd
        currencycd
        salesaccountid
        purchaseaccountid
        taxabilitycd
        reversechargeflag
        itemtype
        hsnid
        is_active
        statuscode
        statusmessage
        relateditemamountdetails {
          id
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          amount
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstcompensationvalue
          gstrate
          statuscode
          statusmessage
          lastupdatedby
          discounttype
          discountvalue
          invoicetype
          pricetype
          isactive
          isdefault
          pricetypeid
          tabletype
          __typename
        }
        relateditemgstdetails {
          itemid
          companyid
          enteredtimestamp
          expiredtimestamp
          hsnid
          gstcesstype
          gstcompensationvalue
          effectivedate
          expireddate
          gstcessvalue
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemimages {
          attachmentid
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          imagename
          imageurl
          documentname
          type
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        serialnumber
        financialyearid
        description
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        cessexist
        barcode
        __typename
      }
      pricetypeid
      manualgst
      cessrate
      cesstype
      type
      __typename
    }
    relatedinvoicelinenonitems {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoicelineitemtype
      incomeaccountid
      hsnsaccode
      taxability
      itemdescription
      taxableamount
      rate
      discount
      netamount
      relatedaccounts {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accountname
        accounttypecd
        accountgroupid
        hsnsaccode
        displayordernumber
        statuscode
        statusmessage
        restrictedflag
        is_active
        accounttypeflag
        relatedaccountgstdetails {
          accountid
          companyid
          enteredtimestamp
          expiredtimestamp
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstrate
          cessamount
          lastupdatedby
          statuscode
          statusmessage
          hsnsaccode
          codetype
          description
          taxability
          __typename
        }
        relatedaccountopeningbalance {
          accountsid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          financialyearid
          startdate
          creditamount
          debitamount
          statuscode
          statusmessage
          __typename
        }
        relatedaccountgroupmaster {
          accountgroupid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          accounttypecd
          accountgroupname
          accountparentgroupid
          displayordernumber
          statuscode
          statusmessage
          is_active
          restrictedflag
          path
          __typename
        }
        relatedaccountbalance {
          accountid
          accountbalance
          actualbalance
          __typename
        }
        path
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      gstrate
      gsttypecd
      gstamount
      cessamount
      incomeaccountname
      manualgst
      manualcess
      cessrate
      cesstype
      type
      __typename
    }
    relatedinvoiceattachment {
      invoiceid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      lastupdatedby
      statuscode
      statusmessage
      documentname
      type
      __typename
    }
    relatedinvoicedispatch {
      invoiceid
      dispatchid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transportationcd
      vehiclenumber
      dispatchdate
      ewaybillnumber
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedinvoiceposdetails {
      posid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      partyposid
      lastupdatedby
      relatedposparty {
        pospartyid
        companyid
        partyname
        partycontactnumberid
        lastupdatedby
        enteredtimestamp
        expiredtimestamp
        relatedphonecontacts {
          id
          objecttype
          objectid
          enteredtimestamp
          expiredtimestamp
          countrycode
          phonenumber
          verifieddatetime
          promotionssignup
          smsallowed
          callallowed
          whatsappallowed
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        __typename
      }
      statuscode
      statusmessage
      __typename
    }
    relatedinvoicelinegst {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      gsttypecd
      gstamount
      cessamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedinvoicelinenongst {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      gsttypecd
      gstamount
      cessamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedinvoicenumbertracker {
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      nextinvoicenumber
      lastupdatedby
      __typename
    }
    relatedinvoicetransactiondetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      vouchernumber
      entrydate
      bankreferencenumber
      comments
      relatedtransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        accountid
        creditamount
        debitamount
        comments
        entryordernumber
        transactionbalance
        openingbalance
        lastupdatedby
        statuscode
        statusmessage
        financialyearid
        __typename
      }
      relatedtransactionattachment {
        transactionid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        documentname
        statuscode
        statusmessage
        type
        __typename
      }
      relatedtransactiontdsdetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tdsapplicablecd
        tdsamount
        tdsmanual
        lastupdatedby
        statuscode
        statusmessage
        tdspercentage
        __typename
      }
      relatedpurchasemaster {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        purchasegsttypecd
        supplierid
        entrydate
        vouchernumber
        supplierinvoicedate
        supplierinvoicenumber
        supplieraddressid
        paymenttypecd
        paidamount
        creditduration
        paymentaccountid
        comments
        tdsapplicableflag
        granttotalamount
        balancedueamount
        paymentclearedflag
        placeofsupply
        companystate
        relatedpurchasetdsdetails {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          totaltaxableamount
          ineligibletcflag
          reversechargeflag
          gstcesstotal
          tdsamount
          adjustmentamount
          tdssection
          tdspercentage
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaselineitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          itemnumber
          itemid
          purchaseaccountid
          hsncode
          itemquantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          taxableamount
          description
          discounttype
          discountrate
          netamount
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          pricetype
          lotid
          hsnid
          hsncodetype
          hsndescription
          gstrate
          gstamount
          cessamount
          unit
          uqc
          purchaseaccountname
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          pricetypeid
          manualgst
          cessrate
          cesstype
          type
          __typename
        }
        relatedpurchaselinenonitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchaselineitemtype
          purchaseaccountid
          hsnsaccode
          itemdescription
          taxableamount
          rate
          discount
          netamount
          relatedpurchaselinenongst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gstamount
          cessamount
          purchaseaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          type
          __typename
        }
        relatedpurchaselinegst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaseattachment {
          purchaseid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedpurchasetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              description
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              description
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        relatedpurchasetransactionrelation {
          transactionid
          transactiontypecd
          objecttype
          objectid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          linkedamount
          objectattribute
          isdirect
          lastupdatedby
          accountid
          paymentvouchernumber
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        cancelflag
        roundoffamount
        discounttype
        discountvalue
        adjustmentamount
        serialnumber
        currencycode
        currencyrate
        reversechargeflag
        paymentstatus
        partyregistrationtype
        partygstcategory
        itcflag
        __typename
      }
      relatedinvoicemaster {
        invoiceid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        invoicetypecd
        partyid
        paymentaccountid
        invoicedate
        invoicenumber
        customerordernumber
        customerorderdate
        invoiceamount
        paymenttype
        creditduration
        invoicebillingaddressid
        invoicedeliveryaddressid
        invoicetaxabletypecd
        receipturl
        invoicelinetypecd
        invoicecurrencycd
        exchangerate
        comments
        receivedamount
        adjustmentamount
        placeofsupply
        balancedueamount
        reversechargeflag
        tcsapplicableflag
        relatedinvoicelineitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          lineitemnumber
          invoicelineitemtype
          itemid
          quantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          taxableamount
          discounttype
          discountrate
          netamount
          hsnsaccode
          taxability
          lastupdatedby
          statuscode
          statusmessage
          pricetype
          lotid
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          unit
          uqc
          salesaccountname
          salesaccountid
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          itemmaster_timestamp
          description
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          pricetypeid
          manualgst
          cessrate
          cesstype
          type
          __typename
        }
        relatedinvoicelinenonitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicelineitemtype
          incomeaccountid
          hsnsaccode
          taxability
          itemdescription
          taxableamount
          rate
          discount
          netamount
          relatedaccounts {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accountname
            accounttypecd
            accountgroupid
            hsnsaccode
            displayordernumber
            statuscode
            statusmessage
            restrictedflag
            is_active
            accounttypeflag
            relatedaccountgstdetails {
              accountid
              companyid
              enteredtimestamp
              expiredtimestamp
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstrate
              cessamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsaccode
              codetype
              description
              taxability
              __typename
            }
            relatedaccountopeningbalance {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              financialyearid
              startdate
              creditamount
              debitamount
              statuscode
              statusmessage
              __typename
            }
            relatedaccountgroupmaster {
              accountgroupid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accounttypecd
              accountgroupname
              accountparentgroupid
              displayordernumber
              statuscode
              statusmessage
              is_active
              restrictedflag
              path
              __typename
            }
            relatedaccountbalance {
              accountid
              accountbalance
              actualbalance
              __typename
            }
            path
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          incomeaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          type
          __typename
        }
        relatedinvoiceattachment {
          invoiceid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedinvoicedispatch {
          invoiceid
          dispatchid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transportationcd
          vehiclenumber
          dispatchdate
          ewaybillnumber
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoiceposdetails {
          posid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          partyposid
          lastupdatedby
          relatedposparty {
            pospartyid
            companyid
            partyname
            partycontactnumberid
            lastupdatedby
            enteredtimestamp
            expiredtimestamp
            relatedphonecontacts {
              id
              objecttype
              objectid
              enteredtimestamp
              expiredtimestamp
              countrycode
              phonenumber
              verifieddatetime
              promotionssignup
              smsallowed
              callallowed
              whatsappallowed
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            __typename
          }
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicelinegst {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          gsttypecd
          gstamount
          cessamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicenumbertracker {
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          nextinvoicenumber
          lastupdatedby
          __typename
        }
        relatedinvoicetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              description
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              description
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        lastupdatedby
        cancelflag
        statuscode
        statusmessage
        consigneename
        consigneegstin
        companystate
        cancelremark
        deleteremark
        roundoffamount
        discounttype
        discountvalue
        serialnumber
        currencycode
        currencyrate
        paymentstatus
        ackno
        ackdt
        irn
        signedqrcode
        itcflag
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      cancelflag
      cancelremark
      serialnumber
      pdflink
      towards
      isvouchereditable
      __typename
    }
    relatedpartymaster {
      partyid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      partytypecd
      partydisplayname
      partylegalname
      groupaccountid
      gstcategory
      placeofsupply
      entity
      email
      contactnumber
      whatsappnumber
      accountsid
      is_active
      msmetype
      deliveryconsigneename
      deliveryconsigneegstin
      statuscode
      statusmessage
      relatedpartygstdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        pannumber
        gstin
        partyaddressid
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycreditdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        creditperiodduration
        billingcurrency
        creditlimitcd
        creditlimitamount
        billwiseflag
        notes
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycontact {
        partyid
        enteredtimestamp
        expiredtimestamp
        contacttypename
        contactdesignationname
        contactorder
        email
        phonenumber
        whatsappnumber
        lastupdatedby
        statuscode
        statusmessage
        contactcountry
        whatsappcountry
        __typename
      }
      relatedpartyimages {
        attachmentid
        partyid
        companyid
        enteredtimestamp
        expiredtimestamp
        type
        documentname
        imagename
        imageurl
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      tdspercentage
      udhyamregno
      sameaddressflag
      comments
      tdssection
      accountname
      deliverystatecode
      deliverystatename
      contactcountry
      whatsappcountry
      entityname
      __typename
    }
    relatedpaymentaccountdetails {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    relatedinvoiceaddressdetails {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      line1
      line2
      line3
      city
      statecode
      statename
      statuscode
      statusmessage
      pincode
      countrycode
      codevalue
      district
      lastupdatedby
      godownname
      gstin
      phone
      email
      personincharge
      consigneename
      consigneegstin
      foreignstate
      foreigndistrict
      defaultflag
      addresstitle
      addressindex
      __typename
    }
    lastupdatedby
    statuscode
    statusmessage
    cancelflag
    consigneename
    consigneegstin
    companystate
    cancelremark
    deleteremark
    roundoffamount
    discounttype
    discountvalue
    serialnumber
    serialflag
    currencycode
    currencyrate
    partydisplayname
    partylegalname
    partyaccountid
    paymentstatus
    ackno
    ackdt
    irn
    signedqrcode
    partyemail
    invoicepdf
    partygstin
    partytypecd
    partygstcategory
    is_cancelled
    cancel_reason
    cancel_remarks
    phonenumber
    bankaccountid
    bankamount
    ewaybillno
    validupto
    ewaybill_validupto
    ewaybill_is_cancelled
    ewaybill_cancel_remarks
    ewaybill_cancel_rsn_code
    cancel_rsn_code
    einvoiceenteredtimestamp
    ewaybillenteredtimestamp
    ewaybillid
    ewaybillpdf
    ewaybillstatus
    invoicetype
    accountname
    partyisactive
    goods_exist
    overduedays
    duedatetimestamp
    isvouchereditable
    itcflag
    taxability
    linkedamount
    cessexist
    partyamount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPartyInvoicesQueryVariables,
  APITypes.ListPartyInvoicesQuery
>;
export const listOutstandingInvoiceMaster = /* GraphQL */ `query ListOutstandingInvoiceMaster(
  $basedon: Int
  $ageing: Int
  $word: String!
  $startdate: Int!
  $enddate: Int!
  $rowfrom: Int!
  $limitno: Int!
  $columnname: String
  $ordertype: String
  $searchmode: Int
  $searcharray: AWSJSON
) {
  listOutstandingInvoiceMaster(
    basedon: $basedon
    ageing: $ageing
    word: $word
    startdate: $startdate
    enddate: $enddate
    rowfrom: $rowfrom
    limitno: $limitno
    columnname: $columnname
    ordertype: $ordertype
    searchmode: $searchmode
    searcharray: $searcharray
  ) {
    invoiceid
    invoicetype
    invoicenumber
    invoicedate
    partydisplayname
    partylegalname
    invoiceamount
    receivedamount
    balancedueamount
    creditduration
    overduedays
    duedate
    recordcount
    total_balancedueamount
    partyid
    partyaccountid
    adjustment_details {
      transactionid
      transactiontypecd
      vouchernumber
      linkedamount
      linkeddate
      isdirect
      paymentvouchernumber
      objectattribute
      transactiondate
      description
      __typename
    }
    adjustment_summary {
      total_receipts
      total_credit_notes
      total_debit_notes
      total_payments
      adjustment_count
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOutstandingInvoiceMasterQueryVariables,
  APITypes.ListOutstandingInvoiceMasterQuery
>;
export const listOutstandingPurchaseMaster = /* GraphQL */ `query ListOutstandingPurchaseMaster(
  $basedon: Int
  $ageing: Int
  $word: String!
  $startdate: Int!
  $enddate: Int!
  $rowfrom: Int!
  $limitno: Int!
  $columnname: String
  $ordertype: String
  $searchmode: Int
  $searcharray: AWSJSON
) {
  listOutstandingPurchaseMaster(
    basedon: $basedon
    ageing: $ageing
    word: $word
    startdate: $startdate
    enddate: $enddate
    rowfrom: $rowfrom
    limitno: $limitno
    columnname: $columnname
    ordertype: $ordertype
    searchmode: $searchmode
    searcharray: $searcharray
  ) {
    purchaseid
    invoicetype
    purchaseinvoicenumber
    purchaseinvoicedate
    partydisplayname
    partylegalname
    granttotalamount
    receivedamount
    balancedueamount
    creditduration
    overduedays
    duedate
    recordcount
    total_balancedueamount
    partyid
    partyaccountid
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOutstandingPurchaseMasterQueryVariables,
  APITypes.ListOutstandingPurchaseMasterQuery
>;
export const listLUTBondMaster = /* GraphQL */ `query ListLUTBondMaster {
  listLUTBondMaster {
    id
    lutno
    companyid
    enteredtimestamp
    expiredtimestamp
    validfrom
    validto
    financialyearid
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLUTBondMasterQueryVariables,
  APITypes.ListLUTBondMasterQuery
>;
export const listLineItems = /* GraphQL */ `query ListLineItems($jsondata: AWSJSON!) {
  listLineItems(jsondata: $jsondata) {
    type
    invoiceid
    purchaseid
    itemid
    quantity
    unittypecd
    itemrate
    itemamount
    itemdiscount
    itemdiscounttype
    itemdiscountrate
    netamount
    lineitemnumber
    invoicelineitemtype
    hsnsaccode
    taxability
    pricetype
    lotid
    companyid
    enteredtimestamp
    expiredtimestamp
    vouchernumber
    invoicelinetypecd
    comments
    balancedueamount
    reversechargeflag
    cancelflag
    invoiceitemid
    purchaseitemid
    gstrate
    gstamount
    cessamount
    itemquantity
    hsncode
    itemname
    salesaccountid
    purchaseaccountid
    hsndescription
    itemcode
    itemtype
    hsnsacid
    hsncodetype
    hsnmastercode
    pricetypeid
    manualgst
    manualdiscount
    manualcess
    cessrate
    cesstype
    placeofsupply
    statename
    description
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLineItemsQueryVariables,
  APITypes.ListLineItemsQuery
>;
export const listlatestInvoice = /* GraphQL */ `query ListlatestInvoice {
  listlatestInvoice {
    invoiceid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    invoicetypecd
    partyid
    paymentaccountid
    invoicedate
    invoicenumber
    customerordernumber
    customerorderdate
    invoiceamount
    paymenttype
    creditduration
    invoicebillingaddressid
    invoicedeliveryaddressid
    invoicetaxabletypecd
    receipturl
    invoicelinetypecd
    invoicecurrencycd
    exchangerate
    comments
    receivedamount
    adjustmentamount
    placeofsupply
    balancedueamount
    reversechargeflag
    tcsapplicableflag
    relatedinvoicetcsdetails {
      invoiceid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tcsapplicablecd
      totaltaxableamount
      ineligibletcflag
      reversechargeflag
      gstcesstotal
      tcsamount
      adjustmentamount
      tcssection
      lastupdatedby
      statuscode
      statusmessage
      tcspercentage
      tcsmanual
      __typename
    }
    relatedinvoicelineitems {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      lineitemnumber
      invoicelineitemtype
      itemid
      quantity
      unittypecd
      itemrate
      itemamount
      itemdiscount
      taxableamount
      discounttype
      discountrate
      netamount
      hsnsaccode
      taxability
      lastupdatedby
      statuscode
      statusmessage
      pricetype
      lotid
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      gstrate
      gsttypecd
      gstamount
      cessamount
      unit
      uqc
      salesaccountname
      salesaccountid
      itemname
      itemcode
      itemtype
      manualdiscount
      manualcess
      itemmaster_timestamp
      description
      relatedinvoicelinegst {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        gsttypecd
        gstamount
        cessamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relateditemmaster {
        itemid
        itemcode
        companyid
        enteredtimestamp
        expiredtimestamp
        itemname
        salesinvoiceflag
        purchaseinvoiceflag
        itemcategorycd
        measurementcd
        currencycd
        salesaccountid
        purchaseaccountid
        taxabilitycd
        reversechargeflag
        itemtype
        hsnid
        is_active
        statuscode
        statusmessage
        relateditemamountdetails {
          id
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          amount
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstcompensationvalue
          gstrate
          statuscode
          statusmessage
          lastupdatedby
          discounttype
          discountvalue
          invoicetype
          pricetype
          isactive
          isdefault
          pricetypeid
          tabletype
          __typename
        }
        relateditemgstdetails {
          itemid
          companyid
          enteredtimestamp
          expiredtimestamp
          hsnid
          gstcesstype
          gstcompensationvalue
          effectivedate
          expireddate
          gstcessvalue
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemimages {
          attachmentid
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          imagename
          imageurl
          documentname
          type
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        serialnumber
        financialyearid
        description
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        cessexist
        barcode
        __typename
      }
      pricetypeid
      manualgst
      cessrate
      cesstype
      type
      __typename
    }
    relatedinvoicelinenonitems {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoicelineitemtype
      incomeaccountid
      hsnsaccode
      taxability
      itemdescription
      taxableamount
      rate
      discount
      netamount
      relatedaccounts {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accountname
        accounttypecd
        accountgroupid
        hsnsaccode
        displayordernumber
        statuscode
        statusmessage
        restrictedflag
        is_active
        accounttypeflag
        relatedaccountgstdetails {
          accountid
          companyid
          enteredtimestamp
          expiredtimestamp
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstrate
          cessamount
          lastupdatedby
          statuscode
          statusmessage
          hsnsaccode
          codetype
          description
          taxability
          __typename
        }
        relatedaccountopeningbalance {
          accountsid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          financialyearid
          startdate
          creditamount
          debitamount
          statuscode
          statusmessage
          __typename
        }
        relatedaccountgroupmaster {
          accountgroupid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          accounttypecd
          accountgroupname
          accountparentgroupid
          displayordernumber
          statuscode
          statusmessage
          is_active
          restrictedflag
          path
          __typename
        }
        relatedaccountbalance {
          accountid
          accountbalance
          actualbalance
          __typename
        }
        path
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      gstrate
      gsttypecd
      gstamount
      cessamount
      incomeaccountname
      manualgst
      manualcess
      cessrate
      cesstype
      type
      __typename
    }
    relatedinvoiceattachment {
      invoiceid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      lastupdatedby
      statuscode
      statusmessage
      documentname
      type
      __typename
    }
    relatedinvoicedispatch {
      invoiceid
      dispatchid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transportationcd
      vehiclenumber
      dispatchdate
      ewaybillnumber
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedinvoiceposdetails {
      posid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      partyposid
      lastupdatedby
      relatedposparty {
        pospartyid
        companyid
        partyname
        partycontactnumberid
        lastupdatedby
        enteredtimestamp
        expiredtimestamp
        relatedphonecontacts {
          id
          objecttype
          objectid
          enteredtimestamp
          expiredtimestamp
          countrycode
          phonenumber
          verifieddatetime
          promotionssignup
          smsallowed
          callallowed
          whatsappallowed
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        __typename
      }
      statuscode
      statusmessage
      __typename
    }
    relatedinvoicelinegst {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      gsttypecd
      gstamount
      cessamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedinvoicelinenongst {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      gsttypecd
      gstamount
      cessamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedinvoicenumbertracker {
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      nextinvoicenumber
      lastupdatedby
      __typename
    }
    relatedinvoicetransactiondetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      vouchernumber
      entrydate
      bankreferencenumber
      comments
      relatedtransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        accountid
        creditamount
        debitamount
        comments
        entryordernumber
        transactionbalance
        openingbalance
        lastupdatedby
        statuscode
        statusmessage
        financialyearid
        __typename
      }
      relatedtransactionattachment {
        transactionid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        documentname
        statuscode
        statusmessage
        type
        __typename
      }
      relatedtransactiontdsdetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tdsapplicablecd
        tdsamount
        tdsmanual
        lastupdatedby
        statuscode
        statusmessage
        tdspercentage
        __typename
      }
      relatedpurchasemaster {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        purchasegsttypecd
        supplierid
        entrydate
        vouchernumber
        supplierinvoicedate
        supplierinvoicenumber
        supplieraddressid
        paymenttypecd
        paidamount
        creditduration
        paymentaccountid
        comments
        tdsapplicableflag
        granttotalamount
        balancedueamount
        paymentclearedflag
        placeofsupply
        companystate
        relatedpurchasetdsdetails {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          totaltaxableamount
          ineligibletcflag
          reversechargeflag
          gstcesstotal
          tdsamount
          adjustmentamount
          tdssection
          tdspercentage
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaselineitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          itemnumber
          itemid
          purchaseaccountid
          hsncode
          itemquantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          taxableamount
          description
          discounttype
          discountrate
          netamount
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          pricetype
          lotid
          hsnid
          hsncodetype
          hsndescription
          gstrate
          gstamount
          cessamount
          unit
          uqc
          purchaseaccountname
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          pricetypeid
          manualgst
          cessrate
          cesstype
          type
          __typename
        }
        relatedpurchaselinenonitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchaselineitemtype
          purchaseaccountid
          hsnsaccode
          itemdescription
          taxableamount
          rate
          discount
          netamount
          relatedpurchaselinenongst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gstamount
          cessamount
          purchaseaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          type
          __typename
        }
        relatedpurchaselinegst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaseattachment {
          purchaseid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedpurchasetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              description
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              description
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        relatedpurchasetransactionrelation {
          transactionid
          transactiontypecd
          objecttype
          objectid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          linkedamount
          objectattribute
          isdirect
          lastupdatedby
          accountid
          paymentvouchernumber
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        cancelflag
        roundoffamount
        discounttype
        discountvalue
        adjustmentamount
        serialnumber
        currencycode
        currencyrate
        reversechargeflag
        paymentstatus
        partyregistrationtype
        partygstcategory
        itcflag
        __typename
      }
      relatedinvoicemaster {
        invoiceid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        invoicetypecd
        partyid
        paymentaccountid
        invoicedate
        invoicenumber
        customerordernumber
        customerorderdate
        invoiceamount
        paymenttype
        creditduration
        invoicebillingaddressid
        invoicedeliveryaddressid
        invoicetaxabletypecd
        receipturl
        invoicelinetypecd
        invoicecurrencycd
        exchangerate
        comments
        receivedamount
        adjustmentamount
        placeofsupply
        balancedueamount
        reversechargeflag
        tcsapplicableflag
        relatedinvoicelineitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          lineitemnumber
          invoicelineitemtype
          itemid
          quantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          taxableamount
          discounttype
          discountrate
          netamount
          hsnsaccode
          taxability
          lastupdatedby
          statuscode
          statusmessage
          pricetype
          lotid
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          unit
          uqc
          salesaccountname
          salesaccountid
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          itemmaster_timestamp
          description
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          pricetypeid
          manualgst
          cessrate
          cesstype
          type
          __typename
        }
        relatedinvoicelinenonitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicelineitemtype
          incomeaccountid
          hsnsaccode
          taxability
          itemdescription
          taxableamount
          rate
          discount
          netamount
          relatedaccounts {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accountname
            accounttypecd
            accountgroupid
            hsnsaccode
            displayordernumber
            statuscode
            statusmessage
            restrictedflag
            is_active
            accounttypeflag
            relatedaccountgstdetails {
              accountid
              companyid
              enteredtimestamp
              expiredtimestamp
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstrate
              cessamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsaccode
              codetype
              description
              taxability
              __typename
            }
            relatedaccountopeningbalance {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              financialyearid
              startdate
              creditamount
              debitamount
              statuscode
              statusmessage
              __typename
            }
            relatedaccountgroupmaster {
              accountgroupid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accounttypecd
              accountgroupname
              accountparentgroupid
              displayordernumber
              statuscode
              statusmessage
              is_active
              restrictedflag
              path
              __typename
            }
            relatedaccountbalance {
              accountid
              accountbalance
              actualbalance
              __typename
            }
            path
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          incomeaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          type
          __typename
        }
        relatedinvoiceattachment {
          invoiceid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedinvoicedispatch {
          invoiceid
          dispatchid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transportationcd
          vehiclenumber
          dispatchdate
          ewaybillnumber
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoiceposdetails {
          posid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          partyposid
          lastupdatedby
          relatedposparty {
            pospartyid
            companyid
            partyname
            partycontactnumberid
            lastupdatedby
            enteredtimestamp
            expiredtimestamp
            relatedphonecontacts {
              id
              objecttype
              objectid
              enteredtimestamp
              expiredtimestamp
              countrycode
              phonenumber
              verifieddatetime
              promotionssignup
              smsallowed
              callallowed
              whatsappallowed
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            __typename
          }
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicelinegst {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          gsttypecd
          gstamount
          cessamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicenumbertracker {
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          nextinvoicenumber
          lastupdatedby
          __typename
        }
        relatedinvoicetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              description
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              description
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        lastupdatedby
        cancelflag
        statuscode
        statusmessage
        consigneename
        consigneegstin
        companystate
        cancelremark
        deleteremark
        roundoffamount
        discounttype
        discountvalue
        serialnumber
        currencycode
        currencyrate
        paymentstatus
        ackno
        ackdt
        irn
        signedqrcode
        itcflag
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      cancelflag
      cancelremark
      serialnumber
      pdflink
      towards
      isvouchereditable
      __typename
    }
    relatedpartymaster {
      partyid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      partytypecd
      partydisplayname
      partylegalname
      groupaccountid
      gstcategory
      placeofsupply
      entity
      email
      contactnumber
      whatsappnumber
      accountsid
      is_active
      msmetype
      deliveryconsigneename
      deliveryconsigneegstin
      statuscode
      statusmessage
      relatedpartygstdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        pannumber
        gstin
        partyaddressid
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycreditdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        creditperiodduration
        billingcurrency
        creditlimitcd
        creditlimitamount
        billwiseflag
        notes
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycontact {
        partyid
        enteredtimestamp
        expiredtimestamp
        contacttypename
        contactdesignationname
        contactorder
        email
        phonenumber
        whatsappnumber
        lastupdatedby
        statuscode
        statusmessage
        contactcountry
        whatsappcountry
        __typename
      }
      relatedpartyimages {
        attachmentid
        partyid
        companyid
        enteredtimestamp
        expiredtimestamp
        type
        documentname
        imagename
        imageurl
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      tdspercentage
      udhyamregno
      sameaddressflag
      comments
      tdssection
      accountname
      deliverystatecode
      deliverystatename
      contactcountry
      whatsappcountry
      entityname
      __typename
    }
    relatedpaymentaccountdetails {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    relatedinvoiceaddressdetails {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      line1
      line2
      line3
      city
      statecode
      statename
      statuscode
      statusmessage
      pincode
      countrycode
      codevalue
      district
      lastupdatedby
      godownname
      gstin
      phone
      email
      personincharge
      consigneename
      consigneegstin
      foreignstate
      foreigndistrict
      defaultflag
      addresstitle
      addressindex
      __typename
    }
    lastupdatedby
    statuscode
    statusmessage
    cancelflag
    consigneename
    consigneegstin
    companystate
    cancelremark
    deleteremark
    roundoffamount
    discounttype
    discountvalue
    serialnumber
    serialflag
    currencycode
    currencyrate
    partydisplayname
    partylegalname
    partyaccountid
    paymentstatus
    ackno
    ackdt
    irn
    signedqrcode
    partyemail
    invoicepdf
    partygstin
    partytypecd
    partygstcategory
    is_cancelled
    cancel_reason
    cancel_remarks
    phonenumber
    bankaccountid
    bankamount
    ewaybillno
    validupto
    ewaybill_validupto
    ewaybill_is_cancelled
    ewaybill_cancel_remarks
    ewaybill_cancel_rsn_code
    cancel_rsn_code
    einvoiceenteredtimestamp
    ewaybillenteredtimestamp
    ewaybillid
    ewaybillpdf
    ewaybillstatus
    invoicetype
    accountname
    partyisactive
    goods_exist
    overduedays
    duedatetimestamp
    isvouchereditable
    itcflag
    taxability
    linkedamount
    cessexist
    partyamount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListlatestInvoiceQueryVariables,
  APITypes.ListlatestInvoiceQuery
>;
export const listlatestPurchase = /* GraphQL */ `query ListlatestPurchase {
  listlatestPurchase {
    purchaseid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    purchasegsttypecd
    supplierid
    entrydate
    vouchernumber
    supplierinvoicedate
    supplierinvoicenumber
    supplieraddressid
    paymenttypecd
    paidamount
    creditduration
    paymentaccountid
    comments
    tdsapplicableflag
    granttotalamount
    balancedueamount
    paymentclearedflag
    placeofsupply
    companystate
    relatedpurchasetdsdetails {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tdsapplicablecd
      totaltaxableamount
      ineligibletcflag
      reversechargeflag
      gstcesstotal
      tdsamount
      adjustmentamount
      tdssection
      tdspercentage
      tdsmanual
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpurchasetcsdetails {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tcsapplicablecd
      totaltaxableamount
      ineligibletcflag
      reversechargeflag
      gstcesstotal
      tcsamount
      adjustmentamount
      tcssection
      lastupdatedby
      statuscode
      statusmessage
      tcspercentage
      tcsmanual
      __typename
    }
    relatedpurchaselineitems {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      itemnumber
      itemid
      purchaseaccountid
      hsncode
      itemquantity
      unittypecd
      itemrate
      itemamount
      itemdiscount
      taxableamount
      description
      discounttype
      discountrate
      netamount
      relatedpurchaselinegst {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        cessamount
        gstamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relateditemmaster {
        itemid
        itemcode
        companyid
        enteredtimestamp
        expiredtimestamp
        itemname
        salesinvoiceflag
        purchaseinvoiceflag
        itemcategorycd
        measurementcd
        currencycd
        salesaccountid
        purchaseaccountid
        taxabilitycd
        reversechargeflag
        itemtype
        hsnid
        is_active
        statuscode
        statusmessage
        relateditemamountdetails {
          id
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          amount
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstcompensationvalue
          gstrate
          statuscode
          statusmessage
          lastupdatedby
          discounttype
          discountvalue
          invoicetype
          pricetype
          isactive
          isdefault
          pricetypeid
          tabletype
          __typename
        }
        relateditemgstdetails {
          itemid
          companyid
          enteredtimestamp
          expiredtimestamp
          hsnid
          gstcesstype
          gstcompensationvalue
          effectivedate
          expireddate
          gstcessvalue
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemimages {
          attachmentid
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          imagename
          imageurl
          documentname
          type
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        serialnumber
        financialyearid
        description
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        cessexist
        barcode
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      taxability
      pricetype
      lotid
      hsnid
      hsncodetype
      hsndescription
      gstrate
      gstamount
      cessamount
      unit
      uqc
      purchaseaccountname
      itemname
      itemcode
      itemtype
      manualdiscount
      manualcess
      pricetypeid
      manualgst
      cessrate
      cesstype
      type
      __typename
    }
    relatedpurchaselinenonitems {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      purchaselineitemtype
      purchaseaccountid
      hsnsaccode
      itemdescription
      taxableamount
      rate
      discount
      netamount
      relatedpurchaselinenongst {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        cessamount
        gstamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      taxability
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      gstrate
      gstamount
      cessamount
      purchaseaccountname
      manualgst
      manualcess
      cessrate
      cesstype
      type
      __typename
    }
    relatedpurchaselinegst {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      cessamount
      gstamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpurchaselinenongst {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      cessamount
      gstamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpurchaseattachment {
      purchaseid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      lastupdatedby
      statuscode
      statusmessage
      documentname
      type
      __typename
    }
    relatedpurchasetransactiondetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      vouchernumber
      entrydate
      bankreferencenumber
      comments
      relatedtransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        accountid
        creditamount
        debitamount
        comments
        entryordernumber
        transactionbalance
        openingbalance
        lastupdatedby
        statuscode
        statusmessage
        financialyearid
        __typename
      }
      relatedtransactionattachment {
        transactionid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        documentname
        statuscode
        statusmessage
        type
        __typename
      }
      relatedtransactiontdsdetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tdsapplicablecd
        tdsamount
        tdsmanual
        lastupdatedby
        statuscode
        statusmessage
        tdspercentage
        __typename
      }
      relatedpurchasemaster {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        purchasegsttypecd
        supplierid
        entrydate
        vouchernumber
        supplierinvoicedate
        supplierinvoicenumber
        supplieraddressid
        paymenttypecd
        paidamount
        creditduration
        paymentaccountid
        comments
        tdsapplicableflag
        granttotalamount
        balancedueamount
        paymentclearedflag
        placeofsupply
        companystate
        relatedpurchasetdsdetails {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          totaltaxableamount
          ineligibletcflag
          reversechargeflag
          gstcesstotal
          tdsamount
          adjustmentamount
          tdssection
          tdspercentage
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaselineitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          itemnumber
          itemid
          purchaseaccountid
          hsncode
          itemquantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          taxableamount
          description
          discounttype
          discountrate
          netamount
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          pricetype
          lotid
          hsnid
          hsncodetype
          hsndescription
          gstrate
          gstamount
          cessamount
          unit
          uqc
          purchaseaccountname
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          pricetypeid
          manualgst
          cessrate
          cesstype
          type
          __typename
        }
        relatedpurchaselinenonitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchaselineitemtype
          purchaseaccountid
          hsnsaccode
          itemdescription
          taxableamount
          rate
          discount
          netamount
          relatedpurchaselinenongst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gstamount
          cessamount
          purchaseaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          type
          __typename
        }
        relatedpurchaselinegst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaseattachment {
          purchaseid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedpurchasetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              description
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              description
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        relatedpurchasetransactionrelation {
          transactionid
          transactiontypecd
          objecttype
          objectid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          linkedamount
          objectattribute
          isdirect
          lastupdatedby
          accountid
          paymentvouchernumber
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        cancelflag
        roundoffamount
        discounttype
        discountvalue
        adjustmentamount
        serialnumber
        currencycode
        currencyrate
        reversechargeflag
        paymentstatus
        partyregistrationtype
        partygstcategory
        itcflag
        __typename
      }
      relatedinvoicemaster {
        invoiceid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        invoicetypecd
        partyid
        paymentaccountid
        invoicedate
        invoicenumber
        customerordernumber
        customerorderdate
        invoiceamount
        paymenttype
        creditduration
        invoicebillingaddressid
        invoicedeliveryaddressid
        invoicetaxabletypecd
        receipturl
        invoicelinetypecd
        invoicecurrencycd
        exchangerate
        comments
        receivedamount
        adjustmentamount
        placeofsupply
        balancedueamount
        reversechargeflag
        tcsapplicableflag
        relatedinvoicelineitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          lineitemnumber
          invoicelineitemtype
          itemid
          quantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          taxableamount
          discounttype
          discountrate
          netamount
          hsnsaccode
          taxability
          lastupdatedby
          statuscode
          statusmessage
          pricetype
          lotid
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          unit
          uqc
          salesaccountname
          salesaccountid
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          itemmaster_timestamp
          description
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          pricetypeid
          manualgst
          cessrate
          cesstype
          type
          __typename
        }
        relatedinvoicelinenonitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicelineitemtype
          incomeaccountid
          hsnsaccode
          taxability
          itemdescription
          taxableamount
          rate
          discount
          netamount
          relatedaccounts {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accountname
            accounttypecd
            accountgroupid
            hsnsaccode
            displayordernumber
            statuscode
            statusmessage
            restrictedflag
            is_active
            accounttypeflag
            relatedaccountgstdetails {
              accountid
              companyid
              enteredtimestamp
              expiredtimestamp
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstrate
              cessamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsaccode
              codetype
              description
              taxability
              __typename
            }
            relatedaccountopeningbalance {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              financialyearid
              startdate
              creditamount
              debitamount
              statuscode
              statusmessage
              __typename
            }
            relatedaccountgroupmaster {
              accountgroupid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accounttypecd
              accountgroupname
              accountparentgroupid
              displayordernumber
              statuscode
              statusmessage
              is_active
              restrictedflag
              path
              __typename
            }
            relatedaccountbalance {
              accountid
              accountbalance
              actualbalance
              __typename
            }
            path
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          incomeaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          type
          __typename
        }
        relatedinvoiceattachment {
          invoiceid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedinvoicedispatch {
          invoiceid
          dispatchid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transportationcd
          vehiclenumber
          dispatchdate
          ewaybillnumber
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoiceposdetails {
          posid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          partyposid
          lastupdatedby
          relatedposparty {
            pospartyid
            companyid
            partyname
            partycontactnumberid
            lastupdatedby
            enteredtimestamp
            expiredtimestamp
            relatedphonecontacts {
              id
              objecttype
              objectid
              enteredtimestamp
              expiredtimestamp
              countrycode
              phonenumber
              verifieddatetime
              promotionssignup
              smsallowed
              callallowed
              whatsappallowed
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            __typename
          }
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicelinegst {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          gsttypecd
          gstamount
          cessamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicenumbertracker {
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          nextinvoicenumber
          lastupdatedby
          __typename
        }
        relatedinvoicetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              description
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              description
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        lastupdatedby
        cancelflag
        statuscode
        statusmessage
        consigneename
        consigneegstin
        companystate
        cancelremark
        deleteremark
        roundoffamount
        discounttype
        discountvalue
        serialnumber
        currencycode
        currencyrate
        paymentstatus
        ackno
        ackdt
        irn
        signedqrcode
        itcflag
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      cancelflag
      cancelremark
      serialnumber
      pdflink
      towards
      isvouchereditable
      __typename
    }
    relatedpartymaster {
      partyid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      partytypecd
      partydisplayname
      partylegalname
      groupaccountid
      gstcategory
      placeofsupply
      entity
      email
      contactnumber
      whatsappnumber
      accountsid
      is_active
      msmetype
      deliveryconsigneename
      deliveryconsigneegstin
      statuscode
      statusmessage
      relatedpartygstdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        pannumber
        gstin
        partyaddressid
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycreditdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        creditperiodduration
        billingcurrency
        creditlimitcd
        creditlimitamount
        billwiseflag
        notes
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycontact {
        partyid
        enteredtimestamp
        expiredtimestamp
        contacttypename
        contactdesignationname
        contactorder
        email
        phonenumber
        whatsappnumber
        lastupdatedby
        statuscode
        statusmessage
        contactcountry
        whatsappcountry
        __typename
      }
      relatedpartyimages {
        attachmentid
        partyid
        companyid
        enteredtimestamp
        expiredtimestamp
        type
        documentname
        imagename
        imageurl
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      tdspercentage
      udhyamregno
      sameaddressflag
      comments
      tdssection
      accountname
      deliverystatecode
      deliverystatename
      contactcountry
      whatsappcountry
      entityname
      __typename
    }
    relatedpartyaddressdetails {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      line1
      line2
      line3
      city
      statecode
      statename
      statuscode
      statusmessage
      pincode
      countrycode
      codevalue
      district
      lastupdatedby
      godownname
      gstin
      phone
      email
      personincharge
      consigneename
      consigneegstin
      foreignstate
      foreigndistrict
      defaultflag
      addresstitle
      addressindex
      __typename
    }
    relatedpaymentaccountdetails {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    relatedpurchaseaddressdetails {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      line1
      line2
      line3
      city
      statecode
      statename
      statuscode
      statusmessage
      pincode
      countrycode
      codevalue
      district
      lastupdatedby
      godownname
      gstin
      phone
      email
      personincharge
      consigneename
      consigneegstin
      foreignstate
      foreigndistrict
      defaultflag
      addresstitle
      addressindex
      __typename
    }
    lastupdatedby
    cancelflag
    roundoffamount
    discounttype
    discountvalue
    adjustmentamount
    statuscode
    statusmessage
    serialnumber
    currencycode
    currencyrate
    partydisplayname
    partylegalname
    partyaccountid
    reversechargeflag
    overduedays
    paymentstatus
    partyregistrationtype
    purchaseinvoicepdf
    partygstcategory
    partyemail
    partygstin
    partytypecd
    ewaybillno
    validupto
    ewaybill_is_cancelled
    ewaybill_cancel_remarks
    cancel_rsn_code
    einvoiceenteredtimestamp
    ewaybillenteredtimestamp
    ewaybillid
    accountname
    duedatetimestamp
    partyisactive
    consigneename
    consigneegstin
    ewaybillpdf
    ewaybillstatus
    isvouchereditable
    goods_exist
    itcflag
    linkedamount
    cessexist
    partyamount
    totalgstamount
    tdsamount
    tcsamount
    taxableamount
    igstamount
    cgstamount
    sgstamount
    cessamount
    sourceofsupply
    taxabilitylabel
    additionaldiscount
    netinvoiceamount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListlatestPurchaseQueryVariables,
  APITypes.ListlatestPurchaseQuery
>;
export const listitemtablepreference = /* GraphQL */ `query Listitemtablepreference {
  listitemtablepreference {
    id
    companyid
    type
    itemcode
    itemname
    category
    unit
    showitemin
    purchaseac
    salesac
    hsnSAC
    taxability
    purchaseamount
    sellingprice
    updateprice
    totalsellingprice
    effectivefrom
    effectiveto
    actions
    userid
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListitemtablepreferenceQueryVariables,
  APITypes.ListitemtablepreferenceQuery
>;
export const listItemmastersv2 = /* GraphQL */ `query ListItemmastersv2(
  $rowfrom: Int!
  $limitno: Int!
  $columnname: String
  $ordertype: String
  $searchmode: Int
  $searcharray: AWSJSON
) {
  listItemmastersv2(
    rowfrom: $rowfrom
    limitno: $limitno
    columnname: $columnname
    ordertype: $ordertype
    searchmode: $searchmode
    searcharray: $searcharray
  ) {
    itemid
    itemcode
    companyid
    enteredtimestamp
    expiredtimestamp
    itemname
    salesinvoiceflag
    purchaseinvoiceflag
    itemcategorycd
    measurementcd
    currencycd
    salesaccountid
    purchaseaccountid
    taxabilitycd
    reversechargeflag
    itemtype
    hsnid
    is_active
    statuscode
    statusmessage
    lastupdatedby
    itemamountenteredtimestamp
    itemamountexpiredtimestamp
    amount
    effectivedate
    expireddate
    sellinghsnid
    purchasehsnid
    gstcompensationtype
    gstcompensationvalue
    gstrate
    discounttype
    discountvalue
    imagename
    imageurl
    serialnumber
    isdefault
    invoicetype
    defaultsellingprice
    defaultpurchaseprice
    codetext
    itemcategory
    sellinggstcompensationtype
    purchasegstcompensationtype
    sellinggstcompensationvalue
    purchasegstcompensationvalue
    sellinggstrate
    purchasegstrate
    sellingdiscounttype
    purchasediscounttype
    sellingdiscountvalue
    purchasediscountvalue
    purchaseaccountname
    salesaccountname
    defaultnetsellingprice
    defaultnetpurchaseprice
    description
    hsnsacid
    hsncodetype
    hsnsaccode
    hsndescription
    cessexist
    barcode
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListItemmastersv2QueryVariables,
  APITypes.ListItemmastersv2Query
>;
export const listItemmastersv2Count = /* GraphQL */ `query ListItemmastersv2Count(
  $rowfrom: Int!
  $limitno: Int!
  $columnname: String
  $ordertype: String
  $searchmode: Int
  $searcharray: AWSJSON
) {
  listItemmastersv2Count(
    rowfrom: $rowfrom
    limitno: $limitno
    columnname: $columnname
    ordertype: $ordertype
    searchmode: $searchmode
    searcharray: $searcharray
  ) {
    itemcount
    total_defaultnetsellingprice
    total_defaultnetpurchaseprice
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListItemmastersv2CountQueryVariables,
  APITypes.ListItemmastersv2CountQuery
>;
export const listItemmasters = /* GraphQL */ `query ListItemmasters {
  listItemmasters {
    itemid
    itemcode
    companyid
    enteredtimestamp
    expiredtimestamp
    itemname
    salesinvoiceflag
    purchaseinvoiceflag
    itemcategorycd
    measurementcd
    currencycd
    salesaccountid
    purchaseaccountid
    taxabilitycd
    reversechargeflag
    itemtype
    hsnid
    is_active
    statuscode
    statusmessage
    relateditemamountdetails {
      id
      itemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      amount
      effectivedate
      expireddate
      hsnid
      gstcompensationtype
      gstcompensationvalue
      gstrate
      statuscode
      statusmessage
      lastupdatedby
      discounttype
      discountvalue
      invoicetype
      pricetype
      isactive
      isdefault
      pricetypeid
      tabletype
      __typename
    }
    relateditemgstdetails {
      itemid
      companyid
      enteredtimestamp
      expiredtimestamp
      hsnid
      gstcesstype
      gstcompensationvalue
      effectivedate
      expireddate
      gstcessvalue
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relateditemimages {
      attachmentid
      itemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      imagename
      imageurl
      documentname
      type
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    lastupdatedby
    serialnumber
    financialyearid
    description
    hsnsacid
    hsncodetype
    hsncodevalue
    hsndescription
    cessexist
    barcode
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListItemmastersQueryVariables,
  APITypes.ListItemmastersQuery
>;
export const listItemLotDetails = /* GraphQL */ `query ListItemLotDetails {
  listItemLotDetails {
    lotid
    itemid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    lotnumber
    lotquantity
    itemrate
    typecd
    balance
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListItemLotDetailsQueryVariables,
  APITypes.ListItemLotDetailsQuery
>;
export const listItemCategorymaster = /* GraphQL */ `query ListItemCategorymaster($maincategory: String!) {
  listItemCategorymaster(maincategory: $maincategory) {
    itemcategoryid
    companyid
    enteredtimestamp
    expiredtimestamp
    category
    itemcategorygroupid
    maincategory
    statuscode
    statusmessage
    lastupdatedby
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListItemCategorymasterQueryVariables,
  APITypes.ListItemCategorymasterQuery
>;
export const listInvoiceSettings = /* GraphQL */ `query ListInvoiceSettings($type: String!) {
  listInvoiceSettings(type: $type) {
    invoicesettingsid
    companyid
    enteredtimestamp
    expiredtimestamp
    typecd
    invoiceheading
    signaturetext
    declarationatfooter
    termsandcondition
    declarationatfooterflag
    termsandconditionsflag
    companyname
    companycin
    invoicenumber
    companyaddress
    companylogo
    invoicedate
    companycontactnumber
    companyemail
    paymentmode
    companygstin
    companywebsite
    creditperiod
    companypan
    companybankdetails
    paymentduedate
    customerlegalname
    customergstin
    lutbonddetails
    customerdisplayname
    placeofsupply
    dispatchdetails
    customerbillingaddress
    customercontactperson
    customercontactnumber
    customername
    ewaybilldetails
    customershippingaddress
    customerordernoanddate
    einvoicedetails
    itemwisediscount
    hsnsacode
    showroundoff
    hsnsasummarytable
    invoicedescription
    regularinvoicesignaturefilename
    last_updated_by
    statuscode
    statusmessage
    posinvoicesignaturefilename
    defaultsetting
    bankdetails
    upi_id
    acknowledgement
    acknowledgementflag
    bosinvoiceheading
    bank_name
    branch
    ac_name
    ac_no
    ifsc
    swift_code
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInvoiceSettingsQueryVariables,
  APITypes.ListInvoiceSettingsQuery
>;
export const listInvoiceMastervr2 = /* GraphQL */ `query ListInvoiceMastervr2 {
  listInvoiceMastervr2 {
    invoiceid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    invoicetypecd
    partyid
    paymentaccountid
    invoicedate
    invoicenumber
    customerordernumber
    customerorderdate
    invoiceamount
    paymenttype
    creditduration
    invoicebillingaddressid
    invoicedeliveryaddressid
    invoicetaxabletypecd
    receipturl
    invoicelinetypecd
    invoicecurrencycd
    exchangerate
    comments
    receivedamount
    adjustmentamount
    placeofsupply
    balancedueamount
    reversechargeflag
    tcsapplicableflag
    lastupdatedby
    statuscode
    statusmessage
    cancelflag
    consigneename
    consigneegstin
    companystate
    cancelremark
    deleteremark
    roundoffamount
    discounttype
    discountvalue
    serialnumber
    currencycode
    currencyrate
    partydisplayname
    partylegalname
    partyaccountid
    paymentstatus
    ackno
    ackdt
    irn
    signedqrcode
    partyemail
    invoicepdf
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInvoiceMastervr2QueryVariables,
  APITypes.ListInvoiceMastervr2Query
>;
export const listInvoiceMasterv2 = /* GraphQL */ `query ListInvoiceMasterv2(
  $rowfrom: Int!
  $limitno: Int!
  $columnname: String
  $ordertype: String
  $searchmode: Int
  $searcharray: AWSJSON
) {
  listInvoiceMasterv2(
    rowfrom: $rowfrom
    limitno: $limitno
    columnname: $columnname
    ordertype: $ordertype
    searchmode: $searchmode
    searcharray: $searcharray
  ) {
    invoiceid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    invoicetypecd
    partyid
    paymentaccountid
    invoicedate
    invoicenumber
    customerordernumber
    customerorderdate
    invoiceamount
    paymenttype
    creditduration
    invoicebillingaddressid
    invoicedeliveryaddressid
    invoicetaxabletypecd
    receipturl
    invoicelinetypecd
    invoicecurrencycd
    exchangerate
    comments
    receivedamount
    adjustmentamount
    placeofsupply
    balancedueamount
    reversechargeflag
    tcsapplicableflag
    relatedinvoicetcsdetails {
      invoiceid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tcsapplicablecd
      totaltaxableamount
      ineligibletcflag
      reversechargeflag
      gstcesstotal
      tcsamount
      adjustmentamount
      tcssection
      lastupdatedby
      statuscode
      statusmessage
      tcspercentage
      tcsmanual
      __typename
    }
    relatedinvoicelineitems {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      lineitemnumber
      invoicelineitemtype
      itemid
      quantity
      unittypecd
      itemrate
      itemamount
      itemdiscount
      taxableamount
      discounttype
      discountrate
      netamount
      hsnsaccode
      taxability
      lastupdatedby
      statuscode
      statusmessage
      pricetype
      lotid
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      gstrate
      gsttypecd
      gstamount
      cessamount
      unit
      uqc
      salesaccountname
      salesaccountid
      itemname
      itemcode
      itemtype
      manualdiscount
      manualcess
      itemmaster_timestamp
      description
      relatedinvoicelinegst {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        gsttypecd
        gstamount
        cessamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relateditemmaster {
        itemid
        itemcode
        companyid
        enteredtimestamp
        expiredtimestamp
        itemname
        salesinvoiceflag
        purchaseinvoiceflag
        itemcategorycd
        measurementcd
        currencycd
        salesaccountid
        purchaseaccountid
        taxabilitycd
        reversechargeflag
        itemtype
        hsnid
        is_active
        statuscode
        statusmessage
        relateditemamountdetails {
          id
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          amount
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstcompensationvalue
          gstrate
          statuscode
          statusmessage
          lastupdatedby
          discounttype
          discountvalue
          invoicetype
          pricetype
          isactive
          isdefault
          pricetypeid
          tabletype
          __typename
        }
        relateditemgstdetails {
          itemid
          companyid
          enteredtimestamp
          expiredtimestamp
          hsnid
          gstcesstype
          gstcompensationvalue
          effectivedate
          expireddate
          gstcessvalue
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemimages {
          attachmentid
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          imagename
          imageurl
          documentname
          type
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        serialnumber
        financialyearid
        description
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        cessexist
        barcode
        __typename
      }
      pricetypeid
      manualgst
      cessrate
      cesstype
      type
      __typename
    }
    relatedinvoicelinenonitems {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoicelineitemtype
      incomeaccountid
      hsnsaccode
      taxability
      itemdescription
      taxableamount
      rate
      discount
      netamount
      relatedaccounts {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accountname
        accounttypecd
        accountgroupid
        hsnsaccode
        displayordernumber
        statuscode
        statusmessage
        restrictedflag
        is_active
        accounttypeflag
        relatedaccountgstdetails {
          accountid
          companyid
          enteredtimestamp
          expiredtimestamp
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstrate
          cessamount
          lastupdatedby
          statuscode
          statusmessage
          hsnsaccode
          codetype
          description
          taxability
          __typename
        }
        relatedaccountopeningbalance {
          accountsid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          financialyearid
          startdate
          creditamount
          debitamount
          statuscode
          statusmessage
          __typename
        }
        relatedaccountgroupmaster {
          accountgroupid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          accounttypecd
          accountgroupname
          accountparentgroupid
          displayordernumber
          statuscode
          statusmessage
          is_active
          restrictedflag
          path
          __typename
        }
        relatedaccountbalance {
          accountid
          accountbalance
          actualbalance
          __typename
        }
        path
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      gstrate
      gsttypecd
      gstamount
      cessamount
      incomeaccountname
      manualgst
      manualcess
      cessrate
      cesstype
      type
      __typename
    }
    relatedinvoiceattachment {
      invoiceid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      lastupdatedby
      statuscode
      statusmessage
      documentname
      type
      __typename
    }
    relatedinvoicedispatch {
      invoiceid
      dispatchid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transportationcd
      vehiclenumber
      dispatchdate
      ewaybillnumber
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedinvoiceposdetails {
      posid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      partyposid
      lastupdatedby
      relatedposparty {
        pospartyid
        companyid
        partyname
        partycontactnumberid
        lastupdatedby
        enteredtimestamp
        expiredtimestamp
        relatedphonecontacts {
          id
          objecttype
          objectid
          enteredtimestamp
          expiredtimestamp
          countrycode
          phonenumber
          verifieddatetime
          promotionssignup
          smsallowed
          callallowed
          whatsappallowed
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        __typename
      }
      statuscode
      statusmessage
      __typename
    }
    relatedinvoicelinegst {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      gsttypecd
      gstamount
      cessamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedinvoicelinenongst {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      gsttypecd
      gstamount
      cessamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedinvoicenumbertracker {
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      nextinvoicenumber
      lastupdatedby
      __typename
    }
    relatedinvoicetransactiondetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      vouchernumber
      entrydate
      bankreferencenumber
      comments
      relatedtransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        accountid
        creditamount
        debitamount
        comments
        entryordernumber
        transactionbalance
        openingbalance
        lastupdatedby
        statuscode
        statusmessage
        financialyearid
        __typename
      }
      relatedtransactionattachment {
        transactionid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        documentname
        statuscode
        statusmessage
        type
        __typename
      }
      relatedtransactiontdsdetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tdsapplicablecd
        tdsamount
        tdsmanual
        lastupdatedby
        statuscode
        statusmessage
        tdspercentage
        __typename
      }
      relatedpurchasemaster {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        purchasegsttypecd
        supplierid
        entrydate
        vouchernumber
        supplierinvoicedate
        supplierinvoicenumber
        supplieraddressid
        paymenttypecd
        paidamount
        creditduration
        paymentaccountid
        comments
        tdsapplicableflag
        granttotalamount
        balancedueamount
        paymentclearedflag
        placeofsupply
        companystate
        relatedpurchasetdsdetails {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          totaltaxableamount
          ineligibletcflag
          reversechargeflag
          gstcesstotal
          tdsamount
          adjustmentamount
          tdssection
          tdspercentage
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaselineitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          itemnumber
          itemid
          purchaseaccountid
          hsncode
          itemquantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          taxableamount
          description
          discounttype
          discountrate
          netamount
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          pricetype
          lotid
          hsnid
          hsncodetype
          hsndescription
          gstrate
          gstamount
          cessamount
          unit
          uqc
          purchaseaccountname
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          pricetypeid
          manualgst
          cessrate
          cesstype
          type
          __typename
        }
        relatedpurchaselinenonitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchaselineitemtype
          purchaseaccountid
          hsnsaccode
          itemdescription
          taxableamount
          rate
          discount
          netamount
          relatedpurchaselinenongst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gstamount
          cessamount
          purchaseaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          type
          __typename
        }
        relatedpurchaselinegst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaseattachment {
          purchaseid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedpurchasetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              description
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              description
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        relatedpurchasetransactionrelation {
          transactionid
          transactiontypecd
          objecttype
          objectid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          linkedamount
          objectattribute
          isdirect
          lastupdatedby
          accountid
          paymentvouchernumber
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        cancelflag
        roundoffamount
        discounttype
        discountvalue
        adjustmentamount
        serialnumber
        currencycode
        currencyrate
        reversechargeflag
        paymentstatus
        partyregistrationtype
        partygstcategory
        itcflag
        __typename
      }
      relatedinvoicemaster {
        invoiceid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        invoicetypecd
        partyid
        paymentaccountid
        invoicedate
        invoicenumber
        customerordernumber
        customerorderdate
        invoiceamount
        paymenttype
        creditduration
        invoicebillingaddressid
        invoicedeliveryaddressid
        invoicetaxabletypecd
        receipturl
        invoicelinetypecd
        invoicecurrencycd
        exchangerate
        comments
        receivedamount
        adjustmentamount
        placeofsupply
        balancedueamount
        reversechargeflag
        tcsapplicableflag
        relatedinvoicelineitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          lineitemnumber
          invoicelineitemtype
          itemid
          quantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          taxableamount
          discounttype
          discountrate
          netamount
          hsnsaccode
          taxability
          lastupdatedby
          statuscode
          statusmessage
          pricetype
          lotid
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          unit
          uqc
          salesaccountname
          salesaccountid
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          itemmaster_timestamp
          description
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          pricetypeid
          manualgst
          cessrate
          cesstype
          type
          __typename
        }
        relatedinvoicelinenonitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicelineitemtype
          incomeaccountid
          hsnsaccode
          taxability
          itemdescription
          taxableamount
          rate
          discount
          netamount
          relatedaccounts {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accountname
            accounttypecd
            accountgroupid
            hsnsaccode
            displayordernumber
            statuscode
            statusmessage
            restrictedflag
            is_active
            accounttypeflag
            relatedaccountgstdetails {
              accountid
              companyid
              enteredtimestamp
              expiredtimestamp
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstrate
              cessamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsaccode
              codetype
              description
              taxability
              __typename
            }
            relatedaccountopeningbalance {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              financialyearid
              startdate
              creditamount
              debitamount
              statuscode
              statusmessage
              __typename
            }
            relatedaccountgroupmaster {
              accountgroupid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accounttypecd
              accountgroupname
              accountparentgroupid
              displayordernumber
              statuscode
              statusmessage
              is_active
              restrictedflag
              path
              __typename
            }
            relatedaccountbalance {
              accountid
              accountbalance
              actualbalance
              __typename
            }
            path
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          incomeaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          type
          __typename
        }
        relatedinvoiceattachment {
          invoiceid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedinvoicedispatch {
          invoiceid
          dispatchid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transportationcd
          vehiclenumber
          dispatchdate
          ewaybillnumber
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoiceposdetails {
          posid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          partyposid
          lastupdatedby
          relatedposparty {
            pospartyid
            companyid
            partyname
            partycontactnumberid
            lastupdatedby
            enteredtimestamp
            expiredtimestamp
            relatedphonecontacts {
              id
              objecttype
              objectid
              enteredtimestamp
              expiredtimestamp
              countrycode
              phonenumber
              verifieddatetime
              promotionssignup
              smsallowed
              callallowed
              whatsappallowed
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            __typename
          }
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicelinegst {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          gsttypecd
          gstamount
          cessamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicenumbertracker {
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          nextinvoicenumber
          lastupdatedby
          __typename
        }
        relatedinvoicetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              description
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              description
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        lastupdatedby
        cancelflag
        statuscode
        statusmessage
        consigneename
        consigneegstin
        companystate
        cancelremark
        deleteremark
        roundoffamount
        discounttype
        discountvalue
        serialnumber
        currencycode
        currencyrate
        paymentstatus
        ackno
        ackdt
        irn
        signedqrcode
        itcflag
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      cancelflag
      cancelremark
      serialnumber
      pdflink
      towards
      isvouchereditable
      __typename
    }
    relatedpartymaster {
      partyid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      partytypecd
      partydisplayname
      partylegalname
      groupaccountid
      gstcategory
      placeofsupply
      entity
      email
      contactnumber
      whatsappnumber
      accountsid
      is_active
      msmetype
      deliveryconsigneename
      deliveryconsigneegstin
      statuscode
      statusmessage
      relatedpartygstdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        pannumber
        gstin
        partyaddressid
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycreditdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        creditperiodduration
        billingcurrency
        creditlimitcd
        creditlimitamount
        billwiseflag
        notes
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycontact {
        partyid
        enteredtimestamp
        expiredtimestamp
        contacttypename
        contactdesignationname
        contactorder
        email
        phonenumber
        whatsappnumber
        lastupdatedby
        statuscode
        statusmessage
        contactcountry
        whatsappcountry
        __typename
      }
      relatedpartyimages {
        attachmentid
        partyid
        companyid
        enteredtimestamp
        expiredtimestamp
        type
        documentname
        imagename
        imageurl
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      tdspercentage
      udhyamregno
      sameaddressflag
      comments
      tdssection
      accountname
      deliverystatecode
      deliverystatename
      contactcountry
      whatsappcountry
      entityname
      __typename
    }
    relatedpaymentaccountdetails {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    relatedinvoiceaddressdetails {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      line1
      line2
      line3
      city
      statecode
      statename
      statuscode
      statusmessage
      pincode
      countrycode
      codevalue
      district
      lastupdatedby
      godownname
      gstin
      phone
      email
      personincharge
      consigneename
      consigneegstin
      foreignstate
      foreigndistrict
      defaultflag
      addresstitle
      addressindex
      __typename
    }
    lastupdatedby
    statuscode
    statusmessage
    cancelflag
    consigneename
    consigneegstin
    companystate
    cancelremark
    deleteremark
    roundoffamount
    discounttype
    discountvalue
    serialnumber
    serialflag
    currencycode
    currencyrate
    partydisplayname
    partylegalname
    partyaccountid
    paymentstatus
    ackno
    ackdt
    irn
    signedqrcode
    partyemail
    invoicepdf
    partygstin
    partytypecd
    partygstcategory
    is_cancelled
    cancel_reason
    cancel_remarks
    phonenumber
    bankaccountid
    bankamount
    ewaybillno
    validupto
    ewaybill_validupto
    ewaybill_is_cancelled
    ewaybill_cancel_remarks
    ewaybill_cancel_rsn_code
    cancel_rsn_code
    einvoiceenteredtimestamp
    ewaybillenteredtimestamp
    ewaybillid
    ewaybillpdf
    ewaybillstatus
    invoicetype
    accountname
    partyisactive
    goods_exist
    overduedays
    duedatetimestamp
    isvouchereditable
    itcflag
    taxability
    linkedamount
    cessexist
    partyamount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInvoiceMasterv2QueryVariables,
  APITypes.ListInvoiceMasterv2Query
>;
export const listInvoiceMasterRange = /* GraphQL */ `query ListInvoiceMasterRange($startdate: Int!, $enddate: Int!) {
  listInvoiceMasterRange(startdate: $startdate, enddate: $enddate) {
    invoiceid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    invoicetypecd
    partyid
    paymentaccountid
    invoicedate
    invoicenumber
    customerordernumber
    customerorderdate
    invoiceamount
    paymenttype
    creditduration
    invoicebillingaddressid
    invoicedeliveryaddressid
    invoicetaxabletypecd
    receipturl
    invoicelinetypecd
    invoicecurrencycd
    exchangerate
    comments
    receivedamount
    adjustmentamount
    placeofsupply
    balancedueamount
    reversechargeflag
    tcsapplicableflag
    relatedinvoicetcsdetails {
      invoiceid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tcsapplicablecd
      totaltaxableamount
      ineligibletcflag
      reversechargeflag
      gstcesstotal
      tcsamount
      adjustmentamount
      tcssection
      lastupdatedby
      statuscode
      statusmessage
      tcspercentage
      tcsmanual
      __typename
    }
    relatedinvoicelineitems {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      lineitemnumber
      invoicelineitemtype
      itemid
      quantity
      unittypecd
      itemrate
      itemamount
      itemdiscount
      taxableamount
      discounttype
      discountrate
      netamount
      hsnsaccode
      taxability
      lastupdatedby
      statuscode
      statusmessage
      pricetype
      lotid
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      gstrate
      gsttypecd
      gstamount
      cessamount
      unit
      uqc
      salesaccountname
      salesaccountid
      itemname
      itemcode
      itemtype
      manualdiscount
      manualcess
      itemmaster_timestamp
      description
      relatedinvoicelinegst {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        gsttypecd
        gstamount
        cessamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relateditemmaster {
        itemid
        itemcode
        companyid
        enteredtimestamp
        expiredtimestamp
        itemname
        salesinvoiceflag
        purchaseinvoiceflag
        itemcategorycd
        measurementcd
        currencycd
        salesaccountid
        purchaseaccountid
        taxabilitycd
        reversechargeflag
        itemtype
        hsnid
        is_active
        statuscode
        statusmessage
        relateditemamountdetails {
          id
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          amount
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstcompensationvalue
          gstrate
          statuscode
          statusmessage
          lastupdatedby
          discounttype
          discountvalue
          invoicetype
          pricetype
          isactive
          isdefault
          pricetypeid
          tabletype
          __typename
        }
        relateditemgstdetails {
          itemid
          companyid
          enteredtimestamp
          expiredtimestamp
          hsnid
          gstcesstype
          gstcompensationvalue
          effectivedate
          expireddate
          gstcessvalue
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemimages {
          attachmentid
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          imagename
          imageurl
          documentname
          type
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        serialnumber
        financialyearid
        description
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        cessexist
        barcode
        __typename
      }
      pricetypeid
      manualgst
      cessrate
      cesstype
      type
      __typename
    }
    relatedinvoicelinenonitems {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoicelineitemtype
      incomeaccountid
      hsnsaccode
      taxability
      itemdescription
      taxableamount
      rate
      discount
      netamount
      relatedaccounts {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accountname
        accounttypecd
        accountgroupid
        hsnsaccode
        displayordernumber
        statuscode
        statusmessage
        restrictedflag
        is_active
        accounttypeflag
        relatedaccountgstdetails {
          accountid
          companyid
          enteredtimestamp
          expiredtimestamp
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstrate
          cessamount
          lastupdatedby
          statuscode
          statusmessage
          hsnsaccode
          codetype
          description
          taxability
          __typename
        }
        relatedaccountopeningbalance {
          accountsid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          financialyearid
          startdate
          creditamount
          debitamount
          statuscode
          statusmessage
          __typename
        }
        relatedaccountgroupmaster {
          accountgroupid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          accounttypecd
          accountgroupname
          accountparentgroupid
          displayordernumber
          statuscode
          statusmessage
          is_active
          restrictedflag
          path
          __typename
        }
        relatedaccountbalance {
          accountid
          accountbalance
          actualbalance
          __typename
        }
        path
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      gstrate
      gsttypecd
      gstamount
      cessamount
      incomeaccountname
      manualgst
      manualcess
      cessrate
      cesstype
      type
      __typename
    }
    relatedinvoiceattachment {
      invoiceid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      lastupdatedby
      statuscode
      statusmessage
      documentname
      type
      __typename
    }
    relatedinvoicedispatch {
      invoiceid
      dispatchid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transportationcd
      vehiclenumber
      dispatchdate
      ewaybillnumber
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedinvoiceposdetails {
      posid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      partyposid
      lastupdatedby
      relatedposparty {
        pospartyid
        companyid
        partyname
        partycontactnumberid
        lastupdatedby
        enteredtimestamp
        expiredtimestamp
        relatedphonecontacts {
          id
          objecttype
          objectid
          enteredtimestamp
          expiredtimestamp
          countrycode
          phonenumber
          verifieddatetime
          promotionssignup
          smsallowed
          callallowed
          whatsappallowed
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        __typename
      }
      statuscode
      statusmessage
      __typename
    }
    relatedinvoicelinegst {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      gsttypecd
      gstamount
      cessamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedinvoicelinenongst {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      gsttypecd
      gstamount
      cessamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedinvoicenumbertracker {
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      nextinvoicenumber
      lastupdatedby
      __typename
    }
    relatedinvoicetransactiondetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      vouchernumber
      entrydate
      bankreferencenumber
      comments
      relatedtransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        accountid
        creditamount
        debitamount
        comments
        entryordernumber
        transactionbalance
        openingbalance
        lastupdatedby
        statuscode
        statusmessage
        financialyearid
        __typename
      }
      relatedtransactionattachment {
        transactionid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        documentname
        statuscode
        statusmessage
        type
        __typename
      }
      relatedtransactiontdsdetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tdsapplicablecd
        tdsamount
        tdsmanual
        lastupdatedby
        statuscode
        statusmessage
        tdspercentage
        __typename
      }
      relatedpurchasemaster {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        purchasegsttypecd
        supplierid
        entrydate
        vouchernumber
        supplierinvoicedate
        supplierinvoicenumber
        supplieraddressid
        paymenttypecd
        paidamount
        creditduration
        paymentaccountid
        comments
        tdsapplicableflag
        granttotalamount
        balancedueamount
        paymentclearedflag
        placeofsupply
        companystate
        relatedpurchasetdsdetails {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          totaltaxableamount
          ineligibletcflag
          reversechargeflag
          gstcesstotal
          tdsamount
          adjustmentamount
          tdssection
          tdspercentage
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaselineitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          itemnumber
          itemid
          purchaseaccountid
          hsncode
          itemquantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          taxableamount
          description
          discounttype
          discountrate
          netamount
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          pricetype
          lotid
          hsnid
          hsncodetype
          hsndescription
          gstrate
          gstamount
          cessamount
          unit
          uqc
          purchaseaccountname
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          pricetypeid
          manualgst
          cessrate
          cesstype
          type
          __typename
        }
        relatedpurchaselinenonitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchaselineitemtype
          purchaseaccountid
          hsnsaccode
          itemdescription
          taxableamount
          rate
          discount
          netamount
          relatedpurchaselinenongst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gstamount
          cessamount
          purchaseaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          type
          __typename
        }
        relatedpurchaselinegst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaseattachment {
          purchaseid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedpurchasetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              description
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              description
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        relatedpurchasetransactionrelation {
          transactionid
          transactiontypecd
          objecttype
          objectid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          linkedamount
          objectattribute
          isdirect
          lastupdatedby
          accountid
          paymentvouchernumber
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        cancelflag
        roundoffamount
        discounttype
        discountvalue
        adjustmentamount
        serialnumber
        currencycode
        currencyrate
        reversechargeflag
        paymentstatus
        partyregistrationtype
        partygstcategory
        itcflag
        __typename
      }
      relatedinvoicemaster {
        invoiceid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        invoicetypecd
        partyid
        paymentaccountid
        invoicedate
        invoicenumber
        customerordernumber
        customerorderdate
        invoiceamount
        paymenttype
        creditduration
        invoicebillingaddressid
        invoicedeliveryaddressid
        invoicetaxabletypecd
        receipturl
        invoicelinetypecd
        invoicecurrencycd
        exchangerate
        comments
        receivedamount
        adjustmentamount
        placeofsupply
        balancedueamount
        reversechargeflag
        tcsapplicableflag
        relatedinvoicelineitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          lineitemnumber
          invoicelineitemtype
          itemid
          quantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          taxableamount
          discounttype
          discountrate
          netamount
          hsnsaccode
          taxability
          lastupdatedby
          statuscode
          statusmessage
          pricetype
          lotid
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          unit
          uqc
          salesaccountname
          salesaccountid
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          itemmaster_timestamp
          description
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          pricetypeid
          manualgst
          cessrate
          cesstype
          type
          __typename
        }
        relatedinvoicelinenonitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicelineitemtype
          incomeaccountid
          hsnsaccode
          taxability
          itemdescription
          taxableamount
          rate
          discount
          netamount
          relatedaccounts {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accountname
            accounttypecd
            accountgroupid
            hsnsaccode
            displayordernumber
            statuscode
            statusmessage
            restrictedflag
            is_active
            accounttypeflag
            relatedaccountgstdetails {
              accountid
              companyid
              enteredtimestamp
              expiredtimestamp
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstrate
              cessamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsaccode
              codetype
              description
              taxability
              __typename
            }
            relatedaccountopeningbalance {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              financialyearid
              startdate
              creditamount
              debitamount
              statuscode
              statusmessage
              __typename
            }
            relatedaccountgroupmaster {
              accountgroupid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accounttypecd
              accountgroupname
              accountparentgroupid
              displayordernumber
              statuscode
              statusmessage
              is_active
              restrictedflag
              path
              __typename
            }
            relatedaccountbalance {
              accountid
              accountbalance
              actualbalance
              __typename
            }
            path
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          incomeaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          type
          __typename
        }
        relatedinvoiceattachment {
          invoiceid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedinvoicedispatch {
          invoiceid
          dispatchid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transportationcd
          vehiclenumber
          dispatchdate
          ewaybillnumber
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoiceposdetails {
          posid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          partyposid
          lastupdatedby
          relatedposparty {
            pospartyid
            companyid
            partyname
            partycontactnumberid
            lastupdatedby
            enteredtimestamp
            expiredtimestamp
            relatedphonecontacts {
              id
              objecttype
              objectid
              enteredtimestamp
              expiredtimestamp
              countrycode
              phonenumber
              verifieddatetime
              promotionssignup
              smsallowed
              callallowed
              whatsappallowed
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            __typename
          }
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicelinegst {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          gsttypecd
          gstamount
          cessamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicenumbertracker {
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          nextinvoicenumber
          lastupdatedby
          __typename
        }
        relatedinvoicetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              description
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              description
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        lastupdatedby
        cancelflag
        statuscode
        statusmessage
        consigneename
        consigneegstin
        companystate
        cancelremark
        deleteremark
        roundoffamount
        discounttype
        discountvalue
        serialnumber
        currencycode
        currencyrate
        paymentstatus
        ackno
        ackdt
        irn
        signedqrcode
        itcflag
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      cancelflag
      cancelremark
      serialnumber
      pdflink
      towards
      isvouchereditable
      __typename
    }
    relatedpartymaster {
      partyid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      partytypecd
      partydisplayname
      partylegalname
      groupaccountid
      gstcategory
      placeofsupply
      entity
      email
      contactnumber
      whatsappnumber
      accountsid
      is_active
      msmetype
      deliveryconsigneename
      deliveryconsigneegstin
      statuscode
      statusmessage
      relatedpartygstdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        pannumber
        gstin
        partyaddressid
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycreditdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        creditperiodduration
        billingcurrency
        creditlimitcd
        creditlimitamount
        billwiseflag
        notes
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycontact {
        partyid
        enteredtimestamp
        expiredtimestamp
        contacttypename
        contactdesignationname
        contactorder
        email
        phonenumber
        whatsappnumber
        lastupdatedby
        statuscode
        statusmessage
        contactcountry
        whatsappcountry
        __typename
      }
      relatedpartyimages {
        attachmentid
        partyid
        companyid
        enteredtimestamp
        expiredtimestamp
        type
        documentname
        imagename
        imageurl
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      tdspercentage
      udhyamregno
      sameaddressflag
      comments
      tdssection
      accountname
      deliverystatecode
      deliverystatename
      contactcountry
      whatsappcountry
      entityname
      __typename
    }
    relatedpaymentaccountdetails {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    relatedinvoiceaddressdetails {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      line1
      line2
      line3
      city
      statecode
      statename
      statuscode
      statusmessage
      pincode
      countrycode
      codevalue
      district
      lastupdatedby
      godownname
      gstin
      phone
      email
      personincharge
      consigneename
      consigneegstin
      foreignstate
      foreigndistrict
      defaultflag
      addresstitle
      addressindex
      __typename
    }
    lastupdatedby
    statuscode
    statusmessage
    cancelflag
    consigneename
    consigneegstin
    companystate
    cancelremark
    deleteremark
    roundoffamount
    discounttype
    discountvalue
    serialnumber
    serialflag
    currencycode
    currencyrate
    partydisplayname
    partylegalname
    partyaccountid
    paymentstatus
    ackno
    ackdt
    irn
    signedqrcode
    partyemail
    invoicepdf
    partygstin
    partytypecd
    partygstcategory
    is_cancelled
    cancel_reason
    cancel_remarks
    phonenumber
    bankaccountid
    bankamount
    ewaybillno
    validupto
    ewaybill_validupto
    ewaybill_is_cancelled
    ewaybill_cancel_remarks
    ewaybill_cancel_rsn_code
    cancel_rsn_code
    einvoiceenteredtimestamp
    ewaybillenteredtimestamp
    ewaybillid
    ewaybillpdf
    ewaybillstatus
    invoicetype
    accountname
    partyisactive
    goods_exist
    overduedays
    duedatetimestamp
    isvouchereditable
    itcflag
    taxability
    linkedamount
    cessexist
    partyamount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInvoiceMasterRangeQueryVariables,
  APITypes.ListInvoiceMasterRangeQuery
>;
export const listInvoiceMasterCount = /* GraphQL */ `query ListInvoiceMasterCount(
  $columnname: String
  $ordertype: String
  $searchmode: Int
  $searcharray: AWSJSON
) {
  listInvoiceMasterCount(
    columnname: $columnname
    ordertype: $ordertype
    searchmode: $searchmode
    searcharray: $searcharray
  ) {
    invoicemasterlistcount
    total_invoiceamount
    total_invoiceamount_side
    total_receivedamount
    total_receivedamount_side
    total_balancedueamount
    total_balancedueamount_side
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInvoiceMasterCountQueryVariables,
  APITypes.ListInvoiceMasterCountQuery
>;
export const listInvoiceMaster = /* GraphQL */ `query ListInvoiceMaster {
  listInvoiceMaster {
    invoiceid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    invoicetypecd
    partyid
    paymentaccountid
    invoicedate
    invoicenumber
    customerordernumber
    customerorderdate
    invoiceamount
    paymenttype
    creditduration
    invoicebillingaddressid
    invoicedeliveryaddressid
    invoicetaxabletypecd
    receipturl
    invoicelinetypecd
    invoicecurrencycd
    exchangerate
    comments
    receivedamount
    adjustmentamount
    placeofsupply
    balancedueamount
    reversechargeflag
    tcsapplicableflag
    relatedinvoicetcsdetails {
      invoiceid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tcsapplicablecd
      totaltaxableamount
      ineligibletcflag
      reversechargeflag
      gstcesstotal
      tcsamount
      adjustmentamount
      tcssection
      lastupdatedby
      statuscode
      statusmessage
      tcspercentage
      tcsmanual
      __typename
    }
    relatedinvoicelineitems {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      lineitemnumber
      invoicelineitemtype
      itemid
      quantity
      unittypecd
      itemrate
      itemamount
      itemdiscount
      taxableamount
      discounttype
      discountrate
      netamount
      hsnsaccode
      taxability
      lastupdatedby
      statuscode
      statusmessage
      pricetype
      lotid
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      gstrate
      gsttypecd
      gstamount
      cessamount
      unit
      uqc
      salesaccountname
      salesaccountid
      itemname
      itemcode
      itemtype
      manualdiscount
      manualcess
      itemmaster_timestamp
      description
      relatedinvoicelinegst {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        gsttypecd
        gstamount
        cessamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relateditemmaster {
        itemid
        itemcode
        companyid
        enteredtimestamp
        expiredtimestamp
        itemname
        salesinvoiceflag
        purchaseinvoiceflag
        itemcategorycd
        measurementcd
        currencycd
        salesaccountid
        purchaseaccountid
        taxabilitycd
        reversechargeflag
        itemtype
        hsnid
        is_active
        statuscode
        statusmessage
        relateditemamountdetails {
          id
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          amount
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstcompensationvalue
          gstrate
          statuscode
          statusmessage
          lastupdatedby
          discounttype
          discountvalue
          invoicetype
          pricetype
          isactive
          isdefault
          pricetypeid
          tabletype
          __typename
        }
        relateditemgstdetails {
          itemid
          companyid
          enteredtimestamp
          expiredtimestamp
          hsnid
          gstcesstype
          gstcompensationvalue
          effectivedate
          expireddate
          gstcessvalue
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemimages {
          attachmentid
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          imagename
          imageurl
          documentname
          type
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        serialnumber
        financialyearid
        description
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        cessexist
        barcode
        __typename
      }
      pricetypeid
      manualgst
      cessrate
      cesstype
      type
      __typename
    }
    relatedinvoicelinenonitems {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoicelineitemtype
      incomeaccountid
      hsnsaccode
      taxability
      itemdescription
      taxableamount
      rate
      discount
      netamount
      relatedaccounts {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accountname
        accounttypecd
        accountgroupid
        hsnsaccode
        displayordernumber
        statuscode
        statusmessage
        restrictedflag
        is_active
        accounttypeflag
        relatedaccountgstdetails {
          accountid
          companyid
          enteredtimestamp
          expiredtimestamp
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstrate
          cessamount
          lastupdatedby
          statuscode
          statusmessage
          hsnsaccode
          codetype
          description
          taxability
          __typename
        }
        relatedaccountopeningbalance {
          accountsid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          financialyearid
          startdate
          creditamount
          debitamount
          statuscode
          statusmessage
          __typename
        }
        relatedaccountgroupmaster {
          accountgroupid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          accounttypecd
          accountgroupname
          accountparentgroupid
          displayordernumber
          statuscode
          statusmessage
          is_active
          restrictedflag
          path
          __typename
        }
        relatedaccountbalance {
          accountid
          accountbalance
          actualbalance
          __typename
        }
        path
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      gstrate
      gsttypecd
      gstamount
      cessamount
      incomeaccountname
      manualgst
      manualcess
      cessrate
      cesstype
      type
      __typename
    }
    relatedinvoiceattachment {
      invoiceid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      lastupdatedby
      statuscode
      statusmessage
      documentname
      type
      __typename
    }
    relatedinvoicedispatch {
      invoiceid
      dispatchid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transportationcd
      vehiclenumber
      dispatchdate
      ewaybillnumber
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedinvoiceposdetails {
      posid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      partyposid
      lastupdatedby
      relatedposparty {
        pospartyid
        companyid
        partyname
        partycontactnumberid
        lastupdatedby
        enteredtimestamp
        expiredtimestamp
        relatedphonecontacts {
          id
          objecttype
          objectid
          enteredtimestamp
          expiredtimestamp
          countrycode
          phonenumber
          verifieddatetime
          promotionssignup
          smsallowed
          callallowed
          whatsappallowed
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        __typename
      }
      statuscode
      statusmessage
      __typename
    }
    relatedinvoicelinegst {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      gsttypecd
      gstamount
      cessamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedinvoicelinenongst {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      gsttypecd
      gstamount
      cessamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedinvoicenumbertracker {
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      nextinvoicenumber
      lastupdatedby
      __typename
    }
    relatedinvoicetransactiondetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      vouchernumber
      entrydate
      bankreferencenumber
      comments
      relatedtransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        accountid
        creditamount
        debitamount
        comments
        entryordernumber
        transactionbalance
        openingbalance
        lastupdatedby
        statuscode
        statusmessage
        financialyearid
        __typename
      }
      relatedtransactionattachment {
        transactionid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        documentname
        statuscode
        statusmessage
        type
        __typename
      }
      relatedtransactiontdsdetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tdsapplicablecd
        tdsamount
        tdsmanual
        lastupdatedby
        statuscode
        statusmessage
        tdspercentage
        __typename
      }
      relatedpurchasemaster {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        purchasegsttypecd
        supplierid
        entrydate
        vouchernumber
        supplierinvoicedate
        supplierinvoicenumber
        supplieraddressid
        paymenttypecd
        paidamount
        creditduration
        paymentaccountid
        comments
        tdsapplicableflag
        granttotalamount
        balancedueamount
        paymentclearedflag
        placeofsupply
        companystate
        relatedpurchasetdsdetails {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          totaltaxableamount
          ineligibletcflag
          reversechargeflag
          gstcesstotal
          tdsamount
          adjustmentamount
          tdssection
          tdspercentage
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaselineitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          itemnumber
          itemid
          purchaseaccountid
          hsncode
          itemquantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          taxableamount
          description
          discounttype
          discountrate
          netamount
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          pricetype
          lotid
          hsnid
          hsncodetype
          hsndescription
          gstrate
          gstamount
          cessamount
          unit
          uqc
          purchaseaccountname
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          pricetypeid
          manualgst
          cessrate
          cesstype
          type
          __typename
        }
        relatedpurchaselinenonitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchaselineitemtype
          purchaseaccountid
          hsnsaccode
          itemdescription
          taxableamount
          rate
          discount
          netamount
          relatedpurchaselinenongst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gstamount
          cessamount
          purchaseaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          type
          __typename
        }
        relatedpurchaselinegst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaseattachment {
          purchaseid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedpurchasetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              description
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              description
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        relatedpurchasetransactionrelation {
          transactionid
          transactiontypecd
          objecttype
          objectid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          linkedamount
          objectattribute
          isdirect
          lastupdatedby
          accountid
          paymentvouchernumber
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        cancelflag
        roundoffamount
        discounttype
        discountvalue
        adjustmentamount
        serialnumber
        currencycode
        currencyrate
        reversechargeflag
        paymentstatus
        partyregistrationtype
        partygstcategory
        itcflag
        __typename
      }
      relatedinvoicemaster {
        invoiceid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        invoicetypecd
        partyid
        paymentaccountid
        invoicedate
        invoicenumber
        customerordernumber
        customerorderdate
        invoiceamount
        paymenttype
        creditduration
        invoicebillingaddressid
        invoicedeliveryaddressid
        invoicetaxabletypecd
        receipturl
        invoicelinetypecd
        invoicecurrencycd
        exchangerate
        comments
        receivedamount
        adjustmentamount
        placeofsupply
        balancedueamount
        reversechargeflag
        tcsapplicableflag
        relatedinvoicelineitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          lineitemnumber
          invoicelineitemtype
          itemid
          quantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          taxableamount
          discounttype
          discountrate
          netamount
          hsnsaccode
          taxability
          lastupdatedby
          statuscode
          statusmessage
          pricetype
          lotid
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          unit
          uqc
          salesaccountname
          salesaccountid
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          itemmaster_timestamp
          description
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          pricetypeid
          manualgst
          cessrate
          cesstype
          type
          __typename
        }
        relatedinvoicelinenonitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicelineitemtype
          incomeaccountid
          hsnsaccode
          taxability
          itemdescription
          taxableamount
          rate
          discount
          netamount
          relatedaccounts {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accountname
            accounttypecd
            accountgroupid
            hsnsaccode
            displayordernumber
            statuscode
            statusmessage
            restrictedflag
            is_active
            accounttypeflag
            relatedaccountgstdetails {
              accountid
              companyid
              enteredtimestamp
              expiredtimestamp
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstrate
              cessamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsaccode
              codetype
              description
              taxability
              __typename
            }
            relatedaccountopeningbalance {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              financialyearid
              startdate
              creditamount
              debitamount
              statuscode
              statusmessage
              __typename
            }
            relatedaccountgroupmaster {
              accountgroupid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accounttypecd
              accountgroupname
              accountparentgroupid
              displayordernumber
              statuscode
              statusmessage
              is_active
              restrictedflag
              path
              __typename
            }
            relatedaccountbalance {
              accountid
              accountbalance
              actualbalance
              __typename
            }
            path
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          incomeaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          type
          __typename
        }
        relatedinvoiceattachment {
          invoiceid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedinvoicedispatch {
          invoiceid
          dispatchid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transportationcd
          vehiclenumber
          dispatchdate
          ewaybillnumber
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoiceposdetails {
          posid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          partyposid
          lastupdatedby
          relatedposparty {
            pospartyid
            companyid
            partyname
            partycontactnumberid
            lastupdatedby
            enteredtimestamp
            expiredtimestamp
            relatedphonecontacts {
              id
              objecttype
              objectid
              enteredtimestamp
              expiredtimestamp
              countrycode
              phonenumber
              verifieddatetime
              promotionssignup
              smsallowed
              callallowed
              whatsappallowed
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            __typename
          }
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicelinegst {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          gsttypecd
          gstamount
          cessamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicenumbertracker {
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          nextinvoicenumber
          lastupdatedby
          __typename
        }
        relatedinvoicetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              description
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              description
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        lastupdatedby
        cancelflag
        statuscode
        statusmessage
        consigneename
        consigneegstin
        companystate
        cancelremark
        deleteremark
        roundoffamount
        discounttype
        discountvalue
        serialnumber
        currencycode
        currencyrate
        paymentstatus
        ackno
        ackdt
        irn
        signedqrcode
        itcflag
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      cancelflag
      cancelremark
      serialnumber
      pdflink
      towards
      isvouchereditable
      __typename
    }
    relatedpartymaster {
      partyid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      partytypecd
      partydisplayname
      partylegalname
      groupaccountid
      gstcategory
      placeofsupply
      entity
      email
      contactnumber
      whatsappnumber
      accountsid
      is_active
      msmetype
      deliveryconsigneename
      deliveryconsigneegstin
      statuscode
      statusmessage
      relatedpartygstdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        pannumber
        gstin
        partyaddressid
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycreditdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        creditperiodduration
        billingcurrency
        creditlimitcd
        creditlimitamount
        billwiseflag
        notes
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycontact {
        partyid
        enteredtimestamp
        expiredtimestamp
        contacttypename
        contactdesignationname
        contactorder
        email
        phonenumber
        whatsappnumber
        lastupdatedby
        statuscode
        statusmessage
        contactcountry
        whatsappcountry
        __typename
      }
      relatedpartyimages {
        attachmentid
        partyid
        companyid
        enteredtimestamp
        expiredtimestamp
        type
        documentname
        imagename
        imageurl
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      tdspercentage
      udhyamregno
      sameaddressflag
      comments
      tdssection
      accountname
      deliverystatecode
      deliverystatename
      contactcountry
      whatsappcountry
      entityname
      __typename
    }
    relatedpaymentaccountdetails {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    relatedinvoiceaddressdetails {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      line1
      line2
      line3
      city
      statecode
      statename
      statuscode
      statusmessage
      pincode
      countrycode
      codevalue
      district
      lastupdatedby
      godownname
      gstin
      phone
      email
      personincharge
      consigneename
      consigneegstin
      foreignstate
      foreigndistrict
      defaultflag
      addresstitle
      addressindex
      __typename
    }
    lastupdatedby
    statuscode
    statusmessage
    cancelflag
    consigneename
    consigneegstin
    companystate
    cancelremark
    deleteremark
    roundoffamount
    discounttype
    discountvalue
    serialnumber
    serialflag
    currencycode
    currencyrate
    partydisplayname
    partylegalname
    partyaccountid
    paymentstatus
    ackno
    ackdt
    irn
    signedqrcode
    partyemail
    invoicepdf
    partygstin
    partytypecd
    partygstcategory
    is_cancelled
    cancel_reason
    cancel_remarks
    phonenumber
    bankaccountid
    bankamount
    ewaybillno
    validupto
    ewaybill_validupto
    ewaybill_is_cancelled
    ewaybill_cancel_remarks
    ewaybill_cancel_rsn_code
    cancel_rsn_code
    einvoiceenteredtimestamp
    ewaybillenteredtimestamp
    ewaybillid
    ewaybillpdf
    ewaybillstatus
    invoicetype
    accountname
    partyisactive
    goods_exist
    overduedays
    duedatetimestamp
    isvouchereditable
    itcflag
    taxability
    linkedamount
    cessexist
    partyamount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInvoiceMasterQueryVariables,
  APITypes.ListInvoiceMasterQuery
>;
export const listInvoiceDenominations = /* GraphQL */ `query ListInvoiceDenominations($invoiceid: Int) {
  listInvoiceDenominations(invoiceid: $invoiceid) {
    invoiceid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    denomination
    number_of_notes
    typecd
    last_updated_by
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInvoiceDenominationsQueryVariables,
  APITypes.ListInvoiceDenominationsQuery
>;
export const listIndustryType = /* GraphQL */ `query ListIndustryType {
  listIndustryType {
    industrytypeid
    companyid
    enteredtimestamp
    expiredtimestamp
    industrytype
    lastupdatedby
    restrictedflag
    isactive
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListIndustryTypeQueryVariables,
  APITypes.ListIndustryTypeQuery
>;
export const listHSN = /* GraphQL */ `query ListHSN($rowfrom: Int!, $limitno: Int!) {
  listHSN(rowfrom: $rowfrom, limitno: $limitno) {
    hsnsacid
    codetype
    hsnsaccode
    description
    enteredtimestamp
    expiredtimestamp
    lastupdatedby
    statuscode
    statusmessage
    companyid
    __typename
  }
}
` as GeneratedQuery<APITypes.ListHSNQueryVariables, APITypes.ListHSNQuery>;
export const listGeneralSetting = /* GraphQL */ `query ListGeneralSetting($entrytypecd: String!, $financialyearid: Int) {
  listGeneralSetting(
    entrytypecd: $entrytypecd
    financialyearid: $financialyearid
  ) {
    id
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    financialyearid
    entrytypecd
    serialnumber
    serialisactive
    serialisused
    nextinvoicenumber
    prefix
    suffix
    lastupdatedby
    statuscode
    statusmessage
    serialflag
    startinvoicenumber
    taxability
    lastused
    secondlastused
    restrictedflag
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListGeneralSettingQueryVariables,
  APITypes.ListGeneralSettingQuery
>;
export const listFinancialYearTransferHistory = /* GraphQL */ `query ListFinancialYearTransferHistory {
  listFinancialYearTransferHistory {
    id
    companyid
    enteredtimestamp
    expiredtimestamp
    financialyearidfrom
    financialyearidto
    transferdate
    ledgertransferdate
    ledgercbtransferdate
    partyledgertransferdate
    partycbtransferdate
    itemtransferdate
    itemcbtransferdate
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFinancialYearTransferHistoryQueryVariables,
  APITypes.ListFinancialYearTransferHistoryQuery
>;
export const listFinancialYearStatus = /* GraphQL */ `query ListFinancialYearStatus {
  listFinancialYearStatus {
    financialyearid
    statustypecd
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    statusvalue
    userid
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFinancialYearStatusQueryVariables,
  APITypes.ListFinancialYearStatusQuery
>;
export const listFinancialYear = /* GraphQL */ `query ListFinancialYear {
  listFinancialYear {
    financialyearid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    startdate
    enddate
    startyear
    endyear
    comments
    userid
    aliasname
    statuscode
    statusmessage
    freezestatus
    transferdate
    freezedate
    stepscompleted
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFinancialYearQueryVariables,
  APITypes.ListFinancialYearQuery
>;
export const listEmailContacts = /* GraphQL */ `query ListEmailContacts {
  listEmailContacts {
    id
    objecttype
    objectid
    enteredtimestamp
    expiredtimestamp
    emailaddress
    verifieddatetime
    promotionssignup
    statuscode
    statusmessage
    lastupdatedby
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEmailContactsQueryVariables,
  APITypes.ListEmailContactsQuery
>;
export const listeInvoiceUsers = /* GraphQL */ `query ListeInvoiceUsers {
  listeInvoiceUsers {
    id
    companyid
    username
    password
    enteredtimestamp
    expiredtimestamp
    is_active
    lastupdatedby
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListeInvoiceUsersQueryVariables,
  APITypes.ListeInvoiceUsersQuery
>;
export const listDeletedPayments = /* GraphQL */ `query ListDeletedPayments($type: String!) {
  listDeletedPayments(type: $type) {
    transactionid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    transactiontypecd
    vouchernumber
    entrydate
    bankreferencenumber
    comments
    relatedtransactiondetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      accountid
      creditamount
      debitamount
      comments
      entryordernumber
      transactionbalance
      openingbalance
      relatedaccounts {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accountname
        accounttypecd
        accountgroupid
        hsnsaccode
        displayordernumber
        statuscode
        statusmessage
        restrictedflag
        is_active
        accounttypeflag
        relatedaccountgstdetails {
          accountid
          companyid
          enteredtimestamp
          expiredtimestamp
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstrate
          cessamount
          lastupdatedby
          statuscode
          statusmessage
          hsnsaccode
          codetype
          description
          taxability
          __typename
        }
        relatedaccountopeningbalance {
          accountsid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          financialyearid
          startdate
          creditamount
          debitamount
          statuscode
          statusmessage
          __typename
        }
        relatedaccountgroupmaster {
          accountgroupid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          accounttypecd
          accountgroupname
          accountparentgroupid
          displayordernumber
          statuscode
          statusmessage
          is_active
          restrictedflag
          path
          __typename
        }
        relatedaccountbalance {
          accountid
          accountbalance
          actualbalance
          __typename
        }
        path
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      financialyearid
      __typename
    }
    relatedtransactionattachment {
      transactionid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      lastupdatedby
      documentname
      statuscode
      statusmessage
      type
      __typename
    }
    relatedtransactiontdsdetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tdsapplicablecd
      tdsamount
      tdsmanual
      lastupdatedby
      statuscode
      statusmessage
      tdspercentage
      __typename
    }
    relatedpurchasemaster {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      purchasegsttypecd
      supplierid
      entrydate
      vouchernumber
      supplierinvoicedate
      supplierinvoicenumber
      supplieraddressid
      paymenttypecd
      paidamount
      creditduration
      paymentaccountid
      comments
      tdsapplicableflag
      granttotalamount
      balancedueamount
      paymentclearedflag
      placeofsupply
      companystate
      relatedpurchasetdsdetails {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tdsapplicablecd
        totaltaxableamount
        ineligibletcflag
        reversechargeflag
        gstcesstotal
        tdsamount
        adjustmentamount
        tdssection
        tdspercentage
        tdsmanual
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpurchaselineitems {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        itemnumber
        itemid
        purchaseaccountid
        hsncode
        itemquantity
        unittypecd
        itemrate
        itemamount
        itemdiscount
        taxableamount
        description
        discounttype
        discountrate
        netamount
        relatedpurchaselinegst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemmaster {
          itemid
          itemcode
          companyid
          enteredtimestamp
          expiredtimestamp
          itemname
          salesinvoiceflag
          purchaseinvoiceflag
          itemcategorycd
          measurementcd
          currencycd
          salesaccountid
          purchaseaccountid
          taxabilitycd
          reversechargeflag
          itemtype
          hsnid
          is_active
          statuscode
          statusmessage
          relateditemamountdetails {
            id
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            amount
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstcompensationvalue
            gstrate
            statuscode
            statusmessage
            lastupdatedby
            discounttype
            discountvalue
            invoicetype
            pricetype
            isactive
            isdefault
            pricetypeid
            tabletype
            __typename
          }
          relateditemgstdetails {
            itemid
            companyid
            enteredtimestamp
            expiredtimestamp
            hsnid
            gstcesstype
            gstcompensationvalue
            effectivedate
            expireddate
            gstcessvalue
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemimages {
            attachmentid
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            imagename
            imageurl
            documentname
            type
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          serialnumber
          financialyearid
          description
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          cessexist
          barcode
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        taxability
        pricetype
        lotid
        hsnid
        hsncodetype
        hsndescription
        gstrate
        gstamount
        cessamount
        unit
        uqc
        purchaseaccountname
        itemname
        itemcode
        itemtype
        manualdiscount
        manualcess
        pricetypeid
        manualgst
        cessrate
        cesstype
        type
        __typename
      }
      relatedpurchaselinenonitems {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        purchaselineitemtype
        purchaseaccountid
        hsnsaccode
        itemdescription
        taxableamount
        rate
        discount
        netamount
        relatedpurchaselinenongst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        taxability
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gstamount
        cessamount
        purchaseaccountname
        manualgst
        manualcess
        cessrate
        cesstype
        type
        __typename
      }
      relatedpurchaselinegst {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        cessamount
        gstamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpurchaseattachment {
        purchaseid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        statuscode
        statusmessage
        documentname
        type
        __typename
      }
      relatedpurchasetransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        vouchernumber
        entrydate
        bankreferencenumber
        comments
        relatedtransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          accountid
          creditamount
          debitamount
          comments
          entryordernumber
          transactionbalance
          openingbalance
          lastupdatedby
          statuscode
          statusmessage
          financialyearid
          __typename
        }
        relatedtransactionattachment {
          transactionid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          documentname
          statuscode
          statusmessage
          type
          __typename
        }
        relatedtransactiontdsdetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          tdsamount
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          tdspercentage
          __typename
        }
        relatedpurchasemaster {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchasegsttypecd
          supplierid
          entrydate
          vouchernumber
          supplierinvoicedate
          supplierinvoicenumber
          supplieraddressid
          paymenttypecd
          paidamount
          creditduration
          paymentaccountid
          comments
          tdsapplicableflag
          granttotalamount
          balancedueamount
          paymentclearedflag
          placeofsupply
          companystate
          relatedpurchasetdsdetails {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            totaltaxableamount
            ineligibletcflag
            reversechargeflag
            gstcesstotal
            tdsamount
            adjustmentamount
            tdssection
            tdspercentage
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaselineitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            itemnumber
            itemid
            purchaseaccountid
            hsncode
            itemquantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            description
            discounttype
            discountrate
            netamount
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            pricetype
            lotid
            hsnid
            hsncodetype
            hsndescription
            gstrate
            gstamount
            cessamount
            unit
            uqc
            purchaseaccountname
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinenonitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchaselineitemtype
            purchaseaccountid
            hsnsaccode
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedpurchaselinenongst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gstamount
            cessamount
            purchaseaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaseattachment {
            purchaseid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedpurchasetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          relatedpurchasetransactionrelation {
            transactionid
            transactiontypecd
            objecttype
            objectid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            linkedamount
            objectattribute
            isdirect
            lastupdatedby
            accountid
            paymentvouchernumber
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          cancelflag
          roundoffamount
          discounttype
          discountvalue
          adjustmentamount
          serialnumber
          currencycode
          currencyrate
          reversechargeflag
          paymentstatus
          partyregistrationtype
          partygstcategory
          itcflag
          __typename
        }
        relatedinvoicemaster {
          invoiceid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicetypecd
          partyid
          paymentaccountid
          invoicedate
          invoicenumber
          customerordernumber
          customerorderdate
          invoiceamount
          paymenttype
          creditduration
          invoicebillingaddressid
          invoicedeliveryaddressid
          invoicetaxabletypecd
          receipturl
          invoicelinetypecd
          invoicecurrencycd
          exchangerate
          comments
          receivedamount
          adjustmentamount
          placeofsupply
          balancedueamount
          reversechargeflag
          tcsapplicableflag
          relatedinvoicelineitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            lineitemnumber
            invoicelineitemtype
            itemid
            quantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            discounttype
            discountrate
            netamount
            hsnsaccode
            taxability
            lastupdatedby
            statuscode
            statusmessage
            pricetype
            lotid
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            unit
            uqc
            salesaccountname
            salesaccountid
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            itemmaster_timestamp
            description
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoicelinenonitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicelineitemtype
            incomeaccountid
            hsnsaccode
            taxability
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedaccounts {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accountname
              accounttypecd
              accountgroupid
              hsnsaccode
              displayordernumber
              statuscode
              statusmessage
              restrictedflag
              is_active
              accounttypeflag
              path
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            incomeaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoiceattachment {
            invoiceid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedinvoicedispatch {
            invoiceid
            dispatchid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transportationcd
            vehiclenumber
            dispatchdate
            ewaybillnumber
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoiceposdetails {
            posid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            partyposid
            lastupdatedby
            relatedposparty {
              pospartyid
              companyid
              partyname
              partycontactnumberid
              lastupdatedby
              enteredtimestamp
              expiredtimestamp
              __typename
            }
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicenumbertracker {
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            nextinvoicenumber
            lastupdatedby
            __typename
          }
          relatedinvoicetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          lastupdatedby
          cancelflag
          statuscode
          statusmessage
          consigneename
          consigneegstin
          companystate
          cancelremark
          deleteremark
          roundoffamount
          discounttype
          discountvalue
          serialnumber
          currencycode
          currencyrate
          paymentstatus
          ackno
          ackdt
          irn
          signedqrcode
          itcflag
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        cancelflag
        cancelremark
        serialnumber
        pdflink
        towards
        isvouchereditable
        __typename
      }
      relatedpurchasetransactionrelation {
        transactionid
        transactiontypecd
        objecttype
        objectid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        linkedamount
        objectattribute
        isdirect
        lastupdatedby
        accountid
        paymentvouchernumber
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      cancelflag
      roundoffamount
      discounttype
      discountvalue
      adjustmentamount
      serialnumber
      currencycode
      currencyrate
      reversechargeflag
      paymentstatus
      partyregistrationtype
      partygstcategory
      itcflag
      __typename
    }
    relatedinvoicemaster {
      invoiceid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoicetypecd
      partyid
      paymentaccountid
      invoicedate
      invoicenumber
      customerordernumber
      customerorderdate
      invoiceamount
      paymenttype
      creditduration
      invoicebillingaddressid
      invoicedeliveryaddressid
      invoicetaxabletypecd
      receipturl
      invoicelinetypecd
      invoicecurrencycd
      exchangerate
      comments
      receivedamount
      adjustmentamount
      placeofsupply
      balancedueamount
      reversechargeflag
      tcsapplicableflag
      relatedinvoicelineitems {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        lineitemnumber
        invoicelineitemtype
        itemid
        quantity
        unittypecd
        itemrate
        itemamount
        itemdiscount
        taxableamount
        discounttype
        discountrate
        netamount
        hsnsaccode
        taxability
        lastupdatedby
        statuscode
        statusmessage
        pricetype
        lotid
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gsttypecd
        gstamount
        cessamount
        unit
        uqc
        salesaccountname
        salesaccountid
        itemname
        itemcode
        itemtype
        manualdiscount
        manualcess
        itemmaster_timestamp
        description
        relatedinvoicelinegst {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          gsttypecd
          gstamount
          cessamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemmaster {
          itemid
          itemcode
          companyid
          enteredtimestamp
          expiredtimestamp
          itemname
          salesinvoiceflag
          purchaseinvoiceflag
          itemcategorycd
          measurementcd
          currencycd
          salesaccountid
          purchaseaccountid
          taxabilitycd
          reversechargeflag
          itemtype
          hsnid
          is_active
          statuscode
          statusmessage
          relateditemamountdetails {
            id
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            amount
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstcompensationvalue
            gstrate
            statuscode
            statusmessage
            lastupdatedby
            discounttype
            discountvalue
            invoicetype
            pricetype
            isactive
            isdefault
            pricetypeid
            tabletype
            __typename
          }
          relateditemgstdetails {
            itemid
            companyid
            enteredtimestamp
            expiredtimestamp
            hsnid
            gstcesstype
            gstcompensationvalue
            effectivedate
            expireddate
            gstcessvalue
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemimages {
            attachmentid
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            imagename
            imageurl
            documentname
            type
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          serialnumber
          financialyearid
          description
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          cessexist
          barcode
          __typename
        }
        pricetypeid
        manualgst
        cessrate
        cesstype
        type
        __typename
      }
      relatedinvoicelinenonitems {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        invoicelineitemtype
        incomeaccountid
        hsnsaccode
        taxability
        itemdescription
        taxableamount
        rate
        discount
        netamount
        relatedaccounts {
          accountsid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          accountname
          accounttypecd
          accountgroupid
          hsnsaccode
          displayordernumber
          statuscode
          statusmessage
          restrictedflag
          is_active
          accounttypeflag
          relatedaccountgstdetails {
            accountid
            companyid
            enteredtimestamp
            expiredtimestamp
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstrate
            cessamount
            lastupdatedby
            statuscode
            statusmessage
            hsnsaccode
            codetype
            description
            taxability
            __typename
          }
          relatedaccountopeningbalance {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            financialyearid
            startdate
            creditamount
            debitamount
            statuscode
            statusmessage
            __typename
          }
          relatedaccountgroupmaster {
            accountgroupid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accounttypecd
            accountgroupname
            accountparentgroupid
            displayordernumber
            statuscode
            statusmessage
            is_active
            restrictedflag
            path
            __typename
          }
          relatedaccountbalance {
            accountid
            accountbalance
            actualbalance
            __typename
          }
          path
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gsttypecd
        gstamount
        cessamount
        incomeaccountname
        manualgst
        manualcess
        cessrate
        cesstype
        type
        __typename
      }
      relatedinvoiceattachment {
        invoiceid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        statuscode
        statusmessage
        documentname
        type
        __typename
      }
      relatedinvoicedispatch {
        invoiceid
        dispatchid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transportationcd
        vehiclenumber
        dispatchdate
        ewaybillnumber
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedinvoiceposdetails {
        posid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        partyposid
        lastupdatedby
        relatedposparty {
          pospartyid
          companyid
          partyname
          partycontactnumberid
          lastupdatedby
          enteredtimestamp
          expiredtimestamp
          relatedphonecontacts {
            id
            objecttype
            objectid
            enteredtimestamp
            expiredtimestamp
            countrycode
            phonenumber
            verifieddatetime
            promotionssignup
            smsallowed
            callallowed
            whatsappallowed
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          __typename
        }
        statuscode
        statusmessage
        __typename
      }
      relatedinvoicelinegst {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        gsttypecd
        gstamount
        cessamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedinvoicenumbertracker {
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        nextinvoicenumber
        lastupdatedby
        __typename
      }
      relatedinvoicetransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        vouchernumber
        entrydate
        bankreferencenumber
        comments
        relatedtransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          accountid
          creditamount
          debitamount
          comments
          entryordernumber
          transactionbalance
          openingbalance
          lastupdatedby
          statuscode
          statusmessage
          financialyearid
          __typename
        }
        relatedtransactionattachment {
          transactionid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          documentname
          statuscode
          statusmessage
          type
          __typename
        }
        relatedtransactiontdsdetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          tdsamount
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          tdspercentage
          __typename
        }
        relatedpurchasemaster {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchasegsttypecd
          supplierid
          entrydate
          vouchernumber
          supplierinvoicedate
          supplierinvoicenumber
          supplieraddressid
          paymenttypecd
          paidamount
          creditduration
          paymentaccountid
          comments
          tdsapplicableflag
          granttotalamount
          balancedueamount
          paymentclearedflag
          placeofsupply
          companystate
          relatedpurchasetdsdetails {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            totaltaxableamount
            ineligibletcflag
            reversechargeflag
            gstcesstotal
            tdsamount
            adjustmentamount
            tdssection
            tdspercentage
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaselineitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            itemnumber
            itemid
            purchaseaccountid
            hsncode
            itemquantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            description
            discounttype
            discountrate
            netamount
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            pricetype
            lotid
            hsnid
            hsncodetype
            hsndescription
            gstrate
            gstamount
            cessamount
            unit
            uqc
            purchaseaccountname
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinenonitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchaselineitemtype
            purchaseaccountid
            hsnsaccode
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedpurchaselinenongst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gstamount
            cessamount
            purchaseaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaseattachment {
            purchaseid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedpurchasetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          relatedpurchasetransactionrelation {
            transactionid
            transactiontypecd
            objecttype
            objectid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            linkedamount
            objectattribute
            isdirect
            lastupdatedby
            accountid
            paymentvouchernumber
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          cancelflag
          roundoffamount
          discounttype
          discountvalue
          adjustmentamount
          serialnumber
          currencycode
          currencyrate
          reversechargeflag
          paymentstatus
          partyregistrationtype
          partygstcategory
          itcflag
          __typename
        }
        relatedinvoicemaster {
          invoiceid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicetypecd
          partyid
          paymentaccountid
          invoicedate
          invoicenumber
          customerordernumber
          customerorderdate
          invoiceamount
          paymenttype
          creditduration
          invoicebillingaddressid
          invoicedeliveryaddressid
          invoicetaxabletypecd
          receipturl
          invoicelinetypecd
          invoicecurrencycd
          exchangerate
          comments
          receivedamount
          adjustmentamount
          placeofsupply
          balancedueamount
          reversechargeflag
          tcsapplicableflag
          relatedinvoicelineitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            lineitemnumber
            invoicelineitemtype
            itemid
            quantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            discounttype
            discountrate
            netamount
            hsnsaccode
            taxability
            lastupdatedby
            statuscode
            statusmessage
            pricetype
            lotid
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            unit
            uqc
            salesaccountname
            salesaccountid
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            itemmaster_timestamp
            description
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoicelinenonitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicelineitemtype
            incomeaccountid
            hsnsaccode
            taxability
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedaccounts {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accountname
              accounttypecd
              accountgroupid
              hsnsaccode
              displayordernumber
              statuscode
              statusmessage
              restrictedflag
              is_active
              accounttypeflag
              path
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            incomeaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoiceattachment {
            invoiceid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedinvoicedispatch {
            invoiceid
            dispatchid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transportationcd
            vehiclenumber
            dispatchdate
            ewaybillnumber
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoiceposdetails {
            posid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            partyposid
            lastupdatedby
            relatedposparty {
              pospartyid
              companyid
              partyname
              partycontactnumberid
              lastupdatedby
              enteredtimestamp
              expiredtimestamp
              __typename
            }
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicenumbertracker {
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            nextinvoicenumber
            lastupdatedby
            __typename
          }
          relatedinvoicetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          lastupdatedby
          cancelflag
          statuscode
          statusmessage
          consigneename
          consigneegstin
          companystate
          cancelremark
          deleteremark
          roundoffamount
          discounttype
          discountvalue
          serialnumber
          currencycode
          currencyrate
          paymentstatus
          ackno
          ackdt
          irn
          signedqrcode
          itcflag
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        cancelflag
        cancelremark
        serialnumber
        pdflink
        towards
        isvouchereditable
        __typename
      }
      lastupdatedby
      cancelflag
      statuscode
      statusmessage
      consigneename
      consigneegstin
      companystate
      cancelremark
      deleteremark
      roundoffamount
      discounttype
      discountvalue
      serialnumber
      currencycode
      currencyrate
      paymentstatus
      ackno
      ackdt
      irn
      signedqrcode
      itcflag
      __typename
    }
    lastupdatedby
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDeletedPaymentsQueryVariables,
  APITypes.ListDeletedPaymentsQuery
>;
export const listDeletedParty = /* GraphQL */ `query ListDeletedParty($type: String!) {
  listDeletedParty(type: $type) {
    partyid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    partytypecd
    partydisplayname
    partylegalname
    groupaccountid
    gstcategory
    placeofsupply
    entity
    email
    contactnumber
    whatsappnumber
    accountsid
    is_active
    msmetype
    deliveryconsigneename
    deliveryconsigneegstin
    statuscode
    statusmessage
    relatedpartygstdetails {
      partyid
      enteredtimestamp
      expiredtimestamp
      pannumber
      gstin
      partyaddressid
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpartycreditdetails {
      partyid
      enteredtimestamp
      expiredtimestamp
      creditperiodduration
      billingcurrency
      creditlimitcd
      creditlimitamount
      billwiseflag
      notes
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpartycontact {
      partyid
      enteredtimestamp
      expiredtimestamp
      contacttypename
      contactdesignationname
      contactorder
      email
      phonenumber
      whatsappnumber
      lastupdatedby
      statuscode
      statusmessage
      contactcountry
      whatsappcountry
      __typename
    }
    relatedpartyimages {
      attachmentid
      partyid
      companyid
      enteredtimestamp
      expiredtimestamp
      type
      documentname
      imagename
      imageurl
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpurchasemaster {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      purchasegsttypecd
      supplierid
      entrydate
      vouchernumber
      supplierinvoicedate
      supplierinvoicenumber
      supplieraddressid
      paymenttypecd
      paidamount
      creditduration
      paymentaccountid
      comments
      tdsapplicableflag
      granttotalamount
      balancedueamount
      paymentclearedflag
      placeofsupply
      companystate
      relatedpurchasetdsdetails {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tdsapplicablecd
        totaltaxableamount
        ineligibletcflag
        reversechargeflag
        gstcesstotal
        tdsamount
        adjustmentamount
        tdssection
        tdspercentage
        tdsmanual
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpurchaselineitems {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        itemnumber
        itemid
        purchaseaccountid
        hsncode
        itemquantity
        unittypecd
        itemrate
        itemamount
        itemdiscount
        taxableamount
        description
        discounttype
        discountrate
        netamount
        relatedpurchaselinegst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemmaster {
          itemid
          itemcode
          companyid
          enteredtimestamp
          expiredtimestamp
          itemname
          salesinvoiceflag
          purchaseinvoiceflag
          itemcategorycd
          measurementcd
          currencycd
          salesaccountid
          purchaseaccountid
          taxabilitycd
          reversechargeflag
          itemtype
          hsnid
          is_active
          statuscode
          statusmessage
          relateditemamountdetails {
            id
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            amount
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstcompensationvalue
            gstrate
            statuscode
            statusmessage
            lastupdatedby
            discounttype
            discountvalue
            invoicetype
            pricetype
            isactive
            isdefault
            pricetypeid
            tabletype
            __typename
          }
          relateditemgstdetails {
            itemid
            companyid
            enteredtimestamp
            expiredtimestamp
            hsnid
            gstcesstype
            gstcompensationvalue
            effectivedate
            expireddate
            gstcessvalue
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemimages {
            attachmentid
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            imagename
            imageurl
            documentname
            type
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          serialnumber
          financialyearid
          description
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          cessexist
          barcode
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        taxability
        pricetype
        lotid
        hsnid
        hsncodetype
        hsndescription
        gstrate
        gstamount
        cessamount
        unit
        uqc
        purchaseaccountname
        itemname
        itemcode
        itemtype
        manualdiscount
        manualcess
        pricetypeid
        manualgst
        cessrate
        cesstype
        type
        __typename
      }
      relatedpurchaselinenonitems {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        purchaselineitemtype
        purchaseaccountid
        hsnsaccode
        itemdescription
        taxableamount
        rate
        discount
        netamount
        relatedpurchaselinenongst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        taxability
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gstamount
        cessamount
        purchaseaccountname
        manualgst
        manualcess
        cessrate
        cesstype
        type
        __typename
      }
      relatedpurchaselinegst {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        cessamount
        gstamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpurchaseattachment {
        purchaseid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        statuscode
        statusmessage
        documentname
        type
        __typename
      }
      relatedpurchasetransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        vouchernumber
        entrydate
        bankreferencenumber
        comments
        relatedtransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          accountid
          creditamount
          debitamount
          comments
          entryordernumber
          transactionbalance
          openingbalance
          lastupdatedby
          statuscode
          statusmessage
          financialyearid
          __typename
        }
        relatedtransactionattachment {
          transactionid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          documentname
          statuscode
          statusmessage
          type
          __typename
        }
        relatedtransactiontdsdetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          tdsamount
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          tdspercentage
          __typename
        }
        relatedpurchasemaster {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchasegsttypecd
          supplierid
          entrydate
          vouchernumber
          supplierinvoicedate
          supplierinvoicenumber
          supplieraddressid
          paymenttypecd
          paidamount
          creditduration
          paymentaccountid
          comments
          tdsapplicableflag
          granttotalamount
          balancedueamount
          paymentclearedflag
          placeofsupply
          companystate
          relatedpurchasetdsdetails {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            totaltaxableamount
            ineligibletcflag
            reversechargeflag
            gstcesstotal
            tdsamount
            adjustmentamount
            tdssection
            tdspercentage
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaselineitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            itemnumber
            itemid
            purchaseaccountid
            hsncode
            itemquantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            description
            discounttype
            discountrate
            netamount
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            pricetype
            lotid
            hsnid
            hsncodetype
            hsndescription
            gstrate
            gstamount
            cessamount
            unit
            uqc
            purchaseaccountname
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinenonitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchaselineitemtype
            purchaseaccountid
            hsnsaccode
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedpurchaselinenongst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gstamount
            cessamount
            purchaseaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaseattachment {
            purchaseid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedpurchasetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          relatedpurchasetransactionrelation {
            transactionid
            transactiontypecd
            objecttype
            objectid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            linkedamount
            objectattribute
            isdirect
            lastupdatedby
            accountid
            paymentvouchernumber
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          cancelflag
          roundoffamount
          discounttype
          discountvalue
          adjustmentamount
          serialnumber
          currencycode
          currencyrate
          reversechargeflag
          paymentstatus
          partyregistrationtype
          partygstcategory
          itcflag
          __typename
        }
        relatedinvoicemaster {
          invoiceid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicetypecd
          partyid
          paymentaccountid
          invoicedate
          invoicenumber
          customerordernumber
          customerorderdate
          invoiceamount
          paymenttype
          creditduration
          invoicebillingaddressid
          invoicedeliveryaddressid
          invoicetaxabletypecd
          receipturl
          invoicelinetypecd
          invoicecurrencycd
          exchangerate
          comments
          receivedamount
          adjustmentamount
          placeofsupply
          balancedueamount
          reversechargeflag
          tcsapplicableflag
          relatedinvoicelineitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            lineitemnumber
            invoicelineitemtype
            itemid
            quantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            discounttype
            discountrate
            netamount
            hsnsaccode
            taxability
            lastupdatedby
            statuscode
            statusmessage
            pricetype
            lotid
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            unit
            uqc
            salesaccountname
            salesaccountid
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            itemmaster_timestamp
            description
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoicelinenonitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicelineitemtype
            incomeaccountid
            hsnsaccode
            taxability
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedaccounts {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accountname
              accounttypecd
              accountgroupid
              hsnsaccode
              displayordernumber
              statuscode
              statusmessage
              restrictedflag
              is_active
              accounttypeflag
              path
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            incomeaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoiceattachment {
            invoiceid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedinvoicedispatch {
            invoiceid
            dispatchid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transportationcd
            vehiclenumber
            dispatchdate
            ewaybillnumber
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoiceposdetails {
            posid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            partyposid
            lastupdatedby
            relatedposparty {
              pospartyid
              companyid
              partyname
              partycontactnumberid
              lastupdatedby
              enteredtimestamp
              expiredtimestamp
              __typename
            }
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicenumbertracker {
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            nextinvoicenumber
            lastupdatedby
            __typename
          }
          relatedinvoicetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          lastupdatedby
          cancelflag
          statuscode
          statusmessage
          consigneename
          consigneegstin
          companystate
          cancelremark
          deleteremark
          roundoffamount
          discounttype
          discountvalue
          serialnumber
          currencycode
          currencyrate
          paymentstatus
          ackno
          ackdt
          irn
          signedqrcode
          itcflag
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        cancelflag
        cancelremark
        serialnumber
        pdflink
        towards
        isvouchereditable
        __typename
      }
      relatedpurchasetransactionrelation {
        transactionid
        transactiontypecd
        objecttype
        objectid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        linkedamount
        objectattribute
        isdirect
        lastupdatedby
        accountid
        paymentvouchernumber
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      cancelflag
      roundoffamount
      discounttype
      discountvalue
      adjustmentamount
      serialnumber
      currencycode
      currencyrate
      reversechargeflag
      paymentstatus
      partyregistrationtype
      partygstcategory
      itcflag
      __typename
    }
    relatedinvoicemaster {
      invoiceid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoicetypecd
      partyid
      paymentaccountid
      invoicedate
      invoicenumber
      customerordernumber
      customerorderdate
      invoiceamount
      paymenttype
      creditduration
      invoicebillingaddressid
      invoicedeliveryaddressid
      invoicetaxabletypecd
      receipturl
      invoicelinetypecd
      invoicecurrencycd
      exchangerate
      comments
      receivedamount
      adjustmentamount
      placeofsupply
      balancedueamount
      reversechargeflag
      tcsapplicableflag
      relatedinvoicelineitems {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        lineitemnumber
        invoicelineitemtype
        itemid
        quantity
        unittypecd
        itemrate
        itemamount
        itemdiscount
        taxableamount
        discounttype
        discountrate
        netamount
        hsnsaccode
        taxability
        lastupdatedby
        statuscode
        statusmessage
        pricetype
        lotid
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gsttypecd
        gstamount
        cessamount
        unit
        uqc
        salesaccountname
        salesaccountid
        itemname
        itemcode
        itemtype
        manualdiscount
        manualcess
        itemmaster_timestamp
        description
        relatedinvoicelinegst {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          gsttypecd
          gstamount
          cessamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemmaster {
          itemid
          itemcode
          companyid
          enteredtimestamp
          expiredtimestamp
          itemname
          salesinvoiceflag
          purchaseinvoiceflag
          itemcategorycd
          measurementcd
          currencycd
          salesaccountid
          purchaseaccountid
          taxabilitycd
          reversechargeflag
          itemtype
          hsnid
          is_active
          statuscode
          statusmessage
          relateditemamountdetails {
            id
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            amount
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstcompensationvalue
            gstrate
            statuscode
            statusmessage
            lastupdatedby
            discounttype
            discountvalue
            invoicetype
            pricetype
            isactive
            isdefault
            pricetypeid
            tabletype
            __typename
          }
          relateditemgstdetails {
            itemid
            companyid
            enteredtimestamp
            expiredtimestamp
            hsnid
            gstcesstype
            gstcompensationvalue
            effectivedate
            expireddate
            gstcessvalue
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemimages {
            attachmentid
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            imagename
            imageurl
            documentname
            type
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          serialnumber
          financialyearid
          description
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          cessexist
          barcode
          __typename
        }
        pricetypeid
        manualgst
        cessrate
        cesstype
        type
        __typename
      }
      relatedinvoicelinenonitems {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        invoicelineitemtype
        incomeaccountid
        hsnsaccode
        taxability
        itemdescription
        taxableamount
        rate
        discount
        netamount
        relatedaccounts {
          accountsid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          accountname
          accounttypecd
          accountgroupid
          hsnsaccode
          displayordernumber
          statuscode
          statusmessage
          restrictedflag
          is_active
          accounttypeflag
          relatedaccountgstdetails {
            accountid
            companyid
            enteredtimestamp
            expiredtimestamp
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstrate
            cessamount
            lastupdatedby
            statuscode
            statusmessage
            hsnsaccode
            codetype
            description
            taxability
            __typename
          }
          relatedaccountopeningbalance {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            financialyearid
            startdate
            creditamount
            debitamount
            statuscode
            statusmessage
            __typename
          }
          relatedaccountgroupmaster {
            accountgroupid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accounttypecd
            accountgroupname
            accountparentgroupid
            displayordernumber
            statuscode
            statusmessage
            is_active
            restrictedflag
            path
            __typename
          }
          relatedaccountbalance {
            accountid
            accountbalance
            actualbalance
            __typename
          }
          path
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gsttypecd
        gstamount
        cessamount
        incomeaccountname
        manualgst
        manualcess
        cessrate
        cesstype
        type
        __typename
      }
      relatedinvoiceattachment {
        invoiceid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        statuscode
        statusmessage
        documentname
        type
        __typename
      }
      relatedinvoicedispatch {
        invoiceid
        dispatchid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transportationcd
        vehiclenumber
        dispatchdate
        ewaybillnumber
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedinvoiceposdetails {
        posid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        partyposid
        lastupdatedby
        relatedposparty {
          pospartyid
          companyid
          partyname
          partycontactnumberid
          lastupdatedby
          enteredtimestamp
          expiredtimestamp
          relatedphonecontacts {
            id
            objecttype
            objectid
            enteredtimestamp
            expiredtimestamp
            countrycode
            phonenumber
            verifieddatetime
            promotionssignup
            smsallowed
            callallowed
            whatsappallowed
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          __typename
        }
        statuscode
        statusmessage
        __typename
      }
      relatedinvoicelinegst {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        gsttypecd
        gstamount
        cessamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedinvoicenumbertracker {
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        nextinvoicenumber
        lastupdatedby
        __typename
      }
      relatedinvoicetransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        vouchernumber
        entrydate
        bankreferencenumber
        comments
        relatedtransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          accountid
          creditamount
          debitamount
          comments
          entryordernumber
          transactionbalance
          openingbalance
          lastupdatedby
          statuscode
          statusmessage
          financialyearid
          __typename
        }
        relatedtransactionattachment {
          transactionid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          documentname
          statuscode
          statusmessage
          type
          __typename
        }
        relatedtransactiontdsdetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          tdsamount
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          tdspercentage
          __typename
        }
        relatedpurchasemaster {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchasegsttypecd
          supplierid
          entrydate
          vouchernumber
          supplierinvoicedate
          supplierinvoicenumber
          supplieraddressid
          paymenttypecd
          paidamount
          creditduration
          paymentaccountid
          comments
          tdsapplicableflag
          granttotalamount
          balancedueamount
          paymentclearedflag
          placeofsupply
          companystate
          relatedpurchasetdsdetails {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            totaltaxableamount
            ineligibletcflag
            reversechargeflag
            gstcesstotal
            tdsamount
            adjustmentamount
            tdssection
            tdspercentage
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaselineitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            itemnumber
            itemid
            purchaseaccountid
            hsncode
            itemquantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            description
            discounttype
            discountrate
            netamount
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            pricetype
            lotid
            hsnid
            hsncodetype
            hsndescription
            gstrate
            gstamount
            cessamount
            unit
            uqc
            purchaseaccountname
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinenonitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchaselineitemtype
            purchaseaccountid
            hsnsaccode
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedpurchaselinenongst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gstamount
            cessamount
            purchaseaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaseattachment {
            purchaseid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedpurchasetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          relatedpurchasetransactionrelation {
            transactionid
            transactiontypecd
            objecttype
            objectid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            linkedamount
            objectattribute
            isdirect
            lastupdatedby
            accountid
            paymentvouchernumber
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          cancelflag
          roundoffamount
          discounttype
          discountvalue
          adjustmentamount
          serialnumber
          currencycode
          currencyrate
          reversechargeflag
          paymentstatus
          partyregistrationtype
          partygstcategory
          itcflag
          __typename
        }
        relatedinvoicemaster {
          invoiceid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicetypecd
          partyid
          paymentaccountid
          invoicedate
          invoicenumber
          customerordernumber
          customerorderdate
          invoiceamount
          paymenttype
          creditduration
          invoicebillingaddressid
          invoicedeliveryaddressid
          invoicetaxabletypecd
          receipturl
          invoicelinetypecd
          invoicecurrencycd
          exchangerate
          comments
          receivedamount
          adjustmentamount
          placeofsupply
          balancedueamount
          reversechargeflag
          tcsapplicableflag
          relatedinvoicelineitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            lineitemnumber
            invoicelineitemtype
            itemid
            quantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            discounttype
            discountrate
            netamount
            hsnsaccode
            taxability
            lastupdatedby
            statuscode
            statusmessage
            pricetype
            lotid
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            unit
            uqc
            salesaccountname
            salesaccountid
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            itemmaster_timestamp
            description
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoicelinenonitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicelineitemtype
            incomeaccountid
            hsnsaccode
            taxability
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedaccounts {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accountname
              accounttypecd
              accountgroupid
              hsnsaccode
              displayordernumber
              statuscode
              statusmessage
              restrictedflag
              is_active
              accounttypeflag
              path
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            incomeaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoiceattachment {
            invoiceid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedinvoicedispatch {
            invoiceid
            dispatchid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transportationcd
            vehiclenumber
            dispatchdate
            ewaybillnumber
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoiceposdetails {
            posid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            partyposid
            lastupdatedby
            relatedposparty {
              pospartyid
              companyid
              partyname
              partycontactnumberid
              lastupdatedby
              enteredtimestamp
              expiredtimestamp
              __typename
            }
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicenumbertracker {
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            nextinvoicenumber
            lastupdatedby
            __typename
          }
          relatedinvoicetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          lastupdatedby
          cancelflag
          statuscode
          statusmessage
          consigneename
          consigneegstin
          companystate
          cancelremark
          deleteremark
          roundoffamount
          discounttype
          discountvalue
          serialnumber
          currencycode
          currencyrate
          paymentstatus
          ackno
          ackdt
          irn
          signedqrcode
          itcflag
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        cancelflag
        cancelremark
        serialnumber
        pdflink
        towards
        isvouchereditable
        __typename
      }
      lastupdatedby
      cancelflag
      statuscode
      statusmessage
      consigneename
      consigneegstin
      companystate
      cancelremark
      deleteremark
      roundoffamount
      discounttype
      discountvalue
      serialnumber
      currencycode
      currencyrate
      paymentstatus
      ackno
      ackdt
      irn
      signedqrcode
      itcflag
      __typename
    }
    lastupdatedby
    tdspercentage
    udhyamregno
    sameaddressflag
    comments
    tdssection
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDeletedPartyQueryVariables,
  APITypes.ListDeletedPartyQuery
>;
export const listDeletedItem = /* GraphQL */ `query ListDeletedItem($type: String!) {
  listDeletedItem(type: $type) {
    itemid
    itemcode
    companyid
    enteredtimestamp
    expiredtimestamp
    itemname
    salesinvoiceflag
    purchaseinvoiceflag
    itemcategorycd
    measurementcd
    currencycd
    salesaccountid
    purchaseaccountid
    taxabilitycd
    reversechargeflag
    itemtype
    hsnid
    is_active
    statuscode
    statusmessage
    relateditemamountdetails {
      itemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      amount
      effectivedate
      expireddate
      hsnid
      gstcompensationtype
      gstcompensationvalue
      gstrate
      statuscode
      statusmessage
      lastupdatedby
      discounttype
      discountvalue
      invoicetype
      pricetype
      isactive
      isdefault
      __typename
    }
    relateditemgstdetails {
      itemid
      companyid
      enteredtimestamp
      expiredtimestamp
      hsnid
      gstcesstype
      gstcompensationvalue
      effectivedate
      expireddate
      gstcessvalue
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relateditemimages {
      attachmentid
      itemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      imagename
      imageurl
      documentname
      type
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    lastupdatedby
    serialnumber
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDeletedItemQueryVariables,
  APITypes.ListDeletedItemQuery
>;
export const listDeletedTransactionManualJournal = /* GraphQL */ `query ListDeletedTransactionManualJournal {
  listDeletedTransactionManualJournal {
    transactionid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    transactiontypecd
    vouchernumber
    entrydate
    bankreferencenumber
    comments
    relatedtransactiondetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      accountid
      creditamount
      debitamount
      comments
      entryordernumber
      transactionbalance
      openingbalance
      relatedaccounts {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accountname
        accounttypecd
        accountgroupid
        hsnsaccode
        displayordernumber
        statuscode
        statusmessage
        restrictedflag
        is_active
        accounttypeflag
        relatedaccountgstdetails {
          accountid
          companyid
          enteredtimestamp
          expiredtimestamp
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstrate
          cessamount
          lastupdatedby
          statuscode
          statusmessage
          hsnsaccode
          codetype
          description
          taxability
          __typename
        }
        relatedaccountopeningbalance {
          accountsid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          financialyearid
          startdate
          creditamount
          debitamount
          statuscode
          statusmessage
          __typename
        }
        relatedaccountgroupmaster {
          accountgroupid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          accounttypecd
          accountgroupname
          accountparentgroupid
          displayordernumber
          statuscode
          statusmessage
          is_active
          restrictedflag
          path
          __typename
        }
        relatedaccountbalance {
          accountid
          accountbalance
          actualbalance
          __typename
        }
        path
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      financialyearid
      __typename
    }
    relatedtransactionattachment {
      transactionid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      lastupdatedby
      documentname
      statuscode
      statusmessage
      type
      __typename
    }
    relatedtransactiontdsdetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tdsapplicablecd
      tdsamount
      tdsmanual
      lastupdatedby
      statuscode
      statusmessage
      tdspercentage
      __typename
    }
    relatedpurchasemaster {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      purchasegsttypecd
      supplierid
      entrydate
      vouchernumber
      supplierinvoicedate
      supplierinvoicenumber
      supplieraddressid
      paymenttypecd
      paidamount
      creditduration
      paymentaccountid
      comments
      tdsapplicableflag
      granttotalamount
      balancedueamount
      paymentclearedflag
      placeofsupply
      companystate
      relatedpurchasetdsdetails {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tdsapplicablecd
        totaltaxableamount
        ineligibletcflag
        reversechargeflag
        gstcesstotal
        tdsamount
        adjustmentamount
        tdssection
        tdspercentage
        tdsmanual
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpurchaselineitems {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        itemnumber
        itemid
        purchaseaccountid
        hsncode
        itemquantity
        unittypecd
        itemrate
        itemamount
        itemdiscount
        taxableamount
        description
        discounttype
        discountrate
        netamount
        relatedpurchaselinegst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemmaster {
          itemid
          itemcode
          companyid
          enteredtimestamp
          expiredtimestamp
          itemname
          salesinvoiceflag
          purchaseinvoiceflag
          itemcategorycd
          measurementcd
          currencycd
          salesaccountid
          purchaseaccountid
          taxabilitycd
          reversechargeflag
          itemtype
          hsnid
          is_active
          statuscode
          statusmessage
          relateditemamountdetails {
            id
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            amount
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstcompensationvalue
            gstrate
            statuscode
            statusmessage
            lastupdatedby
            discounttype
            discountvalue
            invoicetype
            pricetype
            isactive
            isdefault
            pricetypeid
            tabletype
            __typename
          }
          relateditemgstdetails {
            itemid
            companyid
            enteredtimestamp
            expiredtimestamp
            hsnid
            gstcesstype
            gstcompensationvalue
            effectivedate
            expireddate
            gstcessvalue
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemimages {
            attachmentid
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            imagename
            imageurl
            documentname
            type
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          serialnumber
          financialyearid
          description
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          cessexist
          barcode
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        taxability
        pricetype
        lotid
        hsnid
        hsncodetype
        hsndescription
        gstrate
        gstamount
        cessamount
        unit
        uqc
        purchaseaccountname
        itemname
        itemcode
        itemtype
        manualdiscount
        manualcess
        pricetypeid
        manualgst
        cessrate
        cesstype
        type
        __typename
      }
      relatedpurchaselinenonitems {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        purchaselineitemtype
        purchaseaccountid
        hsnsaccode
        itemdescription
        taxableamount
        rate
        discount
        netamount
        relatedpurchaselinenongst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        taxability
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gstamount
        cessamount
        purchaseaccountname
        manualgst
        manualcess
        cessrate
        cesstype
        type
        __typename
      }
      relatedpurchaselinegst {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        cessamount
        gstamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpurchaseattachment {
        purchaseid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        statuscode
        statusmessage
        documentname
        type
        __typename
      }
      relatedpurchasetransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        vouchernumber
        entrydate
        bankreferencenumber
        comments
        relatedtransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          accountid
          creditamount
          debitamount
          comments
          entryordernumber
          transactionbalance
          openingbalance
          lastupdatedby
          statuscode
          statusmessage
          financialyearid
          __typename
        }
        relatedtransactionattachment {
          transactionid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          documentname
          statuscode
          statusmessage
          type
          __typename
        }
        relatedtransactiontdsdetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          tdsamount
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          tdspercentage
          __typename
        }
        relatedpurchasemaster {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchasegsttypecd
          supplierid
          entrydate
          vouchernumber
          supplierinvoicedate
          supplierinvoicenumber
          supplieraddressid
          paymenttypecd
          paidamount
          creditduration
          paymentaccountid
          comments
          tdsapplicableflag
          granttotalamount
          balancedueamount
          paymentclearedflag
          placeofsupply
          companystate
          relatedpurchasetdsdetails {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            totaltaxableamount
            ineligibletcflag
            reversechargeflag
            gstcesstotal
            tdsamount
            adjustmentamount
            tdssection
            tdspercentage
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaselineitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            itemnumber
            itemid
            purchaseaccountid
            hsncode
            itemquantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            description
            discounttype
            discountrate
            netamount
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            pricetype
            lotid
            hsnid
            hsncodetype
            hsndescription
            gstrate
            gstamount
            cessamount
            unit
            uqc
            purchaseaccountname
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinenonitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchaselineitemtype
            purchaseaccountid
            hsnsaccode
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedpurchaselinenongst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gstamount
            cessamount
            purchaseaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaseattachment {
            purchaseid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedpurchasetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          relatedpurchasetransactionrelation {
            transactionid
            transactiontypecd
            objecttype
            objectid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            linkedamount
            objectattribute
            isdirect
            lastupdatedby
            accountid
            paymentvouchernumber
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          cancelflag
          roundoffamount
          discounttype
          discountvalue
          adjustmentamount
          serialnumber
          currencycode
          currencyrate
          reversechargeflag
          paymentstatus
          partyregistrationtype
          partygstcategory
          itcflag
          __typename
        }
        relatedinvoicemaster {
          invoiceid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicetypecd
          partyid
          paymentaccountid
          invoicedate
          invoicenumber
          customerordernumber
          customerorderdate
          invoiceamount
          paymenttype
          creditduration
          invoicebillingaddressid
          invoicedeliveryaddressid
          invoicetaxabletypecd
          receipturl
          invoicelinetypecd
          invoicecurrencycd
          exchangerate
          comments
          receivedamount
          adjustmentamount
          placeofsupply
          balancedueamount
          reversechargeflag
          tcsapplicableflag
          relatedinvoicelineitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            lineitemnumber
            invoicelineitemtype
            itemid
            quantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            discounttype
            discountrate
            netamount
            hsnsaccode
            taxability
            lastupdatedby
            statuscode
            statusmessage
            pricetype
            lotid
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            unit
            uqc
            salesaccountname
            salesaccountid
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            itemmaster_timestamp
            description
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoicelinenonitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicelineitemtype
            incomeaccountid
            hsnsaccode
            taxability
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedaccounts {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accountname
              accounttypecd
              accountgroupid
              hsnsaccode
              displayordernumber
              statuscode
              statusmessage
              restrictedflag
              is_active
              accounttypeflag
              path
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            incomeaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoiceattachment {
            invoiceid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedinvoicedispatch {
            invoiceid
            dispatchid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transportationcd
            vehiclenumber
            dispatchdate
            ewaybillnumber
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoiceposdetails {
            posid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            partyposid
            lastupdatedby
            relatedposparty {
              pospartyid
              companyid
              partyname
              partycontactnumberid
              lastupdatedby
              enteredtimestamp
              expiredtimestamp
              __typename
            }
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicenumbertracker {
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            nextinvoicenumber
            lastupdatedby
            __typename
          }
          relatedinvoicetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          lastupdatedby
          cancelflag
          statuscode
          statusmessage
          consigneename
          consigneegstin
          companystate
          cancelremark
          deleteremark
          roundoffamount
          discounttype
          discountvalue
          serialnumber
          currencycode
          currencyrate
          paymentstatus
          ackno
          ackdt
          irn
          signedqrcode
          itcflag
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        cancelflag
        cancelremark
        serialnumber
        pdflink
        towards
        isvouchereditable
        __typename
      }
      relatedpurchasetransactionrelation {
        transactionid
        transactiontypecd
        objecttype
        objectid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        linkedamount
        objectattribute
        isdirect
        lastupdatedby
        accountid
        paymentvouchernumber
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      cancelflag
      roundoffamount
      discounttype
      discountvalue
      adjustmentamount
      serialnumber
      currencycode
      currencyrate
      reversechargeflag
      paymentstatus
      partyregistrationtype
      partygstcategory
      itcflag
      __typename
    }
    relatedinvoicemaster {
      invoiceid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoicetypecd
      partyid
      paymentaccountid
      invoicedate
      invoicenumber
      customerordernumber
      customerorderdate
      invoiceamount
      paymenttype
      creditduration
      invoicebillingaddressid
      invoicedeliveryaddressid
      invoicetaxabletypecd
      receipturl
      invoicelinetypecd
      invoicecurrencycd
      exchangerate
      comments
      receivedamount
      adjustmentamount
      placeofsupply
      balancedueamount
      reversechargeflag
      tcsapplicableflag
      relatedinvoicelineitems {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        lineitemnumber
        invoicelineitemtype
        itemid
        quantity
        unittypecd
        itemrate
        itemamount
        itemdiscount
        taxableamount
        discounttype
        discountrate
        netamount
        hsnsaccode
        taxability
        lastupdatedby
        statuscode
        statusmessage
        pricetype
        lotid
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gsttypecd
        gstamount
        cessamount
        unit
        uqc
        salesaccountname
        salesaccountid
        itemname
        itemcode
        itemtype
        manualdiscount
        manualcess
        itemmaster_timestamp
        description
        relatedinvoicelinegst {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          gsttypecd
          gstamount
          cessamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemmaster {
          itemid
          itemcode
          companyid
          enteredtimestamp
          expiredtimestamp
          itemname
          salesinvoiceflag
          purchaseinvoiceflag
          itemcategorycd
          measurementcd
          currencycd
          salesaccountid
          purchaseaccountid
          taxabilitycd
          reversechargeflag
          itemtype
          hsnid
          is_active
          statuscode
          statusmessage
          relateditemamountdetails {
            id
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            amount
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstcompensationvalue
            gstrate
            statuscode
            statusmessage
            lastupdatedby
            discounttype
            discountvalue
            invoicetype
            pricetype
            isactive
            isdefault
            pricetypeid
            tabletype
            __typename
          }
          relateditemgstdetails {
            itemid
            companyid
            enteredtimestamp
            expiredtimestamp
            hsnid
            gstcesstype
            gstcompensationvalue
            effectivedate
            expireddate
            gstcessvalue
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemimages {
            attachmentid
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            imagename
            imageurl
            documentname
            type
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          serialnumber
          financialyearid
          description
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          cessexist
          barcode
          __typename
        }
        pricetypeid
        manualgst
        cessrate
        cesstype
        type
        __typename
      }
      relatedinvoicelinenonitems {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        invoicelineitemtype
        incomeaccountid
        hsnsaccode
        taxability
        itemdescription
        taxableamount
        rate
        discount
        netamount
        relatedaccounts {
          accountsid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          accountname
          accounttypecd
          accountgroupid
          hsnsaccode
          displayordernumber
          statuscode
          statusmessage
          restrictedflag
          is_active
          accounttypeflag
          relatedaccountgstdetails {
            accountid
            companyid
            enteredtimestamp
            expiredtimestamp
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstrate
            cessamount
            lastupdatedby
            statuscode
            statusmessage
            hsnsaccode
            codetype
            description
            taxability
            __typename
          }
          relatedaccountopeningbalance {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            financialyearid
            startdate
            creditamount
            debitamount
            statuscode
            statusmessage
            __typename
          }
          relatedaccountgroupmaster {
            accountgroupid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accounttypecd
            accountgroupname
            accountparentgroupid
            displayordernumber
            statuscode
            statusmessage
            is_active
            restrictedflag
            path
            __typename
          }
          relatedaccountbalance {
            accountid
            accountbalance
            actualbalance
            __typename
          }
          path
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gsttypecd
        gstamount
        cessamount
        incomeaccountname
        manualgst
        manualcess
        cessrate
        cesstype
        type
        __typename
      }
      relatedinvoiceattachment {
        invoiceid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        statuscode
        statusmessage
        documentname
        type
        __typename
      }
      relatedinvoicedispatch {
        invoiceid
        dispatchid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transportationcd
        vehiclenumber
        dispatchdate
        ewaybillnumber
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedinvoiceposdetails {
        posid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        partyposid
        lastupdatedby
        relatedposparty {
          pospartyid
          companyid
          partyname
          partycontactnumberid
          lastupdatedby
          enteredtimestamp
          expiredtimestamp
          relatedphonecontacts {
            id
            objecttype
            objectid
            enteredtimestamp
            expiredtimestamp
            countrycode
            phonenumber
            verifieddatetime
            promotionssignup
            smsallowed
            callallowed
            whatsappallowed
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          __typename
        }
        statuscode
        statusmessage
        __typename
      }
      relatedinvoicelinegst {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        gsttypecd
        gstamount
        cessamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedinvoicenumbertracker {
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        nextinvoicenumber
        lastupdatedby
        __typename
      }
      relatedinvoicetransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        vouchernumber
        entrydate
        bankreferencenumber
        comments
        relatedtransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          accountid
          creditamount
          debitamount
          comments
          entryordernumber
          transactionbalance
          openingbalance
          lastupdatedby
          statuscode
          statusmessage
          financialyearid
          __typename
        }
        relatedtransactionattachment {
          transactionid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          documentname
          statuscode
          statusmessage
          type
          __typename
        }
        relatedtransactiontdsdetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          tdsamount
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          tdspercentage
          __typename
        }
        relatedpurchasemaster {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchasegsttypecd
          supplierid
          entrydate
          vouchernumber
          supplierinvoicedate
          supplierinvoicenumber
          supplieraddressid
          paymenttypecd
          paidamount
          creditduration
          paymentaccountid
          comments
          tdsapplicableflag
          granttotalamount
          balancedueamount
          paymentclearedflag
          placeofsupply
          companystate
          relatedpurchasetdsdetails {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            totaltaxableamount
            ineligibletcflag
            reversechargeflag
            gstcesstotal
            tdsamount
            adjustmentamount
            tdssection
            tdspercentage
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaselineitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            itemnumber
            itemid
            purchaseaccountid
            hsncode
            itemquantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            description
            discounttype
            discountrate
            netamount
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            pricetype
            lotid
            hsnid
            hsncodetype
            hsndescription
            gstrate
            gstamount
            cessamount
            unit
            uqc
            purchaseaccountname
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinenonitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchaselineitemtype
            purchaseaccountid
            hsnsaccode
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedpurchaselinenongst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gstamount
            cessamount
            purchaseaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaseattachment {
            purchaseid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedpurchasetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          relatedpurchasetransactionrelation {
            transactionid
            transactiontypecd
            objecttype
            objectid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            linkedamount
            objectattribute
            isdirect
            lastupdatedby
            accountid
            paymentvouchernumber
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          cancelflag
          roundoffamount
          discounttype
          discountvalue
          adjustmentamount
          serialnumber
          currencycode
          currencyrate
          reversechargeflag
          paymentstatus
          partyregistrationtype
          partygstcategory
          itcflag
          __typename
        }
        relatedinvoicemaster {
          invoiceid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicetypecd
          partyid
          paymentaccountid
          invoicedate
          invoicenumber
          customerordernumber
          customerorderdate
          invoiceamount
          paymenttype
          creditduration
          invoicebillingaddressid
          invoicedeliveryaddressid
          invoicetaxabletypecd
          receipturl
          invoicelinetypecd
          invoicecurrencycd
          exchangerate
          comments
          receivedamount
          adjustmentamount
          placeofsupply
          balancedueamount
          reversechargeflag
          tcsapplicableflag
          relatedinvoicelineitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            lineitemnumber
            invoicelineitemtype
            itemid
            quantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            discounttype
            discountrate
            netamount
            hsnsaccode
            taxability
            lastupdatedby
            statuscode
            statusmessage
            pricetype
            lotid
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            unit
            uqc
            salesaccountname
            salesaccountid
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            itemmaster_timestamp
            description
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoicelinenonitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicelineitemtype
            incomeaccountid
            hsnsaccode
            taxability
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedaccounts {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accountname
              accounttypecd
              accountgroupid
              hsnsaccode
              displayordernumber
              statuscode
              statusmessage
              restrictedflag
              is_active
              accounttypeflag
              path
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            incomeaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoiceattachment {
            invoiceid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedinvoicedispatch {
            invoiceid
            dispatchid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transportationcd
            vehiclenumber
            dispatchdate
            ewaybillnumber
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoiceposdetails {
            posid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            partyposid
            lastupdatedby
            relatedposparty {
              pospartyid
              companyid
              partyname
              partycontactnumberid
              lastupdatedby
              enteredtimestamp
              expiredtimestamp
              __typename
            }
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicenumbertracker {
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            nextinvoicenumber
            lastupdatedby
            __typename
          }
          relatedinvoicetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          lastupdatedby
          cancelflag
          statuscode
          statusmessage
          consigneename
          consigneegstin
          companystate
          cancelremark
          deleteremark
          roundoffamount
          discounttype
          discountvalue
          serialnumber
          currencycode
          currencyrate
          paymentstatus
          ackno
          ackdt
          irn
          signedqrcode
          itcflag
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        cancelflag
        cancelremark
        serialnumber
        pdflink
        towards
        isvouchereditable
        __typename
      }
      lastupdatedby
      cancelflag
      statuscode
      statusmessage
      consigneename
      consigneegstin
      companystate
      cancelremark
      deleteremark
      roundoffamount
      discounttype
      discountvalue
      serialnumber
      currencycode
      currencyrate
      paymentstatus
      ackno
      ackdt
      irn
      signedqrcode
      itcflag
      __typename
    }
    lastupdatedby
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDeletedTransactionManualJournalQueryVariables,
  APITypes.ListDeletedTransactionManualJournalQuery
>;
export const listDeletedPurchases = /* GraphQL */ `query ListDeletedPurchases {
  listDeletedPurchases {
    purchaseid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    purchasegsttypecd
    supplierid
    entrydate
    vouchernumber
    supplierinvoicedate
    supplierinvoicenumber
    supplieraddressid
    paymenttypecd
    paidamount
    creditduration
    paymentaccountid
    comments
    tdsapplicableflag
    granttotalamount
    balancedueamount
    paymentclearedflag
    placeofsupply
    companystate
    relatedpurchasetdsdetails {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tdsapplicablecd
      totaltaxableamount
      ineligibletcflag
      reversechargeflag
      gstcesstotal
      tdsamount
      adjustmentamount
      tdssection
      tdspercentage
      tdsmanual
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpurchaselineitems {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      itemnumber
      itemid
      purchaseaccountid
      hsncode
      itemquantity
      unittypecd
      itemrate
      itemamount
      itemdiscount
      taxableamount
      description
      discounttype
      discountrate
      netamount
      relatedpurchaselinegst {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        cessamount
        gstamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relateditemmaster {
        itemid
        itemcode
        companyid
        enteredtimestamp
        expiredtimestamp
        itemname
        salesinvoiceflag
        purchaseinvoiceflag
        itemcategorycd
        measurementcd
        currencycd
        salesaccountid
        purchaseaccountid
        taxabilitycd
        reversechargeflag
        itemtype
        hsnid
        is_active
        statuscode
        statusmessage
        relateditemamountdetails {
          id
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          amount
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstcompensationvalue
          gstrate
          statuscode
          statusmessage
          lastupdatedby
          discounttype
          discountvalue
          invoicetype
          pricetype
          isactive
          isdefault
          pricetypeid
          tabletype
          __typename
        }
        relateditemgstdetails {
          itemid
          companyid
          enteredtimestamp
          expiredtimestamp
          hsnid
          gstcesstype
          gstcompensationvalue
          effectivedate
          expireddate
          gstcessvalue
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemimages {
          attachmentid
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          imagename
          imageurl
          documentname
          type
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        serialnumber
        financialyearid
        description
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        cessexist
        barcode
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      taxability
      pricetype
      lotid
      hsnid
      hsncodetype
      hsndescription
      gstrate
      gstamount
      cessamount
      unit
      uqc
      purchaseaccountname
      itemname
      itemcode
      itemtype
      manualdiscount
      manualcess
      pricetypeid
      manualgst
      cessrate
      cesstype
      type
      __typename
    }
    relatedpurchaselinenonitems {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      purchaselineitemtype
      purchaseaccountid
      hsnsaccode
      itemdescription
      taxableamount
      rate
      discount
      netamount
      relatedpurchaselinenongst {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        cessamount
        gstamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      taxability
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      gstrate
      gstamount
      cessamount
      purchaseaccountname
      manualgst
      manualcess
      cessrate
      cesstype
      type
      __typename
    }
    relatedpurchaselinegst {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      cessamount
      gstamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpurchaseattachment {
      purchaseid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      lastupdatedby
      statuscode
      statusmessage
      documentname
      type
      __typename
    }
    relatedpurchasetransactiondetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      vouchernumber
      entrydate
      bankreferencenumber
      comments
      relatedtransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        accountid
        creditamount
        debitamount
        comments
        entryordernumber
        transactionbalance
        openingbalance
        lastupdatedby
        statuscode
        statusmessage
        financialyearid
        __typename
      }
      relatedtransactionattachment {
        transactionid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        documentname
        statuscode
        statusmessage
        type
        __typename
      }
      relatedtransactiontdsdetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tdsapplicablecd
        tdsamount
        tdsmanual
        lastupdatedby
        statuscode
        statusmessage
        tdspercentage
        __typename
      }
      relatedpurchasemaster {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        purchasegsttypecd
        supplierid
        entrydate
        vouchernumber
        supplierinvoicedate
        supplierinvoicenumber
        supplieraddressid
        paymenttypecd
        paidamount
        creditduration
        paymentaccountid
        comments
        tdsapplicableflag
        granttotalamount
        balancedueamount
        paymentclearedflag
        placeofsupply
        companystate
        relatedpurchasetdsdetails {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          totaltaxableamount
          ineligibletcflag
          reversechargeflag
          gstcesstotal
          tdsamount
          adjustmentamount
          tdssection
          tdspercentage
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaselineitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          itemnumber
          itemid
          purchaseaccountid
          hsncode
          itemquantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          taxableamount
          description
          discounttype
          discountrate
          netamount
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          pricetype
          lotid
          hsnid
          hsncodetype
          hsndescription
          gstrate
          gstamount
          cessamount
          unit
          uqc
          purchaseaccountname
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          pricetypeid
          manualgst
          cessrate
          cesstype
          type
          __typename
        }
        relatedpurchaselinenonitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchaselineitemtype
          purchaseaccountid
          hsnsaccode
          itemdescription
          taxableamount
          rate
          discount
          netamount
          relatedpurchaselinenongst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gstamount
          cessamount
          purchaseaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          type
          __typename
        }
        relatedpurchaselinegst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaseattachment {
          purchaseid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedpurchasetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              description
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              description
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        relatedpurchasetransactionrelation {
          transactionid
          transactiontypecd
          objecttype
          objectid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          linkedamount
          objectattribute
          isdirect
          lastupdatedby
          accountid
          paymentvouchernumber
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        cancelflag
        roundoffamount
        discounttype
        discountvalue
        adjustmentamount
        serialnumber
        currencycode
        currencyrate
        reversechargeflag
        paymentstatus
        partyregistrationtype
        partygstcategory
        itcflag
        __typename
      }
      relatedinvoicemaster {
        invoiceid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        invoicetypecd
        partyid
        paymentaccountid
        invoicedate
        invoicenumber
        customerordernumber
        customerorderdate
        invoiceamount
        paymenttype
        creditduration
        invoicebillingaddressid
        invoicedeliveryaddressid
        invoicetaxabletypecd
        receipturl
        invoicelinetypecd
        invoicecurrencycd
        exchangerate
        comments
        receivedamount
        adjustmentamount
        placeofsupply
        balancedueamount
        reversechargeflag
        tcsapplicableflag
        relatedinvoicelineitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          lineitemnumber
          invoicelineitemtype
          itemid
          quantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          taxableamount
          discounttype
          discountrate
          netamount
          hsnsaccode
          taxability
          lastupdatedby
          statuscode
          statusmessage
          pricetype
          lotid
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          unit
          uqc
          salesaccountname
          salesaccountid
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          itemmaster_timestamp
          description
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          pricetypeid
          manualgst
          cessrate
          cesstype
          type
          __typename
        }
        relatedinvoicelinenonitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicelineitemtype
          incomeaccountid
          hsnsaccode
          taxability
          itemdescription
          taxableamount
          rate
          discount
          netamount
          relatedaccounts {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accountname
            accounttypecd
            accountgroupid
            hsnsaccode
            displayordernumber
            statuscode
            statusmessage
            restrictedflag
            is_active
            accounttypeflag
            relatedaccountgstdetails {
              accountid
              companyid
              enteredtimestamp
              expiredtimestamp
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstrate
              cessamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsaccode
              codetype
              description
              taxability
              __typename
            }
            relatedaccountopeningbalance {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              financialyearid
              startdate
              creditamount
              debitamount
              statuscode
              statusmessage
              __typename
            }
            relatedaccountgroupmaster {
              accountgroupid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accounttypecd
              accountgroupname
              accountparentgroupid
              displayordernumber
              statuscode
              statusmessage
              is_active
              restrictedflag
              path
              __typename
            }
            relatedaccountbalance {
              accountid
              accountbalance
              actualbalance
              __typename
            }
            path
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          incomeaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          type
          __typename
        }
        relatedinvoiceattachment {
          invoiceid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedinvoicedispatch {
          invoiceid
          dispatchid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transportationcd
          vehiclenumber
          dispatchdate
          ewaybillnumber
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoiceposdetails {
          posid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          partyposid
          lastupdatedby
          relatedposparty {
            pospartyid
            companyid
            partyname
            partycontactnumberid
            lastupdatedby
            enteredtimestamp
            expiredtimestamp
            relatedphonecontacts {
              id
              objecttype
              objectid
              enteredtimestamp
              expiredtimestamp
              countrycode
              phonenumber
              verifieddatetime
              promotionssignup
              smsallowed
              callallowed
              whatsappallowed
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            __typename
          }
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicelinegst {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          gsttypecd
          gstamount
          cessamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicenumbertracker {
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          nextinvoicenumber
          lastupdatedby
          __typename
        }
        relatedinvoicetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              description
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              description
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        lastupdatedby
        cancelflag
        statuscode
        statusmessage
        consigneename
        consigneegstin
        companystate
        cancelremark
        deleteremark
        roundoffamount
        discounttype
        discountvalue
        serialnumber
        currencycode
        currencyrate
        paymentstatus
        ackno
        ackdt
        irn
        signedqrcode
        itcflag
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      cancelflag
      cancelremark
      serialnumber
      pdflink
      towards
      isvouchereditable
      __typename
    }
    relatedpartymaster {
      partyid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      partytypecd
      partydisplayname
      partylegalname
      groupaccountid
      gstcategory
      placeofsupply
      entity
      email
      contactnumber
      whatsappnumber
      accountsid
      is_active
      msmetype
      deliveryconsigneename
      deliveryconsigneegstin
      statuscode
      statusmessage
      relatedpartygstdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        pannumber
        gstin
        partyaddressid
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycreditdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        creditperiodduration
        billingcurrency
        creditlimitcd
        creditlimitamount
        billwiseflag
        notes
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycontact {
        partyid
        enteredtimestamp
        expiredtimestamp
        contacttypename
        contactdesignationname
        contactorder
        email
        phonenumber
        whatsappnumber
        lastupdatedby
        statuscode
        statusmessage
        contactcountry
        whatsappcountry
        __typename
      }
      relatedpartyimages {
        attachmentid
        partyid
        companyid
        enteredtimestamp
        expiredtimestamp
        type
        documentname
        imagename
        imageurl
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      tdspercentage
      udhyamregno
      sameaddressflag
      comments
      tdssection
      accountname
      deliverystatecode
      deliverystatename
      contactcountry
      whatsappcountry
      entityname
      __typename
    }
    relatedpartyaddressdetails {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      line1
      line2
      line3
      city
      statecode
      statename
      statuscode
      statusmessage
      pincode
      countrycode
      codevalue
      district
      lastupdatedby
      godownname
      gstin
      phone
      email
      personincharge
      consigneename
      consigneegstin
      foreignstate
      foreigndistrict
      defaultflag
      addresstitle
      addressindex
      __typename
    }
    relatedpaymentaccountdetails {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    lastupdatedby
    cancelflag
    roundoffamount
    discounttype
    discountvalue
    adjustmentamount
    serialnumber
    currencycode
    currencyrate
    reversechargeflag
    paymentstatus
    partyregistrationtype
    partygstcategory
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDeletedPurchasesQueryVariables,
  APITypes.ListDeletedPurchasesQuery
>;
export const listDeletedInvoices = /* GraphQL */ `query ListDeletedInvoices {
  listDeletedInvoices {
    invoiceid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    invoicetypecd
    partyid
    paymentaccountid
    invoicedate
    invoicenumber
    customerordernumber
    customerorderdate
    invoiceamount
    paymenttype
    creditduration
    invoicebillingaddressid
    invoicedeliveryaddressid
    invoicetaxabletypecd
    receipturl
    invoicelinetypecd
    invoicecurrencycd
    exchangerate
    comments
    receivedamount
    adjustmentamount
    placeofsupply
    balancedueamount
    reversechargeflag
    tcsapplicableflag
    relatedinvoicelineitems {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      lineitemnumber
      invoicelineitemtype
      itemid
      quantity
      unittypecd
      itemrate
      itemamount
      itemdiscount
      taxableamount
      discounttype
      discountrate
      netamount
      hsnsaccode
      taxability
      lastupdatedby
      statuscode
      statusmessage
      pricetype
      lotid
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      gstrate
      gsttypecd
      gstamount
      cessamount
      unit
      uqc
      salesaccountname
      salesaccountid
      itemname
      itemcode
      itemtype
      manualdiscount
      manualcess
      itemmaster_timestamp
      description
      relatedinvoicelinegst {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        gsttypecd
        gstamount
        cessamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relateditemmaster {
        itemid
        itemcode
        companyid
        enteredtimestamp
        expiredtimestamp
        itemname
        salesinvoiceflag
        purchaseinvoiceflag
        itemcategorycd
        measurementcd
        currencycd
        salesaccountid
        purchaseaccountid
        taxabilitycd
        reversechargeflag
        itemtype
        hsnid
        is_active
        statuscode
        statusmessage
        relateditemamountdetails {
          id
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          amount
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstcompensationvalue
          gstrate
          statuscode
          statusmessage
          lastupdatedby
          discounttype
          discountvalue
          invoicetype
          pricetype
          isactive
          isdefault
          pricetypeid
          tabletype
          __typename
        }
        relateditemgstdetails {
          itemid
          companyid
          enteredtimestamp
          expiredtimestamp
          hsnid
          gstcesstype
          gstcompensationvalue
          effectivedate
          expireddate
          gstcessvalue
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemimages {
          attachmentid
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          imagename
          imageurl
          documentname
          type
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        serialnumber
        financialyearid
        description
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        cessexist
        barcode
        __typename
      }
      pricetypeid
      manualgst
      cessrate
      cesstype
      type
      __typename
    }
    relatedinvoicelinonitems {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoicelineitemtype
      incomeaccountid
      hsnsaccode
      taxability
      itemdescription
      taxableamount
      rate
      discount
      netamount
      relatedaccounts {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accountname
        accounttypecd
        accountgroupid
        hsnsaccode
        displayordernumber
        statuscode
        statusmessage
        restrictedflag
        is_active
        accounttypeflag
        relatedaccountgstdetails {
          accountid
          companyid
          enteredtimestamp
          expiredtimestamp
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstrate
          cessamount
          lastupdatedby
          statuscode
          statusmessage
          hsnsaccode
          codetype
          description
          taxability
          __typename
        }
        relatedaccountopeningbalance {
          accountsid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          financialyearid
          startdate
          creditamount
          debitamount
          statuscode
          statusmessage
          __typename
        }
        relatedaccountgroupmaster {
          accountgroupid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          accounttypecd
          accountgroupname
          accountparentgroupid
          displayordernumber
          statuscode
          statusmessage
          is_active
          restrictedflag
          path
          __typename
        }
        relatedaccountbalance {
          accountid
          accountbalance
          actualbalance
          __typename
        }
        path
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      gstrate
      gsttypecd
      gstamount
      cessamount
      incomeaccountname
      manualgst
      manualcess
      cessrate
      cesstype
      type
      __typename
    }
    relatedinvoiceattachment {
      invoiceid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      lastupdatedby
      statuscode
      statusmessage
      documentname
      type
      __typename
    }
    relatedinvoicedispatch {
      invoiceid
      dispatchid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transportationcd
      vehiclenumber
      dispatchdate
      ewaybillnumber
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedinvoiceposdetails {
      posid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      partyposid
      lastupdatedby
      relatedposparty {
        pospartyid
        companyid
        partyname
        partycontactnumberid
        lastupdatedby
        enteredtimestamp
        expiredtimestamp
        relatedphonecontacts {
          id
          objecttype
          objectid
          enteredtimestamp
          expiredtimestamp
          countrycode
          phonenumber
          verifieddatetime
          promotionssignup
          smsallowed
          callallowed
          whatsappallowed
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        __typename
      }
      statuscode
      statusmessage
      __typename
    }
    relatedinvoicelinegst {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      gsttypecd
      gstamount
      cessamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedinvoicenumbertracker {
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      nextinvoicenumber
      lastupdatedby
      __typename
    }
    relatedinvoicetransactiondetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      vouchernumber
      entrydate
      bankreferencenumber
      comments
      relatedtransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        accountid
        creditamount
        debitamount
        comments
        entryordernumber
        transactionbalance
        openingbalance
        lastupdatedby
        statuscode
        statusmessage
        financialyearid
        __typename
      }
      relatedtransactionattachment {
        transactionid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        documentname
        statuscode
        statusmessage
        type
        __typename
      }
      relatedtransactiontdsdetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tdsapplicablecd
        tdsamount
        tdsmanual
        lastupdatedby
        statuscode
        statusmessage
        tdspercentage
        __typename
      }
      relatedpurchasemaster {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        purchasegsttypecd
        supplierid
        entrydate
        vouchernumber
        supplierinvoicedate
        supplierinvoicenumber
        supplieraddressid
        paymenttypecd
        paidamount
        creditduration
        paymentaccountid
        comments
        tdsapplicableflag
        granttotalamount
        balancedueamount
        paymentclearedflag
        placeofsupply
        companystate
        relatedpurchasetdsdetails {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          totaltaxableamount
          ineligibletcflag
          reversechargeflag
          gstcesstotal
          tdsamount
          adjustmentamount
          tdssection
          tdspercentage
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaselineitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          itemnumber
          itemid
          purchaseaccountid
          hsncode
          itemquantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          taxableamount
          description
          discounttype
          discountrate
          netamount
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          pricetype
          lotid
          hsnid
          hsncodetype
          hsndescription
          gstrate
          gstamount
          cessamount
          unit
          uqc
          purchaseaccountname
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          pricetypeid
          manualgst
          cessrate
          cesstype
          type
          __typename
        }
        relatedpurchaselinenonitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchaselineitemtype
          purchaseaccountid
          hsnsaccode
          itemdescription
          taxableamount
          rate
          discount
          netamount
          relatedpurchaselinenongst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gstamount
          cessamount
          purchaseaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          type
          __typename
        }
        relatedpurchaselinegst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaseattachment {
          purchaseid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedpurchasetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              description
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              description
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        relatedpurchasetransactionrelation {
          transactionid
          transactiontypecd
          objecttype
          objectid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          linkedamount
          objectattribute
          isdirect
          lastupdatedby
          accountid
          paymentvouchernumber
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        cancelflag
        roundoffamount
        discounttype
        discountvalue
        adjustmentamount
        serialnumber
        currencycode
        currencyrate
        reversechargeflag
        paymentstatus
        partyregistrationtype
        partygstcategory
        itcflag
        __typename
      }
      relatedinvoicemaster {
        invoiceid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        invoicetypecd
        partyid
        paymentaccountid
        invoicedate
        invoicenumber
        customerordernumber
        customerorderdate
        invoiceamount
        paymenttype
        creditduration
        invoicebillingaddressid
        invoicedeliveryaddressid
        invoicetaxabletypecd
        receipturl
        invoicelinetypecd
        invoicecurrencycd
        exchangerate
        comments
        receivedamount
        adjustmentamount
        placeofsupply
        balancedueamount
        reversechargeflag
        tcsapplicableflag
        relatedinvoicelineitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          lineitemnumber
          invoicelineitemtype
          itemid
          quantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          taxableamount
          discounttype
          discountrate
          netamount
          hsnsaccode
          taxability
          lastupdatedby
          statuscode
          statusmessage
          pricetype
          lotid
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          unit
          uqc
          salesaccountname
          salesaccountid
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          itemmaster_timestamp
          description
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          pricetypeid
          manualgst
          cessrate
          cesstype
          type
          __typename
        }
        relatedinvoicelinenonitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicelineitemtype
          incomeaccountid
          hsnsaccode
          taxability
          itemdescription
          taxableamount
          rate
          discount
          netamount
          relatedaccounts {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accountname
            accounttypecd
            accountgroupid
            hsnsaccode
            displayordernumber
            statuscode
            statusmessage
            restrictedflag
            is_active
            accounttypeflag
            relatedaccountgstdetails {
              accountid
              companyid
              enteredtimestamp
              expiredtimestamp
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstrate
              cessamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsaccode
              codetype
              description
              taxability
              __typename
            }
            relatedaccountopeningbalance {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              financialyearid
              startdate
              creditamount
              debitamount
              statuscode
              statusmessage
              __typename
            }
            relatedaccountgroupmaster {
              accountgroupid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accounttypecd
              accountgroupname
              accountparentgroupid
              displayordernumber
              statuscode
              statusmessage
              is_active
              restrictedflag
              path
              __typename
            }
            relatedaccountbalance {
              accountid
              accountbalance
              actualbalance
              __typename
            }
            path
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          incomeaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          type
          __typename
        }
        relatedinvoiceattachment {
          invoiceid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedinvoicedispatch {
          invoiceid
          dispatchid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transportationcd
          vehiclenumber
          dispatchdate
          ewaybillnumber
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoiceposdetails {
          posid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          partyposid
          lastupdatedby
          relatedposparty {
            pospartyid
            companyid
            partyname
            partycontactnumberid
            lastupdatedby
            enteredtimestamp
            expiredtimestamp
            relatedphonecontacts {
              id
              objecttype
              objectid
              enteredtimestamp
              expiredtimestamp
              countrycode
              phonenumber
              verifieddatetime
              promotionssignup
              smsallowed
              callallowed
              whatsappallowed
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            __typename
          }
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicelinegst {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          gsttypecd
          gstamount
          cessamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicenumbertracker {
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          nextinvoicenumber
          lastupdatedby
          __typename
        }
        relatedinvoicetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              description
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              description
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        lastupdatedby
        cancelflag
        statuscode
        statusmessage
        consigneename
        consigneegstin
        companystate
        cancelremark
        deleteremark
        roundoffamount
        discounttype
        discountvalue
        serialnumber
        currencycode
        currencyrate
        paymentstatus
        ackno
        ackdt
        irn
        signedqrcode
        itcflag
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      cancelflag
      cancelremark
      serialnumber
      pdflink
      towards
      isvouchereditable
      __typename
    }
    relatedpartymaster {
      partyid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      partytypecd
      partydisplayname
      partylegalname
      groupaccountid
      gstcategory
      placeofsupply
      entity
      email
      contactnumber
      whatsappnumber
      accountsid
      is_active
      msmetype
      deliveryconsigneename
      deliveryconsigneegstin
      statuscode
      statusmessage
      relatedpartygstdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        pannumber
        gstin
        partyaddressid
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycreditdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        creditperiodduration
        billingcurrency
        creditlimitcd
        creditlimitamount
        billwiseflag
        notes
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycontact {
        partyid
        enteredtimestamp
        expiredtimestamp
        contacttypename
        contactdesignationname
        contactorder
        email
        phonenumber
        whatsappnumber
        lastupdatedby
        statuscode
        statusmessage
        contactcountry
        whatsappcountry
        __typename
      }
      relatedpartyimages {
        attachmentid
        partyid
        companyid
        enteredtimestamp
        expiredtimestamp
        type
        documentname
        imagename
        imageurl
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      tdspercentage
      udhyamregno
      sameaddressflag
      comments
      tdssection
      accountname
      deliverystatecode
      deliverystatename
      contactcountry
      whatsappcountry
      entityname
      __typename
    }
    relatedpartybillingaddressdetails {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      line1
      line2
      line3
      city
      statecode
      statename
      statuscode
      statusmessage
      pincode
      countrycode
      codevalue
      district
      lastupdatedby
      godownname
      gstin
      phone
      email
      personincharge
      consigneename
      consigneegstin
      foreignstate
      foreigndistrict
      defaultflag
      addresstitle
      addressindex
      __typename
    }
    relatedpartydeliveryaddressdetails {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      line1
      line2
      line3
      city
      statecode
      statename
      statuscode
      statusmessage
      pincode
      countrycode
      codevalue
      district
      lastupdatedby
      godownname
      gstin
      phone
      email
      personincharge
      consigneename
      consigneegstin
      foreignstate
      foreigndistrict
      defaultflag
      addresstitle
      addressindex
      __typename
    }
    relatedpaymentaccountdetails {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    lastupdatedby
    statuscode
    statusmessage
    cancelflag
    consigneename
    consigneeGSTIN
    companystate
    roundoffamount
    discounttype
    discountvalue
    serialnumber
    currencycode
    currencyrate
    paymentstatus
    ackno
    ackdt
    irn
    signedqrcode
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDeletedInvoicesQueryVariables,
  APITypes.ListDeletedInvoicesQuery
>;
export const listDeletedAccountGroups = /* GraphQL */ `query ListDeletedAccountGroups {
  listDeletedAccountGroups {
    AccountGroupID
    CompanyID
    CompanyBranchID
    EnteredTimeStamp
    ExpiredTimeStamp
    AccountTypeCD
    AccountGroupName
    AccountParentGroupID
    DisplayOrderNumber
    StatusCode
    StatusMessage
    Restrictedflag
    Is_Active
    RelatedAccounts {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    path
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDeletedAccountGroupsQueryVariables,
  APITypes.ListDeletedAccountGroupsQuery
>;
export const listDeletedCrDrNoteMaster = /* GraphQL */ `query ListDeletedCrDrNoteMaster($type: String!) {
  listDeletedCrDrNoteMaster(type: $type) {
    crdrnoteid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    crdrnotetypecd
    crdrnotedate
    crdrnotenumber
    invoicetypecd
    gsttypecd
    partyid
    deliveryaddressid
    paymenttype
    grandtotalamount
    transactionid
    userid
    creditduration
    statuscode
    statusmessage
    psflag
    reversechargeflag
    balancedueamount
    consigneeName
    consigneeGstin
    companystate
    placeofsupply
    relatedcrdrnoteinvoices {
      crdrnoteid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoiceid
      statuscode
      statusmessage
      lastupdatedby
      __typename
    }
    relatedcrdrattachment {
      crdrnoteid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      userid
      statuscode
      statusmessage
      documentname
      type
      __typename
    }
    relatedcrdrnotedetails {
      crdrnoteid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      totaltaxableamount
      totalgst
      totalgstcess
      totaladjustments
      comments
      accountid
      partamount
      transportationcd
      vehiclenumber
      dispatchdate
      ewaybillnumber
      userid
      statuscode
      statusmessage
      __typename
    }
    relatedcrdrnotelineitems {
      crdrnoteid
      crdrnoteitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      lineitemnumber
      lineitemtype
      itemid
      quantity
      unittypecd
      itemrate
      itemamount
      itemdiscount
      taxableamount
      description
      discounttype
      discountrate
      gstrate
      gsttypecd
      gstamount
      gstcess
      hsnsaccode
      netamount
      userid
      taxability
      reason
      statuscode
      statusmessage
      pricetype
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      unit
      uqc
      salesaccountname
      purchaseaccountname
      salesaccountid
      purchaseaccountid
      itemname
      itemcode
      itemtype
      manualdiscount
      manualcess
      pricetypeid
      manualgst
      cessrate
      cesstype
      type
      __typename
    }
    relatedcrdrnotelinnonitems {
      crdrnoteid
      crdrnoteitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      lineitemtype
      ledgeraccountid
      hsnsaccode
      itemdescription
      taxableamount
      gstrate
      gsttypecd
      gstamount
      gstcess
      rate
      discount
      netamount
      userid
      taxability
      reason
      statuscode
      statusmessage
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      ledgeraccountname
      manualgst
      manualcess
      cessrate
      cesstype
      type
      __typename
    }
    serialnumber
    currencycode
    currencyrate
    originalinvoicenumber
    partyinvoicenumber
    paymentstatus
    partyregistrationtype
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDeletedCrDrNoteMasterQueryVariables,
  APITypes.ListDeletedCrDrNoteMasterQuery
>;
export const listDeletedAccounts = /* GraphQL */ `query ListDeletedAccounts {
  listDeletedAccounts {
    accountid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    accountname
    accounttypecd
    accountgroupid
    hsnsaccode
    displayordernumber
    statuscode
    statusmessage
    restrictedflag
    relatedaccountgstdetails {
      accountid
      companyid
      enteredtimestamp
      expiredtimestamp
      effectivedate
      expireddate
      hsnid
      gstcompensationtype
      gstrate
      cessamount
      lastupdatedby
      statuscode
      statusmessage
      hsnsaccode
      codetype
      description
      taxability
      __typename
    }
    relatedaccountopeningbalance {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      financialyearid
      startdate
      creditamount
      debitamount
      statuscode
      statusmessage
      __typename
    }
    relatedaccountgroupmaster {
      accountgroupid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accounttypecd
      accountgroupname
      accountparentgroupid
      displayordernumber
      statuscode
      statusmessage
      is_active
      restrictedflag
      path
      __typename
    }
    relatedaccountbalance {
      accountid
      accountbalance
      actualbalance
      __typename
    }
    path
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDeletedAccountsQueryVariables,
  APITypes.ListDeletedAccountsQuery
>;
export const listPlaceOfSupply = /* GraphQL */ `query ListPlaceOfSupply {
  listPlaceOfSupply {
    id
    statename
    statecode
    enteredtimestamp
    expiredtimestamp
    isactive
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPlaceOfSupplyQueryVariables,
  APITypes.ListPlaceOfSupplyQuery
>;
export const listDayBookTransactionsCount = /* GraphQL */ `query ListDayBookTransactionsCount(
  $startdate: Int!
  $enddate: Int!
  $searchmode: Int
  $searcharray: AWSJSON
) {
  listDayBookTransactionsCount(
    startdate: $startdate
    enddate: $enddate
    searchmode: $searchmode
    searcharray: $searcharray
  ) {
    transactioncount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDayBookTransactionsCountQueryVariables,
  APITypes.ListDayBookTransactionsCountQuery
>;
export const listDayBookTransactionDetails = /* GraphQL */ `query ListDayBookTransactionDetails(
  $startdate: Int!
  $enddate: Int!
  $rowfrom: Int!
  $limitno: Int!
  $columnname: String
  $ordertype: String
  $searchmode: Int
  $searcharray: AWSJSON
) {
  listDayBookTransactionDetails(
    startdate: $startdate
    enddate: $enddate
    rowfrom: $rowfrom
    limitno: $limitno
    columnname: $columnname
    ordertype: $ordertype
    searchmode: $searchmode
    searcharray: $searcharray
  ) {
    transactionid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    transactiontypecd
    accountid
    accountname
    balancesign
    totalcreditamount
    totaldebitamount
    comments
    entryordernumber
    financialyearid
    cancelflag
    balance
    transactiontype
    vouchernumber
    voucherid
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDayBookTransactionDetailsQueryVariables,
  APITypes.ListDayBookTransactionDetailsQuery
>;
export const listaccountopeningbalancev2 = /* GraphQL */ `query Listaccountopeningbalancev2($companyid: Int!) {
  listaccountopeningbalancev2(companyid: $companyid) {
    accountid
    accountname
    accounttypecd
    displayordernumber
    path
    accountgroupid
    accountgroupname
    accountparentgroupid
    companyid
    financialyearid
    creditamount
    debitamount
    enteredtimestamp
    restrictedflag
    is_active
    root_group_id
    root_group_name
    balancesign
    balance
    type
    __typename
  }
}
` as GeneratedQuery<
  APITypes.Listaccountopeningbalancev2QueryVariables,
  APITypes.Listaccountopeningbalancev2Query
>;
export const listAccountsDropdown = /* GraphQL */ `query ListAccountsDropdown($rowfrom: Int!, $limitno: Int!, $word: String!) {
  listAccountsDropdown(rowfrom: $rowfrom, limitno: $limitno, word: $word) {
    accountsid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    accountname
    accounttypecd
    accountgroupid
    hsnsaccode
    displayordernumber
    statuscode
    statusmessage
    restrictedflag
    is_active
    accounttypeflag
    relatedaccountgstdetails {
      accountid
      companyid
      enteredtimestamp
      expiredtimestamp
      effectivedate
      expireddate
      hsnid
      gstcompensationtype
      gstrate
      cessamount
      lastupdatedby
      statuscode
      statusmessage
      hsnsaccode
      codetype
      description
      taxability
      __typename
    }
    relatedaccountopeningbalance {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      financialyearid
      startdate
      creditamount
      debitamount
      statuscode
      statusmessage
      __typename
    }
    relatedaccountgroupmaster {
      accountgroupid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accounttypecd
      accountgroupname
      accountparentgroupid
      displayordernumber
      statuscode
      statusmessage
      is_active
      restrictedflag
      path
      __typename
    }
    relatedaccountbalance {
      accountid
      accountbalance
      actualbalance
      __typename
    }
    path
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAccountsDropdownQueryVariables,
  APITypes.ListAccountsDropdownQuery
>;
export const listaccountsubgroups = /* GraphQL */ `query Listaccountsubgroups($accountgroupid: Int) {
  listaccountsubgroups(accountgroupid: $accountgroupid) {
    accountgroupid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    accounttypecd
    accountgroupname
    accountparentgroupid
    displayordernumber
    statuscode
    statusmessage
    restrictedflag
    is_active
    relatedaccounts {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    path
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListaccountsubgroupsQueryVariables,
  APITypes.ListaccountsubgroupsQuery
>;
export const listAccountTransactionDetailsv3 = /* GraphQL */ `query ListAccountTransactionDetailsv3(
  $accountid: Int!
  $startdate: AWSTimestamp!
  $enddate: AWSTimestamp!
  $limitno: Int!
  $rowfrom: Int!
  $columnname: String
  $ordertype: String
  $searchmode: Int
  $searcharray: AWSJSON
  $openingbalance: Int
) {
  listAccountTransactionDetailsv3(
    accountid: $accountid
    startdate: $startdate
    enddate: $enddate
    limitno: $limitno
    rowfrom: $rowfrom
    columnname: $columnname
    ordertype: $ordertype
    searchmode: $searchmode
    searcharray: $searcharray
    openingbalance: $openingbalance
  ) {
    transactionid
    companyid
    enteredtimestamp
    financialyearid
    invoiceid
    purchaseid
    crdrnoteid
    vouchertype
    vouchernumber
    accountid
    accountname
    accounttypecd
    balancesign
    accountgroupname
    transactiontype
    entryordernumber
    totaldebitamount
    totalcreditamount
    balance
    oppositeaccountid
    oppositeaccountname
    comments
    setoffremarks
    setoffbalance
    accounttypeflag
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAccountTransactionDetailsv3QueryVariables,
  APITypes.ListAccountTransactionDetailsv3Query
>;
export const listAddressEntitys = /* GraphQL */ `query ListAddressEntitys {
  listAddressEntitys {
    id
    objecttype
    objectid
    enteredtimestamp
    expiredtimestamp
    line1
    line2
    line3
    city
    statecode
    statename
    statuscode
    statusmessage
    pincode
    countrycode
    codevalue
    district
    lastupdatedby
    godownname
    gstin
    phone
    email
    personincharge
    consigneename
    consigneegstin
    foreignstate
    foreigndistrict
    defaultflag
    addresstitle
    addressindex
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAddressEntitysQueryVariables,
  APITypes.ListAddressEntitysQuery
>;
export const listAllFinancialYears = /* GraphQL */ `query ListAllFinancialYears {
  listAllFinancialYears {
    financialyearid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    startdate
    enddate
    startyear
    endyear
    comments
    userid
    aliasname
    statuscode
    statusmessage
    freezestatus
    transferdate
    freezedate
    stepscompleted
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAllFinancialYearsQueryVariables,
  APITypes.ListAllFinancialYearsQuery
>;
export const listBankAccounts = /* GraphQL */ `query ListBankAccounts {
  listBankAccounts {
    accountsid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    accountname
    accounttypecd
    accountgroupid
    hsnsaccode
    displayordernumber
    statuscode
    statusmessage
    restrictedflag
    is_active
    accountgroupenteredtimestamp
    accountgroupexpiredtimestamp
    accountgrouptypecd
    accountgroupname
    accountparentgroupid
    accountgroupdisplayordernumber
    accountgrouprestrictedflag
    accountgroupis_active
    accountgstenteredtimestamp
    accountgstexpiredtimestamp
    accountgsteffectivedate
    accountgstexpireddate
    hsnid
    gstcompensationtype
    gstrate
    cessamount
    accounttypeflag
    partyid
    tdspercentage
    tdssection
    path
    tax_type
    balancesign
    accountcreationdate
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBankAccountsQueryVariables,
  APITypes.ListBankAccountsQuery
>;
export const listBankDetails = /* GraphQL */ `query ListBankDetails {
  listBankDetails {
    bankdetailsid
    companyid
    companybranchid
    objecttype
    enteredtimestamp
    expiredtimestamp
    objectid
    userid
    bankname
    bankaccountnumber
    ifsccode
    branch
    notes
    ledgeraccount
    bankaccounttype
    cash
    swiftcode
    statuscode
    statusmessage
    relatedaccountdetails {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    upi
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBankDetailsQueryVariables,
  APITypes.ListBankDetailsQuery
>;
export const listBusinessType = /* GraphQL */ `query ListBusinessType {
  listBusinessType {
    businesstypeid
    companyid
    enteredtimestamp
    expiredtimestamp
    businesstype
    lastupdatedby
    restrictedflag
    isactive
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBusinessTypeQueryVariables,
  APITypes.ListBusinessTypeQuery
>;
export const listCashAccounts = /* GraphQL */ `query ListCashAccounts {
  listCashAccounts {
    accountsid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    accountname
    accounttypecd
    accountgroupid
    hsnsaccode
    displayordernumber
    statuscode
    statusmessage
    restrictedflag
    is_active
    accountgroupenteredtimestamp
    accountgroupexpiredtimestamp
    accountgrouptypecd
    accountgroupname
    accountparentgroupid
    accountgroupdisplayordernumber
    accountgrouprestrictedflag
    accountgroupis_active
    accountgstenteredtimestamp
    accountgstexpiredtimestamp
    accountgsteffectivedate
    accountgstexpireddate
    hsnid
    gstcompensationtype
    gstrate
    cessamount
    accounttypeflag
    partyid
    tdspercentage
    tdssection
    path
    tax_type
    balancesign
    accountcreationdate
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCashAccountsQueryVariables,
  APITypes.ListCashAccountsQuery
>;
export const listCashTransactionDetails = /* GraphQL */ `query ListCashTransactionDetails(
  $rowfrom: Int!
  $limitno: Int!
  $startdate: Int!
  $enddate: Int!
) {
  listCashTransactionDetails(
    rowfrom: $rowfrom
    limitno: $limitno
    startdate: $startdate
    enddate: $enddate
  ) {
    transactionid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    transactiontypecd
    accountid
    creditamount
    debitamount
    comments
    entryordernumber
    transactionbalance
    openingbalance
    relatedaccounts {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    relatedaccountstransaction {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      accountid
      creditamount
      debitamount
      comments
      entryordernumber
      transactionbalance
      openingbalance
      vouchernumber
      transactionmastertypecd
      relatedaccounts {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accountname
        accounttypecd
        accountgroupid
        hsnsaccode
        displayordernumber
        statuscode
        statusmessage
        restrictedflag
        is_active
        accounttypeflag
        relatedaccountgstdetails {
          accountid
          companyid
          enteredtimestamp
          expiredtimestamp
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstrate
          cessamount
          lastupdatedby
          statuscode
          statusmessage
          hsnsaccode
          codetype
          description
          taxability
          __typename
        }
        relatedaccountopeningbalance {
          accountsid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          financialyearid
          startdate
          creditamount
          debitamount
          statuscode
          statusmessage
          __typename
        }
        relatedaccountgroupmaster {
          accountgroupid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          accounttypecd
          accountgroupname
          accountparentgroupid
          displayordernumber
          statuscode
          statusmessage
          is_active
          restrictedflag
          path
          __typename
        }
        relatedaccountbalance {
          accountid
          accountbalance
          actualbalance
          __typename
        }
        path
        __typename
      }
      financialyearid
      __typename
    }
    lastupdatedby
    financialyearid
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCashTransactionDetailsQueryVariables,
  APITypes.ListCashTransactionDetailsQuery
>;
export const listCompanyDocuments = /* GraphQL */ `query ListCompanyDocuments($documenttype: String!, $partyid: Int!) {
  listCompanyDocuments(documenttype: $documenttype, partyid: $partyid) {
    id
    companyid
    partyid
    documenttype
    enteredtimestamp
    expiredtimestamp
    imagename
    imageurl
    lastupdatedby
    isactive
    type
    documentname
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCompanyDocumentsQueryVariables,
  APITypes.ListCompanyDocumentsQuery
>;
export const listTransactionMasterCount = /* GraphQL */ `query ListTransactionMasterCount(
  $transactiontypecd: String
  $columnname: String
  $ordertype: String
  $searchmode: Int
  $searcharray: AWSJSON
) {
  listTransactionMasterCount(
    transactiontypecd: $transactiontypecd
    columnname: $columnname
    ordertype: $ordertype
    searchmode: $searchmode
    searcharray: $searcharray
  ) {
    transactionmasterlistcount
    total_paymentamount
    total_paymentamount_side
    total_receiptamount
    total_receiptamount_side
    total_totalamount
    total_totalamount_side
    total_tds_payable_amount
    total_tds_payable_amount_side
    total_tds_receivable_amount
    total_tds_receivable_amount_side
    total_tcs_payable_amount
    total_tcs_payable_amount_side
    total_tcs_receivable_amount
    total_tcs_receivable_amount_side
    statuscode
    statusmessage
    min_paymentamount
    max_paymentamount
    min_receiptamount
    max_receiptamount
    min_tds_payable_amount
    max_tds_payable_amount
    min_tds_receivable_amount
    max_tds_receivable_amount
    min_totalamount
    max_totalamount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTransactionMasterCountQueryVariables,
  APITypes.ListTransactionMasterCountQuery
>;
export const listReceiptsTransactionType = /* GraphQL */ `query ListReceiptsTransactionType {
  listReceiptsTransactionType {
    transactionid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    transactiontypecd
    vouchernumber
    entrydate
    bankreferencenumber
    comments
    relatedtransactiondetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      accountid
      creditamount
      debitamount
      comments
      entryordernumber
      transactionbalance
      openingbalance
      lastupdatedby
      statuscode
      statusmessage
      financialyearid
      __typename
    }
    relatedtransactionattachment {
      transactionid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      lastupdatedby
      documentname
      statuscode
      statusmessage
      type
      __typename
    }
    relatedtransactiontdsdetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tdsapplicablecd
      tdsamount
      tdsmanual
      lastupdatedby
      statuscode
      statusmessage
      tdspercentage
      __typename
    }
    relatedpurchasemaster {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      purchasegsttypecd
      supplierid
      entrydate
      vouchernumber
      supplierinvoicedate
      supplierinvoicenumber
      supplieraddressid
      paymenttypecd
      paidamount
      creditduration
      paymentaccountid
      comments
      tdsapplicableflag
      granttotalamount
      balancedueamount
      paymentclearedflag
      placeofsupply
      companystate
      relatedpurchasetdsdetails {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tdsapplicablecd
        totaltaxableamount
        ineligibletcflag
        reversechargeflag
        gstcesstotal
        tdsamount
        adjustmentamount
        tdssection
        tdspercentage
        tdsmanual
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpurchaselineitems {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        itemnumber
        itemid
        purchaseaccountid
        hsncode
        itemquantity
        unittypecd
        itemrate
        itemamount
        itemdiscount
        taxableamount
        description
        discounttype
        discountrate
        netamount
        relatedpurchaselinegst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemmaster {
          itemid
          itemcode
          companyid
          enteredtimestamp
          expiredtimestamp
          itemname
          salesinvoiceflag
          purchaseinvoiceflag
          itemcategorycd
          measurementcd
          currencycd
          salesaccountid
          purchaseaccountid
          taxabilitycd
          reversechargeflag
          itemtype
          hsnid
          is_active
          statuscode
          statusmessage
          relateditemamountdetails {
            id
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            amount
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstcompensationvalue
            gstrate
            statuscode
            statusmessage
            lastupdatedby
            discounttype
            discountvalue
            invoicetype
            pricetype
            isactive
            isdefault
            pricetypeid
            tabletype
            __typename
          }
          relateditemgstdetails {
            itemid
            companyid
            enteredtimestamp
            expiredtimestamp
            hsnid
            gstcesstype
            gstcompensationvalue
            effectivedate
            expireddate
            gstcessvalue
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemimages {
            attachmentid
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            imagename
            imageurl
            documentname
            type
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          serialnumber
          financialyearid
          description
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          cessexist
          barcode
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        taxability
        pricetype
        lotid
        hsnid
        hsncodetype
        hsndescription
        gstrate
        gstamount
        cessamount
        unit
        uqc
        purchaseaccountname
        itemname
        itemcode
        itemtype
        manualdiscount
        manualcess
        pricetypeid
        manualgst
        cessrate
        cesstype
        type
        __typename
      }
      relatedpurchaselinenonitems {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        purchaselineitemtype
        purchaseaccountid
        hsnsaccode
        itemdescription
        taxableamount
        rate
        discount
        netamount
        relatedpurchaselinenongst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        taxability
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gstamount
        cessamount
        purchaseaccountname
        manualgst
        manualcess
        cessrate
        cesstype
        type
        __typename
      }
      relatedpurchaselinegst {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        cessamount
        gstamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpurchaseattachment {
        purchaseid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        statuscode
        statusmessage
        documentname
        type
        __typename
      }
      relatedpurchasetransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        vouchernumber
        entrydate
        bankreferencenumber
        comments
        relatedtransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          accountid
          creditamount
          debitamount
          comments
          entryordernumber
          transactionbalance
          openingbalance
          lastupdatedby
          statuscode
          statusmessage
          financialyearid
          __typename
        }
        relatedtransactionattachment {
          transactionid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          documentname
          statuscode
          statusmessage
          type
          __typename
        }
        relatedtransactiontdsdetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          tdsamount
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          tdspercentage
          __typename
        }
        relatedpurchasemaster {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchasegsttypecd
          supplierid
          entrydate
          vouchernumber
          supplierinvoicedate
          supplierinvoicenumber
          supplieraddressid
          paymenttypecd
          paidamount
          creditduration
          paymentaccountid
          comments
          tdsapplicableflag
          granttotalamount
          balancedueamount
          paymentclearedflag
          placeofsupply
          companystate
          relatedpurchasetdsdetails {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            totaltaxableamount
            ineligibletcflag
            reversechargeflag
            gstcesstotal
            tdsamount
            adjustmentamount
            tdssection
            tdspercentage
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaselineitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            itemnumber
            itemid
            purchaseaccountid
            hsncode
            itemquantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            description
            discounttype
            discountrate
            netamount
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            pricetype
            lotid
            hsnid
            hsncodetype
            hsndescription
            gstrate
            gstamount
            cessamount
            unit
            uqc
            purchaseaccountname
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinenonitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchaselineitemtype
            purchaseaccountid
            hsnsaccode
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedpurchaselinenongst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gstamount
            cessamount
            purchaseaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaseattachment {
            purchaseid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedpurchasetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          relatedpurchasetransactionrelation {
            transactionid
            transactiontypecd
            objecttype
            objectid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            linkedamount
            objectattribute
            isdirect
            lastupdatedby
            accountid
            paymentvouchernumber
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          cancelflag
          roundoffamount
          discounttype
          discountvalue
          adjustmentamount
          serialnumber
          currencycode
          currencyrate
          reversechargeflag
          paymentstatus
          partyregistrationtype
          partygstcategory
          itcflag
          __typename
        }
        relatedinvoicemaster {
          invoiceid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicetypecd
          partyid
          paymentaccountid
          invoicedate
          invoicenumber
          customerordernumber
          customerorderdate
          invoiceamount
          paymenttype
          creditduration
          invoicebillingaddressid
          invoicedeliveryaddressid
          invoicetaxabletypecd
          receipturl
          invoicelinetypecd
          invoicecurrencycd
          exchangerate
          comments
          receivedamount
          adjustmentamount
          placeofsupply
          balancedueamount
          reversechargeflag
          tcsapplicableflag
          relatedinvoicelineitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            lineitemnumber
            invoicelineitemtype
            itemid
            quantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            discounttype
            discountrate
            netamount
            hsnsaccode
            taxability
            lastupdatedby
            statuscode
            statusmessage
            pricetype
            lotid
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            unit
            uqc
            salesaccountname
            salesaccountid
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            itemmaster_timestamp
            description
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoicelinenonitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicelineitemtype
            incomeaccountid
            hsnsaccode
            taxability
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedaccounts {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accountname
              accounttypecd
              accountgroupid
              hsnsaccode
              displayordernumber
              statuscode
              statusmessage
              restrictedflag
              is_active
              accounttypeflag
              path
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            incomeaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoiceattachment {
            invoiceid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedinvoicedispatch {
            invoiceid
            dispatchid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transportationcd
            vehiclenumber
            dispatchdate
            ewaybillnumber
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoiceposdetails {
            posid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            partyposid
            lastupdatedby
            relatedposparty {
              pospartyid
              companyid
              partyname
              partycontactnumberid
              lastupdatedby
              enteredtimestamp
              expiredtimestamp
              __typename
            }
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicenumbertracker {
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            nextinvoicenumber
            lastupdatedby
            __typename
          }
          relatedinvoicetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          lastupdatedby
          cancelflag
          statuscode
          statusmessage
          consigneename
          consigneegstin
          companystate
          cancelremark
          deleteremark
          roundoffamount
          discounttype
          discountvalue
          serialnumber
          currencycode
          currencyrate
          paymentstatus
          ackno
          ackdt
          irn
          signedqrcode
          itcflag
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        cancelflag
        cancelremark
        serialnumber
        pdflink
        towards
        isvouchereditable
        __typename
      }
      relatedpurchasetransactionrelation {
        transactionid
        transactiontypecd
        objecttype
        objectid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        linkedamount
        objectattribute
        isdirect
        lastupdatedby
        accountid
        paymentvouchernumber
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      cancelflag
      roundoffamount
      discounttype
      discountvalue
      adjustmentamount
      serialnumber
      currencycode
      currencyrate
      reversechargeflag
      paymentstatus
      partyregistrationtype
      partygstcategory
      itcflag
      __typename
    }
    relatedinvoicemaster {
      invoiceid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoicetypecd
      partyid
      paymentaccountid
      invoicedate
      invoicenumber
      customerordernumber
      customerorderdate
      invoiceamount
      paymenttype
      creditduration
      invoicebillingaddressid
      invoicedeliveryaddressid
      invoicetaxabletypecd
      receipturl
      invoicelinetypecd
      invoicecurrencycd
      exchangerate
      comments
      receivedamount
      adjustmentamount
      placeofsupply
      balancedueamount
      reversechargeflag
      tcsapplicableflag
      relatedinvoicelineitems {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        lineitemnumber
        invoicelineitemtype
        itemid
        quantity
        unittypecd
        itemrate
        itemamount
        itemdiscount
        taxableamount
        discounttype
        discountrate
        netamount
        hsnsaccode
        taxability
        lastupdatedby
        statuscode
        statusmessage
        pricetype
        lotid
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gsttypecd
        gstamount
        cessamount
        unit
        uqc
        salesaccountname
        salesaccountid
        itemname
        itemcode
        itemtype
        manualdiscount
        manualcess
        itemmaster_timestamp
        description
        relatedinvoicelinegst {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          gsttypecd
          gstamount
          cessamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemmaster {
          itemid
          itemcode
          companyid
          enteredtimestamp
          expiredtimestamp
          itemname
          salesinvoiceflag
          purchaseinvoiceflag
          itemcategorycd
          measurementcd
          currencycd
          salesaccountid
          purchaseaccountid
          taxabilitycd
          reversechargeflag
          itemtype
          hsnid
          is_active
          statuscode
          statusmessage
          relateditemamountdetails {
            id
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            amount
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstcompensationvalue
            gstrate
            statuscode
            statusmessage
            lastupdatedby
            discounttype
            discountvalue
            invoicetype
            pricetype
            isactive
            isdefault
            pricetypeid
            tabletype
            __typename
          }
          relateditemgstdetails {
            itemid
            companyid
            enteredtimestamp
            expiredtimestamp
            hsnid
            gstcesstype
            gstcompensationvalue
            effectivedate
            expireddate
            gstcessvalue
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemimages {
            attachmentid
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            imagename
            imageurl
            documentname
            type
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          serialnumber
          financialyearid
          description
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          cessexist
          barcode
          __typename
        }
        pricetypeid
        manualgst
        cessrate
        cesstype
        type
        __typename
      }
      relatedinvoicelinenonitems {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        invoicelineitemtype
        incomeaccountid
        hsnsaccode
        taxability
        itemdescription
        taxableamount
        rate
        discount
        netamount
        relatedaccounts {
          accountsid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          accountname
          accounttypecd
          accountgroupid
          hsnsaccode
          displayordernumber
          statuscode
          statusmessage
          restrictedflag
          is_active
          accounttypeflag
          relatedaccountgstdetails {
            accountid
            companyid
            enteredtimestamp
            expiredtimestamp
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstrate
            cessamount
            lastupdatedby
            statuscode
            statusmessage
            hsnsaccode
            codetype
            description
            taxability
            __typename
          }
          relatedaccountopeningbalance {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            financialyearid
            startdate
            creditamount
            debitamount
            statuscode
            statusmessage
            __typename
          }
          relatedaccountgroupmaster {
            accountgroupid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accounttypecd
            accountgroupname
            accountparentgroupid
            displayordernumber
            statuscode
            statusmessage
            is_active
            restrictedflag
            path
            __typename
          }
          relatedaccountbalance {
            accountid
            accountbalance
            actualbalance
            __typename
          }
          path
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gsttypecd
        gstamount
        cessamount
        incomeaccountname
        manualgst
        manualcess
        cessrate
        cesstype
        type
        __typename
      }
      relatedinvoiceattachment {
        invoiceid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        statuscode
        statusmessage
        documentname
        type
        __typename
      }
      relatedinvoicedispatch {
        invoiceid
        dispatchid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transportationcd
        vehiclenumber
        dispatchdate
        ewaybillnumber
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedinvoiceposdetails {
        posid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        partyposid
        lastupdatedby
        relatedposparty {
          pospartyid
          companyid
          partyname
          partycontactnumberid
          lastupdatedby
          enteredtimestamp
          expiredtimestamp
          relatedphonecontacts {
            id
            objecttype
            objectid
            enteredtimestamp
            expiredtimestamp
            countrycode
            phonenumber
            verifieddatetime
            promotionssignup
            smsallowed
            callallowed
            whatsappallowed
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          __typename
        }
        statuscode
        statusmessage
        __typename
      }
      relatedinvoicelinegst {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        gsttypecd
        gstamount
        cessamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedinvoicenumbertracker {
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        nextinvoicenumber
        lastupdatedby
        __typename
      }
      relatedinvoicetransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        vouchernumber
        entrydate
        bankreferencenumber
        comments
        relatedtransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          accountid
          creditamount
          debitamount
          comments
          entryordernumber
          transactionbalance
          openingbalance
          lastupdatedby
          statuscode
          statusmessage
          financialyearid
          __typename
        }
        relatedtransactionattachment {
          transactionid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          documentname
          statuscode
          statusmessage
          type
          __typename
        }
        relatedtransactiontdsdetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          tdsamount
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          tdspercentage
          __typename
        }
        relatedpurchasemaster {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchasegsttypecd
          supplierid
          entrydate
          vouchernumber
          supplierinvoicedate
          supplierinvoicenumber
          supplieraddressid
          paymenttypecd
          paidamount
          creditduration
          paymentaccountid
          comments
          tdsapplicableflag
          granttotalamount
          balancedueamount
          paymentclearedflag
          placeofsupply
          companystate
          relatedpurchasetdsdetails {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            totaltaxableamount
            ineligibletcflag
            reversechargeflag
            gstcesstotal
            tdsamount
            adjustmentamount
            tdssection
            tdspercentage
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaselineitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            itemnumber
            itemid
            purchaseaccountid
            hsncode
            itemquantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            description
            discounttype
            discountrate
            netamount
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            pricetype
            lotid
            hsnid
            hsncodetype
            hsndescription
            gstrate
            gstamount
            cessamount
            unit
            uqc
            purchaseaccountname
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinenonitems {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchaselineitemtype
            purchaseaccountid
            hsnsaccode
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedpurchaselinenongst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            taxability
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gstamount
            cessamount
            purchaseaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedpurchaseattachment {
            purchaseid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedpurchasetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          relatedpurchasetransactionrelation {
            transactionid
            transactiontypecd
            objecttype
            objectid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            linkedamount
            objectattribute
            isdirect
            lastupdatedby
            accountid
            paymentvouchernumber
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          cancelflag
          roundoffamount
          discounttype
          discountvalue
          adjustmentamount
          serialnumber
          currencycode
          currencyrate
          reversechargeflag
          paymentstatus
          partyregistrationtype
          partygstcategory
          itcflag
          __typename
        }
        relatedinvoicemaster {
          invoiceid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicetypecd
          partyid
          paymentaccountid
          invoicedate
          invoicenumber
          customerordernumber
          customerorderdate
          invoiceamount
          paymenttype
          creditduration
          invoicebillingaddressid
          invoicedeliveryaddressid
          invoicetaxabletypecd
          receipturl
          invoicelinetypecd
          invoicecurrencycd
          exchangerate
          comments
          receivedamount
          adjustmentamount
          placeofsupply
          balancedueamount
          reversechargeflag
          tcsapplicableflag
          relatedinvoicelineitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            lineitemnumber
            invoicelineitemtype
            itemid
            quantity
            unittypecd
            itemrate
            itemamount
            itemdiscount
            taxableamount
            discounttype
            discountrate
            netamount
            hsnsaccode
            taxability
            lastupdatedby
            statuscode
            statusmessage
            pricetype
            lotid
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            unit
            uqc
            salesaccountname
            salesaccountid
            itemname
            itemcode
            itemtype
            manualdiscount
            manualcess
            itemmaster_timestamp
            description
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemmaster {
              itemid
              itemcode
              companyid
              enteredtimestamp
              expiredtimestamp
              itemname
              salesinvoiceflag
              purchaseinvoiceflag
              itemcategorycd
              measurementcd
              currencycd
              salesaccountid
              purchaseaccountid
              taxabilitycd
              reversechargeflag
              itemtype
              hsnid
              is_active
              statuscode
              statusmessage
              lastupdatedby
              serialnumber
              financialyearid
              description
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              cessexist
              barcode
              __typename
            }
            pricetypeid
            manualgst
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoicelinenonitems {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicelineitemtype
            incomeaccountid
            hsnsaccode
            taxability
            itemdescription
            taxableamount
            rate
            discount
            netamount
            relatedaccounts {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accountname
              accounttypecd
              accountgroupid
              hsnsaccode
              displayordernumber
              statuscode
              statusmessage
              restrictedflag
              is_active
              accounttypeflag
              path
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            gstrate
            gsttypecd
            gstamount
            cessamount
            incomeaccountname
            manualgst
            manualcess
            cessrate
            cesstype
            type
            __typename
          }
          relatedinvoiceattachment {
            invoiceid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            statuscode
            statusmessage
            documentname
            type
            __typename
          }
          relatedinvoicedispatch {
            invoiceid
            dispatchid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transportationcd
            vehiclenumber
            dispatchdate
            ewaybillnumber
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoiceposdetails {
            posid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            partyposid
            lastupdatedby
            relatedposparty {
              pospartyid
              companyid
              partyname
              partycontactnumberid
              lastupdatedby
              enteredtimestamp
              expiredtimestamp
              __typename
            }
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relatedinvoicenumbertracker {
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            nextinvoicenumber
            lastupdatedby
            __typename
          }
          relatedinvoicetransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            vouchernumber
            entrydate
            bankreferencenumber
            comments
            relatedtransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              accountid
              creditamount
              debitamount
              comments
              entryordernumber
              transactionbalance
              openingbalance
              lastupdatedby
              statuscode
              statusmessage
              financialyearid
              __typename
            }
            relatedtransactionattachment {
              transactionid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              documentname
              statuscode
              statusmessage
              type
              __typename
            }
            relatedtransactiontdsdetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              tdsamount
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              tdspercentage
              __typename
            }
            relatedpurchasemaster {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchasegsttypecd
              supplierid
              entrydate
              vouchernumber
              supplierinvoicedate
              supplierinvoicenumber
              supplieraddressid
              paymenttypecd
              paidamount
              creditduration
              paymentaccountid
              comments
              tdsapplicableflag
              granttotalamount
              balancedueamount
              paymentclearedflag
              placeofsupply
              companystate
              lastupdatedby
              cancelflag
              roundoffamount
              discounttype
              discountvalue
              adjustmentamount
              serialnumber
              currencycode
              currencyrate
              reversechargeflag
              paymentstatus
              partyregistrationtype
              partygstcategory
              itcflag
              __typename
            }
            relatedinvoicemaster {
              invoiceid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicetypecd
              partyid
              paymentaccountid
              invoicedate
              invoicenumber
              customerordernumber
              customerorderdate
              invoiceamount
              paymenttype
              creditduration
              invoicebillingaddressid
              invoicedeliveryaddressid
              invoicetaxabletypecd
              receipturl
              invoicelinetypecd
              invoicecurrencycd
              exchangerate
              comments
              receivedamount
              adjustmentamount
              placeofsupply
              balancedueamount
              reversechargeflag
              tcsapplicableflag
              lastupdatedby
              cancelflag
              statuscode
              statusmessage
              consigneename
              consigneegstin
              companystate
              cancelremark
              deleteremark
              roundoffamount
              discounttype
              discountvalue
              serialnumber
              currencycode
              currencyrate
              paymentstatus
              ackno
              ackdt
              irn
              signedqrcode
              itcflag
              __typename
            }
            lastupdatedby
            statuscode
            statusmessage
            cancelflag
            cancelremark
            serialnumber
            pdflink
            towards
            isvouchereditable
            __typename
          }
          lastupdatedby
          cancelflag
          statuscode
          statusmessage
          consigneename
          consigneegstin
          companystate
          cancelremark
          deleteremark
          roundoffamount
          discounttype
          discountvalue
          serialnumber
          currencycode
          currencyrate
          paymentstatus
          ackno
          ackdt
          irn
          signedqrcode
          itcflag
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        cancelflag
        cancelremark
        serialnumber
        pdflink
        towards
        isvouchereditable
        __typename
      }
      lastupdatedby
      cancelflag
      statuscode
      statusmessage
      consigneename
      consigneegstin
      companystate
      cancelremark
      deleteremark
      roundoffamount
      discounttype
      discountvalue
      serialnumber
      currencycode
      currencyrate
      paymentstatus
      ackno
      ackdt
      irn
      signedqrcode
      itcflag
      __typename
    }
    lastupdatedby
    statuscode
    statusmessage
    cancelflag
    cancelremark
    serialnumber
    pdflink
    towards
    isvouchereditable
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReceiptsTransactionTypeQueryVariables,
  APITypes.ListReceiptsTransactionTypeQuery
>;
export const listRelatedPaymentTransactionID = /* GraphQL */ `query ListRelatedPaymentTransactionID($objectid: Int!) {
  listRelatedPaymentTransactionID(objectid: $objectid) {
    transactionid
    transactiontypecd
    objecttype
    objectid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    linkedamount
    objectattribute
    isdirect
    lastupdatedby
    accountid
    paymentvouchernumber
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRelatedPaymentTransactionIDQueryVariables,
  APITypes.ListRelatedPaymentTransactionIDQuery
>;
export const listPurchaseMasterv2 = /* GraphQL */ `query ListPurchaseMasterv2 {
  listPurchaseMasterv2 {
    purchaseid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    purchasegsttypecd
    supplierid
    entrydate
    vouchernumber
    supplierinvoicedate
    supplierinvoicenumber
    supplieraddressid
    paymenttypecd
    paidamount
    creditduration
    paymentaccountid
    comments
    tdsapplicableflag
    granttotalamount
    balancedueamount
    paymentclearedflag
    placeofsupply
    companystate
    lastupdatedby
    cancelflag
    roundoffamount
    discounttype
    discountvalue
    adjustmentamount
    statuscode
    statusmessage
    serialnumber
    currencycode
    currencyrate
    partyaccountid
    reversechargeflag
    paymentstatus
    partyregistrationtype
    partygstcategory
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPurchaseMasterv2QueryVariables,
  APITypes.ListPurchaseMasterv2Query
>;
export const listPurchaseMasterCount = /* GraphQL */ `query ListPurchaseMasterCount(
  $columnname: String
  $ordertype: String
  $searchmode: Int
  $searcharray: AWSJSON
) {
  listPurchaseMasterCount(
    columnname: $columnname
    ordertype: $ordertype
    searchmode: $searchmode
    searcharray: $searcharray
  ) {
    purchasemasterlistcount
    total_granttotalamount
    total_granttotalamount_side
    total_receivedamount
    total_receivedamount_side
    total_balancedueamount
    total_balancedueamount_side
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPurchaseMasterCountQueryVariables,
  APITypes.ListPurchaseMasterCountQuery
>;
export const listPartyPurchases = /* GraphQL */ `query ListPartyPurchases($supplierid: Int!) {
  listPartyPurchases(supplierid: $supplierid) {
    purchaseid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    purchasegsttypecd
    supplierid
    entrydate
    vouchernumber
    supplierinvoicedate
    supplierinvoicenumber
    supplieraddressid
    paymenttypecd
    paidamount
    creditduration
    paymentaccountid
    comments
    tdsapplicableflag
    granttotalamount
    balancedueamount
    paymentclearedflag
    placeofsupply
    companystate
    relatedpurchasetdsdetails {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tdsapplicablecd
      totaltaxableamount
      ineligibletcflag
      reversechargeflag
      gstcesstotal
      tdsamount
      adjustmentamount
      tdssection
      tdspercentage
      tdsmanual
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpurchasetcsdetails {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tcsapplicablecd
      totaltaxableamount
      ineligibletcflag
      reversechargeflag
      gstcesstotal
      tcsamount
      adjustmentamount
      tcssection
      lastupdatedby
      statuscode
      statusmessage
      tcspercentage
      tcsmanual
      __typename
    }
    relatedpurchaselineitems {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      itemnumber
      itemid
      purchaseaccountid
      hsncode
      itemquantity
      unittypecd
      itemrate
      itemamount
      itemdiscount
      taxableamount
      description
      discounttype
      discountrate
      netamount
      relatedpurchaselinegst {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        cessamount
        gstamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relateditemmaster {
        itemid
        itemcode
        companyid
        enteredtimestamp
        expiredtimestamp
        itemname
        salesinvoiceflag
        purchaseinvoiceflag
        itemcategorycd
        measurementcd
        currencycd
        salesaccountid
        purchaseaccountid
        taxabilitycd
        reversechargeflag
        itemtype
        hsnid
        is_active
        statuscode
        statusmessage
        relateditemamountdetails {
          id
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          amount
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstcompensationvalue
          gstrate
          statuscode
          statusmessage
          lastupdatedby
          discounttype
          discountvalue
          invoicetype
          pricetype
          isactive
          isdefault
          pricetypeid
          tabletype
          __typename
        }
        relateditemgstdetails {
          itemid
          companyid
          enteredtimestamp
          expiredtimestamp
          hsnid
          gstcesstype
          gstcompensationvalue
          effectivedate
          expireddate
          gstcessvalue
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemimages {
          attachmentid
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          imagename
          imageurl
          documentname
          type
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        serialnumber
        financialyearid
        description
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        cessexist
        barcode
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      taxability
      pricetype
      lotid
      hsnid
      hsncodetype
      hsndescription
      gstrate
      gstamount
      cessamount
      unit
      uqc
      purchaseaccountname
      itemname
      itemcode
      itemtype
      manualdiscount
      manualcess
      pricetypeid
      manualgst
      cessrate
      cesstype
      type
      __typename
    }
    relatedpurchaselinenonitems {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      purchaselineitemtype
      purchaseaccountid
      hsnsaccode
      itemdescription
      taxableamount
      rate
      discount
      netamount
      relatedpurchaselinenongst {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        cessamount
        gstamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      taxability
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      gstrate
      gstamount
      cessamount
      purchaseaccountname
      manualgst
      manualcess
      cessrate
      cesstype
      type
      __typename
    }
    relatedpurchaselinegst {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      cessamount
      gstamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpurchaselinenongst {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      cessamount
      gstamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpurchaseattachment {
      purchaseid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      lastupdatedby
      statuscode
      statusmessage
      documentname
      type
      __typename
    }
    relatedpurchasetransactiondetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      vouchernumber
      entrydate
      bankreferencenumber
      comments
      relatedtransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        accountid
        creditamount
        debitamount
        comments
        entryordernumber
        transactionbalance
        openingbalance
        lastupdatedby
        statuscode
        statusmessage
        financialyearid
        __typename
      }
      relatedtransactionattachment {
        transactionid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        documentname
        statuscode
        statusmessage
        type
        __typename
      }
      relatedtransactiontdsdetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tdsapplicablecd
        tdsamount
        tdsmanual
        lastupdatedby
        statuscode
        statusmessage
        tdspercentage
        __typename
      }
      relatedpurchasemaster {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        purchasegsttypecd
        supplierid
        entrydate
        vouchernumber
        supplierinvoicedate
        supplierinvoicenumber
        supplieraddressid
        paymenttypecd
        paidamount
        creditduration
        paymentaccountid
        comments
        tdsapplicableflag
        granttotalamount
        balancedueamount
        paymentclearedflag
        placeofsupply
        companystate
        relatedpurchasetdsdetails {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          totaltaxableamount
          ineligibletcflag
          reversechargeflag
          gstcesstotal
          tdsamount
          adjustmentamount
          tdssection
          tdspercentage
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaselineitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          itemnumber
          itemid
          purchaseaccountid
          hsncode
          itemquantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          taxableamount
          description
          discounttype
          discountrate
          netamount
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          pricetype
          lotid
          hsnid
          hsncodetype
          hsndescription
          gstrate
          gstamount
          cessamount
          unit
          uqc
          purchaseaccountname
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          pricetypeid
          manualgst
          cessrate
          cesstype
          type
          __typename
        }
        relatedpurchaselinenonitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchaselineitemtype
          purchaseaccountid
          hsnsaccode
          itemdescription
          taxableamount
          rate
          discount
          netamount
          relatedpurchaselinenongst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gstamount
          cessamount
          purchaseaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          type
          __typename
        }
        relatedpurchaselinegst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaseattachment {
          purchaseid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedpurchasetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              description
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              description
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        relatedpurchasetransactionrelation {
          transactionid
          transactiontypecd
          objecttype
          objectid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          linkedamount
          objectattribute
          isdirect
          lastupdatedby
          accountid
          paymentvouchernumber
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        cancelflag
        roundoffamount
        discounttype
        discountvalue
        adjustmentamount
        serialnumber
        currencycode
        currencyrate
        reversechargeflag
        paymentstatus
        partyregistrationtype
        partygstcategory
        itcflag
        __typename
      }
      relatedinvoicemaster {
        invoiceid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        invoicetypecd
        partyid
        paymentaccountid
        invoicedate
        invoicenumber
        customerordernumber
        customerorderdate
        invoiceamount
        paymenttype
        creditduration
        invoicebillingaddressid
        invoicedeliveryaddressid
        invoicetaxabletypecd
        receipturl
        invoicelinetypecd
        invoicecurrencycd
        exchangerate
        comments
        receivedamount
        adjustmentamount
        placeofsupply
        balancedueamount
        reversechargeflag
        tcsapplicableflag
        relatedinvoicelineitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          lineitemnumber
          invoicelineitemtype
          itemid
          quantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          taxableamount
          discounttype
          discountrate
          netamount
          hsnsaccode
          taxability
          lastupdatedby
          statuscode
          statusmessage
          pricetype
          lotid
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          unit
          uqc
          salesaccountname
          salesaccountid
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          itemmaster_timestamp
          description
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          pricetypeid
          manualgst
          cessrate
          cesstype
          type
          __typename
        }
        relatedinvoicelinenonitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicelineitemtype
          incomeaccountid
          hsnsaccode
          taxability
          itemdescription
          taxableamount
          rate
          discount
          netamount
          relatedaccounts {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accountname
            accounttypecd
            accountgroupid
            hsnsaccode
            displayordernumber
            statuscode
            statusmessage
            restrictedflag
            is_active
            accounttypeflag
            relatedaccountgstdetails {
              accountid
              companyid
              enteredtimestamp
              expiredtimestamp
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstrate
              cessamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsaccode
              codetype
              description
              taxability
              __typename
            }
            relatedaccountopeningbalance {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              financialyearid
              startdate
              creditamount
              debitamount
              statuscode
              statusmessage
              __typename
            }
            relatedaccountgroupmaster {
              accountgroupid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accounttypecd
              accountgroupname
              accountparentgroupid
              displayordernumber
              statuscode
              statusmessage
              is_active
              restrictedflag
              path
              __typename
            }
            relatedaccountbalance {
              accountid
              accountbalance
              actualbalance
              __typename
            }
            path
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          incomeaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          type
          __typename
        }
        relatedinvoiceattachment {
          invoiceid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedinvoicedispatch {
          invoiceid
          dispatchid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transportationcd
          vehiclenumber
          dispatchdate
          ewaybillnumber
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoiceposdetails {
          posid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          partyposid
          lastupdatedby
          relatedposparty {
            pospartyid
            companyid
            partyname
            partycontactnumberid
            lastupdatedby
            enteredtimestamp
            expiredtimestamp
            relatedphonecontacts {
              id
              objecttype
              objectid
              enteredtimestamp
              expiredtimestamp
              countrycode
              phonenumber
              verifieddatetime
              promotionssignup
              smsallowed
              callallowed
              whatsappallowed
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            __typename
          }
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicelinegst {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          gsttypecd
          gstamount
          cessamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicenumbertracker {
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          nextinvoicenumber
          lastupdatedby
          __typename
        }
        relatedinvoicetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              description
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              description
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        lastupdatedby
        cancelflag
        statuscode
        statusmessage
        consigneename
        consigneegstin
        companystate
        cancelremark
        deleteremark
        roundoffamount
        discounttype
        discountvalue
        serialnumber
        currencycode
        currencyrate
        paymentstatus
        ackno
        ackdt
        irn
        signedqrcode
        itcflag
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      cancelflag
      cancelremark
      serialnumber
      pdflink
      towards
      isvouchereditable
      __typename
    }
    relatedpartymaster {
      partyid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      partytypecd
      partydisplayname
      partylegalname
      groupaccountid
      gstcategory
      placeofsupply
      entity
      email
      contactnumber
      whatsappnumber
      accountsid
      is_active
      msmetype
      deliveryconsigneename
      deliveryconsigneegstin
      statuscode
      statusmessage
      relatedpartygstdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        pannumber
        gstin
        partyaddressid
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycreditdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        creditperiodduration
        billingcurrency
        creditlimitcd
        creditlimitamount
        billwiseflag
        notes
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycontact {
        partyid
        enteredtimestamp
        expiredtimestamp
        contacttypename
        contactdesignationname
        contactorder
        email
        phonenumber
        whatsappnumber
        lastupdatedby
        statuscode
        statusmessage
        contactcountry
        whatsappcountry
        __typename
      }
      relatedpartyimages {
        attachmentid
        partyid
        companyid
        enteredtimestamp
        expiredtimestamp
        type
        documentname
        imagename
        imageurl
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      tdspercentage
      udhyamregno
      sameaddressflag
      comments
      tdssection
      accountname
      deliverystatecode
      deliverystatename
      contactcountry
      whatsappcountry
      entityname
      __typename
    }
    relatedpartyaddressdetails {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      line1
      line2
      line3
      city
      statecode
      statename
      statuscode
      statusmessage
      pincode
      countrycode
      codevalue
      district
      lastupdatedby
      godownname
      gstin
      phone
      email
      personincharge
      consigneename
      consigneegstin
      foreignstate
      foreigndistrict
      defaultflag
      addresstitle
      addressindex
      __typename
    }
    relatedpaymentaccountdetails {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    relatedpurchaseaddressdetails {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      line1
      line2
      line3
      city
      statecode
      statename
      statuscode
      statusmessage
      pincode
      countrycode
      codevalue
      district
      lastupdatedby
      godownname
      gstin
      phone
      email
      personincharge
      consigneename
      consigneegstin
      foreignstate
      foreigndistrict
      defaultflag
      addresstitle
      addressindex
      __typename
    }
    lastupdatedby
    cancelflag
    roundoffamount
    discounttype
    discountvalue
    adjustmentamount
    statuscode
    statusmessage
    serialnumber
    currencycode
    currencyrate
    partydisplayname
    partylegalname
    partyaccountid
    reversechargeflag
    overduedays
    paymentstatus
    partyregistrationtype
    purchaseinvoicepdf
    partygstcategory
    partyemail
    partygstin
    partytypecd
    ewaybillno
    validupto
    ewaybill_is_cancelled
    ewaybill_cancel_remarks
    cancel_rsn_code
    einvoiceenteredtimestamp
    ewaybillenteredtimestamp
    ewaybillid
    accountname
    duedatetimestamp
    partyisactive
    consigneename
    consigneegstin
    ewaybillpdf
    ewaybillstatus
    isvouchereditable
    goods_exist
    itcflag
    linkedamount
    cessexist
    partyamount
    totalgstamount
    tdsamount
    tcsamount
    taxableamount
    igstamount
    cgstamount
    sgstamount
    cessamount
    sourceofsupply
    taxabilitylabel
    additionaldiscount
    netinvoiceamount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPartyPurchasesQueryVariables,
  APITypes.ListPartyPurchasesQuery
>;
export const listPartyInvoicePurchases = /* GraphQL */ `query ListPartyInvoicePurchases($accountid: Int, $transactiontype: String) {
  listPartyInvoicePurchases(
    accountid: $accountid
    transactiontype: $transactiontype
  ) {
    partyid
    companyid
    partytypecd
    partydisplayname
    partylegalname
    groupaccountid
    gstcategory
    placeofsupply
    entity
    email
    contactnumber
    whatsappnumber
    accountsid
    is_active
    msmetype
    deliveryconsigneename
    deliveryconsigneegstin
    lastupdatedby
    tdspercentage
    udhyamregno
    sameaddressflag
    invoiceid
    invoicetypecd
    invoicepaymentaccountid
    invoicedate
    invoicenumber
    customerordernumber
    customerorderdate
    invoiceamount
    paymenttype
    invoicecreditduration
    invoicebillingaddressid
    invoicedeliveryaddressid
    invoicetaxabletypecd
    receipturl
    invoicelinetypecd
    invoicecurrencycd
    invoiceexchangerate
    invoicecomments
    receivedamount
    invoiceadjustmentamount
    invoiceplaceofsupply
    invoicebalancedueamount
    invoicereversechargeflag
    invoicetcsapplicableflag
    invoicelastupdatedby
    invoicestatuscode
    invoicestatusmessage
    invoicecancelflag
    consigneename
    consigneegstin
    invoicecompanystate
    cancelremark
    deleteremark
    invoiceroundoffamount
    invoicediscounttype
    invoicediscountvalue
    invoiceserialnumber
    invoicecurrencycode
    invoicecurrencyrate
    invoicepartydisplayname
    invoicepartylegalname
    invoicepartyaccountid
    purchaseid
    purchasegsttypecd
    supplierid
    entrydate
    vouchernumber
    supplierinvoicedate
    supplierinvoicenumber
    supplieraddressid
    paymenttypecd
    paidamount
    purchasecreditduration
    purchasepaymentaccountid
    purchasecomments
    tdsapplicableflag
    granttotalamount
    purchasebalancedueamount
    paymentclearedflag
    purchaseplaceofsupply
    purchasecompanystate
    purchaselastupdatedby
    purchasecancelflag
    purchaseroundoffamount
    purchasediscounttype
    purchasediscountvalue
    purchaseadjustmentamount
    purchasestatuscode
    purchasestatusmessage
    purchaseserialnumber
    purchasecurrencycode
    purchasecurrencyrate
    purchasepartydisplayname
    purchasepartylegalname
    purchasepartyaccountid
    purchasereversechargeflag
    crdrnoteid
    crdrnotetypecd
    crdrnotedate
    crdrnotenumber
    crdrinvoicetypecd
    crdrgsttypecd
    crdrpartyid
    crdrdeliveryaddressid
    crdrpaymenttype
    crdrgrandtotalamount
    crdrtransactionid
    crdruserid
    crdrcreditduration
    crdrpsflag
    crdrreversechargeflag
    crdrbalancedueamount
    crdrconsigneename
    crdrconsigneegstin
    crdrplaceofsupply
    crdrcancelflag
    crdrcancelremark
    crdrroundoffamount
    crdrdiscounttype
    crdrdiscountvalue
    crdradjustmentamount
    crdrserialnumber
    crdrcurrencycode
    crdrcurrencyrate
    crdroriginalinvoicenumber
    crdrpaymentstatus
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPartyInvoicePurchasesQueryVariables,
  APITypes.ListPartyInvoicePurchasesQuery
>;
export const listCrDrNoteMasterv2 = /* GraphQL */ `query ListCrDrNoteMasterv2(
  $crdrnotetypecd: String!
  $rowfrom: Int!
  $limitno: Int!
  $columnname: String
  $ordertype: String
  $searchmode: Int
  $searcharray: AWSJSON
) {
  listCrDrNoteMasterv2(
    crdrnotetypecd: $crdrnotetypecd
    rowfrom: $rowfrom
    limitno: $limitno
    columnname: $columnname
    ordertype: $ordertype
    searchmode: $searchmode
    searcharray: $searcharray
  ) {
    crdrnoteid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    crdrnotetypecd
    crdrnotedate
    crdrnotenumber
    invoicetypecd
    gsttypecd
    partyid
    deliveryaddressid
    paymenttype
    grandtotalamount
    transactionid
    userid
    creditduration
    statuscode
    statusmessage
    psflag
    reversechargeflag
    balancedueamount
    consigneename
    consignegstin
    companystate
    placeofsupply
    cancelflag
    cancelremark
    roundoffamount
    discounttype
    discountvalue
    adjustmentamount
    serialnumber
    currencycode
    currencyrate
    partamount
    partydisplayname
    partyaccountid
    partytypecd
    originalinvoicenumber
    partyinvoicenumber
    paymentstatus
    crdrnotepdf
    receivedamount
    partyregistrationtype
    duedatetimestamp
    overduedays
    cessexist
    partyamount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCrDrNoteMasterv2QueryVariables,
  APITypes.ListCrDrNoteMasterv2Query
>;
export const listCrDrNoteMasterCount = /* GraphQL */ `query ListCrDrNoteMasterCount(
  $crdrnotetypecd: String!
  $columnname: String
  $ordertype: String
  $searchmode: Int
  $searcharray: AWSJSON
) {
  listCrDrNoteMasterCount(
    crdrnotetypecd: $crdrnotetypecd
    columnname: $columnname
    ordertype: $ordertype
    searchmode: $searchmode
    searcharray: $searcharray
  ) {
    crdrnotemasterlistcount
    total_grandtotalamount
    total_grandtotalamount_side
    total_receivedamount
    total_receivedamount_side
    total_balancedueamount
    total_balancedueamount_side
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCrDrNoteMasterCountQueryVariables,
  APITypes.ListCrDrNoteMasterCountQuery
>;
export const getCompanyDetails = /* GraphQL */ `query GetCompanyDetails($companyid: Int) {
  getCompanyDetails(companyid: $companyid) {
    companyid
    enteredtimestamp
    expiredtimestamp
    websiteurl
    currencycd
    accountinventoryflag
    pannumber
    tdstcsnumber
    cinregistrationnumber
    registrationtype
    gstrperiod
    lut
    lutbondvalidfrom
    ewaybillflag
    gstapplicablefrom
    thresholdlimitcd
    thresholdlimitamount
    companyshort
    lutbondtodate
    invoicedetailapplicablefromdate
    tdsapplicable
    gstcategory
    financialyearstartandendmonth
    companylogourl
    msmetype
    udhyamregno
    udhyamdocs
    ewaybillstartdate
    minamountewayinter
    minamountewayintra
    einvoiceflag
    einvoicestartingdate
    gstcompensationcessflag
    tradelicensenumber
    tradelicensestartdate
    tradelicenseenddate
    lastupdatedby
    cinregistrationdate
    statuscode
    statusmessage
    activeflag
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCompanyDetailsQueryVariables,
  APITypes.GetCompanyDetailsQuery
>;
export const getCompanyCodeTranslation = /* GraphQL */ `query GetCompanyCodeTranslation($codetype: String!) {
  getCompanyCodeTranslation(codetype: $codetype) {
    id
    companyid
    codetype
    codevalue
    language
    enteredtimestamp
    expiredtimestamp
    codetext
    codeorder
    statuscode
    statusmessage
    lastupdatedby
    uqc
    is_active
    section
    displayas
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCompanyCodeTranslationQueryVariables,
  APITypes.GetCompanyCodeTranslationQuery
>;
export const getCompany = /* GraphQL */ `query GetCompany {
  getCompany {
    companyid
    enteredtimestamp
    expiredtimestamp
    companyname
    statuscode
    statusmessage
    relatedcompanydetailsnew {
      companyid
      enteredtimestamp
      expiredtimestamp
      websiteurl
      currencycd
      accountinventoryflag
      pannumber
      tdstcsnumber
      cinregistrationnumber
      registrationtype
      comppercentage
      gstrperiod
      lut
      lutbondvalidfrom
      ewaybillflag
      gstapplicablefrom
      thresholdlimitcd
      thresholdlimitamount
      companylegalname
      companyshort
      lutbondtodate
      invoicedetailapplicablefromdate
      tdsapplicable
      gstcategory
      financialyearstartandendmonth
      companylogourl
      msmetype
      udhyamregno
      udhyamdocs
      ewaybillstartdate
      minamountewayinter
      minamountewayintra
      einvoiceflag
      einvoicestartingdate
      gstcompensationcessflag
      tradelicensenumber
      tradelicensestartdate
      tradelicenseenddate
      lastupdatedby
      cinregistrationdate
      einvoiceconnect
      statuscode
      statusmessage
      activeflag
      relatedfinancialyeardata {
        financialyearid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        startdate
        enddate
        startyear
        endyear
        comments
        userid
        aliasname
        statuscode
        statusmessage
        freezestatus
        transferdate
        freezedate
        stepscompleted
        __typename
      }
      financialyearid
      lastupdatedtimestamp
      companydeletiontime
      ewaybillconnect
      stepscompleted
      disablegstcompensation
      businesstypeid
      industrytypeid
      __typename
    }
    relatedcompanyentity {
      id
      companyid
      enteredtimestamp
      expiredtimestamp
      legalname
      gstin
      financialyearcode
      companyentitytype
      startdate
      statuscode
      statusmessage
      lastupdatedby
      financialyearid
      __typename
    }
    relatedemailcontacts {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      emailaddress
      verifieddatetime
      promotionssignup
      statuscode
      statusmessage
      lastupdatedby
      __typename
    }
    relatedphonecontacts {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      countrycode
      phonenumber
      verifieddatetime
      promotionssignup
      smsallowed
      callallowed
      whatsappallowed
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedaddressentity {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      line1
      line2
      line3
      city
      statecode
      statename
      statuscode
      statusmessage
      pincode
      countrycode
      codevalue
      district
      lastupdatedby
      godownname
      gstin
      phone
      email
      personincharge
      consigneename
      consigneegstin
      foreignstate
      foreigndistrict
      defaultflag
      addresstitle
      addressindex
      __typename
    }
    lastupdatedby
    addressentityid
    objecttype
    line1
    line2
    line3
    city
    statecode
    statename
    pincode
    countrycode
    district
    financialyearid
    einvoiceusername
    companydeletiontime
    ewaybillusername
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCompanyQueryVariables,
  APITypes.GetCompanyQuery
>;
export const getAccountGroupMaster = /* GraphQL */ `query GetAccountGroupMaster($accountgroupid: Int!) {
  getAccountGroupMaster(accountgroupid: $accountgroupid) {
    accountgroupid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    accounttypecd
    accountgroupname
    accountparentgroupid
    displayordernumber
    statuscode
    statusmessage
    restrictedflag
    is_active
    relatedaccounts {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    path
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAccountGroupMasterQueryVariables,
  APITypes.GetAccountGroupMasterQuery
>;
export const getAccountBalance = /* GraphQL */ `query GetAccountBalance($accountid: Int!) {
  getAccountBalance(accountid: $accountid) {
    accountid
    accountbalance
    actualbalance
    balancesign
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAccountBalanceQueryVariables,
  APITypes.GetAccountBalanceQuery
>;
export const listGeneralSettingDateWise = /* GraphQL */ `query ListGeneralSettingDateWise($entrytypecd: String!, $inputdate: Int!) {
  listGeneralSettingDateWise(entrytypecd: $entrytypecd, inputdate: $inputdate) {
    id
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    financialyearid
    entrytypecd
    serialnumber
    serialisactive
    serialisused
    nextinvoicenumber
    prefix
    suffix
    lastupdatedby
    statuscode
    statusmessage
    serialflag
    startinvoicenumber
    taxability
    lastused
    secondlastused
    restrictedflag
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListGeneralSettingDateWiseQueryVariables,
  APITypes.ListGeneralSettingDateWiseQuery
>;
export const getCrDrNoteMaster = /* GraphQL */ `query GetCrDrNoteMaster($crdrnoteid: Int!) {
  getCrDrNoteMaster(crdrnoteid: $crdrnoteid) {
    crdrnoteid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    crdrnotetypecd
    crdrnotedate
    crdrnotenumber
    invoicetypecd
    gsttypecd
    partyid
    deliveryaddressid
    paymenttype
    grandtotalamount
    transactionid
    userid
    creditduration
    statuscode
    statusmessage
    psflag
    reversechargeflag
    balancedueamount
    consigneename
    consigneegstin
    companystate
    placeofsupply
    cancelflag
    cancelremark
    roundoffamount
    discounttype
    discountvalue
    adjustmentamount
    relatedcrdrnoteinvoices {
      crdrnoteid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoiceid
      statuscode
      statusmessage
      lastupdatedby
      __typename
    }
    relatedcrdrattachment {
      crdrnoteid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      userid
      statuscode
      statusmessage
      documentname
      type
      __typename
    }
    relatedcrdrnotedetails {
      crdrnoteid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      totaltaxableamount
      totalgst
      totalgstcess
      totaladjustments
      comments
      accountid
      partamount
      transportationcd
      vehiclenumber
      dispatchdate
      ewaybillnumber
      userid
      statuscode
      statusmessage
      __typename
    }
    relatedcrdrnotelineitems {
      crdrnoteid
      crdrnoteitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      lineitemnumber
      lineitemtype
      itemid
      quantity
      unittypecd
      itemrate
      itemamount
      itemdiscount
      taxableamount
      description
      discounttype
      discountrate
      gstrate
      gsttypecd
      gstamount
      gstcess
      hsnsaccode
      netamount
      userid
      taxability
      reason
      statuscode
      statusmessage
      pricetype
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      unit
      uqc
      salesaccountname
      purchaseaccountname
      salesaccountid
      purchaseaccountid
      itemname
      itemcode
      itemtype
      manualdiscount
      manualcess
      pricetypeid
      manualgst
      cessrate
      cesstype
      type
      __typename
    }
    relatedcrdrnotelinenonitems {
      crdrnoteid
      crdrnoteitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      lineitemtype
      ledgeraccountid
      hsnsaccode
      itemdescription
      taxableamount
      gstrate
      gsttypecd
      gstamount
      gstcess
      rate
      discount
      netamount
      userid
      taxability
      reason
      statuscode
      statusmessage
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      ledgeraccountname
      manualgst
      manualcess
      cessrate
      cesstype
      type
      __typename
    }
    relatedcrdrnotetcsdetails {
      crdrnoteid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tcsapplicablecd
      totaltaxableamount
      ineligibletcflag
      reversechargeflag
      gstcesstotal
      tcsamount
      adjustmentamount
      tcssection
      tcsmanual
      lastupdatedby
      statuscode
      statusmessage
      tcspercentage
      __typename
    }
    relatedcrdrnotetdsdetails {
      crdrnoteid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tdsapplicablecd
      totaltaxableamount
      ineligibletcflag
      reversechargeflag
      gstcesstotal
      tdsamount
      adjustmentamount
      tdssection
      tdspercentage
      tcsmanual
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedcrdrnotedispatch {
      crdrnoteid
      dispatchid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transportationcd
      vehiclenumber
      dispatchdate
      ewaybillnumber
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    serialnumber
    currencycode
    currencyrate
    partamount
    originalinvoicenumber
    partyinvoicenumber
    totalgst
    totalgstcess
    totaltaxableamount
    totaladjustments
    comments
    accountid
    transportationcd
    vehiclenumber
    dispatchdate
    ewaybillnumber
    paymentstatus
    crdrnotepdf
    partydisplayname
    partylegalname
    partyaccountid
    partygstcategory
    partyemail
    partytypecd
    partygstin
    accountname
    partyregistrationtype
    duedatetimestamp
    overduedays
    partyisactive
    isvouchereditable
    itcflag
    cessexist
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCrDrNoteMasterQueryVariables,
  APITypes.GetCrDrNoteMasterQuery
>;
export const listTransactionRelation = /* GraphQL */ `query ListTransactionRelation {
  listTransactionRelation {
    transactionid
    transactiontypecd
    objecttype
    objectid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    linkedamount
    objectattribute
    isdirect
    lastupdatedby
    accountid
    paymentvouchernumber
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTransactionRelationQueryVariables,
  APITypes.ListTransactionRelationQuery
>;
export const getRelatedPaymentDetails = /* GraphQL */ `query GetRelatedPaymentDetails($invoicetype: String!, $id: Int!) {
  getRelatedPaymentDetails(invoicetype: $invoicetype, id: $id) {
    id
    serialnumber
    paymenttransactionid
    paymentvouchernumber
    transactiontypecd
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRelatedPaymentDetailsQueryVariables,
  APITypes.GetRelatedPaymentDetailsQuery
>;
export const listdashboardbalances = /* GraphQL */ `query Listdashboardbalances(
  $startdate: Int!
  $enddate: Int!
  $openingbalance: Int!
  $companyid: Int!
  $financialyearid: Int!
) {
  listdashboardbalances(
    startdate: $startdate
    enddate: $enddate
    openingbalance: $openingbalance
    companyid: $companyid
    financialyearid: $financialyearid
  ) {
    companyid
    expiredtimestamp
    financialyearid
    type
    accountid
    accountname
    immediate_parent_group_id
    immediate_parent_group_name
    root_group_id
    root_group_name
    accounttypecd
    restrictedflag
    creditamount
    debitamount
    balance
    is_active
    group_path
    balancesign
    accounttypeflag
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListdashboardbalancesQueryVariables,
  APITypes.ListdashboardbalancesQuery
>;
export const listbusinessoverview = /* GraphQL */ `query Listbusinessoverview(
  $startdate: Int!
  $enddate: Int!
  $openingbalance: Int!
  $companyid: Int!
  $financialyearid: Int!
) {
  listbusinessoverview(
    startdate: $startdate
    enddate: $enddate
    openingbalance: $openingbalance
    companyid: $companyid
    financialyearid: $financialyearid
  ) {
    companyid
    expiredtimestamp
    financialyearid
    group_name
    level
    group_path
    balance
    closingstockamt
    openingstockamt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListbusinessoverviewQueryVariables,
  APITypes.ListbusinessoverviewQuery
>;
export const listtop5expense = /* GraphQL */ `query Listtop5expense(
  $startdate: Int!
  $enddate: Int!
  $openingbalance: Int!
  $companyid: Int!
  $financialyearid: Int!
) {
  listtop5expense(
    startdate: $startdate
    enddate: $enddate
    openingbalance: $openingbalance
    companyid: $companyid
    financialyearid: $financialyearid
  ) {
    companyid
    financialyearid
    account_id
    account_name
    balance
    type
    __typename
  }
}
` as GeneratedQuery<
  APITypes.Listtop5expenseQueryVariables,
  APITypes.Listtop5expenseQuery
>;
export const getAccountMaster = /* GraphQL */ `query GetAccountMaster($accountsid: Int!) {
  getAccountMaster(accountsid: $accountsid) {
    accountsid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    accountname
    accounttypecd
    accountgroupid
    hsnsaccode
    displayordernumber
    statuscode
    statusmessage
    restrictedflag
    is_active
    accounttypeflag
    relatedaccountgstdetails {
      accountid
      companyid
      enteredtimestamp
      expiredtimestamp
      effectivedate
      expireddate
      hsnid
      gstcompensationtype
      gstrate
      cessamount
      lastupdatedby
      statuscode
      statusmessage
      hsnsaccode
      codetype
      description
      taxability
      __typename
    }
    relatedaccountopeningbalance {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      financialyearid
      startdate
      creditamount
      debitamount
      statuscode
      statusmessage
      __typename
    }
    relatedaccountgroupmaster {
      accountgroupid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accounttypecd
      accountgroupname
      accountparentgroupid
      displayordernumber
      statuscode
      statusmessage
      is_active
      restrictedflag
      path
      __typename
    }
    relatedaccountbalance {
      accountid
      accountbalance
      actualbalance
      __typename
    }
    path
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAccountMasterQueryVariables,
  APITypes.GetAccountMasterQuery
>;
export const listPurchaseMasterRange = /* GraphQL */ `query ListPurchaseMasterRange($startdate: Int!, $enddate: Int!) {
  listPurchaseMasterRange(startdate: $startdate, enddate: $enddate) {
    purchaseid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    purchasegsttypecd
    supplierid
    entrydate
    vouchernumber
    supplierinvoicedate
    supplierinvoicenumber
    supplieraddressid
    paymenttypecd
    paidamount
    creditduration
    paymentaccountid
    comments
    tdsapplicableflag
    granttotalamount
    balancedueamount
    paymentclearedflag
    placeofsupply
    companystate
    relatedpurchasetdsdetails {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tdsapplicablecd
      totaltaxableamount
      ineligibletcflag
      reversechargeflag
      gstcesstotal
      tdsamount
      adjustmentamount
      tdssection
      tdspercentage
      tdsmanual
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpurchasetcsdetails {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      tcsapplicablecd
      totaltaxableamount
      ineligibletcflag
      reversechargeflag
      gstcesstotal
      tcsamount
      adjustmentamount
      tcssection
      lastupdatedby
      statuscode
      statusmessage
      tcspercentage
      tcsmanual
      __typename
    }
    relatedpurchaselineitems {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      itemnumber
      itemid
      purchaseaccountid
      hsncode
      itemquantity
      unittypecd
      itemrate
      itemamount
      itemdiscount
      taxableamount
      description
      discounttype
      discountrate
      netamount
      relatedpurchaselinegst {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        cessamount
        gstamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relateditemmaster {
        itemid
        itemcode
        companyid
        enteredtimestamp
        expiredtimestamp
        itemname
        salesinvoiceflag
        purchaseinvoiceflag
        itemcategorycd
        measurementcd
        currencycd
        salesaccountid
        purchaseaccountid
        taxabilitycd
        reversechargeflag
        itemtype
        hsnid
        is_active
        statuscode
        statusmessage
        relateditemamountdetails {
          id
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          amount
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstcompensationvalue
          gstrate
          statuscode
          statusmessage
          lastupdatedby
          discounttype
          discountvalue
          invoicetype
          pricetype
          isactive
          isdefault
          pricetypeid
          tabletype
          __typename
        }
        relateditemgstdetails {
          itemid
          companyid
          enteredtimestamp
          expiredtimestamp
          hsnid
          gstcesstype
          gstcompensationvalue
          effectivedate
          expireddate
          gstcessvalue
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemimages {
          attachmentid
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          imagename
          imageurl
          documentname
          type
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        serialnumber
        financialyearid
        description
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        cessexist
        barcode
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      taxability
      pricetype
      lotid
      hsnid
      hsncodetype
      hsndescription
      gstrate
      gstamount
      cessamount
      unit
      uqc
      purchaseaccountname
      itemname
      itemcode
      itemtype
      manualdiscount
      manualcess
      pricetypeid
      manualgst
      cessrate
      cesstype
      type
      __typename
    }
    relatedpurchaselinenonitems {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      purchaselineitemtype
      purchaseaccountid
      hsnsaccode
      itemdescription
      taxableamount
      rate
      discount
      netamount
      relatedpurchaselinenongst {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        cessamount
        gstamount
        cessrate
        cesstype
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      taxability
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      gstrate
      gstamount
      cessamount
      purchaseaccountname
      manualgst
      manualcess
      cessrate
      cesstype
      type
      __typename
    }
    relatedpurchaselinegst {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      cessamount
      gstamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpurchaselinenongst {
      purchaseid
      purchaseitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      cessamount
      gstamount
      cessrate
      cesstype
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relatedpurchaseattachment {
      purchaseid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      lastupdatedby
      statuscode
      statusmessage
      documentname
      type
      __typename
    }
    relatedpurchasetransactiondetails {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      vouchernumber
      entrydate
      bankreferencenumber
      comments
      relatedtransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        accountid
        creditamount
        debitamount
        comments
        entryordernumber
        transactionbalance
        openingbalance
        lastupdatedby
        statuscode
        statusmessage
        financialyearid
        __typename
      }
      relatedtransactionattachment {
        transactionid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        documentname
        statuscode
        statusmessage
        type
        __typename
      }
      relatedtransactiontdsdetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tdsapplicablecd
        tdsamount
        tdsmanual
        lastupdatedby
        statuscode
        statusmessage
        tdspercentage
        __typename
      }
      relatedpurchasemaster {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        purchasegsttypecd
        supplierid
        entrydate
        vouchernumber
        supplierinvoicedate
        supplierinvoicenumber
        supplieraddressid
        paymenttypecd
        paidamount
        creditduration
        paymentaccountid
        comments
        tdsapplicableflag
        granttotalamount
        balancedueamount
        paymentclearedflag
        placeofsupply
        companystate
        relatedpurchasetdsdetails {
          purchaseid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          tdsapplicablecd
          totaltaxableamount
          ineligibletcflag
          reversechargeflag
          gstcesstotal
          tdsamount
          adjustmentamount
          tdssection
          tdspercentage
          tdsmanual
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaselineitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          itemnumber
          itemid
          purchaseaccountid
          hsncode
          itemquantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          taxableamount
          description
          discounttype
          discountrate
          netamount
          relatedpurchaselinegst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          pricetype
          lotid
          hsnid
          hsncodetype
          hsndescription
          gstrate
          gstamount
          cessamount
          unit
          uqc
          purchaseaccountname
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          pricetypeid
          manualgst
          cessrate
          cesstype
          type
          __typename
        }
        relatedpurchaselinenonitems {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          purchaselineitemtype
          purchaseaccountid
          hsnsaccode
          itemdescription
          taxableamount
          rate
          discount
          netamount
          relatedpurchaselinenongst {
            purchaseid
            purchaseitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            cessamount
            gstamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          taxability
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gstamount
          cessamount
          purchaseaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          type
          __typename
        }
        relatedpurchaselinegst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedpurchaseattachment {
          purchaseid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedpurchasetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              description
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              description
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        relatedpurchasetransactionrelation {
          transactionid
          transactiontypecd
          objecttype
          objectid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          linkedamount
          objectattribute
          isdirect
          lastupdatedby
          accountid
          paymentvouchernumber
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        cancelflag
        roundoffamount
        discounttype
        discountvalue
        adjustmentamount
        serialnumber
        currencycode
        currencyrate
        reversechargeflag
        paymentstatus
        partyregistrationtype
        partygstcategory
        itcflag
        __typename
      }
      relatedinvoicemaster {
        invoiceid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        invoicetypecd
        partyid
        paymentaccountid
        invoicedate
        invoicenumber
        customerordernumber
        customerorderdate
        invoiceamount
        paymenttype
        creditduration
        invoicebillingaddressid
        invoicedeliveryaddressid
        invoicetaxabletypecd
        receipturl
        invoicelinetypecd
        invoicecurrencycd
        exchangerate
        comments
        receivedamount
        adjustmentamount
        placeofsupply
        balancedueamount
        reversechargeflag
        tcsapplicableflag
        relatedinvoicelineitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          lineitemnumber
          invoicelineitemtype
          itemid
          quantity
          unittypecd
          itemrate
          itemamount
          itemdiscount
          taxableamount
          discounttype
          discountrate
          netamount
          hsnsaccode
          taxability
          lastupdatedby
          statuscode
          statusmessage
          pricetype
          lotid
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          unit
          uqc
          salesaccountname
          salesaccountid
          itemname
          itemcode
          itemtype
          manualdiscount
          manualcess
          itemmaster_timestamp
          description
          relatedinvoicelinegst {
            invoiceid
            invoiceitemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            gstrate
            gsttypecd
            gstamount
            cessamount
            cessrate
            cesstype
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          relateditemmaster {
            itemid
            itemcode
            companyid
            enteredtimestamp
            expiredtimestamp
            itemname
            salesinvoiceflag
            purchaseinvoiceflag
            itemcategorycd
            measurementcd
            currencycd
            salesaccountid
            purchaseaccountid
            taxabilitycd
            reversechargeflag
            itemtype
            hsnid
            is_active
            statuscode
            statusmessage
            relateditemamountdetails {
              id
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              amount
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstcompensationvalue
              gstrate
              statuscode
              statusmessage
              lastupdatedby
              discounttype
              discountvalue
              invoicetype
              pricetype
              isactive
              isdefault
              pricetypeid
              tabletype
              __typename
            }
            relateditemgstdetails {
              itemid
              companyid
              enteredtimestamp
              expiredtimestamp
              hsnid
              gstcesstype
              gstcompensationvalue
              effectivedate
              expireddate
              gstcessvalue
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relateditemimages {
              attachmentid
              itemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              imagename
              imageurl
              documentname
              type
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            serialnumber
            financialyearid
            description
            hsnsacid
            hsncodetype
            hsncodevalue
            hsndescription
            cessexist
            barcode
            __typename
          }
          pricetypeid
          manualgst
          cessrate
          cesstype
          type
          __typename
        }
        relatedinvoicelinenonitems {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          invoicelineitemtype
          incomeaccountid
          hsnsaccode
          taxability
          itemdescription
          taxableamount
          rate
          discount
          netamount
          relatedaccounts {
            accountsid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            accountname
            accounttypecd
            accountgroupid
            hsnsaccode
            displayordernumber
            statuscode
            statusmessage
            restrictedflag
            is_active
            accounttypeflag
            relatedaccountgstdetails {
              accountid
              companyid
              enteredtimestamp
              expiredtimestamp
              effectivedate
              expireddate
              hsnid
              gstcompensationtype
              gstrate
              cessamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsaccode
              codetype
              description
              taxability
              __typename
            }
            relatedaccountopeningbalance {
              accountsid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              financialyearid
              startdate
              creditamount
              debitamount
              statuscode
              statusmessage
              __typename
            }
            relatedaccountgroupmaster {
              accountgroupid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              accounttypecd
              accountgroupname
              accountparentgroupid
              displayordernumber
              statuscode
              statusmessage
              is_active
              restrictedflag
              path
              __typename
            }
            relatedaccountbalance {
              accountid
              accountbalance
              actualbalance
              __typename
            }
            path
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          gstrate
          gsttypecd
          gstamount
          cessamount
          incomeaccountname
          manualgst
          manualcess
          cessrate
          cesstype
          type
          __typename
        }
        relatedinvoiceattachment {
          invoiceid
          attachmentid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          attachmentname
          attachmenturl
          lastupdatedby
          statuscode
          statusmessage
          documentname
          type
          __typename
        }
        relatedinvoicedispatch {
          invoiceid
          dispatchid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transportationcd
          vehiclenumber
          dispatchdate
          ewaybillnumber
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoiceposdetails {
          posid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          partyposid
          lastupdatedby
          relatedposparty {
            pospartyid
            companyid
            partyname
            partycontactnumberid
            lastupdatedby
            enteredtimestamp
            expiredtimestamp
            relatedphonecontacts {
              id
              objecttype
              objectid
              enteredtimestamp
              expiredtimestamp
              countrycode
              phonenumber
              verifieddatetime
              promotionssignup
              smsallowed
              callallowed
              whatsappallowed
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            __typename
          }
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicelinegst {
          invoiceid
          invoiceitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          gsttypecd
          gstamount
          cessamount
          cessrate
          cesstype
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relatedinvoicenumbertracker {
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          nextinvoicenumber
          lastupdatedby
          __typename
        }
        relatedinvoicetransactiondetails {
          transactionid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          transactiontypecd
          vouchernumber
          entrydate
          bankreferencenumber
          comments
          relatedtransactiondetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            transactiontypecd
            accountid
            creditamount
            debitamount
            comments
            entryordernumber
            transactionbalance
            openingbalance
            lastupdatedby
            statuscode
            statusmessage
            financialyearid
            __typename
          }
          relatedtransactionattachment {
            transactionid
            attachmentid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            attachmentname
            attachmenturl
            lastupdatedby
            documentname
            statuscode
            statusmessage
            type
            __typename
          }
          relatedtransactiontdsdetails {
            transactionid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            tdsapplicablecd
            tdsamount
            tdsmanual
            lastupdatedby
            statuscode
            statusmessage
            tdspercentage
            __typename
          }
          relatedpurchasemaster {
            purchaseid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            purchasegsttypecd
            supplierid
            entrydate
            vouchernumber
            supplierinvoicedate
            supplierinvoicenumber
            supplieraddressid
            paymenttypecd
            paidamount
            creditduration
            paymentaccountid
            comments
            tdsapplicableflag
            granttotalamount
            balancedueamount
            paymentclearedflag
            placeofsupply
            companystate
            relatedpurchasetdsdetails {
              purchaseid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              tdsapplicablecd
              totaltaxableamount
              ineligibletcflag
              reversechargeflag
              gstcesstotal
              tdsamount
              adjustmentamount
              tdssection
              tdspercentage
              tdsmanual
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaselineitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              itemnumber
              itemid
              purchaseaccountid
              hsncode
              itemquantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              description
              discounttype
              discountrate
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              pricetype
              lotid
              hsnid
              hsncodetype
              hsndescription
              gstrate
              gstamount
              cessamount
              unit
              uqc
              purchaseaccountname
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinenonitems {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              purchaselineitemtype
              purchaseaccountid
              hsnsaccode
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              taxability
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gstamount
              cessamount
              purchaseaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedpurchaselinegst {
              purchaseid
              purchaseitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              cessamount
              gstamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedpurchaseattachment {
              purchaseid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedpurchasetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            relatedpurchasetransactionrelation {
              transactionid
              transactiontypecd
              objecttype
              objectid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              linkedamount
              objectattribute
              isdirect
              lastupdatedby
              accountid
              paymentvouchernumber
              statuscode
              statusmessage
              __typename
            }
            lastupdatedby
            cancelflag
            roundoffamount
            discounttype
            discountvalue
            adjustmentamount
            serialnumber
            currencycode
            currencyrate
            reversechargeflag
            paymentstatus
            partyregistrationtype
            partygstcategory
            itcflag
            __typename
          }
          relatedinvoicemaster {
            invoiceid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            invoicetypecd
            partyid
            paymentaccountid
            invoicedate
            invoicenumber
            customerordernumber
            customerorderdate
            invoiceamount
            paymenttype
            creditduration
            invoicebillingaddressid
            invoicedeliveryaddressid
            invoicetaxabletypecd
            receipturl
            invoicelinetypecd
            invoicecurrencycd
            exchangerate
            comments
            receivedamount
            adjustmentamount
            placeofsupply
            balancedueamount
            reversechargeflag
            tcsapplicableflag
            relatedinvoicelineitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              lineitemnumber
              invoicelineitemtype
              itemid
              quantity
              unittypecd
              itemrate
              itemamount
              itemdiscount
              taxableamount
              discounttype
              discountrate
              netamount
              hsnsaccode
              taxability
              lastupdatedby
              statuscode
              statusmessage
              pricetype
              lotid
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              unit
              uqc
              salesaccountname
              salesaccountid
              itemname
              itemcode
              itemtype
              manualdiscount
              manualcess
              itemmaster_timestamp
              description
              pricetypeid
              manualgst
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoicelinenonitems {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              invoicelineitemtype
              incomeaccountid
              hsnsaccode
              taxability
              itemdescription
              taxableamount
              rate
              discount
              netamount
              lastupdatedby
              statuscode
              statusmessage
              hsnsacid
              hsncodetype
              hsncodevalue
              hsndescription
              gstrate
              gsttypecd
              gstamount
              cessamount
              incomeaccountname
              manualgst
              manualcess
              cessrate
              cesstype
              type
              __typename
            }
            relatedinvoiceattachment {
              invoiceid
              attachmentid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              attachmentname
              attachmenturl
              lastupdatedby
              statuscode
              statusmessage
              documentname
              type
              __typename
            }
            relatedinvoicedispatch {
              invoiceid
              dispatchid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transportationcd
              vehiclenumber
              dispatchdate
              ewaybillnumber
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoiceposdetails {
              posid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              partyposid
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicelinegst {
              invoiceid
              invoiceitemid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              gstrate
              gsttypecd
              gstamount
              cessamount
              cessrate
              cesstype
              lastupdatedby
              statuscode
              statusmessage
              __typename
            }
            relatedinvoicenumbertracker {
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              nextinvoicenumber
              lastupdatedby
              __typename
            }
            relatedinvoicetransactiondetails {
              transactionid
              companyid
              companybranchid
              enteredtimestamp
              expiredtimestamp
              transactiontypecd
              vouchernumber
              entrydate
              bankreferencenumber
              comments
              lastupdatedby
              statuscode
              statusmessage
              cancelflag
              cancelremark
              serialnumber
              pdflink
              towards
              isvouchereditable
              __typename
            }
            lastupdatedby
            cancelflag
            statuscode
            statusmessage
            consigneename
            consigneegstin
            companystate
            cancelremark
            deleteremark
            roundoffamount
            discounttype
            discountvalue
            serialnumber
            currencycode
            currencyrate
            paymentstatus
            ackno
            ackdt
            irn
            signedqrcode
            itcflag
            __typename
          }
          lastupdatedby
          statuscode
          statusmessage
          cancelflag
          cancelremark
          serialnumber
          pdflink
          towards
          isvouchereditable
          __typename
        }
        lastupdatedby
        cancelflag
        statuscode
        statusmessage
        consigneename
        consigneegstin
        companystate
        cancelremark
        deleteremark
        roundoffamount
        discounttype
        discountvalue
        serialnumber
        currencycode
        currencyrate
        paymentstatus
        ackno
        ackdt
        irn
        signedqrcode
        itcflag
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      cancelflag
      cancelremark
      serialnumber
      pdflink
      towards
      isvouchereditable
      __typename
    }
    relatedpartymaster {
      partyid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      partytypecd
      partydisplayname
      partylegalname
      groupaccountid
      gstcategory
      placeofsupply
      entity
      email
      contactnumber
      whatsappnumber
      accountsid
      is_active
      msmetype
      deliveryconsigneename
      deliveryconsigneegstin
      statuscode
      statusmessage
      relatedpartygstdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        pannumber
        gstin
        partyaddressid
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycreditdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        creditperiodduration
        billingcurrency
        creditlimitcd
        creditlimitamount
        billwiseflag
        notes
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycontact {
        partyid
        enteredtimestamp
        expiredtimestamp
        contacttypename
        contactdesignationname
        contactorder
        email
        phonenumber
        whatsappnumber
        lastupdatedby
        statuscode
        statusmessage
        contactcountry
        whatsappcountry
        __typename
      }
      relatedpartyimages {
        attachmentid
        partyid
        companyid
        enteredtimestamp
        expiredtimestamp
        type
        documentname
        imagename
        imageurl
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      tdspercentage
      udhyamregno
      sameaddressflag
      comments
      tdssection
      accountname
      deliverystatecode
      deliverystatename
      contactcountry
      whatsappcountry
      entityname
      __typename
    }
    relatedpartyaddressdetails {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      line1
      line2
      line3
      city
      statecode
      statename
      statuscode
      statusmessage
      pincode
      countrycode
      codevalue
      district
      lastupdatedby
      godownname
      gstin
      phone
      email
      personincharge
      consigneename
      consigneegstin
      foreignstate
      foreigndistrict
      defaultflag
      addresstitle
      addressindex
      __typename
    }
    relatedpaymentaccountdetails {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      relatedaccountopeningbalance {
        accountsid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        financialyearid
        startdate
        creditamount
        debitamount
        statuscode
        statusmessage
        __typename
      }
      relatedaccountgroupmaster {
        accountgroupid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        accounttypecd
        accountgroupname
        accountparentgroupid
        displayordernumber
        statuscode
        statusmessage
        is_active
        restrictedflag
        path
        __typename
      }
      relatedaccountbalance {
        accountid
        accountbalance
        actualbalance
        __typename
      }
      path
      __typename
    }
    relatedpurchaseaddressdetails {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      line1
      line2
      line3
      city
      statecode
      statename
      statuscode
      statusmessage
      pincode
      countrycode
      codevalue
      district
      lastupdatedby
      godownname
      gstin
      phone
      email
      personincharge
      consigneename
      consigneegstin
      foreignstate
      foreigndistrict
      defaultflag
      addresstitle
      addressindex
      __typename
    }
    lastupdatedby
    cancelflag
    roundoffamount
    discounttype
    discountvalue
    adjustmentamount
    statuscode
    statusmessage
    serialnumber
    currencycode
    currencyrate
    partydisplayname
    partylegalname
    partyaccountid
    reversechargeflag
    overduedays
    paymentstatus
    partyregistrationtype
    purchaseinvoicepdf
    partygstcategory
    partyemail
    partygstin
    partytypecd
    ewaybillno
    validupto
    ewaybill_is_cancelled
    ewaybill_cancel_remarks
    cancel_rsn_code
    einvoiceenteredtimestamp
    ewaybillenteredtimestamp
    ewaybillid
    accountname
    duedatetimestamp
    partyisactive
    consigneename
    consigneegstin
    ewaybillpdf
    ewaybillstatus
    isvouchereditable
    goods_exist
    itcflag
    linkedamount
    cessexist
    partyamount
    totalgstamount
    tdsamount
    tcsamount
    taxableamount
    igstamount
    cgstamount
    sgstamount
    cessamount
    sourceofsupply
    taxabilitylabel
    additionaldiscount
    netinvoiceamount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPurchaseMasterRangeQueryVariables,
  APITypes.ListPurchaseMasterRangeQuery
>;
export const getMinMaxInvoiceDate = /* GraphQL */ `query GetMinMaxInvoiceDate(
  $invoicetypecd: String!
  $invoiceid: Int!
  $serialnumber: String
) {
  getMinMaxInvoiceDate(
    invoicetypecd: $invoicetypecd
    invoiceid: $invoiceid
    serialnumber: $serialnumber
  ) {
    previnvoicedate
    nextinvoicedate
    latestinvoicedate
    openingbalancedate
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMinMaxInvoiceDateQueryVariables,
  APITypes.GetMinMaxInvoiceDateQuery
>;
export const listPartyMasterSearch = /* GraphQL */ `query ListPartyMasterSearch(
  $word: String!
  $type: String!
  $rowfrom: Int!
  $limitno: Int!
) {
  listPartyMasterSearch(
    word: $word
    type: $type
    rowfrom: $rowfrom
    limitno: $limitno
  ) {
    partyid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    partytypecd
    partydisplayname
    partylegalname
    groupaccountid
    gstcategory
    placeofsupply
    placeofsupplytext
    entity
    email
    contactnumber
    whatsappnumber
    accountsid
    is_active
    msmetype
    deliveryconsigneename
    deliveryconsigneegstin
    statuscode
    statusmessage
    lastupdatedby
    tdspercentage
    udhyamregno
    partygstenteredtimestamp
    partygstexpiredtimestamp
    pannumber
    gstin
    partyaddressid
    contacttypename
    contactdesignationname
    contactorder
    partycontactemail
    phonenumber
    partycontactwhatsappnumber
    creditperiodduration
    billingcurrency
    creditlimitcd
    creditlimitamount
    billwiseflag
    notes
    sameaddressflag
    comments
    accountbalance
    tdssection
    accounttypeflag
    accountgroup
    contactcountry
    whatsappcountry
    partybillingaddress
    partydeliveryaddress
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPartyMasterSearchQueryVariables,
  APITypes.ListPartyMasterSearchQuery
>;
export const listItemMasterSearch = /* GraphQL */ `query ListItemMasterSearch(
  $word: String!
  $type: String!
  $rowfrom: Int!
  $limitno: Int!
) {
  listItemMasterSearch(
    word: $word
    type: $type
    rowfrom: $rowfrom
    limitno: $limitno
  ) {
    itemid
    itemcode
    companyid
    enteredtimestamp
    expiredtimestamp
    itemname
    salesinvoiceflag
    purchaseinvoiceflag
    itemcategorycd
    measurementcd
    currencycd
    salesaccountid
    purchaseaccountid
    taxabilitycd
    reversechargeflag
    itemtype
    hsnid
    is_active
    statuscode
    statusmessage
    relateditemamountdetails {
      id
      itemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      amount
      effectivedate
      expireddate
      hsnid
      gstcompensationtype
      gstcompensationvalue
      gstrate
      statuscode
      statusmessage
      lastupdatedby
      discounttype
      discountvalue
      invoicetype
      pricetype
      isactive
      isdefault
      pricetypeid
      tabletype
      __typename
    }
    relateditemgstdetails {
      itemid
      companyid
      enteredtimestamp
      expiredtimestamp
      hsnid
      gstcesstype
      gstcompensationvalue
      effectivedate
      expireddate
      gstcessvalue
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    relateditemimages {
      attachmentid
      itemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      imagename
      imageurl
      documentname
      type
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    lastupdatedby
    serialnumber
    financialyearid
    description
    hsnsacid
    hsncodetype
    hsncodevalue
    hsndescription
    cessexist
    barcode
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListItemMasterSearchQueryVariables,
  APITypes.ListItemMasterSearchQuery
>;
export const listaccounttransactiondetailstotals = /* GraphQL */ `query Listaccounttransactiondetailstotals(
  $accountid: Int!
  $startdate: Int!
  $enddate: Int!
  $searchmode: Int
  $searcharray: AWSJSON
  $openingbalance: Int
) {
  listaccounttransactiondetailstotals(
    accountid: $accountid
    startdate: $startdate
    enddate: $enddate
    searchmode: $searchmode
    searcharray: $searcharray
    openingbalance: $openingbalance
  ) {
    totalcredit
    totaldebit
    balancesign
    closingbalance
    transactioncount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListaccounttransactiondetailstotalsQueryVariables,
  APITypes.ListaccounttransactiondetailstotalsQuery
>;
export const lambdatest = /* GraphQL */ `query Lambdatest($input: AWSJSON) {
  lambdatest(input: $input) {
    statusCode
    body
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LambdatestQueryVariables,
  APITypes.LambdatestQuery
>;
export const getpospartydetails = /* GraphQL */ `query Getpospartydetails($phonenumber: String!) {
  getpospartydetails(phonenumber: $phonenumber) {
    pospartyid
    companyid
    partyname
    partycontactnumberid
    financialyearid
    id
    objecttype
    objectid
    countrycode
    phonenumber
    verifieddatetime
    promotionssignup
    smsallowed
    callallowed
    whatsappallowed
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetpospartydetailsQueryVariables,
  APITypes.GetpospartydetailsQuery
>;
export const gettdstcsreport = /* GraphQL */ `query Gettdstcsreport(
  $type: String!
  $startdate: Int!
  $enddate: Int!
  $word: String!
  $rowfrom: Int!
  $limitno: Int!
  $columnname: String
  $ordertype: String
  $searcharray: AWSJSON
) {
  gettdstcsreport(
    type: $type
    startdate: $startdate
    enddate: $enddate
    word: $word
    rowfrom: $rowfrom
    limitno: $limitno
    columnname: $columnname
    ordertype: $ordertype
    searcharray: $searcharray
  ) {
    id
    invoicedate
    vouchernumber
    vouchertype
    suppliername
    legalentity
    pan_number
    deductedamount
    tdsamount
    amountaftertds
    tdspercentage
    tdssection
    tdsdetails
    totalcount
    transactiontype
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GettdstcsreportQueryVariables,
  APITypes.GettdstcsreportQuery
>;
export const getjournaldetails = /* GraphQL */ `query Getjournaldetails($transactionid: Int!) {
  getjournaldetails(transactionid: $transactionid) {
    transactionid
    accountsid
    accountname
    creditamount
    debitamount
    transactiontypecd
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetjournaldetailsQueryVariables,
  APITypes.GetjournaldetailsQuery
>;
export const getewaybill = /* GraphQL */ `query Getewaybill($invoiceid: Int!) {
  getewaybill(invoiceid: $invoiceid) {
    id
    invoiceid
    invoicetype
    companyid
    enteredtimestamp
    expiredtimestamp
    ewaybillno
    expirydate
    is_cancelled
    cancel_remarks
    lastupdatedby
    cancel_rsn_code
    ewaybilldate
    supplytype
    subtype
    partyid
    transporterid
    modeoftransport
    vehicleno
    distance
    invoiceno
    invoicedate
    fromgstin
    togstin
    fromstate
    tostate
    frompincode
    topincode
    billingstate
    billingpincode
    transportername
    transportergstin
    validupto
    total_items_count
    gstrate
    gstamount
    cessamount
    ewbrejecteddate
    totalitemamount
    totalinvoiceamount
    fromtradename
    totradename
    transactiontype
    doctype
    status
    transdocno
    transdocdate
    vehicletype
    ewaybillpdf
    addresses {
      objectid
      objecttype
      statecode
      statename
      pincode
      line1
      line2
      line3
      city
      countrycode
      district
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetewaybillQueryVariables,
  APITypes.GetewaybillQuery
>;
export const listtransporters = /* GraphQL */ `query Listtransporters {
  listtransporters {
    transporterid
    transportername
    companyid
    enteredtimestamp
    lastupdatedby
    expiredtimestamp
    transportergstin
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListtransportersQueryVariables,
  APITypes.ListtransportersQuery
>;
export const getLatestAppVersion = /* GraphQL */ `query GetLatestAppVersion {
  getLatestAppVersion {
    id
    version_number
    release_notes
    release_date
    is_mandatory
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLatestAppVersionQueryVariables,
  APITypes.GetLatestAppVersionQuery
>;
export const getFirstTransactionDate = /* GraphQL */ `query GetFirstTransactionDate {
  getFirstTransactionDate {
    transactiontimestamp
    transactioncount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFirstTransactionDateQueryVariables,
  APITypes.GetFirstTransactionDateQuery
>;
export const listewaybill = /* GraphQL */ `query Listewaybill(
  $rowfrom: Int!
  $limitno: Int!
  $columnname: String
  $ordertype: String
  $searchmode: Int
  $searcharray: AWSJSON
) {
  listewaybill(
    rowfrom: $rowfrom
    limitno: $limitno
    columnname: $columnname
    ordertype: $ordertype
    searchmode: $searchmode
    searcharray: $searcharray
  ) {
    id
    invoiceid
    invoicetype
    companyid
    enteredtimestamp
    expiredtimestamp
    ewaybillno
    expirydate
    is_cancelled
    cancel_remarks
    lastupdatedby
    cancel_rsn_code
    ewaybilldate
    supplytype
    subtype
    partyid
    transporterid
    modeoftransport
    vehicleno
    distance
    invoiceno
    invoicedate
    fromgstin
    togstin
    fromstate
    tostate
    frompincode
    topincode
    billingstate
    billingpincode
    transportername
    transportergstin
    validupto
    total_items_count
    gstrate
    gstamount
    cessamount
    ewbrejecteddate
    totalitemamount
    totalinvoiceamount
    fromtradename
    totradename
    transactiontype
    doctype
    status
    transdocno
    transdocdate
    vehicletype
    ewaybillpdf
    addresses {
      objectid
      objecttype
      statecode
      statename
      pincode
      line1
      line2
      line3
      city
      countrycode
      district
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListewaybillQueryVariables,
  APITypes.ListewaybillQuery
>;
export const listewaybillv2 = /* GraphQL */ `query Listewaybillv2(
  $startdate: AWSTimestamp!
  $enddate: AWSTimestamp!
  $rowfrom: Int!
  $limitno: Int!
  $columnname: String
  $ordertype: String
  $searchmode: Int
  $searcharray: AWSJSON
) {
  listewaybillv2(
    startdate: $startdate
    enddate: $enddate
    rowfrom: $rowfrom
    limitno: $limitno
    columnname: $columnname
    ordertype: $ordertype
    searchmode: $searchmode
    searcharray: $searcharray
  ) {
    id
    invoiceid
    invoicetype
    companyid
    enteredtimestamp
    expiredtimestamp
    ewaybillno
    expirydate
    is_cancelled
    cancel_remarks
    lastupdatedby
    cancel_rsn_code
    ewaybilldate
    supplytype
    subtype
    partyid
    transporterid
    modeoftransport
    vehicleno
    distance
    invoiceno
    invoicedate
    fromgstin
    togstin
    fromstate
    tostate
    frompincode
    topincode
    billingstate
    billingpincode
    transportername
    transportergstin
    validupto
    total_items_count
    gstrate
    gstamount
    cessamount
    ewbrejecteddate
    totalitemamount
    totalinvoiceamount
    fromtradename
    totradename
    transactiontype
    doctype
    status
    transdocno
    transdocdate
    vehicletype
    ewaybillpdf
    addresses {
      objectid
      objecttype
      statecode
      statename
      pincode
      line1
      line2
      line3
      city
      countrycode
      district
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.Listewaybillv2QueryVariables,
  APITypes.Listewaybillv2Query
>;
export const listewaybillv2Count = /* GraphQL */ `query Listewaybillv2Count(
  $startdate: AWSTimestamp!
  $enddate: AWSTimestamp!
  $columnname: String
  $ordertype: String
  $searchmode: Int
  $searcharray: AWSJSON
) {
  listewaybillv2Count(
    startdate: $startdate
    enddate: $enddate
    columnname: $columnname
    ordertype: $ordertype
    searchmode: $searchmode
    searcharray: $searcharray
  ) {
    ewaybillcount
    mintotalinvoiceamount
    maxtotalinvoiceamount
    maxtotalitemamount
    maxtotalitemscount
    maxgstcess
    maxdistance
    statuscode
    statusmessage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.Listewaybillv2CountQueryVariables,
  APITypes.Listewaybillv2CountQuery
>;
export const checkitempartyadded = /* GraphQL */ `query Checkitempartyadded {
  checkitempartyadded {
    count
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CheckitempartyaddedQueryVariables,
  APITypes.CheckitempartyaddedQuery
>;
export const listStockSummary = /* GraphQL */ `query ListStockSummary($input: ListStockSummaryInput!) {
  listStockSummary(input: $input) {
    slno
    itemid
    itemcode
    itemname
    unit
    hsn
    taxability
    gstrate
    openingamt
    openingqty
    purchaseamt
    purchaseqty
    salesamt
    salesqty
    closingamt
    closingqty
    total_count
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListStockSummaryQueryVariables,
  APITypes.ListStockSummaryQuery
>;
export const listStockSummaryv2 = /* GraphQL */ `query ListStockSummaryv2($input: ListStockSummaryInput!) {
  listStockSummaryv2(input: $input) {
    slno
    itemid
    itemcode
    itemname
    unit
    hsn
    taxability
    gstrate
    openingamt
    openingqty
    purchaseamt
    purchaseqty
    salesamt
    salesqty
    closingamt
    closingqty
    total_count
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListStockSummaryv2QueryVariables,
  APITypes.ListStockSummaryv2Query
>;
export const listUserInvitations = /* GraphQL */ `query ListUserInvitations(
  $rowfrom: Int!
  $limitno: Int!
  $columnname: String
  $ordertype: String
  $searchmode: Int
  $searcharray: AWSJSON
) {
  listUserInvitations(
    rowfrom: $rowfrom
    limitno: $limitno
    columnname: $columnname
    ordertype: $ordertype
    searchmode: $searchmode
    searcharray: $searcharray
  ) {
    id
    email
    companyid
    invitedby
    status
    invitationtoken
    invitationsource
    acceptedtimestamp
    enteredtimestamp
    expiredtimestamp
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserInvitationsQueryVariables,
  APITypes.ListUserInvitationsQuery
>;
export const listItemwiseStockSummary = /* GraphQL */ `query ListItemwiseStockSummary($input: ListItemwiseStockSummaryInput!) {
  listItemwiseStockSummary(input: $input) {
    itemid
    date
    particular
    voucher_no
    qty
    cost_item
    total_cost
    closing_stock
    closing_stock_amount
    invoiceid
    next_cursor_timestamp
    next_cursor_transactionid
    total_count
    remark
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListItemwiseStockSummaryQueryVariables,
  APITypes.ListItemwiseStockSummaryQuery
>;
export const listItemwiseStockSummaryv2 = /* GraphQL */ `query ListItemwiseStockSummaryv2($input: ListItemwiseStockSummaryInput!) {
  listItemwiseStockSummaryv2(input: $input) {
    itemid
    date
    particular
    voucher_no
    qty
    cost_item
    total_cost
    closing_stock
    closing_stock_amount
    invoiceid
    next_cursor_timestamp
    next_cursor_transactionid
    total_count
    remark
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListItemwiseStockSummaryv2QueryVariables,
  APITypes.ListItemwiseStockSummaryv2Query
>;
export const getItemFinancialYearSummary = /* GraphQL */ `query GetItemFinancialYearSummary($input: ItemFinancialYearSummaryInput!) {
  getItemFinancialYearSummary(input: $input) {
    itemid
    financialyearid
    openingqty
    openingamt
    purchaseqty
    purchaseamt
    closingqty
    closingamt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetItemFinancialYearSummaryQueryVariables,
  APITypes.GetItemFinancialYearSummaryQuery
>;
export const listAllItemOpeningStock = /* GraphQL */ `query ListAllItemOpeningStock {
  listAllItemOpeningStock {
    itemid
    itemcode
    itemname
    units
    stockquantity
    rate_unit
    openingbalance
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAllItemOpeningStockQueryVariables,
  APITypes.ListAllItemOpeningStockQuery
>;
export const listItemDashboardData = /* GraphQL */ `query ListItemDashboardData($starttimestamp: Int!, $endtimestamp: Int!) {
  listItemDashboardData(
    starttimestamp: $starttimestamp
    endtimestamp: $endtimestamp
  ) {
    itemid
    itemcode
    itemname
    itemtype
    itemcategoryid
    is_active
    closing_amount
    closing_quantity
    unit
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListItemDashboardDataQueryVariables,
  APITypes.ListItemDashboardDataQuery
>;
export const listTotalClosingStock = /* GraphQL */ `query ListTotalClosingStock(
  $starttimestamp: Int!
  $endtimestamp: Int!
  $financialyearid: Int!
  $openingbalance: Int
) {
  listTotalClosingStock(
    starttimestamp: $starttimestamp
    endtimestamp: $endtimestamp
    financialyearid: $financialyearid
    openingbalance: $openingbalance
  ) {
    total_closing_quantity
    total_closing_amount
    total_purchase_amount
    total_sales_amount
    total_opening_amount
    total_cogs
    total_profit_loss
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTotalClosingStockQueryVariables,
  APITypes.ListTotalClosingStockQuery
>;
export const getEmailsByPartyIds = /* GraphQL */ `query GetEmailsByPartyIds($partyIds: [Int!]!) {
  getEmailsByPartyIds(partyIds: $partyIds) {
    partyid
    email
    is_active
    partydisplayname
    partylegalname
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEmailsByPartyIdsQueryVariables,
  APITypes.GetEmailsByPartyIdsQuery
>;
export const listTotalOpeningStock = /* GraphQL */ `query ListTotalOpeningStock($starttimestamp: Int!) {
  listTotalOpeningStock(starttimestamp: $starttimestamp) {
    total_opening_quantity
    total_opening_amount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTotalOpeningStockQueryVariables,
  APITypes.ListTotalOpeningStockQuery
>;
export const getLastUsedBankOrCashAccount = /* GraphQL */ `query GetLastUsedBankOrCashAccount($transactiontypecd: TransactionType!) {
  getLastUsedBankOrCashAccount(transactiontypecd: $transactiontypecd) {
    bankpaidtoaccountid
    cashpaidtoaccountid
    bankpaidtoaccountname
    cashpaidtoaccountname
    paymentmethodlastused
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLastUsedBankOrCashAccountQueryVariables,
  APITypes.GetLastUsedBankOrCashAccountQuery
>;
export const gettdstcsreporttotals = /* GraphQL */ `query Gettdstcsreporttotals(
  $type: String!
  $startdate: Int!
  $enddate: Int!
  $word: String!
  $searcharray: AWSJSON
) {
  gettdstcsreporttotals(
    type: $type
    startdate: $startdate
    enddate: $enddate
    word: $word
    searcharray: $searcharray
  ) {
    totaltaxableamount
    totaltdsamount
    totalamountaftertds
    totalrecords
    transactiontype
    taxableamounttransactiontype
    tdsamounttransactiontype
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GettdstcsreporttotalsQueryVariables,
  APITypes.GettdstcsreporttotalsQuery
>;
